import {Component, ElementRef, EventEmitter, Inject, OnInit, Output, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, NavigationStart, NavigationEnd} from '@angular/router';
import {Location} from '@angular/common';
import {ConfService} from '../conf.service';
import {Loggedin} from '../authFilter/platformCentralAuth';
import {AppComponent} from '../app.component';
import {HostListener} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {ListenerService} from '../listener.service';
import {environment} from '../../environments/environment';
import {KongService} from '../kong.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {SnackbarComponent} from '../snackbar/snackbar.component';
import * as CryptoJS from 'crypto-js';
import {NotifyerrortoadminsListenerService} from '../notifyerrortoadmins-listener.service';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {DeletionListenerService} from '../deletion-listener.service';
import {PermissionsListenerService} from '../permissions-listener.service';
import {EmailtemplateListenerService} from '../emailtemplate-listener.service';
import {DatabasesListenerService} from '../databases-listener.service';
import {IdletimeoutListenerService} from '../idletimeout-listener.service';
import {DevexListenerService} from '../devex-listener.service';
import {ApigatewayListenerService} from '../apigateway-listener.service';
import {GuidedTour, GuidedTourService, Orientation} from 'ngx-guided-tour';
import {SqlqueryListenerService} from '../sqlquery-listener.service';
import {TestsuiteListenerService} from '../testsuite-listener.service';
import {TourStep} from 'ngx-guided-tour/lib/guided-tour.constants';
import {WebsocketService} from '../websocket.service';
import {WorkflowListenerService} from '../workflow-listener.service';
import {LeftpanelListenerService} from '../leftpanel-listener.service';
import {JwtParserService} from '../jwt-parser.service';
import {BusinessLogicDataService} from '../new-blockly/business-logic-data.service';
import {AccountInfoService} from '../user/account-info.service';
import {AuthService} from '../user/auth.service';
import {AuditLogService, LogEvent} from '../audit-log.service';


declare let $;

@Component({
    selector: 'app-leftpanel',
    templateUrl: './leftpanel.component.html',
    styleUrls: ['./leftpanel.component.css']
})
export class LeftpanelComponent implements OnInit {
    userName: string;
    searchText: string;
    access: any;
    leftpanelData: any;
    applicationData: any;
    entities: any;
    term: any;
    term1: any;
    term2: any;
    adminSettingsData: any;
    men = [];
    operationGroups = [];
    categories = [];
    commons = [];
    businessTemplates = [];
    thirdpartyapis: any;
    sqlqueryapis: any;
    unifiedqueryapis: any;
    workflowapis: any;
    route: any;
    user: any;
    @Output() sub = new EventEmitter<any>();
    @Output() isDataInitialised = new EventEmitter<any>();
    @Output() dataDeleted = new EventEmitter<any>();
    settingsflag: any;
    basicPermission: boolean;
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    pkey = localStorage.getItem('partnerKey');
    panelOpenState = true;
    SideMenuNavigationUrl: string;
    DisplayApiByCategory = true;
    DisplayCustomOperation = true;
    executors: any;
    searchText1 = {
        'executor_name': ''
    };
    subMenu = false;
    menuTitle: string;

    partnerLogo: any;

    consumerId: any;
    OAuthClientApps: any;
    availableEnvironmentsToSwitch: any;

    properties = [];

    guideTourSteps: Array<TourStep> = [];
    headerCmpTourSteps: Array<TourStep> = [];

    parsedJWT: any;
    videoId = 'GYAB4Td62zI';
    videosData: any;
    videos: any;
    ifTSRExecutors: Boolean = false;
    ifScheduledJobs: Boolean = false;
    settings = [
        {
            'category': 'Partner Settings',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    'categoryName': 'Business Details',
                    'route': '/businessdetails'
                },
                {
                    'categoryName': 'Branding',
                    'route': '/branding'
                },
                {
                    'categoryName': 'Accounts',
                    'route': '/accounts'
                },
                // {
                //     'categoryName': 'API Keys',
                //     'route': '/api-key'
                // },
                {
                    'categoryName': 'Business Locations',
                    'route': '/businesslocations'
                },
                // {
                //     'categoryName': 'Dashboard',
                //     'route': '/dashboard'
                // },
                {
                    'categoryName': 'Databases',
                    'route': '/databases'
                },
                // {
                //     'categoryName': 'Metrics',
                //     'route': '/metrics-settings'
                // },
                {
                    'categoryName': 'IP Restrictions',
                    'route': '/ipconfig'
                },
                {
                    'categoryName': 'Identity Manager',
                    'route': '/identitymanager'
                },
                {
                    'categoryName': 'Credits',
                    'route': '/credits'
                },
                {
                    'categoryName': 'Coupon Management',
                    'route': '/coupon-management-settings'
                },
                // {
                //     'categoryName': 'Encryption',
                //     'route': '/encryption-settings'
                // },
                {
                    'categoryName': 'Email',
                    'route': '/email-settings'
                },
                {
                    'categoryName': 'Document Viewer',
                    'route': '/docs'
                },
                {
                    'categoryName': 'Document Editor',
                    'route': '/docseditor'
                },
                // {
                //     'categoryName': 'Campaign',
                //     'route': '/campaign-settings'
                // },
                // {
                //     'categoryName': 'Audience',
                //     'route': '/audience-settings'
                // },
                // {
                //     'categoryName': 'Compliances',
                //     'route': '/compliance-settings'
                // },
                // {
                //     'categoryName': 'Roles',
                //     'route': '/roles-settings'
                // },
                // {
                //     'categoryName': 'Users',
                //     'route': '/users-settings'
                // },
                // {
                //     'categoryName': 'Permission',
                //     'route': '/permission-settings'
                // },
                // {
                //     'categoryName': 'User Groups',
                //     'route': '/user-groups-settings'
                // },
                // {
                //     'categoryName': 'Permission Groups',
                //     'route': '/permission-group-settings'
                // },
                // {
                //     'categoryName': 'Source Control Management',
                //     'route': '/source-control-management-settings'
                // },
                // {
                //     'categoryName': 'Connectors',
                //     'route': '/connectors-settings'
                // }
                // {
                //     'categoryName': 'API Integrations',
                //     'route': '/integrations'
                // },
                {
                    'categoryName': 'API Categories',
                    'route': '/categories'
                },
                {
                    'categoryName': 'Service Categories',
                    'route': '/provider-category'
                },
                {
                    'categoryName': 'Service Providers',
                    'route': '/providers'
                }
            ]
        },
//         {
//     'category': 'Platform Settings',
//     'expand': false,
//     'route': null,
//     'subcategory': [
//         {
//             'categoryName': 'Themes',
//             'route': '/themes-settings'
//         },
//         {
//             'categoryName': 'Subscription',
//             'route': '/subscription-settings'
//         },
//         {
//             'categoryName': 'Billing',
//             'route': '/billing-settings'
//         },
//         {
//             'categoryName': 'Services',
//             'route': '/services-settings'
//         },
//         {
//             'categoryName': 'Security',
//             'route': '/security-settings'
//         },
//         {
//             'categoryName': 'BOT',
//             'route': '/bot-settings'
//         },
//         {
//             'categoryName': 'Gateway Rate Limiting',
//             'route': '/gr-rate-limiting-settings'
//         },
//         {
//             'categoryName': 'Gateway CORS',
//             'route': '/gt-cors-settings'
//         },
//         {
//             'categoryName': 'Gateway IP Restrictions',
//             'route': '/gt-ip-settings'
//         },
//         {
//             'categoryName': 'Code Generators',
//             'route': '/code-gen-settings'
//         },
//         {
//             'categoryName': 'Integrators',
//             'route': '/integrator-settings'
//         },
//         {
//             'categoryName': 'Service Providers',
//             'route': '/service-providers-settings'
//         },
//         {
//             'categoryName': 'Transformation - Database',
//             'route': '/transformation-database-settings'
//         },
//         {
//             'categoryName': 'Transformation - COBOL',
//             'route': '/transformation-cobol-settings'
//         },
//         {
//             'categoryName': 'Transformation - API',
//             'route': '/transformation-api-settings'
//         },
//         {
//             'categoryName': 'DevEx',
//             'route': '/devex-settings'
//         },
//         {
//             'categoryName': 'Integration Languages',
//             'route': '/integration-languages-settings'
//         },
//         {
//             'categoryName': 'API Registrar',
//             'route': '/api-registrar-settings'
//         },
//     ]
// },
        {
            'category': 'Infrastructure Settings',
            'expand': false,
            'route': null,
            'subcategory': [
                // {
                //     'categoryName': 'Cloud Platforms',
                //     'route': '/cloud-platform-settings'
                // },
                {
                    'categoryName': 'Environment',
                    'route': '/environment-settings'
                },
                // {
                //     'categoryName': 'API Gateway Management',
                //     'route': '/api-gateway-settings'
                // }
                // {
                //     'categoryName': 'Databases',
                //     'route': '/database-inf-settings'
                // },
                {
                    'categoryName': 'Secrets Managers',
                    'route': '/logging-settings'
                }
                // {
                //     'categoryName': 'File System',
                //     'route': '/file-settings'
                // },
                // {
                //     'categoryName': 'Identity Management',
                //     'route': '/identity-settings'
                // },
                // {
                //     'categoryName': 'Traffic',
                //     'route': '/traffic-settings'
                // }
            ]
        }
    ];
    partnerSettings = {
        'category': 'Partner Settings',
        'expand': true,
        'route': null,
        'subcategory': [
            {
                'categoryName': 'Business Details',
                'route': '/businessdetails'
            },
            {
                'categoryName': 'Branding',
                'route': '/branding'
            },
            {
                'categoryName': 'Accounts',
                'route': '/accounts'
            },
            {
                'categoryName': 'API Keys',
                'route': '/api-key'
            },
            {
                'categoryName': 'Business Locations',
                'route': '/businesslocations'
            },
            {
                'categoryName': 'Dashboard',
                'route': '/dashboard'
            },
            {
                'categoryName': 'Databases',
                'route': '/databases'
            },
            {
                'categoryName': 'Metrics',
                'route': '/metrics'
            },
            {
                'categoryName': 'IP Restrictions',
                'route': '/ipconfig'
            },
            {
                'categoryName': 'Identity Manager',
                'route': '/identitymanager'
            },
            {
                'categoryName': 'Credits',
                'route': '/credits'
            }
        ]
    };
    platformSettings = {
        'category': 'Platform Settings',
        'expand': true,
        'route': null,
        'subcategory': [
            {
                'categoryName': 'Business Details',
                'route': '/businessdetails'
            },
            {
                'categoryName': 'Branding',
                'route': '/branding'
            },
            {
                'categoryName': 'Accounts',
                'route': '/accounts'
            },
            {
                'categoryName': 'API Keys',
                'route': '/api-key'
            },
            {
                'categoryName': 'Business Locations',
                'route': '/businesslocations'
            },
            {
                'categoryName': 'Dashboard',
                'route': '/dashboard'
            },
            {
                'categoryName': 'Databases',
                'route': '/databases'
            },
            {
                'categoryName': 'Metrics',
                'route': '/metrics'
            },
            {
                'categoryName': 'IP Restrictions',
                'route': '/ipconfig'
            },
            {
                'categoryName': 'Identity Manager',
                'route': '/identitymanager'
            },
            {
                'categoryName': 'Credits',
                'route': '/credits'
            }
        ]
    };
    infrastructureSettings = {
        'category': 'Infrastructure Settings',
        'expand': true,
        'route': null,
        'subcategory': [
            {
                'categoryName': 'Business Details',
                'route': '/businessdetails'
            },
            {
                'categoryName': 'Branding',
                'route': '/branding'
            },
            {
                'categoryName': 'Accounts',
                'route': '/accounts'
            },
            {
                'categoryName': 'API Keys',
                'route': '/api-key'
            },
            {
                'categoryName': 'Business Locations',
                'route': '/businesslocations'
            },
            {
                'categoryName': 'Dashboard',
                'route': '/dashboard'
            },
            {
                'categoryName': 'Databases',
                'route': '/databases'
            },
            {
                'categoryName': 'Metrics',
                'route': '/metrics'
            },
            {
                'categoryName': 'IP Restrictions',
                'route': '/ipconfig'
            },
            {
                'categoryName': 'Identity Manager',
                'route': '/identitymanager'
            },
            {
                'categoryName': 'Credits',
                'route': '/credits'
            }
        ]
    };
    masterData = [
        {
            'category': 'controlplane',
            'route': '/controlplane',
            'expand': false
        },
        {
            'category': 'infrastructure',
            'expand': true,
            'route': null,
            'subcategory': [
                // {
                //     categoryName: 'Cloud Platforms',
                //     route: '/cloud-platform',
                //     icon: 'fa fa-cloud'
                // },
                {
                    categoryName: 'Environments',
                    route: '/environments',
                    icon: 'fa fa-code-fork'
                },
                {
                    categoryName: 'Secrets Managers',
                    route: '/secrets-manager',
                    icon: 'fa fa-user-secret'
                },
                {
                    categoryName: 'Gateway Managers',
                    route: '/api-gateway',
                    icon: 'fa fa-shield'
                },
                {
                    categoryName: 'Databases',
                    route: '/databases',
                    icon: 'fa fa-database'
                }
            ]
        },
        {
            'category': 'authorization',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    categoryName: 'Roles',
                    route: '/roles',
                    icon: 'fa fa-id-card-o'
                },
                {
                    categoryName: 'Permission Groups',
                    route: '/permissiongroup',
                    icon: 'fa fa-key'
                },
                {
                    categoryName: 'Permissions',
                    route: '/permissions',
                    icon: 'fa fa-id-badge'
                },
                {
                    categoryName: 'User Groups',
                    route: '/usergroups',
                    icon: 'fa fa-users'
                },
                {
                    categoryName: 'Users',
                    route: '/users',
                    icon: 'fa fa-user'
                }
            ]
        },
        // {
        //     'category': 'settings',
        //     'expand': true,
        //     'route': null,
        //     'subcategory': [
        //         {
        //             categoryName: 'Business Details',
        //             route: '/businessdetails',
        //             icon: 'fa fa-building-o'
        //         },
        //         {
        //             categoryName: 'Idle Timeout Settings',
        //             route: '/idle-timeout',
        //             icon: 'fa fa-clock-o'
        //         }
        //     ]
        // },
        {
            'category': 'environments',
            'expand': true,
            'route': null,
            'subcategory': [
                // {
                //     categoryName: 'Admin',
                //     route: '/administration:admin',
                //     hasPermission: true,
                //     icon: 'fa fa-user'
                // },
                // {
                //     categoryName: 'Development',
                //     route: '/administration:development',
                //     hasPermission: true,
                //     icon: 'fa fa-building'
                // }
            ],
        },
        {
            'category': 'partner settings',
            'expand': true,
            'route': null,
            'subcategory': [
                // {
                //     categoryName: 'Accounts',
                //     route: '/accounts',
                //     icon: 'fa fa-user-plus'
                // },
                {
                    categoryName: 'Business Locations',
                    route: '/businesslocations',
                    icon: 'fa fa-globe'
                },
                {
                    categoryName: 'Business Details',
                    route: '/businessdetails',
                    icon: 'fa fa-building-o'
                },
                {
                    categoryName: 'Branding',
                    route: '/branding',
                    icon: 'fa fa-id-badge'
                },
                // {
                //     categoryName: 'Themes',
                //     route: '/themes',
                //     icon: 'fa fa-themeisle'
                // },
                // {
                //     categoryName: 'Gateway',
                //     route: '/api-gateway',
                //     icon: 'fa fa-key'
                // },
                // {
                //     categoryName: 'Security',
                //     route: '/permissiongroup',
                //     icon: 'fa fa-shield'
                // },
                // {
                //     categoryName: 'BOT',
                //     route: '/usergroups',
                //     icon: 'fa fa-commenting-o'
                // },
                // {
                //     categoryName: 'API Creators',
                //     route: '/users',
                //     icon: 'fa fa-plus'
                // },
                // {
                //     categoryName: 'API Transformers',
                //     route: '/users',
                //     icon: 'fa fa-exchange'
                // },
                // {
                //     categoryName: 'API Integrators',
                //     route: '/users',
                //     icon: 'fa fa-user'
                // },
                // {
                //     categoryName: 'API Management',
                //     route: '/api-management',
                //     icon: 'fa fa-cog'
                // },
                // {
                //     categoryName: 'Manage Email Configurations',
                //     route: '/email-settings',
                //     icon: 'fa fa-envelope'
                // },
                // {
                //     categoryName: 'Idle Timeout Settings',
                //     route: '/idle-timeout',
                //     icon: 'fa fa-clock-o'
                // },
                // {
                //     categoryName: 'Consumer Gateway Settings',
                //     route: '/consumer',
                //     icon: 'fa fa-cogs'
                // },
                // {
                //     categoryName: 'Manage Users',
                //     route: '/users-management',
                //     icon: 'fa fa-user'
                // },
                // {
                //     categoryName: 'Manage User Groups',
                //     route: '/user-group',
                //     icon: 'fa fa-users'
                // },
                // {
                //     categoryName: 'Developer Experience',
                //     route: '/devex',
                //     icon: 'fa fa-rocket'
                // }
            ]
        },
        {
            'category': 'billing',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    categoryName: 'Billing',
                    route: '/billing',
                    icon: 'fa fa-usd'
                },
                // {
                //     categoryName: 'Payments',
                //     route: '/permissiongroups',
                //     icon: 'fa fa-credit-card-alt'
                // },
                // {
                //     categoryName: 'Invoices',
                //     route: '/permissions',
                //     icon: 'fa fa-files-o'
                // },
                // {
                //     categoryName: 'Subscriptions',
                //     route: '/usergroups',
                //     icon: 'fa fa-ticket'
                // },
                {
                    categoryName: 'Coupons',
                    route: '/coupon-management',
                    icon: 'fa fa-money'
                },
                {
                    categoryName: 'Credits',
                    route: '/credits',
                    icon: 'fa fa-credit-card'
                }
            ]
        },
        {
            'category': 'creation',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    categoryName: 'Data as a Service',
                    route: '/dataaccessapi',
                    icon: 'fa fa-table'
                },
                {
                    categoryName: 'Data as a Service (Advanced)',
                    route: '/dataaccessapi-advanced',
                    icon: 'fa fa-table'
                },
                {
                    categoryName: 'Application Logic',
                    route: '/businesslogic',
                    icon: 'fa fa-link'
                },
                {
                    categoryName: 'Workflows',
                    route: '/workflow',
                    icon: 'fa fa-sitemap'
                },
                {
                    categoryName: 'Decisions',
                    route: '/dmn',
                    icon: 'fa fa-codepen'
                },
                {
                    categoryName: 'SQL as a Service',
                    route: '/querybuilder',
                    icon: 'fa fa-database'
                },
                {
                    categoryName: 'PLSQL as a Service',
                    route: '/plsql',
                    icon: 'fa fa-tasks'
                },
                {
                    categoryName: 'API Joins',
                    route: '/unified-query-builder',
                    icon: 'fa fa-server'
                },
                {
                    categoryName: 'API Collections',
                    route: '/collections',
                    icon: 'fa fa-object-group'
                },
                {
                    categoryName: 'Test Suite as a Service',
                    route: '/testsuite',
                    icon: 'fa fa-check-circle-o'
                }
                // {
                //     categoryName: 'Documentor',
                //     route: '/documentor',
                //     icon: 'fa fa-file'
                // },
                // {
                //     categoryName: 'UX Builder',
                //     route: 'uxbuilder',
                //     icon: 'fa fa-wrench'
                // }
            ]
        },
        {
            'category': 'genai',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    categoryName: 'Cognitive Search',
                    route: '/cognitive-search',
                    icon: 'fa fa-search'
                },
                {
                    categoryName: 'Data Analytics',
                    route: '/data-analytics',
                    icon: 'fa fa-pie-chart'
                }
            ]
        },
        {
            'category': 'connect',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    categoryName: 'API Providers',
                    route: '/providers',
                    icon: 'fa fa-table'
                },
                {
                    categoryName: 'API Provider Categories',
                    route: '/provider-category',
                    icon: 'fa fa-table'
                },
                {
                    categoryName: 'Accelerators',
                    route: '/accelerators',
                    icon: 'send_time_extension',
                    iconType: 'mat-icon'
                },
                {
                    categoryName: 'Database Connectors',
                    route: '/databases',
                    icon: 'fa fa-database'
                },
                {
                    categoryName: 'API Register',
                    route: '/api-register',
                    icon: 'fa fa-book'
                },
                {
                    categoryName: 'Postman Collection',
                    route: '/postman-collections',
                    icon: 'fa fa-rocket'
                },
                // {
                //     categoryName: 'Marketplace',
                //     route: '/common-data-api',
                //     icon: 'fa fa-table'
                // }
            ]
        },
        {
            'category': 'transform',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    categoryName: 'Design2API',
                    route: '/application',
                    icon: 'fa fa-table'
                },
                {
                    categoryName: 'Data2API',
                    route: '/datacatalog',
                    icon: 'fa fa-table'
                },
                // {
                //     categoryName: 'Files to API',
                //     route: '/jsontoapi',
                //     icon: 'fa fa-table'
                // },
                {
                    categoryName: 'COBOL2API',
                    route: '/coboltoapi',
                    icon: 'fa fa-table'
                },
                {
                    categoryName: 'Data Transformation',
                    route: '/data-transform-plans',
                    icon: 'fa fa-random'
                },
                // {
                //     categoryName: 'Data Transformation Advanced',
                //     route: '/data-transform',
                //     icon: 'fa fa-random'
                // },
                // {
                //     categoryName: 'Data API to API',
                //     route: '/apitoapi',
                //     icon: 'fa fa-table'
                // }
            ]
        },
        // {
        //     'category': 'partner-info',
        //     'expand': true,
        //     'route': null,
        //     'subcategory': []
        // },
        // {
        //     'category': 'learn',
        //     'expand': true,
        //     'route': null,
        //     'subcategory': []
        // },
        {
            'category': 'reference',
            'route': '/docs',
            'expand': false
        },
        // {
        //     'category': 'register',
        //     'expand': true,
        //     'route': null,
        //     'subcategory': [
        //         {
        //             categoryName: 'API Register',
        //             route: '/api-register',
        //             icon: 'fa fa-book'
        //         },
        //         {
        //             categoryName: 'Postman Collection',
        //             route: '/postman-collections',
        //             icon: 'fa fa-rocket'
        //         },
        //     ]
        // },
        {
            'category': 'test',
            'route': '/devex',
            'expand': false,
            'subcategory': [
                {
                    categoryName: 'API Tester',
                    route: '/devex',
                    icon: 'fa fa-rocket'
                },
                {
                    categoryName: 'Test Suite',
                    route: '/testsuite',
                    icon: 'fa fa-check-circle-o'
                },
                {
                    categoryName: 'Test Suite Results',
                    route: '/test-results',
                    icon: 'fa fa-graduation-cap'
                },
                {
                    categoryName: 'APIQL Engine',
                    route: '/apiql',
                    icon: 'fa fa-cubes'
                },
                {
                    categoryName: 'DATAQL Engine',
                    route: '/dataql',
                    icon: 'fa fa-database'
                },
                {
                    categoryName: 'API Collection',
                    route: '/collection',
                    icon: 'fa fa-list-alt'
                }
            ]
        },
        {
            'category': 'manage',
            'expand': true,
            'route': null,
            'subcategory': []
        },
        {
            'category': 'tools',
            'expand': true,
            'route': null,
            'subcategory': [
                // {
                //     categoryName: 'API Tester/Registrar',
                //     route: '/devex',
                //     icon: 'fa fa-rocket'
                // },
                // {
                //     categoryName: 'Documentor',
                //     route: '/documentor',
                //     icon: 'fa fa-file'
                // },
                {
                    categoryName: 'Email Template Builder',
                    // route: '/emailtemplatebuilder',
                    route: '/email-templates',
                    icon: 'fa fa-envelope'
                },
                {
                    categoryName: 'Scheduler',
                    route: '/scheduler',
                    icon: 'fa fa-calendar'
                },
                {
                    categoryName: 'Trigger',
                    route: '/trigger',
                    icon: 'fa fa-bolt'
                },
                {
                    categoryName: 'Data Catalog',
                    route: '/datacatalog',
                    icon: 'fa fa-book',
                },
                {
                    categoryName: 'File Manager',
                    route: '/filestorage',
                    icon: 'fa fa-hdd-o'
                },
                // {
                //     categoryName: 'Alerts',
                //     route: '/alerts',
                //     icon: 'fa fa-bullhorn'
                // },
                // {
                //     categoryName: 'Content Development',
                //     route: '/uxbuilder',
                //     icon: 'fa fa-file-text-o'
                // },
                // {
                //     categoryName: 'API Registrar',
                //     route: '/devex',
                //     icon: 'fa fa-table'
                // }
            ]
        },
        {
            'category': 'Data Access API',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    'categoryName': 'Data Access API',
                    'route': null
                }
            ]
        },
        {
            'category': 'Settings',
            'expand': true,
            'route': null,
            'subcategory': [
                {
                    'categoryName': 'Business Details',
                    'route': '/businessdetails'
                },
                {
                    'categoryName': 'Branding',
                    'route': '/branding'
                },
                // {
                //     'categoryName': 'Accounts',
                //     'route': '/accounts'
                // },
                {
                    'categoryName': 'API Keys',
                    'route': '/api-key'
                },
                {
                    'categoryName': 'Business Locations',
                    'route': '/businesslocations'
                },
                {
                    'categoryName': 'Dashboard',
                    'route': '/dashboard'
                },
                {
                    'categoryName': 'Databases',
                    'route': '/databases'
                },
                {
                    'categoryName': 'Metrics',
                    'route': '/metrics'
                },
                {
                    'categoryName': 'IP Restrictions',
                    'route': '/ipconfig'
                },
                {
                    'categoryName': 'Identity Manager',
                    'route': '/identitymanager'
                },
                {
                    'categoryName': 'Credits',
                    'route': '/credits'
                }
            ]
        },
        {
            'category': 'Billing',
            'route': '/billing',
            'expand': false
        },
        {
            'category': 'logout',
            'route': null,
            'expand': false
        }
    ];
    JSONData: any = {};
    selectedMenu: any;

    businessLogicExecutors: any;
    sqlQueryExecutors: any;
    unifiedQueryExecutors: any;
    plsqlExecutors: any;
    testSuiteExecutors: any;
    workFlowExecutors: any;
    dataTransformationExecutors: any;

    apisByCategory: any;
    businessLogic = [];
    sql = [];
    workflow = [];
    decision = [];

    creationAccess = false;
    editAccess = false;
    deleteAccess = false;
    samplesAccess = false;
    promotionAccess = false;

    billingAccess = false;
    settingsAccess = false;

    environments = [];
    menus = [
        {
            validOn: 'admin',
            stickyMenus: [
                {
                    name: 'environments',
                    displayName: 'Environments',
                    tooltipText: 'Administration of environments, tools and infrastructure',
                    hasSubMenu: true,
                    submenus: [
                        {
                            categoryName: 'Admin',
                            route: '/administrator',
                            icon: 'fa fa-user'
                        },
                        {
                            categoryName: 'Development',
                            route: '/administrator',
                            icon: 'fa fa-building'
                        }
                    ],
                    displayType: 'block',
                    icon: 'fa fa-cogs',
                },
                // {
                //     name: 'infrastructure',
                //     displayName: 'Infra',
                //     tooltipText: 'Infrastructure Settings',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-building',
                //     submenus: [
                //         {
                //             categoryName: 'Cloud Platforms',
                //             route: '/cloudplatforms',
                //             icon: 'fa fa-cloud'
                //         },
                //         {
                //             categoryName: 'Environments',
                //             route: '/environment-settings',
                //             icon: 'fa fa-code-fork'
                //         },
                //         {
                //             categoryName: 'Secrets Managers',
                //             route: '/logging-settings',
                //             icon: 'fa fa-user-secret'
                //         },
                //         {
                //             categoryName: 'Gateway Managers',
                //             route: '/gateways',
                //             icon: 'fa fa-shield'
                //         },
                //         {
                //             categoryName: 'Databases',
                //             route: '/databases',
                //             icon: 'fa fa-database'
                //         }
                //     ]
                // },
                // {
                //     name: 'authorization',
                //     displayName: 'Auth',
                //     tooltipText: 'Authorize access of APIs',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-lock',
                //     submenus: [
                //         {
                //             categoryName: 'Roles',
                //             route: '/roles',
                //             icon: 'fa fa-id-card-o'
                //         },
                //         {
                //             categoryName: 'Permission Groups',
                //             route: '/permissiongroups',
                //             icon: 'fa fa-key'
                //         },
                //         {
                //             categoryName: 'Permissions',
                //             route: '/permissions',
                //             icon: 'fa fa-checksquare-o'
                //         },
                //         {
                //             categoryName: 'User Groups',
                //             route: '/usergroups',
                //             icon: 'fa fa-users'
                //         },
                //         {
                //             categoryName: 'Users',
                //             route: '/users',
                //             icon: 'fa fa-user'
                //         }
                //     ]
                // },
                {
                    name: 'partner settings',
                    displayName: 'Partner Settings',
                    tooltipText: 'Partner specific settings',
                    hasSubMenu: true,
                    displayType: 'block',
                    icon: 'fa fa-cog',
                    submenus: [
                        // {
                        //     categoryName: 'Accounts',
                        //     route: '/accounts',
                        //     icon: 'fa fa-user-plus'
                        // },
                        {
                            categoryName: 'Business Locations',
                            route: '/businesslocations',
                            icon: 'fa fa-globe'
                        },
                        {
                            categoryName: 'Business Details',
                            route: '/businessdetails',
                            icon: 'fa fa-building-o'
                        },
                        {
                            categoryName: 'Branding',
                            route: '/usergroups',
                            icon: 'fa fa-id-badge'
                        },
                        {
                            categoryName: 'Themes',
                            route: '/themes',
                            icon: 'fa fa-themeisle'
                        },
                        // {
                        //     categoryName: 'Gateway',
                        //     route: '/gateways',
                        //     icon: 'fa fa-key'
                        // },
                        {
                            categoryName: 'Security',
                            route: '/permissions',
                            icon: 'fa fa-shield'
                        },
                        {
                            categoryName: 'BOT',
                            route: '/usergroups',
                            icon: 'fa fa-commenting-o'
                        },
                        {
                            categoryName: 'API Creators',
                            route: '/users',
                            icon: 'fa fa-plus'
                        },
                        {
                            categoryName: 'API Transformers',
                            route: '/users',
                            icon: 'fa fa-exchange'
                        },
                        {
                            categoryName: 'API Integrators',
                            route: '/users',
                            icon: 'fa fa-user'
                        },
                        {
                            categoryName: 'API Management',
                            route: '/apimanagement',
                            icon: 'fa fa-cog'
                        },
                        {
                            categoryName: 'Manage Email Configurations',
                            route: '/email-settings',
                            icon: 'fa fa-cog'
                        },
                        {
                            categoryName: 'Idle Timeout Settings',
                            route: '/idle-timeout',
                            icon: 'fa fa-clock-o'
                        }
                        // {
                        //     categoryName: 'Developer Experience',
                        //     route: '/devex',
                        //     icon: 'fa fa-rocket'
                        // }
                    ]
                },
                {
                    name: 'billing',
                    displayName: 'Billing',
                    tooltipText: 'Billing',
                    hasSubMenu: false,
                    route: '/billing',
                    displayType: 'block',
                    icon: 'fa fa-usd',
                }
                // {
                //     name: 'billing',
                //     displayName: 'Billing',
                //     tooltipText: 'Billing Details',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-lock',
                //     submenus: [
                //         {
                //             categoryName: 'Billing',
                //             route: '/billing',
                //             icon: 'fa fa-usd'
                //         },
                //         {
                //             categoryName: 'Payments',
                //             route: '/permissiongroups',
                //             icon: 'fa fa-credit-card-alt'
                //         },
                //         // {
                //         //     categoryName: 'Invoices',
                //         //     route: '/permissions',
                //         //     icon: 'fa fa-files-o'
                //         // },
                //         // {
                //         //     categoryName: 'Subscriptions',
                //         //     route: '/usergroups',
                //         //     icon: 'fa fa-ticket'
                //         // },
                //         {
                //             categoryName: 'Coupons',
                //             route: '/users',
                //             icon: 'fa fa-money'
                //         },
                //         {
                //             categoryName: 'Credits',
                //             route: '/users',
                //             icon: 'fa fa-credit-card'
                //         }
                //     ]
                // }
            ]

        },
        {
            validOn: 'environments',
            stickyMenus: [
                // {
                //     name: 'control-plane',
                //     displayName: 'Control Plane',
                //     tooltipText: 'Control Plane',
                //     hasSubMenu: false,
                //     route: '/controlplane',
                //     displayType: 'block',
                //     icon: 'fa fa-image',
                // },
                // {
                //     name: 'api-discovery',
                //     displayName: 'Search',
                //     tooltipText: 'Discover APIs',
                //     hasSubMenu: false,
                //     route: '/discover',
                //     displayType: 'block',
                //     icon: 'fa fa-search',
                // },
                {
                    name: 'genai',
                    displayName: 'GenAI',
                    tooltipText: 'Generative AI Search',
                    hasSubMenu: true,
                    displayType: 'block',
                    icon: 'fa fa-yelp',
                    submenus: [
                        {
                            categoryName: 'Cognitive Search',
                            route: '/enterprise-search',
                            icon: 'fa fa-search'
                        },
                        {
                            categoryName: 'Data Analytic',
                            route: '/data-analytics',
                            icon: 'fa fa-pie-chart'
                        }
                    ]
                },
                {
                    name: 'creation',
                    displayName: 'Create',
                    tooltipText: 'Create APIs',
                    hasSubMenu: true,
                    displayType: 'block',
                    icon: 'fa fa-plus',
                    submenus: [
                        {
                            categoryName: 'Data as a Service',
                            route: '/dataaccessapi',
                            icon: 'fa fa-table'
                        },
                        {
                            categoryName: 'Data as a Service (Advanced)',
                            route: '/dataaccessapi-advanced',
                            icon: 'fa fa-table'
                        },
                        {
                            categoryName: 'Application Logic',
                            route: '/businesslogic',
                            icon: 'fa fa-link'
                        },
                        {
                            categoryName: 'Workflows',
                            route: '/workflow',
                            icon: 'fa fa-sitemap'
                        },
                        {
                            categoryName: 'Decisions',
                            route: '/dmn',
                            icon: 'fa fa-codepen'
                        },
                        {
                            categoryName: 'SQL as a Service',
                            route: '/querybuilder',
                            icon: 'fa fa-database'
                        },
                        {
                            categoryName: 'PLSQL as a Service',
                            route: '/plsql',
                            icon: 'fa fa-tasks'
                        },
                        {
                            categoryName: 'API Joins',
                            route: '/unified-query-builder',
                            icon: 'fa fa-server'
                        },
                        {
                            categoryName: 'API Collections',
                            route: '/collections',
                            icon: 'fa fa-object-group'
                        },
                        {
                            categoryName: 'Test Suite as a Service',
                            route: '/testsuite',
                            icon: 'fa fa-check-circle-o'
                        },
                    ]
                },
                {
                    name: 'connect',
                    displayName: 'Integrate',
                    tooltipText: 'Integrate APIs',
                    hasSubMenu: true,
                    displayType: 'block',
                    icon: 'fa fa-anchor',
                    submenus: [
                        {
                            categoryName: 'API Providers',
                            route: '/providers',
                            icon: 'fa fa-table'
                        },
                        {
                            categoryName: 'API Provider Categories',
                            route: '/provider-category',
                            icon: 'fa fa-table'
                        },
                        {
                            categoryName: 'Accelerators',
                            route: '/accelerators',
                            icon: 'send_time_extension',
                            iconType: 'mat-icon'
                        },
                        {
                            categoryName: 'Database Connectors',
                            route: '/databases',
                            icon: 'fa fa-database'
                        },
                        {
                            categoryName: 'API Register',
                            route: '/api-register',
                            icon: 'fa fa-book'
                        },
                        {
                            categoryName: 'Postman Collection',
                            route: '/postman-collections',
                            icon: 'fa fa-rocket'
                        },
                        // {
                        //     categoryName: 'Marketplace',
                        //     route: '/common-data-api',
                        //     icon: 'fa fa-table'
                        // }
                    ]
                },
                {
                    name: 'transform',
                    displayName: 'Transform',
                    tooltipText: 'Transform APIs',
                    hasSubMenu: true,
                    displayType: 'block',
                    icon: 'fa fa-random',
                    submenus: [
                        {
                            categoryName: 'Design2API',
                            route: '/application',
                            icon: 'fa fa-table'
                        },
                        {
                            categoryName: 'Data2API',
                            route: '/datacatalog',
                            icon: 'fa fa-table'
                        },
                        // {
                        //     categoryName: 'Files to API',
                        //     route: '/jsontoapi',
                        //     icon: 'fa fa-table'
                        // },
                        {
                            categoryName: 'COBOL2API',
                            route: '/coboltoapi',
                            icon: 'fa fa-table'
                        },
                        {
                            categoryName: 'Data Transformation',
                            route: '/data-transform-plans',
                            icon: 'fa fa-random'
                        },
                        ,
                        // {
                        //     categoryName: 'Data Transformation Advanced',
                        //     route: '/data-transform',
                        //     icon: 'fa fa-random'
                        // },
                        // {
                        //     categoryName: 'DataAPI to API',
                        //     route: '/apitoapi',
                        //     icon: 'fa fa-table'
                        // }
                    ]
                },
                // {
                //     name: 'register',
                //     displayName: 'Register',
                //     tooltipText: 'Register',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-book',
                //     submenu: [
                //         {
                //             name: 'API Register',
                //             route: '/api-register',
                //             icon: 'fa fa-book'
                //         },
                //         {
                //             name: 'Postman Collection',
                //             route: '/postman-collections',
                //             icon: 'fa fa-rocket'
                //         },
                //     ]
                // },
                // {
                //     name: 'reference',
                //     displayName: 'Reference',
                //     tooltipText: 'API Reference',
                //     hasSubMenu: false,
                //     route: '/docs',
                //     displayType: 'block',
                //     icon: 'fa fa-file-code-o',
                // },
                {
                    name: 'test',
                    displayName: 'Test',
                    tooltipText: 'Test',
                    hasSubMenu: true,
                    route: '/devex',
                    displayType: 'block',
                    icon: 'fa fa-rocket',
                    submenus: [
                        {
                            name: 'Devex',
                            route: '/devex',
                            icon: 'fa fa-book'
                        }, {
                            name: 'Test Suite',
                            route: '/testsuite',
                            icon: 'fa fa-check-circle-o'
                        }, {
                            name: 'Test-suite Results',
                            route: '/test-results',
                            icon: 'fa fa-graduation-cap'
                        },
                        {
                            name: 'Register from Postman Collection',
                            route: '/provider-category',
                            icon: 'fa fa-rocket'
                        },
                    ]
                },
                {
                    name: 'manage',
                    displayName: 'Manage',
                    tooltipText: 'Manage your APIs',
                    hasSubMenu: true,
                    displayType: 'list',
                    icon: 'fa fa-tasks',
                    submenus: [
                        {
                            name: 'Data Access API'
                        },
                        {
                            name: 'Business Logic API'
                        },
                        {
                            name: 'Open API'
                        },
                        {
                            name: 'COBOL to API'
                        },
                        {
                            name: 'Database to API'
                        },
                        {
                            name: 'Query Builder'
                        },
                        {
                            name: 'API Query Builder'
                        },
                        {
                            name: 'PLSQL Builder'
                        },
                        {
                            name: 'Email Template Builder'
                        },
                        {
                            name: 'Workflow Builder'
                        },
                        {
                            name: 'Decision Builder'
                        },
                        {
                            name: 'Documentor'
                        },
                        {
                            name: 'API Collection'
                        },
                        {
                            name: 'UX Builder'
                        }
                    ]
                },
                {
                    name: 'tools',
                    displayName: 'Tools',
                    tooltipText: 'Tools',
                    hasSubMenu: true,
                    displayType: 'block',
                    icon: 'fa fa-connectdevelop',
                    submenu: [
                        {
                            name: 'API tester',
                            route: '/devex',
                            icon: 'fa fa-table'
                        },
                        // {
                        //     name: 'API Documentor',
                        //     route: '/devex',
                        //     icon: 'fa fa-table'
                        // },
                        // {
                        //     name: 'Content Development',
                        //     route: '/devex',
                        //     icon: 'fa fa-table'
                        // },
                        {
                            name: 'API Registrar',
                            route: '/devex',
                            icon: 'fa fa-table'
                        },
                        {
                            name: 'Scheduler',
                            route: '/scheduler',
                            icon: 'fa fa-calendar'
                        }
                    ]
                },
                // {
                //     name: 'samples',
                //     displayName: 'Samples',
                //     tooltipText: 'Samples',
                //     hasSubMenu: false,
                //     route: '/samples',
                //     displayType: 'block',
                //     icon: 'fa fa-free-code-camp',
                // },
                // {
                //     name: 'learn',
                //     displayName: 'Learn',
                //     tooltipText: 'Learn',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-graduation-cap',
                //     submenu: []
                // },
                // {
                //     name: 'settings',
                //     displayName: 'Settings',
                //     tooltipText: 'Settings',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-cog',
                //     submenu: []
                // },
                // {
                //     name: 'journey',
                //     displayName: 'Journey',
                //     tooltipText: 'Journey Analytics',
                //     hasSubMenu: false,
                //     route: '/journey',
                //     displayType: 'block',
                //     icon: 'fa fa-line-chart',
                // },
                // {
                //     name: 'partner-info',
                //     displayName: 'Partner Info',
                //     tooltipText: 'Partner Info',
                //     hasSubMenu: true,
                //     displayType: 'block',
                //     icon: 'fa fa-info',
                //     submenu: []
                // },
            ]
        }
    ];
    isDevEnvironmentFromAdmin = false;
    isAdminForPartner = false;
    configurationsForEnvCreation = {};
    cloneableData: any;

    createFrom = {
        'category': 'create from',
        'expand': true,
        'route': null,
        'subcategory': []
    };

    currentSession: any;

    idOfCurrentSession: number;
    actionsOfCurrentSession = [];

    // auditLog variables

    // auth

    // dataaccess


    auditLogPermissions = {
        isAuditForAuth: true,
        isAuditForDataAccess: true,
        isAuditForDataAccessAdvanced: true,
        isAuditForBusinessLogic: true,
        isAuditForSQLQuery: true,
        isAuditForPermissions: true,
        isAuditForAPIIntegrations: true,
        isAuditForDevex: true,
        isAuditForNotifyErrorToAdmins: true,
        isAuditForFileManager: true,
        isAuditForDataCatalog: true,
        isAuditForDigitalTransformer: true,
        isAuditForDeploymentPlan: true,
        isAuditForScheduler: true,
        isAuditForEmailTemplates: true,
        isAuditForLogout: true,
        isAuditForLeftPanel: true,

        login_submit_next_clicked: true,
        login_submit_next_success: true,
        login_submit_next_failed: true,
        signup_submit_next_clicked: true,
        signup_submit_next_success: true,
        signup_submit_next_failed: true,
        signup_submit_verifyotp_clicked: true,
        signup_submit_resendotp_clicked: true,
        signup_submit_resendotp_success: true,
        signup_submit_resendotp_failed: true,
        signup_onboarding_resendverificationlink_success: true,
        signup_onboarding_resendverificationlink_failed: false,
        signup_onboarding_notifyerrortoadmins_success: true,
        signup_onboarding_notifyerrortoadmins_failed: true,
        signup_onboarding_dnsvalidation_success: true,
        signup_onboarding_dnsvalidation_failed: true,
        signup_onboarding_environmentrecreation_success: true,
        signup_onboarding_environmentrecreation_failed: true,
        signup_onboarding_patchadminpartnersettings_failed: true,
        signup_onboarding_patchadminpartnersettings_success: true,
        signup_onboarding_environmentcreation_success: true,
        signup_onboarding_environmentcreation_failed: true,
        signup_onboarding_configureapikeyauthentication_failed: true,
        signup_onboarding_usercreation_success: true,
        signup_onboarding_usercreation_failed: true,
        signup_onboarding_rolecreation_success: true,
        signup_onboarding_rolecreation_failed: true,
        signup_onboarding_settingscreation_success: true,
        signup_onboarding_settingscreation_failed: true,
        signup_onboarding_executeemail_failed: true,
        signup_onboarding_executeemail_success: true,

        dataaccessapi_create_deploy_clicked: true,
        dataaccessapi_create_deploy_success: true,
        dataaccessapi_create_deploy_failed: true,
        dataaccessapi_edit_redeploy_clicked: true,
        dataaccessapi_edit_redeploy_success: true,
        dataaccessapi_edit_redeploy_failed: true,
        dataaccessapi_create_save_clicked: true,
        dataaccessapi_create_save_success: true,
        dataaccessapi_create_save_failed: true,
        dataaccessapi_edit_save_clicked: true,
        dataaccessapi_edit_save_success: true,
        dataaccessapi_edit_save_failed: true,

        businesslogic_create_deploy_clicked: true,
        businesslogic_create_deploy_success: true,
        businesslogic_create_deploy_failed: true,
        businesslogic_edit_redeploy_clicked: true,
        businesslogic_edit_redeploy_success: true,
        businesslogic_edit_redeploy_failed: true,
        businesslogic_debug_test_clicked: true,
        businesslogic_create_save_clicked: true,
        businesslogic_create_save_success: true,
        businesslogic_create_save_failed: true,
        businesslogic_edit_save_clicked: true,
        businesslogic_edit_save_success: true,
        businesslogic_edit_save_failed: true,

        sqlquery_create_deploy_clicked: true,
        sqlquery_create_deploy_success: true,
        sqlquery_create_deploy_failed: true,
        sqlquery_edit_redeploy_clicked: true,
        sqlquery_edit_redeploy_success: true,
        sqlquery_edit_redeploy_failed: true,
        sqlquery_statement_execute_clicked: true,
        sqlquery_statement_execute_success: true,
        sqlquery_statement_execute_failed: true,
        sqlquery_script_execute_clicked: true,
        sqlquery_script_execute_success: true,
        sqlquery_script_execute_failed: true,
        sqlquery_create_save_clicked: true,
        sqlquery_create_save_success: true,
        sqlquery_create_save_failed: true,
        sqlquery_edit_save_clicked: true,
        sqlquery_edit_save_success: true,
        sqlquery_edit_save_failed: true,

        dataaccessapi_delete_clicked: true,
        dataaccessapi_delete_success: true,
        dataaccessapi_delete_failed: true,
        dataaccessapi_data_delete_success: true,
        dataaccessapi_data_delete_failed: true,
        dataaccessapi_apiexecutors_delete_success: true,
        dataaccessapi_apiexecutors_delete_failed: true,
        dataaccessapi_gatewayconfigurations_delete_success: true,
        dataaccessapi_gatewayconfigurations_delete_failed: true,

        businesslogic_delete_clicked: true,
        businesslogic_delete_success: true,
        businesslogic_delete_failed: true,
        businesslogic_apiexecutors_delete_success: true,
        businesslogic_apiexecutors_delete_failed: true,
        businesslogic_gatewayconfigurations_delete_success: true,
        businesslogic_gatewayconfigurations_delete_failed: true,

        sqlquery_delete_clicked: true,
        sqlquery_delete_success: true,
        sqlquery_delete_failed: true,
        sqlquery_apiexecutors_delete_success: true,
        sqlquery_apiexecutors_delete_failed: true,
        sqlquery_gatewayconfigurations_delete_success: true,
        sqlquery_gatewayconfigurations_delete_failed: true,

        thirdparty_delete_clicked: true,
        thirdparty_delete_success: true,
        thirdparty_delete_failed: true,
        thirdparty_apiexecutors_delete_success: true,
        thirdparty_apiexecutors_delete_failed: true,
        thirdparty_gatewayconfigurations_delete_success: true,
        thirdparty_gatewayconfigurations_delete_failed: true,

        workflow_delete_clicked: true,
        workflow_delete_success: true,
        workflow_delete_failed: true,
        workflow_apiexecutors_delete_success: true,
        workflow_apiexecutors_delete_failed: true,
        workflow_gatewayconfigurations_delete_success: true,
        workflow_gatewayconfigurations_delete_failed: true,

        dmn_delete_clicked: true,
        dmn_delete_success: true,
        dmn_delete_failed: true,
        dmn_apiexecutors_delete_success: true,
        dmn_apiexecutors_delete_failed: true,
        dmn_gatewayconfigurations_delete_success: true,
        dmn_gatewayconfigurations_delete_failed: true,

        testsuite_delete_clicked: true,
        testsuite_delete_success: true,
        testsuite_delete_failed: true,
        testsuite_apiexecutors_delete_success: true,
        testsuite_apiexecutors_delete_failed: true,
        testsuite_gatewayconfigurations_delete_success: true,
        testsuite_gatewayconfigurations_delete_failed: true,

        serviceprovider_activate_success: true,
        serviceprovider_activate_failed: true,
        serviceprovider_deactivate_success: true,
        serviceprovider_deactivate_failed: true,
        serviceprovider_provider_create_success: true,
        serviceprovider_provider_create_failed: true,
        serviceprovider_providercategory_patch_success: true,
        serviceprovider_providercategory_patch_failed: true,
        serviceprovider_category_create_success: true,
        serviceprovider_category_create_failed: true,
        serviceprovider_connector_create_success: true,
        serviceprovider_connector_create_failed: true,
        serviceprovider_connector_delete_success: true,
        serviceprovider_connector_delete_failed: true,
        serviceprovider_connector_delete_clicked: true,
        serviceprovider_connector_test_success: true,
        serviceprovider_connector_test_failed: true,
        serviceprovider_connector_test_clicked: true,

        devex_tester_execute_clicked: true,
        devex_tester_execute_success: true,
        devex_tester_execute_failed: true,
        devex_tester_update_clicked: true,
        devex_tester_update_success: true,
        devex_tester_update_failed: true,
        devex_register_apiplatform_clicked: true,
        devex_register_apiplatform_success: true,
        devex_register_apiplatform_failed: true,
        devex_register_asis_clicked: true,
        devex_register_asis_success: true,
        devex_register_asis_failed: true,

        signup_onboarding_checkpartnershortcodeexistence_success: true,
        signup_onboarding_checkpartnershortcodeexistence_failed: true,
        signup_onboarding_getpartnerkey_failed: true,
        signup_onboarding_getpartnerkey_success: true,
        signup_onboarding_createconsumerinapigateway_failed: true,
        signup_onboarding_createconsumerinapigateway_success: true,
        signup_onboarding_createdefaultconsumerinapigateway_failed: true,
        signup_onboarding_createdefaultconsumerinapigateway_success: true,
        signup_onboarding_configureapikeyauthentication_success: true,
        signup_onboarding_partnercreation_success: true,
        signup_onboarding_partnercreation_failed: true,
        signup_onboarding_updateonboardingtoken_success: true,
        signup_onboarding_updateonboardingtoken_failed: true,
        signup_onboarding_getapikey_failed: true,
        signup_onboarding_getapikey_success: true,

        filemanager_uploadfile_clicked: true,
        filemanager_uploadfile_success: true,
        filemanager_uploadfile_failed: true,
        filemanager_uploadfolder_clicked: true,
        filemanager_uploadfolder_success: true,
        filemanager_uploadfolder_failed: true,
        filemanager_createfolder_clicked: true,
        filemanager_createfolder_success: true,
        filemanager_createfolder_failed: true,
        filemanager_deletefolder_clicked: true,
        filemanager_deletefolder_success: true,
        filemanager_deletefolder_failed: true,
        filemanager_deletefile_clicked: true,
        filemanager_deletefile_success: true,
        filemanager_deletefile_failed: true,

        datacatalog_dictionary_update_clicked: true,
        datacatalog_dictionary_update_success: true,
        datacatalog_dictionary_update_failed: true,
        datacatalog_deployasapi_showdeploymentplan_clicked: true,
        datacatalog_deployasapi_showdeploymentplan_success: true,
        datacatalog_deployasapi_showdeploymentplan_failed: true,

        digitaltransformer_listdatabaseobjects_clicked: true,
        digitaltransformer_listdatabaseobjects_success: true,
        digitaltransformer_listdatabaseobjects_failed: true,
        digitaltransformer_showdeploymentplan_clicked: true,
        digitaltransformer_showdeploymentplan_success: true,
        digitaltransformer_showdeploymentplan_failed: true,

        deploymentplan_deploy_clicked: true,
        deploymentplan_deploy_success: true,
        deploymentplan_deploy_failed: true,
        deploymentplan_transform_clicked: true,
        deploymentplan_transform_success: true,
        deploymentplan_transform_failed: true,

        scheduler_schedule_clicked: true,
        scheduler_schedule_success: true,
        scheduler_schedule_failed: true,
        scheduler_reschedule_clicked: true,
        scheduler_reschedule_success: true,
        scheduler_reschedule_failed: true,
        scheduler_resume_clicked: true,
        scheduler_resume_success: true,
        scheduler_resume_failed: true,
        scheduler_pause_clicked: true,
        scheduler_pause_success: true,
        scheduler_pause_failed: true,
        scheduler_delete_clicked: true,
        scheduler_delete_success: true,
        scheduler_delete_failed: true,
        scheduler_edit_clicked: true,
        scheduler_edit_success: true,
        scheduler_edit_failed: true,

        logout_clicked: true,
        logout_success: true,

    };

    auditFeatureArea = {
        dass: 'DATA_ACCESS_API',
        daasAdvanced: 'DATA_ACCESS_API_ADVANCED',
        businessLogic: 'APPLICATION_LOGIC_API',
        queryBuilder: 'QUERY_BUILDER_API',
        plsql: 'PLSQL_API',
        apiJoins: 'API_JOINS',
        workflow: 'WORKFLOW_API',
        tester: 'API_TESTER',
        controlplane: 'CONTROL_PLANE',
        api_register: 'API_REGISTER'
    };

    auditLabels = {
        api_create: 'API_DEPLOY',
        api_update: 'API_REDEPLOY'
    };
    auditCategories = {
        api_deploy_redeploy: [this.auditLabels.api_create, this.auditLabels.api_update]
    };

    // Platform common data providers
    commonsEntities: any;
    templatesEntities: any;
    samplesEntities: any;
    partnerEntities: any;
    partnerEntityTypes = [];
    partnerCategories: any;

    commonsAdminEntities: any;
    templatesAdminEntities: any;
    samplesAdminEntities: any;
    servicesAdminEntities: any;
    partnerAdminEntities: any;

    templatesExecutors: any;
    samplesExecutors: any;
    partnerExecutors: any;

    apiExecutors: any;
    countOfApplications = 0;
    countOfApiExecutors = 0;
    countOfBusinessLogicApis = 0;
    thirdPartyApiExecutors: any;
    countOfThirdPartyApis = 0;
    countOfSqlQueryApis = 0;
    countOfUnifiedQueryApis = 0;
    countOfPlSqlApis = 0;
    countOfTestSuiteApis = 0;
    countOfWorkflowApis = 0;
    countOfDataTransformationApis = 0;
    countOfDmnApis = 0;
    dmnExecutors: any;
    b2bExecutors: any;
    myProviderExecutors: any;
    allExecutorsButDaaS = [];
    providerObjects = {};

    executorLoadingInLeftPanel = false;

    languages: any;
    databases: any;
    datatypes: any;
    apiGateways: any;
    countPartnerEntities: any;
    countPartnerAccountEntities: any;
    categoriesEntitiesForPartner: any;

    item = [];
    url = environment.konghost;
    gatewayUrl: any;
    keyAuthId: any;
    botDetectionId: any;
    cors: any;
    corsId: any;
    acl: any;
    aclId: any;
    rateLimitingId: any;
    requestTerminationId: any;
    requestSizeLimitingId: any;
    ipRestrictionId: any;
    gatewayService: any;
    serviceId: any;
    gatewayRoutes: any;
    gatewayPlugins: any;
    routes: any;
    pathRouteId: any;
    hostRouteId: any;
    pathRouteRateLimitingPluginId: any;
    hostRouteRateLimitingPluginId: any;
    pathRoutePlugins: any;
    hostRoutePlugins: any;
    pathRouteKeyAuthPluginId: any;
    hostRouteKeyAuthPluginId: any;
    error = false;
    errorMessage: string;

    cloudWatchNoOfHits: any;
    cloudWatchLatency: any;
    maxCount: any;
    countOfDataAccessServices = 0;
    listOfDataAccessServices: any;
    entityAndVersion: any;
    authorizationTypes: any;
    registeredConnectors: any;
    queryBuilderAttributes: any;

    platformServiceProviders: any;
    partnerServiceProviders: any;
    settingsData: any;
    apiList: any;
    apiProducers = [];
    defaultGatewayURL: any;

    settingsDataWithoutDBRef: any;

    defaultDatabaseConfiguration = {
        database_name: 'default',
        database_type: 'mongodb',
        region: '',
        database_attributes: {},
        is_default: true,
        audit_logs: [
            {
                action: 'CREATE',
                by: localStorage.getItem('signInEmail'),
                at: 1601280370723
            }
        ]
    };

    settingsPayloadToInsert = {
        partner: '',
        account: '',
        email: '',
        phone_number: '',
        environments: [],
        is_enabled: true,
        subscriptions: {
            providers: [],
            platform_services: [],
            platform_service_categories: []
        },
        logo: '',
        brand_image: ''
    };

    apiKeyData: any;
    apiKey: any;
    apiKeys: any;

    captchaSiteKey: string;
    captcha: string;
    leftPanelLoading = false;
    isSaving = false;
    apiHistory: any;
    isHistoryAvailable = false;
    checkForExistingEntitiesAndExecutorsCount = 0;
    deleteDialog: any;
    apiHistoryInsertCount = 0;
    // @Output() changeInLeftPanelDataV2: EventEmitter<any> = new EventEmitter();
    // @Output() saveEntityAndExecutors: EventEmitter<any> = new EventEmitter();

    databasesMeta: any;
    databasesMetaDefault = [
        {
            'database_name': '',
            'display_name': 'MongoDB',
            'image': './assets/img/partnerOnboarding/mongoDB.png',
            'database_type': 'mongodb',
            'is_nosql': true,
            'database_attributes': [
                {
                    'name': 'username',
                    'display_name': 'Username',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'host',
                    'display_name': 'Host',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'port',
                    'display_name': 'Port',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'dbName',
                    'display_name': 'Database Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        },
        {
            'database_name': '',
            'database_type': 'dynamodb',
            'display_name': 'DynamoDB',
            'image': './assets/img/partnerOnboarding/dynamoDB.png',
            'is_nosql': true,
            'database_attributes': [
                {
                    'name': 'access_key',
                    'display_name': 'Access Key',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'secret_key',
                    'display_name': 'Secret Key',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'region',
                    'display_name': 'Region',
                    'description': '',
                    'required': false
                }
            ]
        },
        {
            'database_name': '',
            'database_type': 'csv',
            'display_name': 'CSV',
            'is_default': false,
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'url',
                    'display_name': 'Url',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'name',
                    'display_name': 'Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'separator',
                    'display_name': 'Separator',
                    'description': '',
                    'required': false
                }
            ]

        },
        {
            'database_name': '',
            'database_type': 'oracle',
            'display_name': 'Oracle',
            'image': './assets/img/partnerOnboarding/oracle.png',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'username',
                    'display_name': 'Username',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'host',
                    'display_name': 'Host',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'port',
                    'display_name': 'Port',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'dbName',
                    'display_name': 'Database Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        },
        {
            'database_name': '',
            'database_type': 'mysql',
            'display_name': 'MySQL',
            'image': './assets/img/partnerOnboarding/mySQL.png',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'username',
                    'display_name': 'Username',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'host',
                    'display_name': 'Host',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'port',
                    'display_name': 'Port',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'dbName',
                    'display_name': 'Database Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        },
        {
            'database_name': '',
            'database_type': 'sqlserver',
            'display_name': 'MS SQL Server',
            'image': './assets/img/partnerOnboarding/msSQL.jpg',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'username',
                    'display_name': 'Username',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'host',
                    'display_name': 'Host',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'port',
                    'display_name': 'Port',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'dbName',
                    'display_name': 'Database Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        },
        {
            'database_name': '',
            'database_type': 'postgresql',
            'display_name': 'PostgreSQL',
            'image': './assets/img/partnerOnboarding/postgreySQL.png',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'username',
                    'display_name': 'Username',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'host',
                    'display_name': 'Host',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'port',
                    'display_name': 'Port',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'dbName',
                    'display_name': 'Database Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        },
        {
            'database_name': '',
            'database_type': 'cosmosdb',
            'display_name': 'CosmosDB',
            'image': './assets/img/partnerOnboarding/cosmosDB.png',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'accountName',
                    'display_name': 'Account Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'accountKey',
                    'display_name': 'Account Key',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'tableEndpoint',
                    'display_name': 'Table Endpoint',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'endpointProtocol',
                    'display_name': 'Endpoint Protocol',
                    'description': '',
                    'required': false
                }
            ]
        },
        {
            'database_name': '',
            'database_type': 'aurora-mysql',
            'display_name': 'Aurora (MySQL)',
            'image': './assets/img/partnerOnboarding/aurora.png',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'username',
                    'display_name': 'Username',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'host',
                    'display_name': 'Host',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'port',
                    'display_name': 'Port',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'dbName',
                    'display_name': 'Database Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        },
        {
            'database_name': '',
            'database_type': 'aurora-postgresql',
            'display_name': 'Aurora (Postgresql)',
            'image': './assets/img/partnerOnboarding/aurora.png',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'username',
                    'display_name': 'Username',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'host',
                    'display_name': 'Host',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'port',
                    'display_name': 'Port',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'dbName',
                    'display_name': 'Database Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        },
        {
            'database_name': '',
            'database_type': 'db2',
            'display_name': 'DB2',
            'image': './assets/img/partnerOnboarding/aurora.png',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'username',
                    'display_name': 'Username',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'host',
                    'display_name': 'Host',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'port',
                    'display_name': 'Port',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'dbName',
                    'display_name': 'Database Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        },
        {
            'database_name': '',
            'database_type': 'snowflake',
            'display_name': 'Snowflake',
            'image': './assets/img/partnerOnboarding/snowflake.png',
            'is_nosql': false,
            'database_attributes': [
                {
                    'name': 'account_name',
                    'display_name': 'Account Name',
                    'description': '',
                    'required': true
                },
                {
                    'name': 'user',
                    'display_name': 'User',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'password',
                    'display_name': 'Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'authenticator',
                    'display_name': 'Authenticator',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'token',
                    'display_name': 'Token',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'role',
                    'display_name': 'Role',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'db',
                    'display_name': 'Database',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'schema',
                    'display_name': 'Schema',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'warehouse',
                    'display_name': 'Warehouse',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'tracing',
                    'display_name': 'Tracing',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'passcode',
                    'display_name': 'Passcode',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'passcodeInPassword',
                    'display_name': 'Passcode In Password',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'loginTimeout',
                    'display_name': 'Login Timeout',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'networkTimeout',
                    'display_name': 'Network Timeout',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'queryTimeout',
                    'display_name': 'Query Timeout',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'application',
                    'display_name': 'Application',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'disableSocksProxy',
                    'display_name': 'Disable Socks Proxy',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'stringsQuotedForColumnDef',
                    'display_name': 'Strings Quoted For Column Def',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'CLIENT_SESSION_KEEP_ALIVE',
                    'display_name': 'CLIENT_SESSION_KEEP_ALIVE',
                    'description': '',
                    'required': false
                },
                {
                    'name': 'connectionString',
                    'display_name': 'Connection String',
                    'description': '',
                    'required': false
                },
            ]
        }
    ];

    loadingForTheFirstTime = true;
    loadingForTheFirstTimeCompleted = false;
    progressMessage = '';
    progress = 0;
    incr = 4;
    defaultGatewaySettings = [{
        'name': 'key-auth',
        'isConfigured': false,
        'img': '/assets/img/key-auth.png',
        'description': 'Configure KeyAuth service..',
        'tagline': 'Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests.',
        'config': [
            {
                'displayName': 'Key Names',
                'parameter': 'key_names',
                'type': 'array_string',
                'value': 'apikey',
                'isRequired': true,
                'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
                    'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
            },
            {
                'displayName': 'Key In Body',
                'parameter': 'key_in_body',
                'type': 'boolean',
                'value': false,
                'isRequired': false,
                'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
            },
            {
                'displayName': 'Hide Credentials',
                'parameter': 'hide_credentials',
                'type': 'boolean',
                'value': false,
                'isRequired': false,
                'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
            },
            {
                'displayName': 'Run On Preflight',
                'parameter': 'run_on_preflight',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
            },
            // {
            //   'displayName': 'Anonymous',
            //   'parameter': 'anonymous',
            //   'type': 'string',
            //   'value': '',
            //     'isRequired': false,
            //     'description': 'An optional string (Consumer UUID) value to use as an anonymous Consumer if authentication fails. If empty (default), the request will fail with an authentication failure 4xx. Note that this value must refer to the Consumer id attribute that is internal to Kong, and not its custom_id'
            // },
            {
                'displayName': 'Key In Header',
                'parameter': 'key_in_header',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
            },
            {
                'displayName': 'Key In Query',
                'parameter': 'key_in_query',
                'type': 'boolean',
                'value': true,
                'isRequired': false,
                'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
            },
        ],
        'id': 9,
        'itemName': 'key-auth'
    },
        {
            'name': 'cors',
            'isConfigured': false,
            'img': 'assets/img/cors.png',
            'description': 'Configure CORS service.',
            'tagline': 'Allow developers to make requests from the browser',
            'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                    'displayName': 'Origins',
                    'parameter': 'origins',
                    'type': 'array_string',
                    'value': '*',
                    'isRequired': false,
                    'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
                },
                {
                    'displayName': 'Headers',
                    'parameter': 'headers',
                    'type': 'array_string',
                    'value': null,
                    'isRequired': false,
                    'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
                },
                {
                    'displayName': 'Exposed Headers',
                    'parameter': 'exposed_headers',
                    'type': 'array_string',
                    'value': null,
                    'isRequired': false,
                    'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
                },
                {
                    'displayName': 'Methods',
                    'parameter': 'methods',
                    'type': 'array_string',
                    'value': null,
                    'isRequired': false,
                    'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
                },
                {
                    'displayName': 'Max Age',
                    'parameter': 'max_age',
                    'type': 'number',
                    'value': 300,
                    'isRequired': false,
                    'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
                },
                {
                    'displayName': 'Credentials',
                    'parameter': 'credentials',
                    'type': 'boolean',
                    'value': false,
                    'isRequired': true,
                    'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
                },
                {
                    'displayName': 'Preflight Continue',
                    'parameter': 'preflight_continue',
                    'type': 'boolean',
                    'value': false,
                    'isRequired': true,
                    'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
                }
            ],
            'id': 11,
            'itemName': 'cors'
        },
        {
            'name': 'ip-restriction',
            'isConfigured': false,
            'img': 'assets/img/ip-restriction.png',
            'description': 'Configure IP Restriction service.',
            'tagline': 'Whitelist or blacklist IPs that can make requests',
            'config': [
                // {
                //   'parameter': 'consumerID',
                //   'type': 'string',
                //   'value': '',
                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                // },
                {
                    'displayName': 'Allow',
                    'parameter': 'allow',
                    'type': 'array_string',
                    'value': '127.0.0.1',
                    'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
                },
                {
                    'displayName': 'Deny',
                    'parameter': 'deny',
                    'type': 'array_string',
                    'value': null,
                    'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
                }
            ],
            'id': 12,
            'itemName': 'ip-restriction'
        },
        {
            'name': 'rate-limiting',
            'isConfigured': false,
            'img': '/assets/img/rate-limiting.png',
            'description': 'Configure Rate limiting service.',
            'tagline': ' Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured.',
            'config': [
                {
                    'displayName': 'Second',
                    'parameter': 'second',
                    'type': 'number',
                    'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per second'
                },
                {
                    'displayName': 'Minute',
                    'parameter': 'minute',
                    'type': 'number',
                    'value': 5,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per minute'
                },
                {
                    'displayName': 'Hour',
                    'parameter': 'hour',
                    'type': 'number',
                    'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per hour'
                },
                {
                    'displayName': 'Day',
                    'parameter': 'day',
                    'type': 'number',
                    'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per day'
                },
                {
                    'displayName': 'Month',
                    'parameter': 'month',
                    'type': 'number',
                    'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per month'
                },
                {
                    'displayName': 'Year',
                    'parameter': 'year',
                    'type': 'number',
                    'value': null,
                    'isRequired': false,
                    'description': 'The number of HTTP requests that can be made per year'
                },
                {
                    'displayName': 'Limit By',
                    'parameter': 'limit_by',
                    'type': 'string',
                    'value': 'consumer',
                    'isRequired': false,
                    'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
                },
                {
                    'displayName': 'Policy',
                    'parameter': 'policy',
                    'type': 'string',
                    'value': 'local',
                    'isRequired': false,
                    'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
                        '\n' +
                        'In Konnect Cloud, the default policy is redis'
                },
                {
                    'displayName': 'Fault Tolerant',
                    'parameter': 'fault_tolerant',
                    'type': 'boolean',
                    'value': true,
                    'isRequired': false,
                    'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
                },
                {
                    'displayName': 'Hide Client Headers',
                    'parameter': 'hide_client_headers',
                    'type': 'boolean',
                    'value': false,
                    'isRequired': false,
                    'description': 'Optionally hide informative response headers'
                },
                {
                    'displayName': 'Redis Host',
                    'parameter': 'redis_host',
                    'type': 'string',
                    'value': 'localhost',
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the address to the Redis server'
                },
                {
                    'displayName': 'Redis Password',
                    'parameter': 'redis_password',
                    'type': 'string',
                    'value': '',
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
                },
                {
                    'displayName': 'Redis Port',
                    'parameter': 'redis_port',
                    'type': 'number',
                    'value': 6379,
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
                },
                {
                    'displayName': 'Redis Timeout',
                    'parameter': 'redis_timeout',
                    'type': 'number',
                    'value': 2000,
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
                },
                {
                    'displayName': 'Redis Database',
                    'parameter': 'redis_database',
                    'type': 'number',
                    'value': 0,
                    'isRequired': false,
                    'description': 'When using the redis policy, this property specifies the Redis database to use'
                },
                // {
                //   'displayName': 'Header Name',
                //   'parameter': 'header_name',
                //   'type': 'string',
                //   'value': '',
                //     'isRequired': false,
                //     'description': 'Header name to be used if limit_by is set to header'
                // },
                // {
                //   'displayName': 'Path',
                //   'parameter': 'path',
                //   'type': 'string',
                //   'value': '',
                //   'isRequired': false,
                //   'description': 'Path to be used if limit_by is set to path'
                // },
            ],
            'id': 18,
            'itemName': 'rate-limiting'
        }];

    passphrase = environment.cipheringPhrase;
    iterationCount = 1000;
    keySize = 128;
    scheduledJobs: any;
    schedulerLogs: any;
    promoteDeniedPermission = '';
    applicationPermissionConfig: any;

    partnerInfo = [
        {
            title: 'Email',
            value: localStorage.getItem('signInEmail'),
            icon: 'fa fa-envelope',
            showCopy: false
        },
        {
            title: 'Partner Short Code',
            value: '',
            icon: 'fa fa-user',
            showCopy: false
        },
        {
            title: 'Partner Key',
            value: localStorage.getItem('partnerKey'),
            icon: 'fa fa-key',
            showCopy: true
        },
        {
            title: 'API Key',
            value: '',
            icon: 'fa fa-key',
            showCopy: true
        }
    ];

    // below declared variables are the alternative platform variables that has to be used going forward for certain localStorage variables that had been set.

    isDataAccessAPISet: any;
    updatedDataAccessAPI: any;
    selection: any;

    dataAccessAPI: any;
    businessLogicAPI: any;
    thirdPartyAPI: any;
    sqlQueryAPI: any;
    unifiedQueryAPI: any;
    testSuiteAPI: any;
    plSqlAPI: any;
    workFlowAPI: any;
    dmnAPI: any;
    b2bAPI: any;

    selectedAPIGateway: any;
    selectedAPIGatewayName: string;
    databaseObjectTypes: any;
    isRegisterTAB: any;
    updatedThirdAPI: any;
    existingEntity: any;
    existingExecutor: any;
    timezoneResponse: any;
    timeZones = [];

    public setProperties = this.setProperty();

    getDaasTourSteps(): Array<TourStep> {

        let steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('GT_DAAS_INTRO_TITLE'),
            content: this.getProperty('GT_DAAS_INTRO_CONTENT')
        });

        steps = steps.concat(this.getDataAccessApiDefinitionSteps());
        steps = steps.concat(this.getSchemaDefinitionTourSteps(true));

        steps.push({
            title: this.getProperty('GT_DAAS_SAVE_API_TITLE'),
            selector: '.tour-create-daas-save-api',
            content: this.getProperty('GT_DAAS_SAVE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_DAAS_DEPLOY_API_TITLE'),
            selector: '.tour-create-daas-deploy-api',
            content: this.getProperty('GT_DAAS_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }

    getBusinessLogicTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('GT_BUSINESS_LOGIC_INTRO_TITLE'),
            content: this.getProperty('GT_BUSINESS_LOGIC_INTRO_CONTENT'),
        }, {
            title: this.getProperty('EXECUTOR_NAME_TITLE'),
            selector: '.tour-create-executor-name',
            content: this.getProperty('EXECUTOR_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_VERSION_TITLE'),
            selector: '.tour-create-executor-version',
            content: this.getProperty('EXECUTOR_VERSION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_METHOD_TYPE_TITLE'),
            selector: '.tour-create-executor-method-type',
            content: this.getProperty('EXECUTOR_METHOD_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_CATEGORY_TITLE'),
            selector: '.tour-create-executor-category',
            content: this.getProperty('EXECUTOR_CATEGORY_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_BUSINESS_LOGIC_BLOCKLY_TITLE'),
            selector: '.tour-create-executor-blockly-container',
            content: this.getProperty('GT_BUSINESS_LOGIC_BLOCKLY_CONTENT'),
            orientation: Orientation.Center
        });
        if ($('.tour-executor-copy-to').length) {
            steps.push({
                title: this.getProperty('GT_API_COPY_TO_TITLE'),
                selector: '.tour-executor-copy-to',
                content: this.getProperty('GT_API_COPY_TO_CONTENT'),
                orientation: Orientation.Bottom
            });
        }
        steps.push({
            title: this.getProperty('GT_BUSINESS_LOGIC_SAVE_API_TITLE'),
            selector: '.tour-create-executor-save-api',
            content: this.getProperty('GT_BUSINESS_LOGIC_SAVE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_BUSINESS_LOGIC_TEST_TITLE'),
            selector: '.tour-create-executor-tester',
            content: this.getProperty('GT_BUSINESS_LOGIC_TEST_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_BUSINESS_LOGIC_DEPLOY_API_TITLE'),
            selector: '.tour-create-executor-create-api',
            content: this.getProperty('GT_BUSINESS_LOGIC_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });
        if ($('.tour-executor-redeploy').length) {
            steps.push({
                title: this.getProperty('GT_REDEPLOY_API_TITLE'),
                selector: '.tour-executor-redeploy',
                content: this.getProperty('GT_REDEPLOY_API_CONTENT'),
                orientation: Orientation.Left
            });
        }

        return steps;
    }

    getQueryBuilderTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('GT_QUERY_BUILDER_INTRO_TITLE'),
            content: this.getProperty('GT_QUERY_BUILDER_INTRO_CONTENT'),
        }, {
            title: this.getProperty('EXECUTOR_NAME_TITLE'),
            selector: '.tour-create-executor-name',
            content: this.getProperty('EXECUTOR_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_VERSION_TITLE'),
            selector: '.tour-create-executor-version',
            content: this.getProperty('EXECUTOR_VERSION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_METHOD_TYPE_TITLE'),
            selector: '.tour-create-executor-method-type',
            content: this.getProperty('EXECUTOR_METHOD_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_QUERY_BUILDER_EXECUTOR_TYPE_TITLE'),
            selector: '.tour-create-executor-type',
            content: this.getProperty('GT_QUERY_BUILDER_EXECUTOR_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_CATEGORY_TITLE'),
            selector: '.tour-create-executor-category',
            content: this.getProperty('EXECUTOR_CATEGORY_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('SELECT_DATABASE_FOR_API_TITLE'),
            selector: '.tour-create-executor-database',
            content: this.getProperty('SELECT_DATABASE_FOR_API_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('QUERY_EDITOR_TITLE'),
            selector: '.tour-create-executor-ace-editor',
            content: this.getProperty('QUERY_EDITOR_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('QUERY_EDITOR_EXECUTE_TITLE'),
            selector: '.tour-create-executor-tester',
            content: this.getProperty('QUERY_EDITOR_EXECUTE_CONTENT'),
            orientation: Orientation.Left
        });
        if ($('.tour-executor-copy-to').length) {
            steps.push({
                title: this.getProperty('GT_API_COPY_TO_TITLE'),
                selector: '.tour-executor-copy-to',
                content: this.getProperty('GT_API_COPY_TO_CONTENT'),
                orientation: Orientation.Bottom
            });
        }
        steps.push({
            title: this.getProperty('GT_QUERY_BUILDER_SAVE_API_TITLE'),
            selector: '.tour-create-executor-save-api',
            content: this.getProperty('GT_QUERY_BUILDER_SAVE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_QUERY_BUILDER_DEPLOY_API_TITLE'),
            selector: '.tour-create-executor-create-api',
            content: this.getProperty('GT_QUERY_BUILDER_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });
        if ($('.tour-executor-redeploy').length) {
            steps.push({
                title: this.getProperty('GT_REDEPLOY_API_TITLE'),
                selector: '.tour-executor-redeploy',
                content: this.getProperty('GT_REDEPLOY_API_CONTENT'),
                orientation: Orientation.Left
            });
        }

        return steps;
    }

    getPlSqlTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('GT_PLSQL_INTRO_TITLE'),
            content: this.getProperty('GT_PLSQL_INTRO_CONTENT'),
        }, {
            title: this.getProperty('EXECUTOR_NAME_TITLE'),
            selector: '.tour-create-executor-name',
            content: this.getProperty('EXECUTOR_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_VERSION_TITLE'),
            selector: '.tour-create-executor-version',
            content: this.getProperty('EXECUTOR_VERSION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_METHOD_TYPE_TITLE'),
            selector: '.tour-create-executor-method-type',
            content: this.getProperty('EXECUTOR_METHOD_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_QUERY_BUILDER_EXECUTOR_TYPE_TITLE'),
            selector: '.tour-create-executor-type',
            content: this.getProperty('GT_QUERY_BUILDER_EXECUTOR_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_CATEGORY_TITLE'),
            selector: '.tour-create-executor-category',
            content: this.getProperty('EXECUTOR_CATEGORY_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_PLSQL_GATEWAY_TITLE'),
            selector: '.tour-create-executor-gateway',
            content: this.getProperty('GT_PLSQL_GATEWAY_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('SELECT_DATABASE_FOR_API_TITLE'),
            selector: '.tour-create-executor-database',
            content: this.getProperty('SELECT_DATABASE_FOR_API_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('QUERY_EDITOR_TITLE'),
            selector: '.tour-create-executor-ace-editor',
            content: this.getProperty('QUERY_EDITOR_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('QUERY_EDITOR_EXECUTE_TITLE'),
            selector: '.tour-create-executor-tester',
            content: this.getProperty('QUERY_EDITOR_EXECUTE_CONTENT'),
            orientation: Orientation.Left
        });
        if ($('.tour-executor-copy-to').length) {
            steps.push({
                title: this.getProperty('GT_API_COPY_TO_TITLE'),
                selector: '.tour-executor-copy-to',
                content: this.getProperty('GT_API_COPY_TO_CONTENT'),
                orientation: Orientation.Bottom
            });
        }
        steps.push({
            title: this.getProperty('GT_QUERY_BUILDER_SAVE_API_TITLE'),
            selector: '.tour-create-executor-save-api',
            content: this.getProperty('GT_QUERY_BUILDER_SAVE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_QUERY_BUILDER_DEPLOY_API_TITLE'),
            selector: '.tour-create-executor-create-api',
            content: this.getProperty('GT_QUERY_BUILDER_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });
        if ($('.tour-executor-redeploy').length) {
            steps.push({
                title: this.getProperty('GT_REDEPLOY_API_TITLE'),
                selector: '.tour-executor-redeploy',
                content: this.getProperty('GT_REDEPLOY_API_CONTENT'),
                orientation: Orientation.Left
            });
        }

        return steps;
    }

    getSchemaDefinitionTourSteps(dynamicRender: boolean): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('SCHEMA_DEFINITION_TITLE'),
            selector: '.tour-schema-def',
            content: this.getProperty('SCHEMA_DEFINITION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('SCHEMA_ADD_ATTRIBUTE_TITLE'),
            selector: '.tour-schema-def-add-attribute',
            content: this.getProperty('SCHEMA_ADD_ATTRIBUTE_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('SCHEMA_ATTRIBUTE_NAME_TITLE'),
            selector: '.tour-schema-def-attribute-name > input',
            content: this.getProperty('SCHEMA_ATTRIBUTE_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('SCHEMA_DATA_TYPE_TITLE'),
            selector: '.tour-schema-def-data-type > input, .tour-schema-def-data-type > select',
            content: this.getProperty('SCHEMA_DATA_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        });

        if (($('.tour-schema-def-array').length && dynamicRender) || !dynamicRender) {
            steps.push({
                title: this.getProperty('SCHEMA_ARRAY_TITLE'),
                selector: '.tour-schema-def-array > mat-checkbox',
                content: this.getProperty('SCHEMA_ARRAY_CONTENT'),
                orientation: Orientation.Bottom
            });
        }

        steps.push({
            title: this.getProperty('SCHEMA_ATTRIBUTE_SIZE_TITLE'),
            selector: '.tour-schema-def-size > input',
            content: this.getProperty('SCHEMA_ATTRIBUTE_SIZE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('SCHEMA_ATTRIBUTE_PRECISION_TITLE'),
            selector: '.tour-schema-def-precision > input',
            content: this.getProperty('SCHEMA_ATTRIBUTE_PRECISION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('SCHEMA_ATTRIBUTE_KEY_TYPE_TITLE'),
            selector: '.tour-schema-def-key-type > select',
            content: this.getProperty('SCHEMA_ATTRIBUTE_KEY_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        });

        if (($('.tour-schema-def-required').length && dynamicRender) || !dynamicRender) {
            steps.push({
                title: this.getProperty('SCHEMA_ATTRIBUTE_REQUIRED_TITLE'),
                selector: '.tour-schema-def-required > mat-checkbox',
                content: this.getProperty('SCHEMA_ATTRIBUTE_REQUIRED_CONTENT'),
                orientation: Orientation.Bottom
            });
        }

        if (($('.tour-schema-def-auto-increment').length && dynamicRender) || !dynamicRender) {
            steps.push({
                title: this.getProperty('SCHEMA_ATTRIBUTE_AUTO_INCREMENT_TITLE'),
                selector: '.tour-schema-def-auto-increment > mat-checkbox',
                content: this.getProperty('SCHEMA_ATTRIBUTE_AUTO_INCREMENT_CONTENT'),
                orientation: Orientation.Bottom
            });
        }

        steps.push({
            title: this.getProperty('SCHEMA_ATTRIBUTE_DEFAULT_VALUE_TITLE'),
            selector: '.tour-schema-def-default-value > input',
            content: this.getProperty('SCHEMA_ATTRIBUTE_DEFAULT_VALUE_CONTENT'),
            orientation: Orientation.Bottom
        });

        return steps;
    }

    getApiManagementTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('API_MANAGEMENT_NAV_CONFIGURATION_TITLE'),
            selector: '.tour-api-management-nav-bar > nav > ul > li:nth-child(1) > a',
            content: this.getProperty('API_MANAGEMENT_NAV_CONFIGURATION_CONTENT'),
            orientation: Orientation.Bottom
        });

        steps.push({
            title: this.getProperty('API_MANAGEMENT_NAV_API_SETTINGS_TITLE'),
            selector: '.tour-api-management-nav-bar > nav > ul > li:nth-child(2) > a',
            content: this.getProperty('API_MANAGEMENT_NAV_API_SETTINGS_CONTENT'),
            orientation: Orientation.Bottom
        });

        steps.push({
            title: this.getProperty('API_MANAGEMENT_NAV_ROUTES_TITLE'),
            selector: '.tour-api-management-nav-bar > nav > ul > li:nth-child(3) > a',
            content: this.getProperty('API_MANAGEMENT_NAV_ROUTES_CONTENT'),
            orientation: Orientation.Bottom
        });

        return steps;
    }

    getApiToApiSteps(): Array<TourStep> {

        let steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_API_TO_API_INTRO_TITLE'),
            content: this.getProperty('GT_API_TO_API_INTRO_CONTENT')
        });

        steps = steps.concat(this.getDataAccessApiDefinitionSteps());

        steps.push({
            title: this.getProperty('GT_API_TO_API_ENTER_URL_TITLE'),
            selector: '.tour-api-to-api-enter-api-url',
            content: this.getProperty('GT_API_TO_API_ENTER_URL_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_API_TO_API_ENTER_ROOT_NODE_TITLE'),
            selector: '.tour-api-to-api-enter-root-node',
            content: this.getProperty('GT_API_TO_API_ENTER_ROOT_NODE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_API_TO_API_IMPORT_DATA_TITLE'),
            selector: '.tour-api-to-api-import-data',
            content: this.getProperty('GT_API_TO_API_IMPORT_DATA_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_API_TO_API_HEADERS_TITLE'),
            selector: '.tour-api-to-api-headers',
            content: this.getProperty('GT_API_TO_API_HEADERS_CONTENT'),
            orientation: Orientation.Top
        }, {
            title: this.getProperty('GT_API_TO_API_CREATE_API_TITLE'),
            selector: '.tour-api-to-api-create-api',
            content: this.getProperty('GT_API_TO_API_CREATE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_API_TO_API_DEPLOY_API_TITLE'),
            selector: '.tour-api-to-api-deploy-api',
            content: this.getProperty('GT_API_TO_API_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;

    }

    getJsonSchemaTourSteps(): Array<TourStep> {

        let steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_JSON_SCHEMA_INTRO_TITLE'),
            content: this.getProperty('GT_JSON_SCHEMA_INTRO_CONTENT')
        });

        steps = steps.concat(this.getDataAccessApiDefinitionSteps());

        steps.push({
            title: this.getProperty('GT_JSON_SCHEMA_JSON_EDITOR_TITLE'),
            selector: 'json-editor',
            content: this.getProperty('GT_JSON_SCHEMA_JSON_EDITOR_CONTENT'),
            orientation: Orientation.Top
        }, {
            title: this.getProperty('GT_JSON_SCHEMA_CREATE_API_TITLE'),
            selector: '.tour-json-schema-create-api',
            content: this.getProperty('GT_JSON_SCHEMA_CREATE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_JSON_SCHEMA_DEPLOY_API_TITLE'),
            selector: '.tour-json-schema-deploy-api',
            content: this.getProperty('GT_JSON_SCHEMA_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;

    }

    getYamlTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        if ($('app-deploymentplan').length === 0) {
            steps.push({
                title: this.getProperty('GT_OPEN_API_INTRO_TITLE'),
                content: this.getProperty('GT_OPEN_API_INTRO_CONTENT')
            });

            steps.push({
                title: this.getProperty('GT_OPEN_API_CODE_EDITOR_TITLE'),
                selector: 'ace-editor',
                content: this.getProperty('GT_OPEN_API_CODE_EDITOR_CONTENT'),
                orientation: Orientation.Center
            }, {
                title: this.getProperty('GT_OPEN_API_SHOW_DEPLOYMENT_PLAN_TITLE'),
                selector: '.tour-open-api-show-deployment',
                content: this.getProperty('GT_OPEN_API_SHOW_DEPLOYMENT_PLAN_CONTENT'),
                orientation: Orientation.Left
            });
        } else {
            steps.push({
                title: this.getProperty('GT_DEPLOYMENT_PLAN_TRANSFORM_TITLE'),
                selector: '.tour-deployment-plan-transform',
                content: this.getProperty('GT_DEPLOYMENT_PLAN_TRANSFORM_CONTENT'),
                orientation: Orientation.Left
            });
        }

        return steps;

    }

    getCobolTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        if ($('app-deploymentplan').length === 0) {
            steps.push({
                title: this.getProperty('GT_COBOL_INTRO_TITLE'),
                content: this.getProperty('GT_COBOL_INTRO_CONTENT')
            });

            steps.push({
                title: this.getProperty('GT_COBOL_CODE_EDITOR_TITLE'),
                selector: 'ace-editor',
                content: this.getProperty('GT_COBOL_CODE_EDITOR_CONTENT'),
                orientation: Orientation.Center
            }, {
                title: this.getProperty('GT_COBOL_SHOW_DEPLOYMENT_PLAN_TITLE'),
                selector: '.tour-cobol-to-api-show-deployment',
                content: this.getProperty('GT_COBOL_SHOW_DEPLOYMENT_PLAN_CONTENT'),
                orientation: Orientation.Left
            });
        } else {
            steps.push({
                title: this.getProperty('GT_DEPLOYMENT_PLAN_TRANSFORM_TITLE'),
                selector: '.tour-deployment-plan-transform',
                content: this.getProperty('GT_DEPLOYMENT_PLAN_TRANSFORM_CONTENT'),
                orientation: Orientation.Left
            });
        }

        return steps;

    }

    getApiRegisterSteps(): Array<TourStep> {

        let steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_API_REGISTER_INTRO_TITLE'),
            content: this.getProperty('GT_API_REGISTER_INTRO_CONTENT')
        });

        steps.push({
            title: this.getProperty('API_NAME_TITLE'),
            selector: '.tour-api-name',
            content: this.getProperty('API_NAME_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('API_VERSION_TITLE'),
            selector: '.tour-api-version',
            content: this.getProperty('API_VERSION_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('API_CATEGORY_TITLE'),
            selector: '.tour-api-category',
            content: this.getProperty('API_CATEGORY_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('GT_API_REGISTER_REGISTER_TYPE_TITLE'),
            selector: '.tour-api-register-type',
            content: this.getProperty('GT_API_REGISTER_REGISTER_TYPE_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('API_CATEGORY_GROUP_TITLE'),
            selector: '.tour-api-category-group',
            content: this.getProperty('API_CATEGORY_GROUP_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('API_DISPLAY_NAME_TITLE'),
            selector: '.tour-api-display-name',
            content: this.getProperty('API_DISPLAY_NAME_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('API_DESCRIPTION_TITLE'),
            selector: '.tour-api-description',
            content: this.getProperty('API_DESCRIPTION_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('SERVICE_PROVIDER_TITLTE'),
            selector: '.tour-api-service-gateway',
            content: this.getProperty('SERVICE_PROVIDER_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('API_ACCESS_POLICY_TITLE'),
            selector: '.tour-api-access-policy',
            content: this.getProperty('API_ACCESS_POLICY_CONTENT'),
            orientation: Orientation.Left
        });
        steps = steps.concat(this.getDevexTourSteps());

        steps.push({
            title: this.getProperty('GT_API_REGISTER_REGISTER_API_TITLE'),
            selector: '.tour-api-register-register',
            content: this.getProperty('GT_API_REGISTER_REGISTER_API_CONTENT'),
            orientation: Orientation.Left
        });


        return steps;

    }

    getDataCatalogTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_DATA_CATALOG_TITLE'),
            content: this.getProperty('GT_DATA_CATALOG_CONTENT')
        });

        steps.push({
            title: this.getProperty('GT_DATA_CATALOG_CONNECTION_LIST_TITLE'),
            selector: 'mat-tree',
            content: this.getProperty('GT_DATA_CATALOG_CONNECTION_LIST_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('GT_DATA_CATALOG_EXPAND_CONNECTION_TITLE'),
            selector: 'button[aria-label=\'connection\']',
            content: this.getProperty('GT_DATA_CATALOG_EXPAND_CONNECTION_CONTENT'),
            orientation: Orientation.BottomLeft
        });

        return steps;

    }

    getDevexPageTourSteps(): Array<TourStep> {

        let steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_DEVEX_INTRO_TITLE'),
            content: this.getProperty('GT_DEVEX_INTRO_CONTENT')
        });

        steps = steps.concat(this.getDevexTourSteps());

        return steps;

    }

    getServiceProviderCategoriesTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_SERVICE_PROVIDER_CATEGORIES_INTRO_TITLE'),
            content: this.getProperty('GT_SERVICE_PROVIDER_CATEGORIES_INTRO_CONTENT')
        });

        steps.push({
            title: this.getProperty('GT_SERVICE_PROVIDER_CATEGORIES_ADD_TITLE'),
            selector: '.tour-provider-category-add-provider-category',
            content: this.getProperty('GT_SERVICE_PROVIDER_CATEGORIES_ADD_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_SERVICE_PROVIDER_CATEGORIES_FILTER_TITLE'),
            selector: '.tour-provider-category-filter-category',
            content: this.getProperty('GT_SERVICE_PROVIDER_CATEGORIES_FILTER_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_SERVICE_PROVIDER_CATEGORIES_VIEW_TITLE'),
            selector: '.tour-provider-category-view-list',
            content: this.getProperty('GT_SERVICE_PROVIDER_CATEGORIES_VIEW_CONTENT'),
            orientation: Orientation.Bottom
        });

        return steps;

    }

    getEmailTemplatesTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_EMAIL_TEMPLATES_INTRO_TITLE'),
            content: this.getProperty('GT_EMAIL_TEMPLATES_INTRO_CONTENT')
        });

        steps.push({
            title: this.getProperty('GT_EMAIL_TEMPLATES_FILTER_TEMPLATE_TITLE'),
            selector: '.tour-manage-templates-filter',
            content: this.getProperty('GT_EMAIL_TEMPLATES_FILTER_TEMPLATE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_EMAIL_TEMPLATES_ADD_TEMPLATE_TITLE'),
            selector: '.tour-manage-templates-create-email-template',
            content: this.getProperty('GT_EMAIL_TEMPLATES_ADD_TEMPLATE_TITLE'),
            orientation: Orientation.Bottom
        });
        if ($('.tour-manage-templates-delete-template').length) {
            steps.push({
                title: this.getProperty('GT_EMAIL_TEMPLATES_DELETE_TEMPLATE_TITLE'),
                selector: '.tour-manage-templates-delete-template',
                content: this.getProperty('GT_EMAIL_TEMPLATES_DELETE_TEMPLATE_CONTENT'),
                orientation: Orientation.Bottom
            });
        }
        if ($('.tour-manage-templates-edit-template').length) {
            steps.push({
                title: this.getProperty('GT_EMAIL_TEMPLATES_EDIT_TEMPLATE_TITLE'),
                selector: '.tour-manage-templates-edit-template',
                content: this.getProperty('GT_EMAIL_TEMPLATES_EDIT_TEMPLATE_CONTENT'),
                orientation: Orientation.Bottom
            });
        }
        if ($('.tour-manage-templates-execute-template').length) {
            steps.push({
                title: this.getProperty('GT_EMAIL_TEMPLATES_EXECUTE_TEMPLATE_TITLE'),
                selector: '.tour-manage-templates-execute-template',
                content: this.getProperty('GT_EMAIL_TEMPLATES_EXECUTE_TEMPLATE_CONTENT'),
                orientation: Orientation.Bottom
            });
        }

        return steps;

    }

    getServiceProvidersTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_SERVICE_PROVIDERS_INTRO_TITLE'),
            content: this.getProperty('GT_SERVICE_PROVIDERS_INTRO_TITLE')
        });

        steps.push({
            title: this.getProperty('GT_SERVICE_PROVIDERS_FILTER_PROVIDER_TITLE'),
            selector: '.tour-providers-add-provider',
            content: this.getProperty('GT_SERVICE_PROVIDERS_ADD_PROVIDER_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_SERVICE_PROVIDERS_FILTER_PROVIDER_TITLE'),
            selector: '.tour-providers-filter-providers',
            content: this.getProperty('GT_SERVICE_PROVIDERS_FILTER_PROVIDER_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_SERVICE_PROVIDERS_MANAGE_TITLE'),
            selector: '.tour-providers-my-providers-manage',
            content: this.getProperty('GT_SERVICE_PROVIDERS_MANAGE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_SERVICE_PROVIDERS_DEACTIVATE_TITLE'),
            selector: '.tour-providers-my-providers-deactivate',
            content: this.getProperty('GT_SERVICE_PROVIDERS_DEACTIVATE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_SERVICE_PROVIDERS_ACTIVATE_TITLE'),
            selector: '.tour-providers-all-providers-activate',
            content: this.getProperty('GT_SERVICE_PROVIDERS_ACTIVATE_CONTENT'),
            orientation: Orientation.Bottom
        });

        return steps;

    }

    getFileManagerTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('GT_FILE_MANAGER_INTRO_TITLE'),
            content: this.getProperty('GT_FILE_MANAGER_INTRO_CONTENT')
        });

        steps.push({
            title: this.getProperty('GT_FILE_MANAGER_UPLOAD_FILE_TITLE'),
            selector: '.tour-file-storage-upload-file',
            content: this.getProperty('GT_FILE_MANAGER_UPLOAD_FILE_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_FILE_MANAGER_UPLOAD_FOLDER_TITLE'),
            selector: '.tour-file-storage-upload-folder',
            content: this.getProperty('GT_FILE_MANAGER_UPLOAD_FOLDER_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_FILE_MANAGER_CREATE_FOLDER_TITLE'),
            selector: '.tour-file-storage-create-folder',
            content: this.getProperty('GT_FILE_MANAGER_CREATE_FOLDER_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_FILE_MANAGER_BUCKET_PATH_TITLE'),
            selector: '.tour-file-storage-bucket-path',
            content: this.getProperty('GT_FILE_MANAGER_BUCKET_PATH_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('GT_FILE_MANAGER_SEARCH_TITLE'),
            selector: '.tour-file-storage-search',
            content: this.getProperty('GT_FILE_MANAGER_SEARCH_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_FILE_NAME_HEADER_TITLE'),
            selector: '.tour-file-storage-file-name',
            content: this.getProperty('GT_FILE_NAME_HEADER_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_FILE_SIZE_HEADER_TITLE'),
            selector: '.tour-file-storage-file-size',
            content: this.getProperty('GT_FILE_SIZE_HEADER_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_FILE_LAST_MODIFIED_HEADER_TITLE'),
            selector: '.tour-file-storage-last-modified',
            content: this.getProperty('GT_FILE_LAST_MODIFIED_HEADER_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_FILE_ACTIONS_HEADER_TITLE'),
            selector: '.tour-file-storage-file-actions',
            content: this.getProperty('GT_FILE_ACTIONS_HEADER_CONTENT'),
            orientation: Orientation.Bottom
        });

        return steps;

    }

    getDataAccessApiDefinitionSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: this.getProperty('API_NAME_TITLE'),
            selector: '.tour-api-name',
            content: this.getProperty('API_NAME_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('API_VERSION_TITLE'),
            selector: '.tour-api-version',
            content: this.getProperty('API_VERSION_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('API_CATEGORY_TITLE'),
            selector: '.tour-api-category',
            content: this.getProperty('API_CATEGORY_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('SELECT_DATABASE_FOR_API_TITLE'),
            selector: '.tour-api-database',
            content: this.getProperty('SELECT_DATABASE_FOR_API_CONTENT'),
            orientation: Orientation.Right
        });

        if ($('input[placeholder^=\'Table Name\'].tour-api-table-name').length) {
            steps.push({
                title: this.getProperty('TABLE_NAME_TITLE'),
                selector: 'input[placeholder^=\'Table Name\'].tour-api-table-name',
                content: this.getProperty('TABLE_NAME_CONTENT'),
                orientation: Orientation.Right
            });
        }

        if ($('input[placeholder^=\'Collection Name\'].tour-api-table-name').length) {
            steps.push({
                title: this.getProperty('COLLECTION_NAME_TITLE'),
                selector: 'input[placeholder^=\'Collection Name\'].tour-api-table-name',
                content: this.getProperty('COLLECTION_NAME_CONTENT'),
                orientation: Orientation.Right
            });
        }

        steps.push({
            title: this.getProperty('API_DISPLAY_NAME_TITLE'),
            selector: '.tour-api-display-name',
            content: this.getProperty('API_DISPLAY_NAME_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('API_DESCRIPTION_TITLE'),
            selector: '.tour-api-description',
            content: this.getProperty('API_DESCRIPTION_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('API_GATEWAY_TITLE'),
            selector: '.tour-api-gateway',
            content: this.getProperty('API_GATEWAY_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('API_METHODS_TITLE'),
            selector: '.tour-api-methods > angular2-multiselect > div.cuppa-dropdown',
            content: this.getProperty('API_METHODS_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('PUBLISH_API_TITLE'),
            selector: '.tour-publish-api',
            content: this.getProperty('PUBLISH_API_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }

    getTestSuiteTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('GT_TEST_SUITE_INTRO_TITLE'),
            content: this.getProperty('GT_TEST_SUITE_INTRO_CONTENT'),
        }, {
            title: this.getProperty('EXECUTOR_NAME_TITLE'),
            selector: '.tour-create-executor-name',
            content: this.getProperty('EXECUTOR_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_VERSION_TITLE'),
            selector: '.tour-create-executor-version',
            content: this.getProperty('EXECUTOR_VERSION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_METHOD_TYPE_TITLE'),
            selector: '.tour-create-executor-method-type',
            content: this.getProperty('EXECUTOR_METHOD_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_CATEGORY_TITLE'),
            selector: '.tour-create-executor-category',
            content: this.getProperty('EXECUTOR_CATEGORY_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_TEST_SUITE_TEST_TITLE'),
            selector: '.tour-create-executor-save-api',
            content: this.getProperty('GT_TEST_SUITE_TEST_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_TEST_SUITE_SAVE_API_TITLE'),
            selector: '.tour-create-executor-tester',
            content: this.getProperty('GT_TEST_SUITE_SAVE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('GT_TEST_SUITE_DEPLOY_API_TITLE'),
            selector: '.tour-create-executor-create-api',
            content: this.getProperty('GT_TEST_SUITE_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }

    getConsoleTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];

        steps.push({
            title: 'Welcome ' + localStorage.getItem('signInEmail'),
            content: this.getProperty('GT_WELCOME_USER_CONTENT'),
        });

        if ($('.tour-control-plane').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_CONTROL_PLANE_TITLE'),
                selector: '.tour-control-plane',
                content: this.getProperty('GT_CONSOLE_CONTROL_PLANE_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-creation').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_CREATE_TITLE'),
                selector: '.tour-creation',
                content: this.getProperty('GT_CONSOLE_CREATE_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-connect').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_CONNECT_TITLE'),
                selector: '.tour-connect',
                content: this.getProperty('GT_CONSOLE_CONNECT_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-register').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_REGISTER_TITLE'),
                selector: '.tour-register',
                content: this.getProperty('GT_CONSOLE_REGISTER_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-test').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_TEST_TITLE'),
                selector: '.tour-test',
                content: this.getProperty('GT_CONSOLE_TEST_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-manage').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_MANAGE_TITLE'),
                selector: '.tour-manage',
                content: this.getProperty('GT_CONSOLE_MANAGE_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-tools').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_TOOLS_TITLE'),
                selector: '.tour-tools',
                content: this.getProperty('GT_CONSOLE_TOOLS_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-samples').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_SAMPLES_TITLE'),
                selector: '.tour-samples',
                content: this.getProperty('GT_CONSOLE_SAMPLES_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-learn').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_LEARN_TITLE'),
                selector: '.tour-learn',
                content: this.getProperty('GT_CONSOLE_LEARN_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-partner-info').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_PARTNER_INFO_TITLE'),
                selector: '.tour-partner-info',
                content: this.getProperty('GT_CONSOLE_PARTNER_INFO_CONTENT'),
                orientation: Orientation.Right
            });
        }
        if ($('.tour-History').length) {
            steps.push({
                title: this.getProperty('GT_CONSOLE_HISTORY_TITLE'),
                selector: '.tour-History',
                content: this.getProperty('GT_CONSOLE_HISTORY_CONTENT'),
                orientation: Orientation.TopLeft
            });
        }
        steps.push({
            title: this.getProperty('GT_RATE_THIS_PAGE_TITLE'),
            selector: '.tourRateThisPage',
            content: this.getProperty('GT_RATE_THIS_PAGE_CONTENT'),
            orientation: Orientation.Top
        }, {
            title: this.getProperty('GT_LET_US_KNOW_YOUR_EXPERIENCE_TITLE'),
            selector: '.tourLetUsKnowYourExperience',
            content: this.getProperty('GT_LET_US_KNOW_YOUR_EXPERIENCE_CONTENT'),
            orientation: Orientation.Top
        }, {
            title: this.getProperty('GT_GUIDE_TOUR_BUTTON_TITLE'),
            selector: '.tourGuideMe',
            content: this.getProperty('GT_GUIDE_TOUR_BUTTON_CONTENT'),
            orientation: Orientation.Top
        });

        return steps;

    }

    getDevexTourSteps(): Array<TourStep> {

        let steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('DEVEX_METHOD_SELECTOR_TITLE'),
            selector: '.tour-devex-method',
            content: this.getProperty('DEVEX_METHOD_SELECTOR_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('DEVEX_API_URL_TITLE'),
            selector: '.tour-devex-api-url',
            content: this.getProperty('DEVEX_API_URL_CONTENT'),
            orientation: Orientation.Right
        });
        steps = steps.concat(this.headerCmpTourSteps);

        if ($('.tour-devex-response-tabs').length) {
            steps.push({
                title: this.getProperty('GT_DEVEX_RESPONSE_BODY_TAB_TITLE'),
                selector: '.tour-devex-response-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1) > div',
                content: this.getProperty('GT_DEVEX_RESPONSE_BODY_TAB_CONTENT'),
                orientation: Orientation.Right
            }, {
                title: this.getProperty('GT_DEVEX_RESPONSE_HEADERS_TAB_TITLE'),
                selector: '.tour-devex-response-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(2) > div',
                content: this.getProperty('GT_DEVEX_RESPONSE_HEADERS_TAB_CONTENT'),
                orientation: Orientation.Right
            }, {
                title: this.getProperty('GT_DEVEX_COOKIES_TAB_TITLE'),
                selector: '.tour-devex-response-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3) > div',
                content: this.getProperty('GT_DEVEX_COOKIES_TAB_CONTENT'),
                orientation: Orientation.Right
            });
        }

        if ($('.tour-devex-test-api').length) {
            steps.push({
                title: this.getProperty('DEVEX_TEST_API_TITLE'),
                selector: '.tour-devex-test-api',
                content: this.getProperty('DEVEX_TEST_API_CONTENT'),
                orientation: Orientation.Left
            });
        }
        if ($('.tour-devex-execute-api').length) {
            steps.push({
                title: this.getProperty('DEVEX_EXECUTE_API_TITLE'),
                selector: '.tour-devex-execute-api',
                content: this.getProperty('DEVEX_EXECUTE_API_CONTENT'),
                orientation: Orientation.Left
            });
        }
        if ($('.tour-devex-register-api').length) {
            steps.push({
                title: this.getProperty('GT_API_REGISTER_REGISTER_API_TITLE'),
                selector: '.tour-devex-register-api',
                content: this.getProperty('GT_API_REGISTER_REGISTER_API_CONTENT'),
                orientation: Orientation.Left
            });
        }

        return steps;
    }

    getPostmanCollectionTourSteps(): Array<TourStep> {
        const steps: TourStep[] = [];

        steps.push({
                title: this.getProperty('GT_POSTMAN_COLLECTION_INTRO_TITLE'),
                content: this.getProperty('GT_POSTMAN_COLLECTION_INTRO_CONTENT')
            }, {
                title: this.getProperty('GT_POSTMAN_COLLECTION_VERSION_TITLE'),
                selector: '.tour-postman-collection-version',
                content: this.getProperty('GT_POSTMAN_COLLECTION_VERSION_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_POSTMAN_COLLECTION_IMPORT_OPTION_TITLE'),
                selector: '.tour-postman-collection-import-option',
                content: this.getProperty('GT_POSTMAN_COLLECTION_IMPORT_OPTION_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_API_REGISTER_REGISTER_TYPE_TITLE'),
                selector: '.tour-postman-collection-register-policy',
                content: this.getProperty('GT_API_REGISTER_REGISTER_TYPE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('EXECUTOR_VERSION_TITLE'),
                selector: '.tour-create-executor-version',
                content: this.getProperty('EXECUTOR_VERSION_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_POSTMAN_COLLECTION_SERVICE_PROVIDER_TITLE'),
                selector: '.tour-postman-collection-provider',
                content: this.getProperty('GT_POSTMAN_COLLECTION_SERVICE_PROVIDER_CONTENT'),
                orientation: Orientation.Bottom
            },
            {
                title: this.getProperty('GT_POSTMAN_COLLECTION_ADD_TITLE'),
                selector: '.tour-postman-collection-add',
                content: this.getProperty('GT_POSTMAN_COLLECTION_ADD_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_POSTMAN_COLLECTION_IMPORT_TITLE'),
                selector: '.tour-postman-collection-import',
                content: this.getProperty('GT_POSTMAN_COLLECTION_IMPORT_CONTENT'),
                orientation: Orientation.Bottom
            },
            {
                title: this.getProperty('GT_POSTMAN_COLLECTION_APIS_TITLE'),
                selector: '.tour-postman-collection-api',
                content: this.getProperty('GT_POSTMAN_COLLECTION_API_TITLE'),
                orientation: Orientation.Bottom
            },
            {
                title: this.getProperty('GT_POSTMAN_COLLECTION_DEPLOYMENT_PLAN_TITLE'),
                selector: '.tour-open-api-show-deployment',
                content: this.getProperty('GT_POSTMAN_COLLECTION_DEPLOYMENT_PLAN_CONTENT'),
                orientation: Orientation.Bottom
            },);

        return steps;
    }

    getExecutorTourSteps(): Array<TourStep> {

        const steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('EXECUTOR_NAME_TITLE'),
            selector: '.tour-create-executor-name',
            content: this.getProperty('EXECUTOR_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_VERSION_TITLE'),
            selector: '.tour-create-executor-version',
            content: this.getProperty('EXECUTOR_VERSION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_METHOD_TYPE_TITLE'),
            selector: '.tour-create-executor-method-type',
            content: this.getProperty('EXECUTOR_METHOD_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_QUERY_BUILDER_EXECUTOR_TYPE_TITLE'),
            selector: '.tour-create-executor-type',
            content: this.getProperty('GT_QUERY_BUILDER_EXECUTOR_TYPE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('EXECUTOR_CATEGORY_TITLE'),
            selector: '.tour-create-executor-category',
            content: this.getProperty('EXECUTOR_CATEGORY_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.getProperty('GT_UNIFIED_QUERY_BUILDER_GATEWAY_TITLE'),
            selector: '.tour-create-executor-gateway',
            content: this.getProperty('GT_UNIFIED_QUERY_BUILDER_GATEWAY_CONTENT'),
            orientation: Orientation.Bottom
        });
        return steps;
    }

    getOpenAPITourSteps() {
        const steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('OPENAPI_3_INTRO_TITLE'),
            content: this.getProperty('OPENAPI_3_INTRO_CONTENT'),
        }, {
            title: this.getProperty('OPENAPI_3_UPLOAD_TITLE'),
            selector: '.tour-upload-button',
            content: this.getProperty('OPENAPI_3_UPLOAD_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.getProperty('OPENAPI_3_CODE_EDITOR_TITLE'),
            selector: '.tour-code-editor',
            content: this.getProperty('OPENAPI_3_CODE_EDITOR_CONTENT'),
            orientation: Orientation.Center
        }, {
            title: this.getProperty('OPENAPI_3_SHOW_DEP_PLAN_TITLE'),
            selector: '.tour-show-dep-plan-button',
            content: this.getProperty('OPENAPI_3_SHOW_DEP_PLAN_CONTENT'),
            orientation: Orientation.Left
        });
        return steps;
    }

    getTSRExecutors(exec) {
        this.ifTSRExecutors = exec;
    }

    getTestResultsTourSteps(): Array<TourStep> {
        const steps: TourStep[] = [];
        if (this.ifTSRExecutors) {
            steps.push({
                title: this.getProperty('GT_TEST_SUITE_RESULTS_TITLE'),
                content: this.getProperty('GT_TEST_SUITE_RESULTS_CONTENT'),
            }, {
                title: this.getProperty('GT_TEST_SUITE_ATTRIBUTE_TITLE'),
                selector: '.tour-attribute',
                content: this.getProperty('GT_TEST_SUITE_ATTRIBUTE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_TEST_SUITE_FILTER_TITLE'),
                selector: '.tour-search',
                content: this.getProperty('GT_TEST_SUITE_FILTER_CONTENT'),
                orientation: Orientation.Left
            }, {
                title: this.getProperty('GT_TEST_SUITE_NAME_TITLE'),
                selector: '.tour-table-head:nth-child(1)',
                content: this.getProperty('GT_TEST_SUITE_NAME_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_TEST_SUITE_VERSION_TITLE'),
                selector: '.tour-table-head:nth-child(2)',
                content: this.getProperty('GT_TEST_SUITE_VERSION_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_TEST_SUITE_TYPE_TITLE'),
                selector: '.tour-table-head:nth-child(3)',
                content: this.getProperty('GT_TEST_SUITE_TYPE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_TEST_SUITE_CREATE_TITLE'),
                selector: '.tour-table-head:nth-child(4)',
                content: this.getProperty('GT_TEST_SUITE_CREATE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_TEST_SUITE_UPDATE_TITLE'),
                selector: '.tour-table-head:nth-child(5)',
                content: this.getProperty('GT_TEST_SUITE_UPDATE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_TEST_SUITE_TRESULT_TITLE'),
                selector: '.tour-table-head:nth-child(6)',
                content: this.getProperty('GT_TEST_SUITE_TRESULT_CONTENT'),
                orientation: Orientation.Bottom
            });
        } else {
            steps.push({
                title: this.getProperty('GT_TEST_SUITE_NO_RESULTS_TITLE'),
                content: this.getProperty('GT_TEST_SUITE_NO_RESULTS_CONTENT'),
            });
        }

        return steps;
    }

    getAPIQLTourSteps() {
        let steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('GT_APIQL_INTRO_TITLE'),
            content: this.getProperty('GT_APIQL_INTRO_CONTENT'),
        });
        steps = steps.concat(this.getDevexTourSteps());
        steps.push({
            title: this.getProperty('GT_APIQL_ADD_TAB_TITLE'),
            selector: '.tour-add-tab',
            content: this.getProperty('GT_APIQL_ADD_TAB_CONTENT'),
            orientation: Orientation.Left
        });
        return steps;
    }

    getDATAQLTourSteps() {
        let steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('GT_DATAQL_INTRO_TITLE'),
            content: this.getProperty('GT_DATAQL_INTRO_CONTENT'),
        });
        steps = steps.concat(this.getDevexTourSteps());
        steps.push({
            title: this.getProperty('GT_APIQL_ADD_TAB_TITLE'),
            selector: '.tour-add-tab',
            content: this.getProperty('GT_APIQL_ADD_TAB_CONTENT'),
            orientation: Orientation.Left
        });
        return steps;
    }

    public restartTour(tour): void {
        this.guidedTourService.startTour(tour);
    }

    getAPICollectionsTourSteps() {
        let steps: TourStep[] = [];
        steps.push({
            title: this.getProperty('GT_API_COLLECTION_INTRO_TITLE'),
            content: this.getProperty('GT_API_COLLECTION_INTRO_CONTENT'),
        }, {
            title: this.getProperty('GT_API_COLLECTION_ADD_COLLECTION_TITLE'),
            selector: '.tour-add-collection',
            content: this.getProperty('GT_API_COLLECTION_ADD_COLLECTION_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('GT_API_COLLECTION_IMPORT_TITLE'),
            selector: '.tour-import',
            content: this.getProperty('GT_API_COLLECTION_IMPORT_CONTENT'),
            orientation: Orientation.Right
        }, {
            title: this.getProperty('GT_API_COLLECTION_MY_COLLECTIONS_TITLE'),
            selector: '.tour-my-collections',
            content: this.getProperty('GT_API_COLLECTION_MY_COLLECTIONS_CONTENT'),
            orientation: Orientation.Right
        });
        steps = steps.concat(this.getDevexTourSteps());
        steps.push({
            title: this.getProperty('GT_API_COLLECTION_ADD_TAB_TITLE'),
            selector: '.tour-add-tab',
            content: this.getProperty('GT_API_COLLECTION_ADD_TAB_CONTENT'),
            orientation: Orientation.Left
        });
        return steps;
    }

    getSchedulerTourSteps() {
        const steps: TourStep[] = [];
        if (this.scheduledJobs) {
            steps.push({
                title: this.getProperty('GT_SCHEDULER_INTRO_TITLE'),
                content: this.getProperty('GT_SCHEDULER_INTRO_CONTENT'),
            }, {
                title: this.getProperty('GT_SCHEDULER_ACTIONS_TITLE'),
                selector: '.tour-scheduler-actions',
                content: this.getProperty('GT_SCHEDULER_ACTIONS_CONTENT'),
                orientation: Orientation.Right
            }, {
                title: this.getProperty('GT_SCHEDULER_ACTIONS_EDIT_TITLE'),
                selector: '.tour-scheduler-actions-edit',
                content: this.getProperty('GT_SCHEDULER_ACTIONS_EDIT_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_ACTIONS_RESCHEDULE_TITLE'),
                selector: '.tour-scheduler-actions-reschedule',
                content: this.getProperty('GT_SCHEDULER_ACTIONS_RESCHEDULE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_ACTIONS_DELETE_TITLE'),
                selector: '.tour-scheduler-actions-delete',
                content: this.getProperty('GT_SCHEDULER_ACTIONS_DELETE_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_JOB_TITLE'),
                selector: '.tour-scheduler-table-head:nth-child(2)',
                content: this.getProperty('GT_SCHEDULER_JOB_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_API_TITLE'),
                selector: '.tour-scheduler-table-head:nth-child(3)',
                content: this.getProperty('GT_SCHEDULER_API_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_TRIGGER_TITLE'),
                selector: '.tour-scheduler-table-head:nth-child(4)',
                content: this.getProperty('GT_SCHEDULER_TRIGGER_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_STATUS_TITLE'),
                selector: '.tour-scheduler-table-head:nth-child(5)',
                content: this.getProperty('GT_SCHEDULER_STATUS_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_CREATED_TITLE'),
                selector: '.tour-scheduler-table-head:nth-child(6)',
                content: this.getProperty('GT_SCHEDULER_CREATED_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_UPDATED_TITLE'),
                selector: '.tour-scheduler-table-head:nth-child(7)',
                content: this.getProperty('GT_SCHEDULER_UPDATED_CONTENT'),
                orientation: Orientation.Bottom
            }, {
                title: this.getProperty('GT_SCHEDULER_HISTORY_TITLE'),
                selector: '.tour-scheduler-table-head:nth-child(8)',
                content: this.getProperty('GT_SCHEDULER_HISTORY_CONTENT'),
                orientation: Orientation.Left
            });
        } else {
            steps.push({
                title: this.getProperty('GT_NO_SCHEDULER_TITLE'),
                content: this.getProperty('GT_NO_SCHEDULER_CONTENT'),
            });
        }
        return steps;
    }

    promoteAPI(item, type) {
        this.closePanel(this.menus[1]['stickyMenus'], 'envMenu');
        if (type === 'DATAACCESS') {
            this.dialog.open(PromoteToEnvironmentComponent, {
                height: '40%',
                width: '30%',
                data: {partner: this.partner, account: this.account, entity: item.entityname, version: item.version, type: 'DATAACCESS'}
            });
        } else {
            this.dialog.open(PromoteToEnvironmentComponent, {
                height: '40%',
                width: '30%',
                data: {partner: this.partner, account: this.account, entity: item.executor_name, version: item.executor_version, type: type}
            });
        }
    }

    constructor(
        private location: Location,
        private router: Router,
        private _route: ActivatedRoute,
        private kong: KongService,
        private confPost: ConfService,
        private _service: ConnecttocrudService,
        public appComponent: AppComponent,
        private dialog: MatDialog,
        private leftPanelDataListener: ListenerService,
        private businessLogicDataService: BusinessLogicDataService,
        private snackBar: MatSnackBar,
        private notifyErrorToAdminsListenerInstance: NotifyerrortoadminsListenerService,
        private deletionListenerInstance: DeletionListenerService,
        private emailTemplatesListenerInstance: EmailtemplateListenerService,
        private databasesListenerInstance: DatabasesListenerService,
        private sqlqueryListenerInstance: SqlqueryListenerService,
        private testsuiteListenerInstance: TestsuiteListenerService,
        private workflowListenerInstance: WorkflowListenerService,
        private idleTimeoutListenerInstance: IdletimeoutListenerService,
        private apiGatewayListenerInstance: ApigatewayListenerService,
        private devexListenerInstance: DevexListenerService,
        private permissionListenerInstance: PermissionsListenerService,
        private auth: Loggedin,
        private authService: AuthService,
        private auditLog: AuditLogService,
        private webSocketService: WebsocketService,
        public guidedTourService: GuidedTourService,
        public leftpanelListner: LeftpanelListenerService,
        public accountInfoService: AccountInfoService,
        private jwtParser: JwtParserService) {
        // this.initialisePlatform();
        router.events
            .subscribe((event: NavigationStart) => {
                if (event.navigationTrigger === 'popstate') {
                    // Perform actions
                    if (localStorage.getItem('partner') && localStorage.getItem('partner').includes('admin-')) {
                        this.closePanel(this.menus[0]['stickyMenus'], 'adminMenu');
                    } else {
                        this.closePanel(this.menus[1]['stickyMenus'], 'envMenu');
                    }
                }
            });
        leftPanelDataListener.changeInLeftPanelData.subscribe(
            (status) => {
                if (status === 'update') {
                    this.entities = undefined;
                    this.leftpanelData = undefined;
                    this.refreshTokenAndPermissions();
                    this.businessLogicDataService.myAPIsForceFetchNextCall = true;
                    setTimeout(() => {
                        this.getEntitiesAndExecutorsForThePartnerAccount();
                    }, 7000);
                } else if (status === 'application') {
                    this.getApplicationsForPartnerAccount();
                }
            }
        );

        // leftPanelDataListener.changeInPlatformAPIsData.subscribe(
        //     async (data: any = {action: 'create', type: 'executor'}) => {
        //         this.partner = localStorage.getItem('partner');
        //         this.account = localStorage.getItem('account');
        //         this.businessLogicDataService.myAPIsForceFetchNextCall = true;
        //         this.closePanel(this.menus[1]['stickyMenus'], 'envMenu');
        //         if (data.action === 'create' || data.action === 'delete') {
        //             Promise.resolve(this.refreshTokenAndPermissions()).then(response => {
        //                 this.getEntitiesAndExecutorsForThePartnerAccount();
        //             }, error => {});
        //         }
        //     });

        leftPanelDataListener.changeInLeftPanelDataV2.subscribe(
            async (resource) => {
                this.leftPanelLoading = true;
                this.partner = localStorage.getItem('partner');
                this.account = localStorage.getItem('account');
                this.term = '';
                this.term1 = '';
                this.term2 = '';
                this.businessLogicDataService.myAPIsForceFetchNextCall = true;
                this.closePanel(this.menus[1]['stickyMenus'], 'envMenu');
                await this.refreshTokenAndPermissions();
                switch (resource) {
                    case 'dataaccess':
                        this.refreshDAAS();
                        break;
                    case 'businesslogic':
                        this.refreshBusinessLogic();
                        break;
                    case 'sql':
                        this.refreshSQLQuery();
                        break;
                    case 'thirdparty':
                        this.refreshThirdParty();
                        break;
                    case 'testsuite':
                        this.refreshTestSuite();
                        break;
                    case 'executors':
                        this.refreshExecutors();
                        break;
                    case 'deletionUpdationOfEntity':
                        this.refreshEntities();
                        break;
                    case 'deletionUpdationOfExecutor':
                        this.refreshExecutors();
                        break;
                }
            }
        );

        leftPanelDataListener.saveEntityAndExecutors.subscribe((status) => {
            if (status && status !== null && status !== undefined && status === 'success') {
                this.isSaving = true;
                this.leftPanelLoading = true;
                this.refreshAPIHistory();
            }
        });

        apiGatewayListenerInstance.apiGatewayListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        deletionListenerInstance.deletionListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        devexListenerInstance.devexListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        emailTemplatesListenerInstance.emailTemplatesListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        databasesListenerInstance.databasesListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        sqlqueryListenerInstance.sqlQueryListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        workflowListenerInstance.workflowListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        testsuiteListenerInstance.testSuiteListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        idleTimeoutListenerInstance.idleTimeoutListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });

        permissionListenerInstance.permissionsListener.subscribe(event => {
            if (event === 'refreshCurrentSession') {
                this.refreshCurrentSession();
            }
        });


    }

    refreshAPIHistory() {
        let repsonseFromAPI: any;
        const refreshHistory = new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + this.partner + '&account=' + this.account + '&sort=-at&fields=at,executor_name,executor_type,by,executor_version,partner,account,action').subscribe(response1 => {
                if (response1 && response1 !== null && response1 !== undefined && response1[0]) {
                    repsonseFromAPI = response1;
                    this.apiHistory = response1;
                    resolve('success');
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
                this.openSnackBar('Error while refreshing the API history. Please try again after sometime.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        });
        Promise.all([refreshHistory]).then(resp => {
            this.apiHistory = repsonseFromAPI;
            if (this.isHistoryAvailable === false) {
                this.refreshLeftPanelStickyMenuForHistory();
            }
            setTimeout(() => {
                this.isSaving = false;
                this.leftPanelLoading = false;
            }, 2000);
        });
    }

    getId(categoryName) {
        const tempCategoryName = categoryName.replace(/\s/g, '');
        return 'btn' + tempCategoryName;
    }

    refreshLeftPanelStickyMenuForHistory() {
        const masterDataPayload = {
            'category': 'History',
            'expand': true,
            'route': null,
            'subcategory': []
        };
        this.masterData.push(masterDataPayload);

        const partnerInfoIndex = this.menus[1].stickyMenus.findIndex(value => value['name'] === 'partner-info');
        const historyData = {
            name: 'History',
            displayName: 'History',
            tooltipText: 'Shows history of API Executors',
            hasSubMenu: true,
            displayType: '',
            icon: 'fa fa-clock-o',
            submenus: []
        };
        if (partnerInfoIndex !== -1) {
            this.menus[1].stickyMenus.splice(partnerInfoIndex, 0, historyData);
        } else {
            this.menus[1].stickyMenus.push(historyData);
        }
        this.isHistoryAvailable = true;
    }

    validateMockResponseData(mockResponses) {
        if (mockResponses === null || mockResponses === undefined) {
            mockResponses = [];
        }
        for (const mockResponse of mockResponses) {
            mockResponse['headers'] = !mockResponse.headers ? [] : mockResponse.headers;
            mockResponse['responseAttributes'] = !mockResponse.responseAttributes ? [] : mockResponse.responseAttributes;

            mockResponse.headers.forEach((header, index) => {
                if (!((header.name && header.value) && header.name !== '' && header.value !== '')) {
                    mockResponse.headers.splice(index);
                }
            });

            mockResponse.responseAttributes.forEach((attribute, index) => {
                // if (!((attribute.attributeName && attribute.attributeType) && attribute.attributeName !== '' && attribute.attributeType !== '')) {
                //     mockResponse.responseAttributes.splice(index);
                // }

                if ((!attribute.attributeName || attribute.attributeName === '') || (!attribute.type || attribute.type === '')) {
                    mockResponse.responseAttributes.splice(index);
                }
            });
        }
        return mockResponses;
    }

    saveExecutorInfo(payload) {
        const saveExecutorInformation = new Promise((resolve, reject) => {
            this.confPost.saveExecutorInformation('v1', payload).subscribe(response => {
                this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + this.partner + '&account=' + this.account + '&sort=-at&fields=at,executor_name,executor_type,by,executor_version,partner,account,action').subscribe(response1 => {
                    if (response1 && response1 !== null && response1 !== undefined && response1[0]) {
                        this.apiHistory = response1;
                        // this.isSaving = false;
                        // this.leftPanelLoading = false;
                        resolve('success');
                        this.openSnackBar('API has been saved successfully.', 'Success', {
                            duration: 3000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else {
                        resolve('success');
                        // this.isSaving = false;
                        // this.leftPanelLoading = false;
                    }
                }, error => {
                    resolve('failed');
                    // this.isSaving = false;
                    // this.leftPanelLoading = false;
                    this.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }, error => {
                // this.isSaving = false;
                // this.leftPanelLoading = false;
                resolve('failed');
                this.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        });
        Promise.all([saveExecutorInformation]).then(resp => {
            this.isSaving = false;
            this.leftPanelLoading = false;
        });
    }

    refreshDAAS() {
        const getDatabasesForPartnerAccount = new Promise((resolve, reject) => {
            this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(databases => {
                    this.databases = databases;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });
        const entityNameAndVersionAsCustomType = new Promise((resolve, reject) => {
            this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
                    if (response.status === 200) {
                        this.entityAndVersion = response.body['entityNameAndVersion'];
                        resolve('success');
                    } else {
                        resolve('failure');
                    }
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting entity name and version for partner account', 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });
        const getDataTypesForPartnerAccount = new Promise((resolve, reject) => {
            this.confPost.getDataTypes().subscribe(data => {
                    this.datatypes = data;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting list of data types: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });
        const getCategoriesForPartnerAccount = new Promise((resolve, reject) => {
            this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                this.partnerCategories = data;
                resolve('success');
            }, error => {
                resolve('failure');
                this.openSnackBar('Error while retrieving data access services group by categories for your account', 'Error', {
                    duration: 30000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        });
        const getEntityCountForPartnerAccount = new Promise((resolve, reject) => {
            this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                    this.countPartnerAccountEntities = data;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting count of entities for partner account: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });
        const getEntityCountForPartner = new Promise((resolve, reject) => {
            this.confPost.getEntityCountForPartner(localStorage.getItem('partner')).subscribe(data => {
                    this.countPartnerEntities = data;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting count of entities for partner: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });

        const getExecutorsByPartnerAccount = new Promise((resolve, reject) => {
            this.getExecutorsForPartnerAccount().then(resp => {
                resolve('success');
            });
        });

        // const getExecutorsForPartnerAccount = new Promise((resolve, reject) => {
        //     this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
        //         this.partnerExecutors = data;
        //         resolve('success');
        //     }, error => {
        //         resolve('failure');
        //         // this.openSnackBar('Error while retrieving API executors for your account', 'Error', {
        //         //     duration: 30000,
        //         //     verticalPosition: 'top',
        //         //     horizontalPosition: 'center'
        //         // });
        //     });
        // });

        const getCategoriesEntitiesForPartner = new Promise((resolve, reject) => {
            const item = [];
            this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                if (data) {
                    this.entities = data;
                    this.partnerEntities = data;
                    this.partnerEntities.forEach(entity => {
                        this.partnerEntityTypes.push(entity.entityname + '_' + entity.version);
                    });
                    this.listOfDataAccessServices = data;
                    this.listOfDataAccessServices.forEach((ent) => {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + this.account + '=>' + ent['entityname'] + '=>' + ent['version'])) {
                            item.push(ent);
                        }
                    });
                    this.countOfDataAccessServices = item.length;
                    this.leftPanelDataListener.manageEntitiesUpdate.emit('update');
                    resolve('success');
                } else {
                    resolve('failure');
                    this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
                        duration: 30000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }, error => {
                resolve('failure');
                this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
                    duration: 30000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });

            // this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            //     if (data && data !== undefined && data !== null) {
            //         this.listOfDataAccessServices = data;
            //         this.listOfDataAccessServices[0]['accounts'].forEach((account) => {
            //             account.categories.forEach((category) => {
            //                 category.entities.forEach((entity) => {
            //                     const ent = {};
            //                     ent['category'] = category.category;
            //                     ent['account_id'] = account.account_id;
            //                     ent['APIs'] = entity;
            //                     if (this.hasAccountPermission('view:' + localStorage.getItem('partner') + '=>' + ent['account_id'] + '=>' + this.getValue(ent['APIs']) + '=>' + this.getVersion(ent['APIs']))) {
            //                         item.push(ent);
            //                     }
            //                 });
            //             });
            //         });
            //         this.countOfDataAccessServices = item.length;
            //         this.leftPanelDataListener.manageEntitiesUpdate.emit('update');
            //         resolve('success');
            //     } else {
            //         resolve('failure');
            //         this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
            //             duration: 30000,
            //             verticalPosition: 'top',
            //             horizontalPosition: 'center'
            //         });
            //     }
            // }, error => {
            //     resolve('failure');
            //     this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
        });

        const getAPIExecutorsByPartnerAccountType = new Promise((resolve, reject) => {
            this.getExecutorsForPartnerAccount().then(resp => {
                resolve('success');
            });
        });

        Promise.all([getDatabasesForPartnerAccount, entityNameAndVersionAsCustomType, getCategoriesEntitiesForPartner, getAPIExecutorsByPartnerAccountType,
            getDataTypesForPartnerAccount, getCategoriesForPartnerAccount, getEntityCountForPartnerAccount, getEntityCountForPartner, getExecutorsByPartnerAccount]).then(response => {
            this.leftPanelLoading = false;
        });

    }

    refreshBusinessLogic() {
        const authorizationTypes = new Promise((resolve, reject) => {
            this._service.getItems('v1', 'services', 'services', 'authorizationTypes', false).subscribe(authTypes => {
                    this.authorizationTypes = authTypes;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting authorization types for partner account: ' + error.error.message, 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });

        const b2bExecutors = new Promise((resolve, reject) => {
            this.providerObjects = {};
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(async response => {
                if (response['body'] && response['body'][0]) {
                    const providers = response['body'][0]['subscriptions']['providers'];
                    const subscribedProviders = [];
                    const myServiceProviders = [];
                    providers.forEach(provider => {
                        if (provider.partner === localStorage.getItem('partner') &&
                            provider.account === localStorage.getItem('account')) {
                            myServiceProviders.push(provider['producer']);
                        } else {
                            subscribedProviders.push(provider['producer']);
                        }
                        this.providerObjects[provider['producer']] = provider['title'];
                    });
                    let subscribedProvidersList = '';
                    for (let i = 0; i < subscribedProviders.length; i++) {
                        subscribedProvidersList += subscribedProviders[i];
                        if (i !== subscribedProviders.length - 1) {
                            subscribedProvidersList += ',';
                        }
                    }
                    let myProvidersList = '';
                    for (let i = 0; i < myServiceProviders.length; i++) {
                        myProvidersList += myServiceProviders[i];
                        if (i !== myServiceProviders.length - 1) {
                            myProvidersList += ',';
                        }
                    }
                    if (subscribedProvidersList !== '') {
                        await this.confPost.getSubscribedExecutors('b2b', 'b2b', subscribedProvidersList).subscribe(response1 => {
                            this.b2bExecutors = response1;
                            resolve('success');
                        }, error => {
                            reject('failed');
                        });
                    } else {
                        resolve('success');
                    }

                    if (myProvidersList !== '') {
                        await this.confPost.getMyProviderExecutors(localStorage.getItem('partner'), localStorage.getItem('account'), myProvidersList).subscribe(response1 => {
                            this.myProviderExecutors = response1;
                            resolve('success');
                        }, error => {
                            reject('failed');
                        });
                    } else {
                        resolve('success');
                    }
                } else {
                    resolve('failure');
                }
            }, error => {
                resolve('failure');
            });
        });

        const registeredConnectors = new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + this.partner + '&account=' + this.account)
                .toPromise().then(apiconnectors => {
                    this.registeredConnectors = apiconnectors;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting authorization types for partner account: ' + error.error.message, 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });

        const getExecutorsByPartnerAccount = new Promise((resolve, reject) => {
            this.getExecutorsForPartnerAccount().then(resp => {
                resolve('success');
            });
        });

        // const getExecutorsForPartnerAccount = new Promise((resolve, reject) => {
        //     this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
        //         this.partnerExecutors = data;
        //         resolve('success');
        //     }, error => {
        //         resolve('failure');
        //         // this.openSnackBar('Error while retrieving API executors for your account', 'Error', {
        //         //     duration: 30000,
        //         //     verticalPosition: 'top',
        //         //     horizontalPosition: 'center'
        //         // });
        //     });
        // });

        Promise.all([authorizationTypes, b2bExecutors, registeredConnectors, getExecutorsByPartnerAccount]).then(repsonse => {
            this.leftPanelLoading = false;
        });
    }

    refreshSQLQuery() {
        const queryBuilderAttributes = new Promise((resolve, reject) => {
            this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
                    this.queryBuilderAttributes = db;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting query builder attributes for partner account: ' + error.error.message, 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });

        const getExecutorsByPartnerAccount = new Promise((resolve, reject) => {
            this.getExecutorsForPartnerAccount().then(resp => {
                resolve('success');
            });
        });

        // const getExecutorsForPartnerAccount = new Promise((resolve, reject) => {
        //     this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
        //         this.partnerExecutors = data;
        //         resolve('success');
        //     }, error => {
        //         resolve('failure');
        //         // this.openSnackBar('Error while retrieving API executors for your account', 'Error', {
        //         //     duration: 30000,
        //         //     verticalPosition: 'top',
        //         //     horizontalPosition: 'center'
        //         // });
        //     });
        // });

        Promise.all([queryBuilderAttributes, getExecutorsByPartnerAccount]).then(response => {
            this.leftPanelLoading = false;
        });
    }

    refreshThirdParty() {

        const getExecutorsByPartnerAccount = new Promise((resolve, reject) => {
            this.getExecutorsForPartnerAccount().then(resp => {
                resolve('success');
            });
        });

        // const getExecutorsForPartnerAccount = new Promise((resolve, reject) => {
        //     this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
        //         this.partnerExecutors = data;
        //         resolve('success');
        //     }, error => {
        //         resolve('failure');
        //         // this.openSnackBar('Error while retrieving API executors for your account', 'Error', {
        //         //     duration: 30000,
        //         //     verticalPosition: 'top',
        //         //     horizontalPosition: 'center'
        //         // });
        //     });
        // });

        Promise.all([getExecutorsByPartnerAccount]).then(response => {
            this.leftPanelLoading = false;
        });
    }

    refreshTestSuite() {

        const getExecutorsByPartnerAccount = new Promise((resolve, reject) => {
            this.getExecutorsForPartnerAccount().then(resp => {
                resolve('success');
            });
        });

        // const getExecutorsForPartnerAccount = new Promise((resolve, reject) => {
        //     this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
        //         this.partnerExecutors = data;
        //         resolve('success');
        //     }, error => {
        //         resolve('failure');
        //     });
        // });

        Promise.all([getExecutorsByPartnerAccount]).then(response => {
            this.leftPanelLoading = false;
        });
    }

    refreshEntities() {

        const getEntityCountForPartnerAccount = new Promise((resolve, reject) => {
            this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                    this.countPartnerAccountEntities = data;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting count of entities for partner account: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });

        const getEntityCountForPartner = new Promise((resolve, reject) => {
            this.confPost.getEntityCountForPartner(localStorage.getItem('partner')).subscribe(data => {
                    this.countPartnerEntities = data;
                    resolve('success');
                },
                error => {
                    resolve('failure');
                    this.openSnackBar('Error while getting count of entities for partner: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });

        const getEntitiesForPartnerAccount = new Promise((resolve, reject) => {
            this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data1 => {
                this.entities = data1;
                this.partnerEntities = data1;
                this.partnerEntities.forEach(entity => {
                    this.partnerEntityTypes.push(entity.entityname + '_' + entity.version);
                });
                resolve('success');
            }, error => {
                resolve('failure');
                this.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
                    duration: 30000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        });

        const getCategoriesEntitiesForPartner = new Promise((resolve, reject) => {
            const item = [];

            this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                if (data) {
                    this.listOfDataAccessServices = data;
                    this.listOfDataAccessServices.forEach((ent) => {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + this.account + '=>' + ent['entityname'] + '=>' + ent['version'])) {
                            item.push(ent);
                        }
                    });
                    this.countOfDataAccessServices = item.length;
                    resolve('success');
                } else {
                    resolve('failure');
                    this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
                        duration: 30000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }, error => {
                resolve('failure');
                this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
                    duration: 30000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });

            // this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            //     if (data && data !== undefined && data !== null) {
            //         this.listOfDataAccessServices = data;
            //         this.listOfDataAccessServices[0]['accounts'].forEach((account) => {
            //             account.categories.forEach((category) => {
            //                 category.entities.forEach((entity) => {
            //                     const ent = {};
            //                     ent['category'] = category.category;
            //                     ent['account_id'] = account.account_id;
            //                     ent['APIs'] = entity;
            //                     if (this.hasAccountPermission('view:' + localStorage.getItem('partner') + '=>' + ent['account_id'] + '=>' + this.getValue(ent['APIs']) + '=>' + this.getVersion(ent['APIs']))) {
            //                         item.push(ent);
            //                     }
            //                 });
            //             });
            //         });
            //         this.countOfDataAccessServices = item.length;
            //         this.leftPanelDataListener.manageEntitiesUpdate.emit('update');
            //         resolve('success');
            //         // this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(entityCount => {
            //         //         if (entityCount) {
            //         //             this.countOfDataAccessServices = entityCount['noOfApis'];
            //         //         } else {
            //         //             this.countOfDataAccessServices = 0;
            //         //         }
            //         //         resolve('success');
            //         //     },
            //         //     error => {
            //         //         this.openSnackBar('Error while getting data access services count for partner: ' + error.error.message, 'Error', {
            //         //             duration: 15000,
            //         //             verticalPosition: 'top',
            //         //             horizontalPosition: 'center'
            //         //         });
            //         //     });
            //     } else {
            //         resolve('failure');
            //         this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
            //             duration: 30000,
            //             verticalPosition: 'top',
            //             horizontalPosition: 'center'
            //         });
            //     }
            // }, error => {
            //     resolve('failure');
            //     this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
        });

        const getAPIExecutorsByPartnerAccountType = new Promise((resolve, reject) => {
            // this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(response => {
            //     if (response && response !== null && response !== undefined) {
            //         this.apiExecutors = [];
            //         let resp: any;
            //         resp = response;
            //         for (const item of resp) {
            //             if (this.hasAccountPermission('view:' + localStorage.getItem('partner') + '=>' + item.account_id + '=>' + item.executor_category + '=>' + item.executor_version)) {
            //                 this.apiExecutors.push(item);
            //             }
            //         }
            //         if (this.apiExecutors) {
            //             this.countOfApiExecutors = this.apiExecutors.length;
            //         }
            //         resolve('success');
            //     } else {
            //         resolve('failure');
            //         this.openSnackBar('Error while retrieving data access APIs for your account', 'Error', {
            //             duration: 30000,
            //             verticalPosition: 'top',
            //             horizontalPosition: 'center'
            //         });
            //     }
            // }, error => {
            //     resolve('failure');
            //     this.openSnackBar('Error while retrieving data access APIs for your account', 'Error', {
            //         duration: 30000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'center'
            //     });
            // });
            this.getExecutorsForPartnerAccount().then(resp => {
                resolve('success');
            });
        });

        Promise.all([getAPIExecutorsByPartnerAccountType, getCategoriesEntitiesForPartner, getEntitiesForPartnerAccount, getEntityCountForPartner, getEntityCountForPartnerAccount]).then(response => {
            this.leftPanelDataListener.manageEntitiesUpdate.emit('update');
            this.leftPanelLoading = false;
        });
    }

    refreshExecutors() {
        const getExecutorsByPartnerAccount = new Promise((resolve, reject) => {
            this.getExecutorsForPartnerAccount().then(resp => {
                resolve('success');
            });
        });

        // const getExecutorsForPartnerAccount = new Promise((resolve, reject) => {
        //     this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
        //         this.partnerExecutors = data;
        //         resolve('success');
        //     }, error => {
        //         resolve('failure');
        //     });
        // });

        Promise.all([getExecutorsByPartnerAccount]).then(response => {
            this.leftPanelDataListener.manageEntitiesUpdate.emit('update');
            this.leftPanelLoading = false;
        });
    }

    notifyErrorToAdmins(payload, successEventName, failedEventName, errorMessage, requestPayload) {
        return new Promise((resolve, reject) => {
            this.confPost.notifyErrorToAdmins(payload).subscribe(resp => {
                resolve('success');
            }, error1 => {
                let errorMessage1 = '';
                if (error1 && error1.error && error1.error.message && error1.error.message !== null && error1.error.message !== undefined && error1.error.message !== '') {
                    errorMessage1 = error1.error.message;
                } else if (error1 && error1.error && error1.error !== undefined && error1.error !== null && error1.error !== '') {
                    errorMessage1 = error1.error;
                } else {
                    errorMessage1 = errorMessage;
                }
                resolve('failed');
            });
        });
    }

    closePanel(menus, id) {
        this.settingsflag = false;
        this.subMenu = false;
        this.appComponent.subMenuPanelExpanded = false;
        this.appComponent.leftMenuPanelExpanded = 'col-md-1 col-lg-1 sideBarCollapsed';
        let flagid: any;
        for (let i = 0; i < menus.length; i++) {
            if ($('#' + id + i).hasClass('selectedClass')) {
                flagid = i;
                $('#' + id + i).removeClass('selectedClass');
            }
        }
    }

    hignlightSelection(index, id, menus) {
        let flagid: any;
        for (let i = 0; i < menus.length; i++) {
            if ($('#' + id + i).hasClass('selectedClass')) {
                flagid = i;
                $('#' + id + i).removeClass('selectedClass');
            }
        }
        if (index !== flagid) {
            $('#' + id + index).addClass('selectedClass');
        }

    }

    hasPartnerInfoPermission(partnerInfo) {
        switch (partnerInfo) {
            case 'Email':
                return this.hasPlatformPermission('VIEW_PRIMARY_EMAIL_PARTNER_DETAILS');
            case 'Partner Short Code':
                return this.hasPlatformPermission('VIEW_PARTNER_SHORTCODE_PARTNER_DETAILS');
            case 'Partner Key':
                return this.hasPlatformPermission('VIEW_PARTNER_KEY_PARTNER_DETAILS');
            case 'API Key':
                return this.hasPlatformPermission('VIEW_API_KEY_PARTNER_DETAILS');
        }
    }

    hasPartnerCopyPermission(partnerInfo) {
        switch (partnerInfo) {
            case 'Partner Key':
                return this.hasPlatformPermission('COPY_PARTNER_KEY_PARTNER_DETAILS');
            case 'API Key':
                return this.hasPlatformPermission('COPY_API_KEY_PARTNER_DETAILS');
        }
    }

    async setEnvironmentsToSettingsPayloadToInsert() {
        this.settingsPayloadToInsert.environments = [
            {
                name: '',
                type: '',
                cloud: [
                    {
                        type: 'aws',
                        region: 'US-East (N.Virginia)',
                        is_default: true,
                        regions: [
                            'US-East (N.Virginia)'
                        ],
                        audit_logs: [
                            {
                                action: 'CREATE',
                                by: localStorage.getItem('signInEmail'),
                                at: Date.now()
                            }
                        ]
                    }
                ],
                display_name: '',
                is_validation_complete: false,
                is_creation_complete: true,
                services: [
                    {
                        name: 'Secrets Manager',
                        type: 'secretsmanager',
                        configurations: [
                            {
                                name: 'Default',
                                providerName: 'apiplatform.io',
                                image: './assets/img/partnerOnboarding/api.png',
                                description: 'apiplatform\'s encryption mechanism',
                                owner: 'apiplatform.io',
                                is_default: true,
                                audit_logs: [
                                    {
                                        action: 'CREATE',
                                        by: localStorage.getItem('signInEmail'),
                                        at: Date.now()
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        name: 'Databases',
                        type: 'databases',
                        configurations: []
                    },
                    {
                        configurations: [
                            {
                                name: 'Platform Console',
                                url: localStorage.getItem('partner') + '.apiplatform.io',
                                audit_logs: [
                                    {
                                        action: 'CREATE',
                                        by: localStorage.getItem('signInEmail'),
                                        at: Date.now()
                                    }
                                ],
                                status: true,
                                verification_status: 'created',
                                env_creation_status_after_verification: 'success',
                                is_default: true,
                                primary_region: 'US-East (N.Virginia)',
                                cloud: 'aws',
                                regions: [
                                    'US-East (N.Virginia)'
                                ]
                            }
                        ],
                        name: 'Platform Console',
                        type: 'dashboard'
                    },
                    {
                        configurations: [
                            {
                                name: 'Developer Experience',
                                url: localStorage.getItem('partner') + '.devex.apiplatform.io',
                                audit_logs: [
                                    {
                                        action: 'CREATE',
                                        by: localStorage.getItem('signInEmail'),
                                        at: Date.now()
                                    }
                                ],
                                status: true,
                                verification_status: 'created',
                                env_creation_status_after_verification: 'success',
                                is_default: true,
                                primary_region: 'US-East (N.Virginia)',
                                cloud: 'aws',
                                regions: [
                                    'US-East (N.Virginia)'
                                ]
                            }
                        ],
                        name: 'Developer Experience',
                        type: 'devex'
                    },
                    {
                        configurations: [
                            {
                                name: 'API Gateway Manager',
                                provider: 'apiplatform.io',
                                gateway_configurations: {},
                                url: await this.getDefaultGatewayURL(),
                                audit_logs: [
                                    {
                                        action: 'CREATE',
                                        by: localStorage.getItem('signInEmail'),
                                        at: Date.now()
                                    }
                                ],
                                status: true,
                                verification_status: 'created',
                                env_creation_status_after_verification: 'success',
                                is_default: true,
                                primary_region: 'US-East (N.Virginia)',
                                cloud: 'aws',
                                regions: [
                                    'US-East (N.Virginia)'
                                ]
                            }
                        ],
                        name: 'API Gateway Manager',
                        type: 'apigateway'
                    },
                    {
                        configurations: [
                            {
                                name: 'Storage',
                                provider: 'apiplatform.io',
                                url: 'https://s3.amazonaws.com/' + localStorage.getItem('partner') + '.apiplatform.io',
                                audit_logs: [
                                    {
                                        action: 'CREATE',
                                        by: localStorage.getItem('signInEmail'),
                                        at: Date.now()
                                    }
                                ],
                                status: true,
                                verification_status: 'created',
                                env_creation_status_after_verification: 'success',
                                is_default: true,
                                primary_region: 'US-East (N.Virginia)',
                                cloud: 'aws',
                                regions: [
                                    'US-East (N.Virginia)'
                                ]
                            }
                        ],
                        name: 'Storage',
                        type: 'storage'
                    },
                    {
                        configurations: [
                            {
                                name: 'S3 Bucket Connectors',
                                audit_logs: [
                                    {
                                        action: 'CREATE',
                                        by: localStorage.getItem('signInEmail'),
                                        at: Date.now()
                                    }
                                ],
                                is_default: true,
                                provider: 'apiplatform.io',
                                bucketName: localStorage.getItem('partner') + '.apiplatform.io',
                                defaultBucket: true
                            }
                        ],
                        name: 'S3 Bucket Connectors',
                        type: 's3BucketConnectors'
                    }
                ],
                is_enabled: false
            }
        ];
    }

    hasCreateFromPermission(categoryName) {
        return true;
    }

    stringifyjson(val) {
        return JSON.stringify(val);
    }

    getFormattedJSONForUI(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

    openSnackBar(message: string, panelClass: string, config: any) {
        let snackBarConfigs: any;
        if (config !== null && config !== undefined && config !== '') {
            snackBarConfigs = config;
            snackBarConfigs['data'] = message;
            snackBarConfigs['panelClass'] = panelClass;
        } else {
            snackBarConfigs = {
                data: message,
                verticalPosition: 'top',
                horizontalPosition: 'center',
                panelClass: panelClass,
                duration: 30000
            };
        }
        this.snackBar.openFromComponent(SnackbarComponent, snackBarConfigs);
        // this.snackBar.openFromComponent(SnackbarComponent, {
        //     data: message,
        //     verticalPosition: 'top',
        //     horizontalPosition: 'center',
        //     panelClass: panelClass,
        //     duration: 30000
        // });
        // Duration and positions needs to be configurable
    }

    checkExistingEntityForPartner(name, version) {
        return new Promise((resolve, reject) => {
            this.confPost.getEntity(localStorage.getItem('partner'), localStorage.getItem('account'), name, version).subscribe(response => {
                if (response !== null && response !== undefined) {
                    reject({status: 'already exists', type: 'entity'});
                } else {
                    resolve('success');
                }
            }, error => {
                if (error.status === 404) {
                    resolve('success');
                } else {
                    this.checkForExistingEntitiesAndExecutorsCount += 1;
                    if (this.checkForExistingEntitiesAndExecutorsCount <= 3) {
                        setTimeout(async () => {
                            await this.checkExistingEntityForPartner(name, version);
                        }, 2000);
                    } else {
                        this.checkForExistingEntitiesAndExecutorsCount = 0;
                        reject({status: 'failed'});
                    }
                }
            });
        });
    }

    checkExistingExecutorForPartner(name, version) {
        return new Promise((resolve, reject) => {
            this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(localStorage.getItem('partner'), localStorage.getItem('account'), name, version).subscribe(response => {
                if (response !== null && response !== undefined) {
                    reject({status: 'already exists', type: 'executor'});
                } else {
                    resolve('success');
                }
            }, error => {
                if (error.status === 404) {
                    resolve('success');
                } else {
                    this.checkForExistingEntitiesAndExecutorsCount += 1;
                    if (this.checkForExistingEntitiesAndExecutorsCount <= 3) {
                        setTimeout(async () => {
                            await this.checkExistingExecutorForPartner(name, version);
                        }, 2000);
                    } else {
                        this.checkForExistingEntitiesAndExecutorsCount = 0;
                        reject({status: 'failed'});
                    }
                }
            });
        });
    }

    CheckForExistingEntityOrExecutor(name, version) {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.checkExistingEntityForPartner(name, version)).then(response => {
                Promise.resolve(this.checkExistingExecutorForPartner(name, version)).then(response1 => {
                    resolve('success');
                }, error => {
                    reject(error);
                });
            }, error => {
                reject(error);
            });
        });

    }

    getRegion(val) {
        return (val != null && val !== '') ? val : environment.defaultDatabaseRegion;
    }

    openAPIPolicies(partner, account, APIName, version) {
        const dialogRef = this.dialog.open(APIPoliciesComponent, {
            height: '70%',
            minWidth: '450px',
            maxWidth: '450px',
            disableClose: true,
            data: {
                partner: partner,
                account: account,
                APIName: APIName,
                version: version,
                email: localStorage.getItem('signInEmail'),
            }
        });
    }

    checkExistingEntityForPartnerWithParams(partner, account, pkey, name, version) {
        return new Promise((resolve, reject) => {
            this.confPost.getEntityForPartner(partner, account, pkey, name, version).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.existingEntity = response;
                    this.existingExecutor = null;
                    reject({status: 'already exists'});
                } else {
                    this.existingEntity = null;
                    this.existingExecutor = null;
                    resolve('success');
                }
            }, error => {
                if (error.status === 404) {
                    resolve('success');
                } else {
                    this.checkForExistingEntitiesAndExecutorsCount += 1;
                    if (this.checkForExistingEntitiesAndExecutorsCount <= 3) {
                        setTimeout(async () => {
                            await this.checkExistingEntityForPartnerWithParams(partner, account, pkey, name, version);
                        }, 2000);
                    } else {
                        this.checkForExistingEntitiesAndExecutorsCount = 0;
                        reject('failed');
                    }
                }
            });
        });
    }

    checkExistingExecutorForPartnerWithParams(partner, account, pkey, name, version) {
        return new Promise((resolve, reject) => {
            this.confPost.getAPIExecutorForPartnerAccount(partner, account, pkey, name, version).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.existingEntity = null;
                    this.existingExecutor = response;
                    reject({status: 'already exists'});
                } else {
                    this.existingEntity = null;
                    this.existingExecutor = null;
                    resolve('success');
                }
            }, error => {
                if (error.status === 404) {
                    resolve('success');
                } else {
                    reject(error);
                }
                // this.checkForExistingEntitiesAndExecutorsCount += 1;
                // if (this.checkForExistingEntitiesAndExecutorsCount <= 3) {
                //     setTimeout(async () => {
                //         await this.checkExistingExecutorForPartnerWithParams(partner, account, pkey, name, version);
                //     }, 2000);
                // } else {
                //     this.checkForExistingEntitiesAndExecutorsCount = 0;
                //     reject('failed');
                // }
            });
        });
    }

    CheckForExistingEntityOrExecutorWithParams(partner, account, pkey, name, version) {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.checkExistingEntityForPartnerWithParams(partner, account, pkey, name, version)).then(response => {
                Promise.resolve(this.checkExistingExecutorForPartnerWithParams(partner, account, pkey, name, version)).then(response1 => {
                    resolve('success');
                }, error => {
                    reject(error);
                });
            }, error => {
                reject(error);
            });
        });

    }

    timeConverter(ts) {
        let str = '';
        const date_ob = new Date(ts);
        const year = date_ob.getFullYear();
        const month = ('0' + (date_ob.getMonth() + 1)).slice(-2);
        const date = ('0' + date_ob.getDate()).slice(-2);
        const hours = ('0' + date_ob.getHours()).slice(-2);
        const minutes = ('0' + date_ob.getMinutes()).slice(-2);
        const seconds = ('0' + date_ob.getSeconds()).slice(-2);
        str = str + date + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;
        return str;
    }

    decrypt(salt, iv, passPhrase, plainText, keySize, iterationCount) {
        const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {keySize: keySize, iterations: iterationCount});
        const cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Base64.parse(plainText)
        });
        const decrypted = CryptoJS.AES.decrypt(
            cipherParams,
            key,
            {iv: CryptoJS.enc.Hex.parse(iv)});
        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        return decryptedString.toString();
    }

    decryptAttribute(salt, iv, passPhrase, plainText, keySize, iterationCount) {
        return new Promise((resolve, reject) => {
            resolve(this.decrypt(salt, iv, passPhrase, plainText, keySize, iterationCount));
        });
    }

    encrypt(salt, iv, passPhrase, plainText, keySize, iterationCount) {
        const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {keySize: keySize, iterations: iterationCount});
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            key,
            {iv: CryptoJS.enc.Hex.parse(iv)});
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }

    encryptAttribute(salt, iv, passPhrase, plainText, keySize, iterationCount) {
        return new Promise((resolve, reject) => {
            resolve(this.encrypt(salt, iv, passPhrase, plainText, keySize, iterationCount));
        });
    }

    generateActionPayload(isError, eventname, logLevel, responseStatusCode, responseStatus, errorMessage, payload, response, slug) {
        return new Promise((resolve, reject) => {
            const actionPayloadForAudit = {
                data: {}
            };
            actionPayloadForAudit['timestamp'] = Date.now();
            actionPayloadForAudit['standardTime'] = this.appComponent.timeConverter(Date.now());
            actionPayloadForAudit['eventName'] = eventname;
            actionPayloadForAudit['logLevel'] = logLevel;
            actionPayloadForAudit['responseStatusCode'] = responseStatusCode;
            actionPayloadForAudit['responseStatus'] = responseStatus;
            actionPayloadForAudit['data']['payload'] = payload;
            actionPayloadForAudit['data']['response'] = response;
            actionPayloadForAudit['slug'] = slug;
            actionPayloadForAudit['user'] = localStorage.getItem('signInEmail');
            if (isError) {
                actionPayloadForAudit['errorMessage'] = errorMessage;
            }
            this.appComponent.actionsOfCurrentSession.push(actionPayloadForAudit);
            resolve(this.appComponent.actionsOfCurrentSession);
        });
    }

    // This function has to be removed
    generateActionPayloadForAudit(isError, eventname, logLevel, responseStatusCode, responseStatus, errorMessage, payload, response, slug) {
        return new Promise((resolve, reject) => {
            resolve();
        });
    }

    createAPIAuditLog(partner, account, name, version, type, schema) {
        return new Promise((resolve, reject) => {
            if (schema['creationTime'] === null || schema['creationTime'] === undefined || schema['creationTime'] === 0) {
                schema['creationTime'] = Date.now();
                schema['lastModifiedTime'] = Date.now();
            }
            const apiAuditPayload = {
                partner: partner,
                account: account,
                type: type,
                name: name,
                version: version,
                audit_logs: [
                    {
                        action: 'CREATE',
                        by: localStorage.getItem('signInEmail'),
                        at: schema['lastModifiedTime'],
                        request_payload: schema
                    }
                ],
                isActive: true
            };
            this._service.addItem(apiAuditPayload, 'v1', 'services', 'services', 'apiAuditLogs').subscribe(resp1 => {
                resolve('success');
            }, error => {
                reject('failed');
            });
        });
    }

    updateAPIAuditLog(partner, account, name, version, type, schema, orig_exec) {
        if (orig_exec['creationTime'] === null || orig_exec['creationTime'] === undefined || orig_exec['creationTime'] === 0) {
            schema['creationTime'] = Date.now();
            schema['lastModifiedTime'] = Date.now();
        }
        this.confPost.getData('services', 'services', 'v1', 'apiAuditLogs', 'partner=' + partner + '&account=' + account + '&name=' + name + '&version=' + version + '&isActive=true').subscribe(async resp => {
            if (resp && resp[0]) {
                let auditResp: any;
                auditResp = resp[0];
                if (auditResp['audit_logs']) {
                    auditResp['audit_logs'].push({
                        action: 'UPDATE',
                        by: localStorage.getItem('signInEmail'),
                        at: schema['lastModifiedTime'],
                        request_payload: schema
                    });
                    this.confPost.patchEntityData('services', 'services', 'v1', 'apiAuditLogs', auditResp['id'], auditResp).subscribe(auditUpdateResp => {
                    });
                }
            } else {
                await Promise.resolve(this.createAPIAuditLog(partner, account, name, version, type, schema)).then(resp1 => {
                    this.updateAPIAuditLog(partner, account, name, version, type, schema, orig_exec);
                });
            }
        });
    }

    deleteAPIAuditLog(partner, account, name, version, type, schema) {
        // this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(partner, account, name, version).subscribe(schema => {
        if (schema) {
            if (schema['creationTime'] === null || schema['creationTime'] === undefined || schema['creationTime'] === 0) {
                schema['creationTime'] = Date.now();
                schema['lastModifiedTime'] = Date.now();
            }
            this.confPost.getData('services', 'services', 'v1', 'apiAuditLogs', 'partner=' + partner + '&account=' + account + '&name=' + name + '&version=' + version + '&isActive=true').subscribe(async resp => {
                if (resp && resp[0]) {
                    let auditResp: any;
                    auditResp = resp[0];
                    if (auditResp['audit_logs']) {
                        auditResp['audit_logs'].push({
                            action: 'DELETE',
                            by: localStorage.getItem('signInEmail'),
                            at: schema['lastModifiedTime'],
                            request_payload: schema
                        });
                        auditResp['isActive'] = false;
                        this.confPost.patchEntityData('services', 'services', 'v1', 'apiAuditLogs', auditResp['id'], auditResp).subscribe(auditUpdateResp => {
                        });
                    }
                } else {
                    await Promise.resolve(this.createAPIAuditLog(partner, account, name, version, type, schema)).then(resp1 => {
                        this.deleteAPIAuditLog(partner, account, name, version, type, schema);
                    });
                }
            });
        }
        // });
    }

    toggleExecutor(ev, id) {
        $(id).slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    getEntitiesForPlatformAccounts() {
        this.confPost.getEntitiesForPartnerAccount('samples', 'samples').toPromise().then(samples => {
            this.samplesEntities = samples;
        }, error => {
            this.openSnackBar('Error while retrieving samples for your account', 'Error', {
                duration: 30000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });

        this.confPost.getEntitiesForPartnerAccount('commons', localStorage.getItem('commons')).toPromise().then(commons => {
            this.commonsEntities = commons;
        }, error => {
            this.openSnackBar('Error while retrieving common data access services for your account', 'Error', {
                duration: 30000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });

        this.confPost.getEntitiesForPartnerAccount('templates', 'templates').toPromise().then(templates => {
            this.templatesEntities = templates;
        }, error => {
            this.openSnackBar('Error while retrieving templates data access services for your account', 'Error', {
                duration: 30000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    async getEntitiesAndExecutorsForThePartnerAccount() {

        await this.getExecutorsForPartnerAccount();

        this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {

            this.entities = data;
            this.partnerEntities = data;
            this.partnerEntities.forEach(entity => {
                this.partnerEntityTypes.push(entity.entityname + '_' + entity.version);
            });
            this.listOfDataAccessServices = data;
            const item = [];
            this.listOfDataAccessServices.forEach((ent) => {
                if (this.hasAccountPermission('view:' + this.partner + '=>' + this.account + '=>' + ent['entityname'] + '=>' + ent['version'])) {
                    item.push(ent);
                }
            });
            this.countOfDataAccessServices = item.length;
            this.leftPanelDataListener.manageEntitiesUpdate.emit('update');

        }, error => {
            this.leftPanelDataListener.manageEntitiesUpdate.emit('update');

            this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
                duration: 30000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    // Not required. Has to be removed
    refreshCurrentSession() {
        return new Promise((resolve, reject) => {
            resolve('success');
        });
    }

    createNestedObject(base, names) {
        for (let i = 0; i < names.length; i++) {
            base = base[names[i]] = base[names[i]] || {};
        }
    }

    // getProperty(key): string {
    //     if (this.properties.length === 0) {
    //         (this.getPropertiesFromAPI()).then(resp => {
    //             return this.returnProperty(key);
    //         });
    //     } else {
    //         return this.returnProperty(key);
    //     }
    // }

    setProperty(): void {
        if (this.properties.length === 0) {
            (this.getPropertiesFromAPI()).then(resp => {
                return;
            });
        }
    }

    // hasProperty(): boolean {
    //     if (this.properties.length > 0) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }

    getApplicationsForPartnerAccount() {
        return new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'application', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account')).subscribe(async resp => {
                this.applicationData = resp;
                this.countOfApplications = this.applicationData.length;
                this.leftPanelDataListener.manageEntitiesUpdate.emit('application');
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    getExecutorsForPartnerAccount() {
        return new Promise((resolve, reject) => {
            this.executorLoadingInLeftPanel = true;
            this.confPost.getApiExecutorsByPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&fields=partner,account_id,executor_name,executor_version,executor_method_type,executor_type,executor_scope,executor_display_name,executor_category,service_provider,apiUrl,published,scopeOfAccess,registeredAsIs,creationTime,lastModifiedTime,executor_description,pathParams,queryParams,headers,authModel,requestBody,responseAttributes,isDocumentationPublished&limit=30000').toPromise().then(data => {
                const apiExecutors = [];
                const businessLogicExecutors = [];
                const sqlQueryExecutors = [];
                const unifiedQueryExecutors = [];
                const testSuiteExecutors = [];
                const workflowExecutors = [];
                const dmnExecutors = [];
                const plsqlExecutors = [];
                const dataTransformationExecutors = [];
                const thirdpartyExecutors = [];
                this.allExecutorsButDaaS = [];


                const partnerExecutors = [];


                this.leftpanelData = data;

                for (const executor of this.leftpanelData) {
                    if (executor) {
                        if (partnerExecutors.length === 0) {
                            partnerExecutors.push({category: executor['executor_category'], executors: []});
                        } else {
                            if (partnerExecutors.findIndex((exec) => exec['category'] === executor['executor_category']) === -1) {
                                partnerExecutors.push({category: executor['executor_category'], executors: []});
                            }
                        }
                    }
                }

                const iterator = this.leftpanelData[Symbol.iterator]();
                while (true) {
                    const tempObject = iterator.next();
                    if (tempObject.done) {
                        break;
                    } else {
                        partnerExecutors[partnerExecutors.findIndex((exec) => exec['category'] === tempObject.value['executor_category'])]['executors'].push(tempObject.value);
                    }
                    if (tempObject.value['executor_type'] === 'API') {
                        apiExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'BUSINESSLOGIC') {
                        businessLogicExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'SQLQUERY') {
                        sqlQueryExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'UNIFIEDQUERY') {
                        unifiedQueryExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'TESTSUITE' || tempObject.value['executor_type'] === 'EXTERNALTESTSUITE') {
                        testSuiteExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'THIRDPARTY') {
                        thirdpartyExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'WORKFLOW') {
                        workflowExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'DMN') {
                        dmnExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'PLSQL') {
                        plsqlExecutors.push(tempObject.value);
                    } else if (tempObject.value['executor_type'] === 'DATATRANSFORMATION') {
                        dataTransformationExecutors.push(tempObject.value);
                    }
                }

                this.partnerExecutors = partnerExecutors;


                this.allExecutorsButDaaS = this.allExecutorsButDaaS.concat(businessLogicExecutors, sqlQueryExecutors, unifiedQueryExecutors, testSuiteExecutors, workflowExecutors, dmnExecutors, plsqlExecutors, dataTransformationExecutors);

                this.apiExecutors = [];
                for (const item of apiExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_category + '=>' + item.executor_version)) {
                            this.apiExecutors.push(item);
                        }
                    }
                }
                if (this.apiExecutors) {
                    this.countOfApiExecutors = this.apiExecutors.length;
                }
                this.businessLogicExecutors = [];
                for (const item of businessLogicExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.businessLogicExecutors.push(item);
                        }
                    }
                }
                if (this.businessLogicExecutors) {
                    this.executors = this.businessLogicExecutors;
                    this.countOfBusinessLogicApis = this.businessLogicExecutors.length;
                }
                this.thirdPartyApiExecutors = [];
                for (const item of thirdpartyExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.thirdPartyApiExecutors.push(item);
                        }
                    }
                }
                if (this.thirdPartyApiExecutors) {
                    this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
                }
                this.sqlQueryExecutors = [];
                for (const item of sqlQueryExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.sqlQueryExecutors.push(item);
                        }
                    }
                }
                if (this.sqlQueryExecutors) {
                    this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
                }

                this.dataTransformationExecutors = [];
                for (const item of dataTransformationExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.dataTransformationExecutors.push(item);
                        }
                    }
                }
                if (this.dataTransformationExecutors) {
                    this.countOfDataTransformationApis = this.dataTransformationExecutors.length;
                }

                this.unifiedQueryExecutors = [];
                for (const item of unifiedQueryExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.unifiedQueryExecutors.push(item);
                        }
                    }
                }
                if (this.unifiedQueryExecutors) {
                    this.countOfUnifiedQueryApis = this.unifiedQueryExecutors.length;
                }
                this.testSuiteExecutors = [];
                for (const item of testSuiteExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.testSuiteExecutors.push(item);
                        }
                    }
                }
                if (this.testSuiteExecutors) {
                    this.countOfTestSuiteApis = this.testSuiteExecutors.length;
                }
                this.workFlowExecutors = [];
                for (const item of workflowExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.workFlowExecutors.push(item);
                        }
                    }
                }
                if (this.workFlowExecutors) {
                    this.countOfWorkflowApis = this.workFlowExecutors.length;
                }
                this.dmnExecutors = [];
                for (const item of dmnExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.dmnExecutors.push(item);
                        }
                    }
                }
                if (this.dmnExecutors) {
                    this.countOfDmnApis = this.dmnExecutors.length;
                }
                this.plsqlExecutors = [];
                for (const item of plsqlExecutors) {
                    if (item) {
                        if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version)) {
                            this.plsqlExecutors.push(item);
                        }
                    }
                }
                if (this.plsqlExecutors) {
                    this.countOfPlSqlApis = this.plsqlExecutors.length;
                }
                this.leftPanelDataListener.manageEntitiesUpdate.emit('update');

                this.executorLoadingInLeftPanel = false;
                resolve('success');
            }, error => {
                this.executorLoadingInLeftPanel = false;
                resolve('failed');
            });
        });

    }

    getProperty(key): string {
        let value = key;

        if (this.properties && this.properties.length > 0) {
            this.properties.forEach(property => {
                if (property.key === key) {
                    value = property.value;
                    return value;
                }
            });
        }
        return value;
    }

    getPropertiesFromAPI() {
        return new Promise((resolve, reject) => {
            this.confPost.getDataFromServiceForPartnerAccount('properties', 'services', 'services').subscribe(props => {
                if (props) {
                    this.properties = props[0]['properties'];
                    resolve('success');
                } else {
                    reject({error: 'No data'});
                }
            }, error => {
                reject(error);
            });
        });
    }

    getGuideTourSteps(): Array<TourStep> {
        return this.guideTourSteps;
    }

    setGuideTourSteps(obj) {
        this.guideTourSteps = obj;
    }

    setheaderCmpTourSteps(obj) {
        this.headerCmpTourSteps = obj;
    }


    getLanguages() {
        this.confPost.getLanguages().subscribe(
            items => {
                this.languages = items;
            },
            error => {
                this.openSnackBar('Error while getting list of languages: ' + error.error.message, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        );
    }

    getCategoriesForPartnerAccount() {
        return new Promise((resolve, reject) => {
            if (this.partnerCategories === null || this.partnerCategories === undefined) {
                this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                    this.partnerCategories = data;
                    resolve('success');
                }, error => {
                    this.openSnackBar('Error while retrieving data access services group by categories for your account', 'Error', {
                        duration: 30000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
            resolve('success');
        });
    }

    copyMessage(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        // selBox.value = $(val).text();
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.openSnackBar('Copied to clipboard.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    getCustomTypes(val) {
        return new Promise((resolve, reject) => {
            this.confPost.getEntityNameAndVersionAsCustomTypeWithParams(localStorage.getItem('partner'), localStorage.getItem('account'), val).subscribe(response => {
                    if (response.status === 200) {
                        this.entityAndVersion = response.body['entityNameAndVersion'];
                        resolve('success');
                    } else {
                        this.entityAndVersion = [];
                        resolve('failed');
                    }
                },
                error => {
                    this.entityAndVersion = [];
                    this.handleErrorGracefully(error, 'Error while getting entity name and version for partner account. Please try again after sometime.');
                    resolve('success');
                });
        });
    }

    getDatabaseObjectTypes() {
        return new Promise((resolve, reject) => {
            this.confPost.getDatabaseObjectTypes().subscribe(data => {
                this.databaseObjectTypes = data;
                resolve('success');
            }, error => {
                reject(error);
            });
        });
    }

    getDatabasesForPartnerAccount() {

        return new Promise((resolve, reject) => {
            this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(async databases => {
                    this.databases = databases;
                    await this.updateIsNoSQLForMongo(this.databases);
                    resolve('success');
                },
                error => {
                    this.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    reject('failed');
                });
        });
    }

    getDataTypesForPartnerAccount() {
        return new Promise((resolve, reject) => {
            this.confPost.getDataTypes().subscribe(data => {
                    this.datatypes = data;
                    resolve('success');
                },
                error => {
                    this.openSnackBar('Error while getting list of data types: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    reject('failure');
                });
        });
    }

    getEntityCountForPartner() {
        this.confPost.getEntityCountForPartner(localStorage.getItem('partner')).subscribe(data => {
                this.countPartnerEntities = data;
            },
            error => {
                this.openSnackBar('Error while getting count of entities for partner: ' + error.error.message, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
    }

    getEntityCountForPartnerAccount() {
        this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                this.countPartnerAccountEntities = data;
            },
            error => {
                this.openSnackBar('Error while getting count of entities for partner account: ' + error.error.message, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
    }

    getCategoriesEntitiesForPartner() {
        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            this.categoriesEntitiesForPartner = data;
        }, error => {
            this.openSnackBar('Error while getting entities grouped by category for partner account: ' + error.error.message, 'Error', {
                duration: 30000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getApiExecutorsByPartnerAccountType() {
        this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
            this.apiExecutors = [];
            let resp: any;
            resp = data;
            for (const item of resp) {
                if (this.hasAccountPermission('view:' + localStorage.getItem('partner') + '=>' + item.account_id + '=>' + item.executor_category + '=>' + item.executor_version)) {
                    this.apiExecutors.push(item);
                }
            }
            if (this.apiExecutors) {
                this.countOfApiExecutors = this.apiExecutors.length;
            }
            // localStorage.setItem('dataAccessAPI', JSON.stringify(this.apiExecutors));
        }, error => {
            this.openSnackBar('Error while getting API Executors grouped by Type for a partner account: ' + error.error.message, 'Error', {
                duration: 30000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getb2bAPIs() {
        return new Promise((resolve, reject) => {
            this.providerObjects = {};
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(async response => {
                if (response['body'] && response['body'][0]) {
                    const providers = response['body'][0]['subscriptions']['providers'];
                    const subscribedProviders = [];
                    const myServiceProviders = [];
                    providers.forEach(provider => {
                        if (provider.partner === localStorage.getItem('partner') &&
                            provider.account === localStorage.getItem('account')) {
                            myServiceProviders.push(provider['producer']);
                        } else {
                            subscribedProviders.push(provider['producer']);
                        }
                        this.providerObjects[provider['producer']] = provider['title'];
                    });
                    let subscribedProvidersList = '';
                    for (let i = 0; i < subscribedProviders.length; i++) {
                        subscribedProvidersList += subscribedProviders[i];
                        if (i !== subscribedProviders.length - 1) {
                            subscribedProvidersList += ',';
                        }
                    }
                    let myProvidersList = '';
                    for (let i = 0; i < myServiceProviders.length; i++) {
                        myProvidersList += myServiceProviders[i];
                        if (i !== myServiceProviders.length - 1) {
                            myProvidersList += ',';
                        }
                    }


                    const mySubscriptionList = new Promise(async (resolveMySubscriptions, rejectMySubscriptions) => {
                        if (subscribedProvidersList !== '') {
                            if (localStorage.getItem('partner') !== 'services') {
                                await this.confPost.getSubscribedExecutors('b2b', 'b2b', subscribedProvidersList).subscribe(response1 => {
                                    this.b2bExecutors = response1;
                                    resolveMySubscriptions('success');
                                }, error => {
                                    rejectMySubscriptions('failed');
                                });
                            }
                        } else {
                            resolveMySubscriptions('success');
                        }
                    });


                    const myProviderList = new Promise(async (resolveMyProviders, rejectMyProviders) => {
                        if (myProvidersList !== '') {
                            if (localStorage.getItem('partner') !== 'services') {
                                await this.confPost.getMyProviderExecutors(localStorage.getItem('partner'), localStorage.getItem('account'), myProvidersList).subscribe(response1 => {
                                    this.myProviderExecutors = response1;
                                    resolveMyProviders('success');
                                }, error => {
                                    rejectMyProviders('failed');
                                });
                            } else {
                                await this.confPost.getSubscribedExecutors('b2b', 'b2b', myProvidersList).subscribe(response1 => {
                                    this.myProviderExecutors = response1;
                                    resolveMyProviders('success');
                                }, error => {
                                    rejectMyProviders('failed');
                                });
                            }
                        } else {
                            resolveMyProviders('success');
                        }
                    });

                    Promise.all([myProviderList, mySubscriptionList]).then(repsonse => {
                        resolve('success');
                    });
                }
            }, error => {
                reject('failed');
            });
        });
    }

    // getApiKeyForUser(signInEmail) {
    //     if (localStorage.getItem('apikey') !== null && localStorage.getItem('apikey') !== undefined) {
    //         this.apiKey = localStorage.getItem('apikey');
    //     } else {
    //         return new Promise((resolve, reject) => {
    //             this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(signInEmail).subscribe(keys => {
    //                 this.apiKeyData = keys;
    //                 if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
    //                     this.apiKeys = this.apiKeyData.data;
    //                     this.apiKey = this.apiKeys[0].key;
    //                     localStorage.setItem('apikey', this.apiKey);
    //                 } else {
    //                     this.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access your APIs.', 'Info', {
    //                         duration: 10000,
    //                         verticalPosition: 'top',
    //                         horizontalPosition: 'center'
    //                     });
    //                 }
    //                 resolve('success');
    //             }, error => {
    //                 this.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access your APIs.', 'Info', {
    //                     duration: 10000,
    //                     verticalPosition: 'top',
    //                     horizontalPosition: 'center'
    //                 });
    //                 resolve('failed');
    //             });
    //         });
    //     }
    // }

    checkEqualStrings(val1, val2) {
        if ((val1 === null || val1 === undefined || val1 === '') && (val2 === null || val2 === undefined || val2 === '')) {
            return true;
        }
        if (val1 && val2 && val1 !== undefined && val2 !== undefined) {
            if (val1 === val2) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    checkEquality(val1, val2) {
        if ((val1 === null || val1 === undefined || val1.length === 0) && (val2 === null || val2 === undefined || val2.length === 0)) {
            return true;
        }
        if ((val1 !== null && val1 !== undefined && val1.length > 0) && (val2 === null || val2 === undefined || val2.length === 0)) {
            return false;
        }
        if ((val2 !== null && val2 !== undefined && val2.length > 0) && (val1 === null || val1 === undefined || val1.length === 0)) {
            return false;
        }

        if (val1 && val2 && val1 !== undefined && val2 !== undefined) {
            for (let i = 0; i < val1.length; i++) {
                if (val1[i] && val1[i] !== undefined && val2[i] && val2[i] !== undefined &&
                    val1[i]['key'] && val1[i]['key'] !== undefined && val2[i]['key'] && val2[i]['key'] !== undefined) {
                    if (val1[i]['key'] !== val2[i]['key'] || val1[i]['value'] !== val2[i]['value']) {
                        return false;
                    }
                }

            }
            return true;
        } else {
            return true;
        }
    }

    getTargetPartnerSettingsData(partner, account, dbref) {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(partner, account, dbref).subscribe(response => {
                if (response && response['body'] && response['body'][0]) {
                    // this.settingsData = response['body'][0];
                    resolve({settingsData: response['body'][0]});
                } else {
                    reject('failed');
                }
            }, error => {
                reject(error);
            });
        });
    }

    async getTargetPartnerDefaultGatewayURL(partner, account, dbref) {

        let defaultGatewayURL = partner + '.gateway.apiplatform.io';

        await this.getTargetPartnerSettingsData(partner, account, dbref).then(response => {
            if (response && response.hasOwnProperty('settingsData')) {
                const settingsData = response['settingsData'];
                const currentEnvironment = settingsData.environments.filter((env) => env['name'] === localStorage.getItem('partner'));
                if (currentEnvironment && currentEnvironment.length > 0) {
                    const apigatewayService = currentEnvironment[0]['services'].filter((service) => service['type'] === 'apigateway');
                    if (apigatewayService && apigatewayService.length > 0) {
                        const defaultGateway = apigatewayService[0]['configurations'].filter((config) => config['is_default'] === true);
                        if (defaultGateway && defaultGateway.length > 0) {
                            defaultGatewayURL = defaultGateway[0]['url'][0];
                        }
                    }
                }
            }
        });

        return defaultGatewayURL;
    }

    getSettingsData(partner, account, dbref) {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(partner, account, dbref).subscribe(response => {
                if (response && response['body'] && response['body'][0]) {
                    this.settingsData = response['body'][0];
                    resolve('success');
                } else {
                    reject('failed');
                }
            }, error => {
                reject(error);
            });
        });
    }

    getApiDiscoveryData(partner, account) {
        return new Promise((resolve, reject) => {
            this.confPost.getApiExecutorForPartnerAccount(partner, account).subscribe(response => {
                if (response) {
                    this.apiList = response;
                    const filteredAPIList = [];
                    if (this.apiList && this.apiList.length) {
                        for (const api of this.apiList) {
                            if (api.executor_type !== 'API') {
                                filteredAPIList.push(api);
                            }
                        }
                    } else {
                        this.apiList = [];
                    }
                    this.apiList = filteredAPIList;
                    resolve('success');
                } else {
                    resolve('failed');
                }
            }, error => {
                this.handleErrorGracefully(error, 'Unable to retrieve API executors for partner account.');
                reject(error);
            });
        });
    }

    getApiDiscoveryServiceProviders() {
        return new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services' + '&account=services').subscribe(platformProviders => {
                if (platformProviders) {
                    const iterator = platformProviders[Symbol.iterator]();
                    while (true) {
                        const tempObject = iterator.next();
                        if (tempObject.done) {
                            break;
                        }
                        this.apiProducers.push(tempObject.value);
                    }
                    resolve('success');
                } else {
                    resolve('failed');
                }
            }, error => {
                this.openSnackBar('Error while getting list of service providers for platform: ' + error.error.message, 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                reject(error);
            });
        });
    }

    async getDefaultGatewayURL() {
        if (this.defaultGatewayURL && this.defaultGatewayURL !== '') {
            return this.defaultGatewayURL.toString();
        } else {

            this.defaultGatewayURL = localStorage.getItem('partner') + '.gateway.apiplatform.io';

            if (!this.settingsData) {
                await this.getSettingsData(localStorage.getItem('partner'), localStorage.getItem('account'), false);
            }
            if (this.settingsData) {
                if (this.settingsData.hasOwnProperty('body')) {
                    this.settingsData = this.settingsData['body'][0];
                }
                const currentEnvironment = this.settingsData.environments.filter((env) => env['name'] === localStorage.getItem('partner'));
                if (currentEnvironment && currentEnvironment.length > 0) {
                    const apigatewayService = currentEnvironment[0]['services'].filter((service) => service['type'] === 'apigateway');
                    if (apigatewayService && apigatewayService.length > 0) {
                        const defaultGateway = apigatewayService[0]['configurations'].filter((config) => config['is_default'] === true);
                        if (defaultGateway && defaultGateway.length > 0) {
                            this.defaultGatewayURL = defaultGateway[0]['url'][0];
                        }
                    }
                }
            }
            return this.defaultGatewayURL.toString();
        }
    }

    getScheduledJobs() {
        return new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'scheduledJobs', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account')).subscribe(response => {
                this.scheduledJobs = response;
                if (this.scheduledJobs) {
                    let jobIDString = '';
                    for (let i = 0; i < this.scheduledJobs.length; i++) {
                        jobIDString = jobIDString.concat(this.scheduledJobs[i]['job_meta']['id']);
                        if (i !== this.scheduledJobs.length - 1) {
                            jobIDString = jobIDString + ',';
                        }
                    }
                    this.confPost.getData('services', 'services', 'v1', 'schedulerLogs', 'event=EVENT_JOB_EXECUTED&details.job_id.in=' + jobIDString).subscribe(response1 => {
                        this.schedulerLogs = response1;
                        resolve('success');
                    }, error1 => {
                        this.handleErrorGracefully(error1, 'Error while retrieving scheduler logs. Please try again after sometime.');
                        reject(error1);
                    });
                }
            }, error2 => {
                this.handleErrorGracefully(error2, 'Error while retrieving scheduled jobs. Please try again after sometime.');
                reject(error2);
            });
        });
    }

    toTimestamp(strDate) {
        const datum = Date.parse(strDate);
        return datum / 1000;
    }

    getTimeZones() {
        this.timeZones = [];
        return new Promise((resolve, reject) => {
            this.confPost.getTimeZones().subscribe(response => {
                this.timezoneResponse = response;
                for (const group of this.timezoneResponse) {
                    for (const zone of group['zones']) {
                        this.timeZones.push(zone['value']);
                    }
                }
                resolve('success');
            }, error => {
                this.handleErrorGracefully(error, 'Error while retrieving timezones. Please try again after sometime.');
                reject(error);
            });
        });
    }

    scheduleAPI(executor_name, executor_version) {
        const date = new Date();
        const date6MonthsFromNow = new Date(date.getTime() + (182 * 24 * 60 * 60 * 1000));
        const dialogRef = this.dialog.open(ScheduleJobDialogComponent, {
            minWidth: '26vw',
            height: 'auto',
            data: {
                mode: 'schedule',
                name: executor_name,
                version: executor_version,
                configuration: {
                    type: 'date',
                    configurations: {
                        'run_date': '',
                        'timezone': 'Asia/Kolkata'
                    }
                },
                startDateActualFormat: new Date().toISOString(),
                endDateActualFormat: date6MonthsFromNow.toISOString(),
                jobName: '',
                jobDescription: '',
                wholeData: null
            }
        });

        dialogRef.afterClosed().subscribe(async response => {
            await this.getScheduledJobs();
            this.leftPanelDataListener.jobScheduled.emit(true);
        });
    }

    hasPlatformPermission(permission) {
        // return this.hasPermission(environment.platformPermissions[permission]);
        return this.accountInfoService.hasPermission(permission);
    }

    hasAccountPermission(permission) {
        return this.accountInfoService.hasPermission(permission);
    }

    hasPermissions(permissions) {
        return this.accountInfoService.hasPermissions(permissions);
    }

    setMenusAfterPermissions() {

        for (const menuItem of this.menus) {
            if (menuItem) {
                for (const menu of menuItem['stickyMenus']) {
                    if (menu) {
                        switch (menu['name']) {
                            case 'control-plane':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_CONTROL_PLANE');
                                break;
                            case 'creation':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_CREATE_NAVIGATION_PANE');
                                break;
                            case 'transform':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_TRANSFORM_NAVIGATION_PANE');
                                break;
                            case 'connect':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_INTEGRATE_NAVIGATION_PANE');
                                break;
                            case 'register':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_REGISTER_NAVIGATION_PANE');
                                break;
                            case 'reference':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_API_REFERENCE');
                                break;
                            case 'test':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_TEST_NAVIGATION_PANE');
                                break;
                            case 'learn':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_LEARN_NAVIGATION_PANE');
                                break;
                            case 'manage':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_MANAGE_NAVIGATION_PANE');
                                break;
                            case 'tools':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_TOOLS_NAVIGATION_PANE');
                                break;
                            case 'samples':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_SAMPLES');
                                break;
                            case 'settings':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_SETTINGS_NAVIGATION_PANE');
                                break;
                            case 'switch To ...':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_SWITCH_TO');
                                break;
                            case 'History':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_HISTORY');
                                break;
                            case 'partner-info':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_PARTNER_INFO_NAVIGATION_PANE');
                                break;
                            case 'api-discovery':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_API_DISCOVERY');
                                break;
                            case 'journey':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_JOURNEY_ANALYTICS');
                                break;
                            case 'billing':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_BILLING');
                                break;
                            case 'genai':
                                menu['hasPermission'] = this.hasPlatformPermission('MENU_CREATE_NAVIGATION_PANE');
                                break;
                            default:
                                menu['hasPermission'] = false;
                                break;
                        }
                    }
                }
            }
        }
    }

    checkForPlatformEditPermissionsForExecutors(partner, account, apiName, version, executorType) {
        if (executorType && executorType !== '') {
            if (executorType === 'BUSINESSLOGIC') {
                return this.hasPermissions(['EDIT_BUSINESS_LOGIC_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'SQLQUERY') {
                return this.hasPermissions(['EDIT_QUERY_BUILDER_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'UNIFIEDQUERY') {
                return this.hasPermissions(['EDIT_UNIFIED_QUERY_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'TESTSUITE') {
                return this.hasPermissions(['EDIT_TEST_SUITE_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'EXTERNALTESTSUITE') {
                return this.hasPermissions(['EDIT_TEST_SUITE_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'THIRDPARTY') {
                return this.hasPermissions(['EDIT_THIRD_PARTY_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'WORKFLOW') {
                return this.hasPermissions(['EDIT_WORKFLOW_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'PLSQL') {
                return this.hasPermissions(['EDIT_PLSQL_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'DATATRANSFORMATION') {
                return this.hasPermissions(['EDIT_DATA_TRANSFORM_API', 'edit:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else {
                return false;
            }
        }
    }

    checkForPlatformDeletePermissionsForExecutors(partner, account, apiName, version, executorType) {
        if (executorType && executorType !== '') {
            if (executorType === 'BUSINESSLOGIC') {
                return this.hasPermissions(['DELETE_BUSINESS_LOGIC_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'SQLQUERY') {
                return this.hasPermissions(['DELETE_QUERY_BUILDER_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'UNIFIEDQUERY') {
                return this.hasPermissions(['DELETE_UNIFIED_QUERY_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'TESTSUITE') {
                return this.hasPermissions(['DELETE_TEST_SUITE_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'EXTERNALTESTSUITE') {
                return this.hasPermissions(['DELETE_TEST_SUITE_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'THIRDPARTY') {
                return this.hasPermissions(['DELETE_THIRD_PARTY_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'WORKFLOW') {
                return this.hasPermissions(['DELETE_WORKFLOW_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'PLSQL') {
                return this.hasPermissions(['DELETE_PLSQL_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'DATATRANSFORMATION') {
                return this.hasPermissions(['DELETE_DATA_TRANSFORM_API', 'delete:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else {
                return false;
            }
        }
    }

    hasGrantAccessPermissions(partner, account, apiName, version, executorType) {
        if (executorType && executorType !== '') {
            if (executorType === 'BUSINESSLOGIC') {
                return this.hasPermissions(['GRANT_ACCESS_BUSINESS_LOGIC_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'SQLQUERY') {
                return this.hasPermissions(['GRANT_ACCESS_QUERY_BUILDER_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'UNIFIEDQUERY') {
                return this.hasPermissions(['GRANT_ACCESS_UNIFIED_QUERY_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'TESTSUITE') {
                return this.hasPermissions(['GRANT_ACCESS_TEST_SUITE_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'EXTERNALTESTSUITE') {
                return this.hasPermissions(['GRANT_ACCESS_TEST_SUITE_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'THIRDPARTY') {
                return this.hasPermissions(['GRANT_ACCESS_THIRD_PARTY_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'WORKFLOW') {
                return this.hasPermissions(['GRANT_ACCESS_WORKFLOW_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'PLSQL') {
                return this.hasPermissions(['GRANT_ACCESS_PLSQL_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'DATATRANSFORMATION') {
                return this.hasPermissions(['GRANT_ACCESS_DATA_TRANSFORM_API', 'grant_access:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else {
                return false;
            }
        }
    }

    checkForPlatformPromotionsPermissionsForExecutors(partner, account, apiName, version, executorType) {
        if (executorType && executorType !== '') {
            if (executorType === 'BUSINESSLOGIC') {
                return this.hasPermissions(['PROMOTE_BUSINESS_LOGIC_API', 'promote:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'SQLQUERY') {
                return this.hasPermissions(['PROMOTE_QUERY_BUILDER_API', 'promote:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'UNIFIEDQUERY') {
                return this.hasPermissions(['PROMOTE_UNIFIED_QUERY_API', 'promote:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'TESTSUITE') {
                return this.hasPermissions(['PROMOTE_TEST_SUITE_API', 'promote:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'WORKFLOW') {
                return this.hasPermissions(['PROMOTE_WORKFLOW_API', 'promote:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'PLSQL') {
                return this.hasPermissions(['PROMOTE_PLSQL_API', 'promote:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'THIRDPARTY') {
                return this.hasPermissions(['PROMOTE_THIRD_PARTY_API', 'promote:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else if (executorType === 'DATATRANSFORMATION') {
                return this.hasPermissions(['PROMOTE_DATA_TRANSFORM_API', 'promote:' + partner + '=>' + account + '=>' + apiName + '=>' + version]);
            } else {
                return false;
            }
        }
    }

    hasPromotePermission(type) {
        this.promoteDeniedPermission = '';
        if (type === 'DATAACCESS') {
            this.promoteDeniedPermission = 'Permission denied to promote Data Access API';
            return this.hasPlatformPermission('PROMOTE_DATA_ACCESS_API');
        } else if (type === 'BUSINESSLOGIC') {
            this.promoteDeniedPermission = 'Permission denied to promote Business Logic API';
            return this.hasPlatformPermission('PROMOTE_BUSINESS_LOGIC_API');
        } else if (type === 'SQLQUERY') {
            this.promoteDeniedPermission = 'Permission denied to promote SQL Query API';
            return this.hasPlatformPermission('PROMOTE_QUERY_BUILDER_API');
        } else if (type === 'TESTSUITE') {
            this.promoteDeniedPermission = 'Permission denied to promote Testsuite API';
            return this.hasPlatformPermission('PROMOTE_TEST_SUITE_API');
        } else if (type === 'PLSQL') {
            this.promoteDeniedPermission = 'Permission denied to promote PLSQL API';
            return this.hasPlatformPermission('PROMOTE_PLSQL_API');
        } else if (type === 'THIRDPARTY') {
            this.promoteDeniedPermission = 'Permission denied to promote Thirdparty API';
            return this.hasPlatformPermission('PROMOTE_THIRD_PARTY_API');
        } else if (type === 'DATATRANSFORMATION') {
            this.promoteDeniedPermission = 'Permission denied to promote Data Transformation API';
            return this.hasPlatformPermission('PROMOTE_DATA_TRANSFORM_API');
        }
    }

    hasPublishPermission(type) {
        if (type === 'DATAACCESS') {
            return this.hasPlatformPermission('PUBLISH_DATA_ACCESS_API');
        } else if (type === 'BUSINESSLOGIC') {
            return this.hasPlatformPermission('PUBLISH_BUSINESS_LOGIC_API');
        } else if (type === 'SQLQUERY') {
            return this.hasPlatformPermission('PUBLISH_QUERY_BUILDER_API');
        } else if (type === 'UNIFIEDQUERY') {
            return this.hasPlatformPermission('PUBLISH_UNIFIED_QUERY_API');
        } else if (type === 'TESTSUITE') {
            return this.hasPlatformPermission('PUBLISH_TEST_SUITE_API');
        } else if (type === 'PLSQL') {
            return this.hasPlatformPermission('PUBLISH_PLSQL_API');
        } else if (type === 'THIRDPARTY') {
            return this.hasPlatformPermission('CREATE_THIRD_PARTY_API');
        } else if (type === 'WORKFLOW') {
            return this.hasPlatformPermission('PUBLISH_WORKFLOW_API');
        } else if (type === 'DATATRANSFORMATION') {
            return this.hasPlatformPermission('PUBLISH_DATA_TRANSFORM_API');
        } else {
            return false;
        }
    }

    validateBillingStatus() {
        const excludedRoutes = ['/billing', '/auth'];
        const currentRoute = this.router.url;
        // console.log(currentRoute);
        const isExcluded = excludedRoutes.some(route => currentRoute.startsWith(route));

        if (!isExcluded) {
            const billingStatusPayload = {
                partner: localStorage.getItem('partner')
            };
            this.confPost.validateBillingStatus(billingStatusPayload).subscribe(res => {
                const temp: any = res;
                const isDialogAlreadyOpen = this.dialog.openDialogs.some(dialogRef =>
                    dialogRef.componentInstance instanceof BillingWarningDialog);

                if (temp && !temp['status'] && !isDialogAlreadyOpen) {
                    console.log(temp['status']);
                    this.dialog.open(BillingWarningDialog, {
                        data: temp,
                        disableClose: true
                    });
                }
            });
        }
    }

    getApplicationPermissionGroupConfig() {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'applicationpermissiongroupconfig', null).subscribe(response => {
                if (response) {
                    this.applicationPermissionConfig = response;
                    resolve('success');
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    createApplicationPermission(payload) {
        return new Promise((resolve, reject) => {
            this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissions').subscribe(async response => {
                resolve(['success', response['upsertedId']]);
            }, async error => {
                resolve(['failed', error.message]);
            });
        });
    }

    createApplicationPermissionGroup(payload) {
        return new Promise((resolve, reject) => {
            this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissiongroups').subscribe(async response => {
                resolve(response['upsertedId']);
            }, async error => {
                resolve('failed');
            });
        });
    }

    returnPermissionsPayloadArray(partner, account, apiName, version, configs, permissionsBulkPayload) {
        if (configs && configs.length > 0) {
            for (const action of configs[0]['actions']) {
                const payload = {
                    permission: '',
                    partner: partner,
                    account: account
                };
                payload['permission'] = action + ':' + partner + '=>' + account + '=>' + apiName + '=>' + version;
                payload['display_name'] = action + ':' + apiName + '=>' + version;
                payload['type'] = 'account';
                permissionsBulkPayload.push(payload);
            }
        }
        return permissionsBulkPayload;
    }

    createAPIMgtPermissions(partner, account, apiName, version, configs, permissionsIdArray) {
        return new Promise(async (resolve, reject) => {
            const payload = {
                permission: '',
                partner: partner,
                account: account
            };
            if (configs && configs.length > 0) {
                for (const action of configs[0]['actions']) {
                    payload['permission'] = action + ':' + partner + '=>' + account + '=>' + apiName + '=>' + version;
                    payload['display_name'] = action + ':' + apiName + '=>' + version;
                    const upsertedId = await this.createApplicationPermission(payload);
                    if (upsertedId && upsertedId !== 0) {
                        permissionsIdArray.push(upsertedId);
                    }
                }
            }
            resolve(permissionsIdArray);
        });
    }

    createDocumentationPermissions(partner, account, apiName, version, configs, permissionsIdArray) {
        return new Promise(async (resolve, reject) => {
            const payload = {
                permission: '',
                partner: partner,
                account: account
            };
            if (configs && configs.length > 0) {
                for (const action of configs[0]['actions']) {
                    payload['permission'] = action + ':' + partner + '=>' + account + '=>' + apiName + '=>' + version;
                    payload['display_name'] = action + ':' + apiName + '=>' + version;
                    const upsertedId = await this.createApplicationPermission(payload);
                    if (upsertedId && upsertedId !== 0) {
                        permissionsIdArray.push(upsertedId);
                    }
                }
            }
            resolve(permissionsIdArray);
        });
    }

    createSchedulerPermissions(partner, account, apiName, version, configs, permissionsIdArray) {
        return new Promise(async (resolve, reject) => {
            const payload = {
                permission: '',
                partner: partner,
                account: account
            };
            if (configs && configs.length > 0) {
                for (const action of configs[0]['actions']) {
                    payload['permission'] = action + ':' + partner + '=>' + account + '=>' + apiName + '=>' + version;
                    payload['display_name'] = action + ':' + apiName + '=>' + version;
                    const upsertedId = await this.createApplicationPermission(payload);
                    if (upsertedId && upsertedId !== 0) {
                        permissionsIdArray.push(upsertedId);
                    }
                }
            }
            resolve(permissionsIdArray);
        });
    }

    associateApplicationPermissionGroupWithApplicationRole(partner, account, email, idToBeAssociated) {
        return new Promise((resolve, reject) => {
            this.confPost.getData(environment.accessPartner, environment.accessPartner, 'v1', 'roles', 'role=' + partner + '=>' + account + '=>' + email + '&dbref=false').subscribe(response => {
                if (response && response[0]) {
                    const permissionGroups = response[0]['permission_groups'];
                    permissionGroups.push(idToBeAssociated);
                    this.confPost.patchEntityData(environment.accessPartner, environment.accessPartner, 'v1', 'roles', response[0]['id'], {'permission_groups': permissionGroups}).subscribe(response1 => {
                        Promise.resolve(this.generateActionPayloadForAudit(false, 'permissiongroup_associatetorole_success', 'INFO', 200, '', '', {'permission_groups': permissionGroups}, response1, this.router.url)).then(response2 => {
                            const payloadToSend = {
                                actions: response2
                            };
                            this.permissionListenerInstance.permissionsListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        resolve('success');
                    }, error => {
                        Promise.resolve(this.generateActionPayloadForAudit(true, 'permissiongroup_associatetorole_failed', 'ERROR', error.status, error.statusText, this.returnErrorMessage(error), {'permission_groups': permissionGroups}, error, this.router.url)).then(response => {
                            const payloadToSend = {
                                actions: response
                            };
                            this.permissionListenerInstance.permissionsListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        resolve('failed');
                    });
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    deletePermissionsCreatedSoFar(permissionsIdArray) {
        let idString = '';
        for (let i = 0; i < permissionsIdArray.length; i++) {
            if (permissionsIdArray[i]) {
                idString = idString + permissionsIdArray[i].toString();
                if (i !== permissionsIdArray.length - 1) {
                    idString = idString + ',';
                }
            }
        }
        this.confPost.deleteDataForAnEntity(environment.accessPartner, environment.accessPartner, environment.accessPkey, 'permissions', 'v1', 'id.in=' + idString).subscribe(response => {
        });
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    publishEventMessage(apiName, version, title, message, timeStamp, action) {
        const data = {
            partner: localStorage.getItem('partner'),
            account: localStorage.getItem('account'),
            apiName: apiName,
            apiVersion: version,
            title: title,
            action: action,
            user: localStorage.getItem('signInEmail'),
            createdDate: Date.now(),
            message: message,
            session: localStorage.getItem('sessionID'),
            timeStamp: timeStamp
        };

        this.webSocketService.sendApiMessage(data, localStorage.getItem('partner'), localStorage.getItem('account'), timeStamp, localStorage.getItem('sessionID'));
    }

    publishEventMessage2(apiName, version, title, message, timestamp, action) {
        // this.websocketService.sendMessage('Hello From crud');
        const data = {
            partner: localStorage.getItem('partner'),
            account: localStorage.getItem('account'),
            apiName: apiName,
            apiVersion: version,
            title: title,
            action: action,
            user: localStorage.getItem('signInEmail'),
            createdDate: Date.now(),
            message: message
        };
        this.webSocketService.sendApiMessage(data, localStorage.getItem('partner'), localStorage.getItem('account'), timestamp, localStorage.getItem('sessionID'));
    }

    // createBulkPermissions(partner, account, APIName, version, email, permissionsPayload, timeStamp, action) {
    //     return new Promise(async(resolve, reject) => {
    //         const permissionIDArray = [];
    //         let isError = false;
    //         let count=0;
    //         for (const payload of permissionsPayload) {
    //             count++;
    //             if (payload) {
    //                 this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                     info:'Creating <b>'+payload['display_name'].split(':')[0]+'</b> permission',
    //                     type:'initial',
    //                     icon: 'fa fa-lock'}, timeStamp,action);
    //
    //                 const id = await this.createApplicationPermission(payload);
    //                 if (id[0] !== 'failed') {
    //                     permissionIDArray.push(id[1]);
    //                     this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                         info:'Creating <b>'+payload['display_name'].split(':')[0]+'</b> permission',
    //                         type:'success', icon: 'fa fa-lock'},
    //                         timeStamp,action);
    //
    //                     } else {
    //                     this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                             info:'Creating <b>'+payload['display_name'].split(':')[0]+'</b> permission',
    //                         type: 'error',
    //                         description: {},
    //                         executor_method_type: 'POST',
    //                         executor_type:'',
    //                         authorization : {},
    //                         queryParameters: [],
    //                         pathParameters: [],
    //                         url: environment.apihost + '/' + 'v1' + '/data/' + environment.accessPartner + '/' + environment.accessPartner + '/' + 'permissions',
    //                         headers: {'pkey': environment.accessPkey,
    //                             'Access-Control-Allow-Origin': '*',
    //                             'observe': 'response' },
    //                         request_body: payload
    //                     }, timeStamp, action);
    //                     isError = true;
    //                     break;
    //                 }
    //             }
    //         }
    //         if (!isError) {
    //             const permissionGroupPayload = {
    //                 permissionGroup: partner + '=>' + account + '=>' + APIName + '=>' + version,
    //                 partner: partner,
    //                 account: account
    //             };
    //             permissionGroupPayload['permissions'] = permissionIDArray;
    //             permissionGroupPayload['display_name'] = APIName + ' (' + version + ')';
    //             permissionGroupPayload['type'] = 'account';
    //             this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                 info:'Creating permission group for the API',
    //                 type:'initial',
    //                 icon: 'fa fa-lock'}, timeStamp,action);
    //             const permissionGroupId = await this.createApplicationPermissionGroup(permissionGroupPayload);
    //             if (permissionGroupId !== 'failed') {
    //                 this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                     info:'Creating permission group for the API',
    //                     type:'success',
    //                     icon: 'fa fa-lock'}, timeStamp,action);
    //                 this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                     info:'Associating permissions with permission group',
    //                     type:'initial',
    //                     icon: 'fa fa-lock'}, timeStamp,action);
    //                 const status = await this.associateApplicationPermissionGroupWithApplicationRole(partner, account, email, permissionGroupId);
    //                 if (status === 'failed') {
    //                     this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                         info:'Associating permissions with permission group',
    //                         type:'error',
    //                         description: '',
    //                         icon: 'fa fa-lock'}, timeStamp,action);
    //                     this.deletePermissionsCreatedSoFar(permissionIDArray);
    //                     this.confPost.deleteDataForAnEntity(environment.accessPartner, environment.accessPartner, environment.accessPkey, 'permissiongroups', 'v1', 'id=' + permissionGroupId).subscribe(response => {
    //                         reject({message: 'Failed'});
    //                     });
    //                 } else {
    //                     this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                         info:'Associating permissions with permission group',
    //                         type:'success',
    //                         icon: 'fa fa-lock'}, timeStamp,action);
    //                     resolve({message: 'success'});
    //                     resolve({message: 'success'});
    //                 }
    //             } else {
    //                 this.publishEventMessage(APIName, version, 'API SECURITY', {
    //                     info:'Creating permission group for the API',
    //                     type:'error',
    //                     description: '',
    //                     icon: 'fa fa-lock'}, timeStamp,action);
    //                 this.deletePermissionsCreatedSoFar(permissionIDArray);
    //                 reject({message: 'Failed'});
    //             }
    //         } else {
    //             this.deletePermissionsCreatedSoFar(permissionIDArray);
    //             reject({message: 'Failed'})
    //         }
    //     });
    // }

    createBulkPermissions(partner, account, APIName, version, emails, permissionsPayload, timeStamp, action) {
        return new Promise(async (resolve, reject) => {
            const permissionIDArray = [];
            const failedPermissions = [];
            const isError = false;

            await Promise.all(permissionsPayload.map(async (payload) => {

                if (payload) {
                    this.publishEventMessage(APIName, version, 'API SECURITY', {
                        info: 'Creating <b>' + payload['display_name'].split(':')[0] + '</b> permission',
                        type: 'initial',
                        icon: 'fa fa-lock'
                    }, timeStamp, action);

                    const id = await this.createApplicationPermission(payload);
                    if (id[0] !== 'failed') {
                        permissionIDArray.push(id[1]);
                        this.publishEventMessage(APIName, version, 'API SECURITY', {
                                info: 'Creating <b>' + payload['display_name'].split(':')[0] + '</b> permission',
                                type: 'success', icon: 'fa fa-lock'
                            },
                            timeStamp, action);

                    } else {
                        payload['error_description'] = id[1];
                        failedPermissions.push(payload);
                        // this.publishEventMessage(APIName, version, 'API SECURITY', {
                        //     info:'Creating <b>'+payload['display_name'].split(':')[0]+'</b> permission',
                        //     type: 'error',
                        //     description: id[1],
                        //     executor_method_type: 'POST',
                        //     executor_type:'',
                        //     authorization : {},
                        //     queryParameters: [],
                        //     pathParameters: [],
                        //     url: environment.apihost + '/' + 'v1' + '/data/' + environment.accessPartner + '/' + environment.accessPartner + '/' + 'permissions',
                        //     headers: {'pkey': environment.accessPkey,
                        //         'Access-Control-Allow-Origin': '*',
                        //         'observe': 'response' },
                        //     request_body: payload
                        // }, timeStamp, action);
                        // isError = true;
                        // break;
                    }
                }
            }));

            const permissionGroupPayload = {
                permissionGroup: partner + '=>' + account + '=>' + APIName + '=>' + version,
                partner: partner,
                account: account
            };
            permissionGroupPayload['permissions'] = permissionIDArray;
            permissionGroupPayload['display_name'] = APIName + ' (' + version + ')';
            permissionGroupPayload['type'] = 'account';
            this.publishEventMessage(APIName, version, 'API SECURITY', {
                info: 'Creating permission group for the API',
                type: 'initial',
                icon: 'fa fa-lock'
            }, timeStamp, action);
            const permissionGroupId = await this.createApplicationPermissionGroup(permissionGroupPayload);
            if (permissionGroupId !== 'failed') {
                this.publishEventMessage(APIName, version, 'API SECURITY', {
                    info: 'Creating permission group for the API',
                    type: 'success',
                    icon: 'fa fa-lock'
                }, timeStamp, action);

                // for (const payload of failedPermissions) {
                //     this.publishEventMessage(APIName, version, 'API SECURITY', {
                //         info:'Creating <b>'+payload['display_name'].split(':')[0]+'</b> permission',
                //         type: 'error',
                //         description: payload['error_description'] + ' (id):'+permissionGroupId,
                //         executor_method_type: 'POST',
                //         executor_type:'',
                //         authorization : {},
                //         queryParameters: [],
                //         pathParameters: [],
                //         url: environment.apihost + '/' + 'v1' + '/data/' + environment.accessPartner + '/' + environment.accessPartner + '/' + 'permissions',
                //         headers: {'pkey': environment.accessPkey,
                //             'Access-Control-Allow-Origin': '*',
                //             'observe': 'response' },
                //         request_body: payload
                //     }, timeStamp, action);
                //
                //
                // }

                this.publishEventMessage(APIName, version, 'API SECURITY', {
                    info: 'Associating permissions with permission group',
                    type: 'initial',
                    icon: 'fa fa-lock'
                }, timeStamp, action);
                await this.retryCreationOfFailedPermissions(partner, account, APIName, version, timeStamp, action, failedPermissions, permissionGroupId);

                const statusArray = [];
                const failedEmails = [];
                for (const email of emails) {
                    const status = await this.associateApplicationPermissionGroupWithApplicationRole(partner, account, email, permissionGroupId);
                    statusArray.push(status);
                    if (status !== 'success') {
                        failedEmails.push(email);
                    }
                }
                if (!((statusArray.reduce(function (n, val) {
                    return n + (val === 'success');
                }, 0)) === statusArray.length)) {
                    this.publishEventMessage(APIName, version, 'API SECURITY', {
                        info: 'Associating permissions with permission group',
                        type: 'error',
                        description: 'Permissions could not be associated for: ' + failedEmails.join(',') + '. Please contact administrator.',
                        icon: 'fa fa-lock'
                    }, timeStamp, action);
                    // this.deletePermissionsCreatedSoFar(permissionIDArray);
                    // this.confPost.deleteDataForAnEntity(environment.accessPartner, environment.accessPartner, environment.accessPkey, 'permissiongroups', 'v1', 'id=' + permissionGroupId).subscribe(response => {
                    //     reject({message: 'Failed'});
                    // });
                } else {
                    this.publishEventMessage(APIName, version, 'API SECURITY', {
                        info: 'Associating permissions with permission group',
                        type: 'success',
                        icon: 'fa fa-lock'
                    }, timeStamp, action);
                    resolve({message: 'success'});
                }
            } else {
                for (const payload of failedPermissions) {
                    this.publishEventMessage(APIName, version, 'API SECURITY', {
                        info: 'Creating <b>' + payload['display_name'].split(':')[0] + '</b> permission',
                        type: 'error',
                        description: payload['error_description'],
                        executor_method_type: 'POST',
                        executor_type: '',
                        authorization: {},
                        queryParameters: [],
                        pathParameters: [],
                        url: environment.apihost + '/' + 'v1' + '/data/' + environment.accessPartner + '/' + environment.accessPartner + '/' + 'permissions',
                        headers: {
                            'pkey': environment.accessPkey,
                            'Access-Control-Allow-Origin': '*',
                            'observe': 'response'
                        },
                        request_body: payload
                    }, timeStamp, action);
                }
                this.publishEventMessage(APIName, version, 'API SECURITY', {
                    info: 'Creating permission group for the API',
                    type: 'error',
                    description: '',
                    icon: 'fa fa-lock'
                }, timeStamp, action);
                this.deletePermissionsCreatedSoFar(permissionIDArray);
                reject({message: 'Failed'});
            }
        });
    }

    retryCreationOfFailedPermissions(partner, account, APIName, version, timeStamp, action, permissionsToBeRecreated, permissionGroupId) {
        return new Promise(async (resolve, reject) => {
            const createdPermissionsIDArray = [];
            for (let i = 0; i < permissionsToBeRecreated.length; i++) {
                if (permissionsToBeRecreated[i]) {
                    this.publishEventMessage(APIName, version, 'API SECURITY', {
                        info: 'Creating <b>' + permissionsToBeRecreated[i]['display_name'].split(':')[0] + '</b> permission',
                        type: 'retry',
                        icon: 'fa fa-lock'
                    }, timeStamp, action);
                    const payload = {
                        permission: permissionsToBeRecreated[i]['permission'],
                        partner: permissionsToBeRecreated[i]['partner'],
                        account: permissionsToBeRecreated[i]['account'],
                        display_name: permissionsToBeRecreated[i]['display_name'],
                        description: permissionsToBeRecreated[i]['description'],
                        type: permissionsToBeRecreated[i]['type']
                    };

                    const id = await this.createApplicationPermission(payload);
                    if (id[0] === 'success') {
                        this.publishEventMessage(APIName, version, 'API SECURITY', {
                            info: 'Creating <b>' + permissionsToBeRecreated[i]['display_name'].split(':')[0] + '</b> permission',
                            type: 'success',
                            icon: 'fa fa-lock'
                        }, timeStamp, action);
                        createdPermissionsIDArray.push(id[1]);
                    } else {
                        this.publishEventMessage(APIName, version, 'API SECURITY', {
                            info: 'Creating <b>' + permissionsToBeRecreated[i]['display_name'].split(':')[0] + '</b> permission',
                            type: 'error',
                            description: id[1],
                            icon: 'fa fa-lock'
                        }, timeStamp, action);
                    }
                }
            }

            if (createdPermissionsIDArray.length > 0) {
                this.confPost.getData('access', 'access', 'v1', 'permissiongroups', 'id=' + permissionGroupId + '&dbref=' + false).subscribe(response => {
                    let permissionGroupResponse: any;
                    permissionGroupResponse = response;
                    if (permissionGroupResponse && permissionGroupResponse.length > 0) {
                        const permissionsArray = permissionGroupResponse[0]['permissions'].concat(createdPermissionsIDArray);
                        this.confPost.patchEntityData('access', 'access', 'v1', 'permissiongroups', permissionGroupId, {permissions: permissionsArray}).subscribe(response1 => {
                            resolve('success');
                        }, error => {
                            resolve('failed');
                        });
                    } else {
                        resolve('failed');
                    }
                });
            } else {
                resolve('failed');
            }
        });
    }

    generateAccountPermissions(partner, account, APIName, version, type) {

        const permissionsbulkPayload = [];
        const apiManagementConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'APIMANAGEMENT');
        const documentationConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'DOCUMENTATION');
        const schedulerConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'SCHEDULER');

        let finalPermissionsBulkPayload: any;

        switch (type) {
            case 'DAAS':
                const DAASPermissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === type);
                if (DAASPermissionConfig && DAASPermissionConfig.length > 0) {
                    for (const action of DAASPermissionConfig[0]['actions']) {
                        const payload = {
                            permission: '',
                            partner: partner,
                            account: account,
                        };
                        payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
                        payload['display_name'] = action + ':' + APIName + '=>' + version;
                        payload['type'] = 'account';
                        permissionsbulkPayload.push(payload);
                    }
                }
                const dataPermissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'DATA');
                if (dataPermissionConfig && dataPermissionConfig.length > 0) {
                    for (const action of dataPermissionConfig[0]['actions']) {
                        const payload = {
                            permission: '',
                            partner: partner,
                            account: account,
                        };
                        payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
                        payload['display_name'] = action + ':' + APIName + '=>' + version;
                        payload['type'] = 'account';
                        permissionsbulkPayload.push(payload);
                    }
                }
                finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, apiManagementConfig, permissionsbulkPayload);
                finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, documentationConfig, finalPermissionsBulkPayload);
                return finalPermissionsBulkPayload;
                break;
            default:
                const permissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === type);
                if (permissionConfig && permissionConfig.length > 0) {
                    for (const action of permissionConfig[0]['actions']) {
                        const payload = {
                            permission: '',
                            partner: partner,
                            account: account,
                        };
                        payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
                        payload['display_name'] = action + ':' + APIName + '=>' + version;
                        payload['type'] = 'account';
                        permissionsbulkPayload.push(payload);
                    }
                }
                finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, apiManagementConfig, permissionsbulkPayload);
                finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, documentationConfig, finalPermissionsBulkPayload);
                finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, schedulerConfig, finalPermissionsBulkPayload);
                return finalPermissionsBulkPayload;
                break;
        }
    }

    generateAccountRolePermissionGroupAndPermissions(partner, account, email, APIName, version, type, refreshToken, timeStamp, action) {
        return new Promise(async (resolve, reject) => {
            if (!this.applicationPermissionConfig) {
                await this.getApplicationPermissionGroupConfig();
            }

            let finalPermissionsBulkPayload: any;

            finalPermissionsBulkPayload = this.generateAccountPermissions(partner, account, APIName, version, type);
            Promise.resolve(this.createBulkPermissions(partner, account, APIName, version, [email], finalPermissionsBulkPayload, timeStamp, action)).then(response => {
                if (refreshToken === true) {
                    this.refreshTokenAndPermissions();
                }
                resolve({message: 'Success'});
            }, error => {
                reject({message: 'Failed'});
            });

        });
    }

    generateAccountRolePermissionGroupAndPermissionsForUsers(partner, account, emails, APIName, version, type, refreshToken, timeStamp, action) {
        return new Promise(async (resolve, reject) => {
            if (!this.applicationPermissionConfig) {
                await this.getApplicationPermissionGroupConfig();
            }

            let finalPermissionsBulkPayload: any;

            finalPermissionsBulkPayload = this.generateAccountPermissions(partner, account, APIName, version, type);
            Promise.resolve(this.createBulkPermissions(partner, account, APIName, version, emails, finalPermissionsBulkPayload, timeStamp, action)).then(response => {
                if (refreshToken === true) {
                    this.refreshTokenAndPermissions();
                }
                resolve({message: 'Success'});
            }, error => {
                reject({message: 'Failed'});
            });

        });
    }

    // async generateAccountRolePermissionGroupAndPermissions(partner, account, email, APIName, version, type, refreshToken) {
    //     if (!this.applicationPermissionConfig) {
    //         await this.getApplicationPermissionGroupConfig();
    //     }
    //     const permissionGroupIDs = [];
    //     const permissionsbulkPayload = [];
    //     const apiManagementConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'APIMANAGEMENT');
    //     const documentationConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'DOCUMENTATION');
    //     const schedulerConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'SCHEDULER');
    //
    //     let finalPermissionsBulkPayload: any;
    //
    //     let permissionGroupId: any;
    //     switch (type) {
    //         case 'DAAS':
    //             const DAASPermissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === type);
    //             if (DAASPermissionConfig && DAASPermissionConfig.length > 0) {
    //                 for (const action of DAASPermissionConfig[0]['actions']) {
    //                     const payload = {
    //                         permission: '',
    //                         partner: partner,
    //                         account: account,
    //                     };
    //                     payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
    //                     payload['display_name'] = action + ':' + APIName + '=>' + version;
    //                     permissionsbulkPayload.push(payload);
    //                 }
    //             }
    //             const dataPermissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'DATA');
    //             if (dataPermissionConfig && dataPermissionConfig.length > 0) {
    //                 for (const action of dataPermissionConfig[0]['actions']) {
    //                     const payload = {
    //                         permission: '',
    //                         partner: partner,
    //                         account: account,
    //                     };
    //                     payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
    //                     payload['display_name'] = action + ':' + APIName + '=>' + version;
    //                     permissionsbulkPayload.push(payload);
    //                 }
    //             }
    //             finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, apiManagementConfig, permissionsbulkPayload);
    //             finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, documentationConfig, finalPermissionsBulkPayload);
    //             await this.createBulkPermissions(partner, account, APIName, version, email, finalPermissionsBulkPayload);
    //             if (refreshToken === true) {
    //                 this.refreshTokenAndPermissions();
    //             }
    //             break;
    //         default:
    //             const permissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === type);
    //             if (permissionConfig && permissionConfig.length > 0) {
    //                 for (const action of permissionConfig[0]['actions']) {
    //                     const payload = {
    //                         permission: '',
    //                         partner: partner,
    //                         account: account,
    //                     };
    //                     payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
    //                     payload['display_name'] = action + ':' + APIName + '=>' + version;
    //                     permissionsbulkPayload.push(payload);
    //                 }
    //             }
    //             finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, apiManagementConfig, permissionsbulkPayload);
    //             finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, documentationConfig, finalPermissionsBulkPayload);
    //             finalPermissionsBulkPayload = this.returnPermissionsPayloadArray(partner, account, APIName, version, schedulerConfig, finalPermissionsBulkPayload);
    //             await this.createBulkPermissions(partner, account, APIName, version, email, finalPermissionsBulkPayload);
    //             if (refreshToken === true) {
    //                 this.refreshTokenAndPermissions();
    //             }
    //             break;
    //     }
    // }

    refreshTokenAndPermissions() {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.accountInfoService.setAccountPermission()).then(async response => {
                await this.getAllPermissions();
                resolve('success');
            }, error => {
                this.openSnackBar('Unexpected error occurred. Please reload the page', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        });
    }

    // async generateAccountRolePermissionGroupAndPermissions(partner, account, email, APIName, version, type) {
    //     if (!this.applicationPermissionConfig) {
    //         await this.getApplicationPermissionGroupConfig();
    //     }
    //     const permissionGroupIDs = [];
    //     let permissionsIdArray: any;
    //     const apiManagementConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'APIMANAGEMENT');
    //     const documentationConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'DOCUMENTATION');
    //     const schedulerConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'SCHEDULER');
    //     const payload = {
    //         permission: '',
    //         partner: partner,
    //         account: account,
    //     };
    //     const permissionGroupPayload = {
    //         permissionGroup: partner + '=>' + account + '=>' + APIName + '=>' + version,
    //         partner: partner,
    //         account: account
    //     };
    //     let permissionGroupId: any;
    //     switch (type) {
    //         case 'DAAS':
    //             const DAASPermissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === type);
    //             if (DAASPermissionConfig && DAASPermissionConfig.length > 0) {
    //                 for (const action of DAASPermissionConfig[0]['actions']) {
    //                     payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
    //                     payload['display_name'] = action + ':' + APIName + '=>' + version;
    //                     const upsertedId = await this.createApplicationPermission(payload);
    //                     if (upsertedId && upsertedId !== 0) {
    //                         permissionGroupIDs.push(upsertedId);
    //                     }
    //                 }
    //             }
    //             const dataPermissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === 'DATA');
    //             if (dataPermissionConfig && dataPermissionConfig.length > 0) {
    //                 for (const action of dataPermissionConfig[0]['actions']) {
    //                     payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
    //                     payload['display_name'] = action + ':' + APIName + '=>' + version;
    //                     const upsertedId = await this.createApplicationPermission(payload);
    //                     if (upsertedId && upsertedId !== 0) {
    //                         permissionGroupIDs.push(upsertedId);
    //                     }                    }
    //             }
    //             permissionsIdArray = await this.createAPIMgtPermissions(partner, account, APIName, version, apiManagementConfig, permissionGroupIDs);
    //             permissionsIdArray = await this.createDocumentationPermissions(partner, account, APIName, version, documentationConfig, permissionGroupIDs);
    //
    //             permissionGroupPayload['permissions'] = permissionsIdArray;
    //             permissionGroupPayload['display_name'] = APIName + '=>' + version;
    //             permissionGroupId = await this.createApplicationPermissionGroup(permissionGroupPayload);
    //             await this.associateApplicationPermissionGroupWithApplicationRole(partner, account, email, permissionGroupId);
    //             break;
    //         default:
    //             const permissionConfig = this.applicationPermissionConfig.filter(element => element['type'] === type);
    //             if (permissionConfig && permissionConfig.length > 0) {
    //                 for (const action of permissionConfig[0]['actions']) {
    //                     payload['permission'] = action + ':' + partner + '=>' + account + '=>' + APIName + '=>' + version;
    //                     payload['display_name'] = action + ':' + APIName + '=>' + version;
    //                     const upsertedId = await this.createApplicationPermission(payload);
    //                     if (upsertedId && upsertedId !== 0) {
    //                         permissionGroupIDs.push(upsertedId);
    //                     }
    //                 }
    //             }
    //             permissionsIdArray = await this.createAPIMgtPermissions(partner, account, APIName, version, apiManagementConfig, permissionGroupIDs);
    //             permissionsIdArray = await this.createDocumentationPermissions(partner, account, APIName, version, documentationConfig, permissionGroupIDs);
    //             permissionsIdArray = await this.createSchedulerPermissions(partner, account, APIName, version, schedulerConfig, permissionGroupIDs);
    //
    //             permissionGroupPayload['permissions'] = permissionsIdArray;
    //             permissionGroupPayload['display_name'] = APIName + '=>' + version;
    //             permissionGroupId = await this.createApplicationPermissionGroup(permissionGroupPayload);
    //             await this.associateApplicationPermissionGroupWithApplicationRole(partner, account, email, permissionGroupId);
    //             break;
    //     }
    // }

    getAllPermissions() {
        return new Promise((resolve, reject) => {
            if (!this.accountInfoService.hasPlatformPermissions()) {
                const dialogRef = this.dialog.open(InsufficientPermissionsToAccessComponent, {
                    width: '75vh',
                    height: 'auto',
                });
                dialogRef.afterClosed().subscribe(resp => {
                    this.authService.logout();
                });
            }
            this.setMenusAfterPermissions();
            resolve('success');
        });
    }

    // getPermissionsOld
    // getAllPermissions1() {
    //     return new Promise((resolve, reject) => {
    //         if (localStorage.getItem('JWTToken')) {
    //             Promise.resolve(this.jwtParser.parseJWTToken(localStorage.getItem('JWTToken')).then(async response => {
    //                 if (response) {
    //                     this.parsedJWT = response;
    //                     this.platformPermissionFound = false;
    //                     this.permissions = [];
    //                     this.permissionIDs = [];
    //                     for (const permissionObj of response['permissions']) {
    //                         if (permissionObj) {
    //                             this.permissions.push(permissionObj['permission']);
    //                             this.permissionIDs.push(permissionObj['id']);
    //                             if (permissionObj['type'] === 'platform') {
    //                                 this.platformPermissionFound = true;
    //                             }
    //                         }
    //                     }
    //                     if (this.platformPermissionFound === false) {
    //                         const dialogRef = this.dialog.open(InsufficientPermissionsToAccessComponent, {
    //                             width: '75vh',
    //                             height: 'auto',
    //                         });
    //                         dialogRef.afterClosed().subscribe(resp => {
    //                             this.authService.logout();
    //                         });
    //                     }
    //                     this.setMenusAfterPermissions();
    //                     resolve('success');
    //                 } else {
    //                     resolve('failed');
    //                 }
    //             }, error => {
    //                 resolve('failed');
    //             }));
    //         } else {
    //             resolve('failed');
    //         }
    //     });
    // }

    convertMSToTimeFormat(millseconds) {
        const oneSecond = 1000;
        const oneMinute = oneSecond * 60;
        const oneHour = oneMinute * 60;
        const oneDay = oneHour * 24;

        const millisecondsremaining = millseconds % 1000;
        const seconds = Math.floor((millseconds % oneMinute) / oneSecond);
        const minutes = Math.floor((millseconds % oneHour) / oneMinute);
        const hours = Math.floor((millseconds % oneDay) / oneHour);
        const days = Math.floor(millseconds / oneDay);

        let timeString = '';
        if (days !== 0) {
            timeString += days + ' d ';
        }
        if (hours !== 0) {
            timeString += hours + ' h ';
        }
        if (minutes !== 0) {
            // timeString += (minutes !== 1) ? (minutes + ' minutes ') : (minutes + ' minute ');
            timeString += minutes + ' m ';
        }
        if (seconds !== 0) {
            timeString += seconds + ' s ';
        }
        if (millisecondsremaining !== 0) {
            timeString += millisecondsremaining + ' ms ';
        }

        return timeString;
    }

    getEnvironments() {
        return new Promise(((resolve, reject) => {
            this.availableEnvironmentsToSwitch = [];
            if (localStorage.getItem('partner') && localStorage.getItem('account')) {
                const partnerTemp = localStorage.getItem('partner').split('-');
                const accountTemp = localStorage.getItem('account').split('-');
                let partnerShortCode: string;
                let partnerAccount: string;
                if (partnerTemp.length > 1) {
                    partnerShortCode = partnerTemp[partnerTemp.length - 1];
                } else {
                    partnerShortCode = partnerTemp[0];
                }
                if (accountTemp.length > 1) {
                    partnerAccount = accountTemp[accountTemp.length - 1];
                } else {
                    partnerAccount = accountTemp[0];
                }
                this.confPost.getSettingsV2CRUD('admin-' + partnerShortCode, 'admin-' + partnerAccount, false).subscribe(response => {
                    if (response && response['body'] && response['body'][0]) {
                        const environments = response['body'][0]['environments'];
                        this.environments = environments;

                        if (environments && environments.length > 1) {
                            environments.forEach(env => {
                                const subMenuPayload = {};
                                if (env && env !== undefined && env !== null) {
                                    if (env['display_name'] && env['display_name'] !== null && env['display_name'] !== undefined && env['display_name'] !== '') {
                                        subMenuPayload['categoryName'] = env['display_name'];
                                    } else {
                                        subMenuPayload['categoryName'] = env['type'];
                                    }
                                    switch (env['type']) {
                                        case 'admin':
                                            subMenuPayload['icon'] = 'fa fa-cog';
                                            break;
                                        case 'prod':
                                            subMenuPayload['icon'] = 'fa fa-users';
                                            break;
                                        case 'dev':
                                            subMenuPayload['icon'] = 'fa fa-users';
                                            break;
                                        case 'staging':
                                            subMenuPayload['icon'] = 'fa fa-users';
                                            break;
                                        case 'qa':
                                            subMenuPayload['icon'] = 'fa fa-users';
                                            break;
                                        default:
                                            subMenuPayload['icon'] = 'fa fa-users';
                                            break;
                                    }
                                    subMenuPayload['envName'] = env['type'];
                                    subMenuPayload['environmentName'] = env['name'];
                                    subMenuPayload['email'] = localStorage.getItem('signInEmail');
                                    if (env['name'] !== localStorage.getItem('partner')) {
                                        this.availableEnvironmentsToSwitch.push(subMenuPayload);
                                    }
                                }
                            });
                        }
                    }
                    resolve('Success');
                });

            } else {
                resolve('failed');
            }
        }));

    }

    setEnvironmentData() {
        const environmentData = this.masterData.find(item => item.category === 'environments');
        const environmentSubCategories: any = [];
        if (this.environments) {
            for (const category of this.environments) {
                environmentSubCategories.push({
                    categoryName: category.display_name,
                    route: '/administration/' + category.name,
                    hasPermission: true,
                    icon: 'fa fa-user'
                });
            }
            const objectIndex = this.masterData.findIndex(item => item.category === 'environments');
            this.masterData[objectIndex].subcategory = environmentSubCategories;
        }

    }

    async initialisePlatform() {
        this.partner = localStorage.getItem('partner');
        this.account = localStorage.getItem('account');
        this.gatewayUrl = await this.getDefaultGatewayURL();
        Promise.resolve(this.getEnvironments().then(res => {
            this.setEnvironmentData();
        }));
        this.setEnvironmentsToSettingsPayloadToInsert();
        this.loadingForTheFirstTime = false;
        return new Promise(async (resolve, reject) => {
            this.progressMessage = 'Getting your environments';
            const partnerTempArray = localStorage.getItem('partner').split('-');
            let partnerShortCode: string;
            if (partnerTempArray.length > 1) {
                partnerShortCode = partnerTempArray[partnerTempArray.length - 1];
            } else {
                partnerShortCode = partnerTempArray[0];
            }
            const partnerShortCodeInPartnerInfo = this.partnerInfo.filter(elem => elem['title'] === 'Partner Short Code');
            if (partnerShortCodeInPartnerInfo && partnerShortCodeInPartnerInfo.length > 0) {
                partnerShortCodeInPartnerInfo[0]['value'] = partnerShortCode;
            }

            if (this.partner && this.account) {
                this.isDataInitialised.emit(false);

                this.getApplicationPermissionGroupConfig();
                this.validateBillingStatus();

                const getPermissions = new Promise(async (resolve, reject) => {
                    await this.getAllPermissions();
                    resolve('success');
                });

                const getProperties = new Promise(async (resolve, reject) => {
                    if (this.properties === null || this.properties === undefined) {
                        (this.getPropertiesFromAPI()).then(resp => {
                            resolve('success');
                        });
                    } else {
                        resolve('failed');
                    }
                });

                const getOAuthCreds = new Promise((resolve, reject) => {
                    this.kong.getKongGatewayConsumerDetails(localStorage.getItem('signInEmail')).subscribe((data) => {
                        const consumerResponse = data['data'][0];
                        this.consumerId = consumerResponse['id'];
                        this.kong.getKongGatewayCredentialDetails('oauth2', this.consumerId).subscribe(response1 => {
                            if (response1 && response1['data']) {
                                this.OAuthClientApps = response1['data'];
                                resolve('success');
                            }
                        });
                    });
                });

                const getAPIKey = new Promise((resolve, reject) => {
                    this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(localStorage.getItem('signInEmail')).subscribe(keys => {
                        this.apiKeyData = keys;
                        if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
                            this.apiKeys = this.apiKeyData.data;
                            this.apiKey = this.apiKeys[0].key;
                            localStorage.setItem('apikey', this.apiKey);
                            const apiKeyInPartnerInfo = this.partnerInfo.filter(elem => elem['title'] === 'API Key');
                            if (apiKeyInPartnerInfo && apiKeyInPartnerInfo.length > 0) {
                                apiKeyInPartnerInfo[0]['value'] = this.apiKey;
                            }
                        }
                        // else {
                        //     this.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access your APIs.', 'Info', {
                        //         duration: 10000,
                        //         verticalPosition: 'top',
                        //         horizontalPosition: 'center'
                        //     });
                        // }
                        resolve('success');
                    }, error => {
                        this.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access your APIs.', 'Info', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        resolve('failed');
                    });
                });

                const getEnvironmentsOfPartner = new Promise((resolve, reject) => {

                    this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + this.partner + '&account=' + this.account + '&sort=-at&fields=at,executor_name,executor_type,by,executor_version,partner,account,action').subscribe(response => {
                        if (response && response !== null && response !== undefined && response[0]) {
                            this.apiHistory = response;
                            const masterDataPayload = {
                                'category': 'History',
                                'expand': true,
                                'route': null,
                                'subcategory': []
                            };
                            this.masterData.push(masterDataPayload);

                            const partnerInfoIndex = this.menus[1].stickyMenus.findIndex(value => value['name'] === 'partner-info');
                            const historyData = {
                                name: 'History',
                                displayName: 'History',
                                tooltipText: 'Shows history of API Executors',
                                hasSubMenu: true,
                                displayType: '',
                                icon: 'fa fa-clock-o',
                                submenus: []
                            };
                            if (partnerInfoIndex !== -1) {
                                this.menus[1].stickyMenus.splice(partnerInfoIndex, 0, historyData);
                            } else {
                                this.menus[1].stickyMenus.push(historyData);
                            }
                            for (const item of this.menus[1].stickyMenus) {
                                if (item['name'] === 'History') {
                                    item['hasPermission'] = this.hasPlatformPermission('MENU_HISTORY');
                                }
                            }
                            this.setMenusAfterPermissions();
                            this.isHistoryAvailable = true;
                        }
                    });
                });

                const getEntitiesPartnerAccount = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your entities...';
                    this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data1 => {
                        this.entities = data1;
                        this.partnerEntities = data1;
                        this.partnerEntities.forEach(entity => {
                            this.partnerEntityTypes.push(entity.entityname + '_' + entity.version);
                        });
                        this.progressMessage = 'Retrieving your entities...Done';
                        this.progress = this.progress + this.incr;
                        resolve('success');
                    }, error => {
                        this.progress = this.progress + this.incr;
                        resolve('failure');
                        this.openSnackBar('Error while retrieving data access services for your account', 'Error', {
                            duration: 30000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                });
                const getExecutorsForPartnerAccount = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your APIs...';
                    this.getExecutorsForPartnerAccount().then(resp => {
                        this.progressMessage = 'Retrieving your APIs...Done';
                        this.progress = this.progress + this.incr;
                        resolve('success');
                    });
                });

                const getApplicationsForPartnerAccount = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your Applications...';
                    this.getApplicationsForPartnerAccount().then(resp => {
                        this.progressMessage = 'Retrieving your Applications...Done';
                        this.progress = this.progress + this.incr;
                        resolve('success');
                    });
                });

                // const getExecutorsOfPartnerAccount = new Promise((resolve, reject) => {
                //     this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
                //         this.partnerExecutors = data;
                //         this.progress = this.progress + this.incr;
                //         resolve('success');
                //     }, error => {
                //         this.progress = this.progress + this.incr;
                //         resolve('failure');
                //         // this.openSnackBar('Error while retrieving API executors for your account', 'Error', {
                //         //     duration: 30000,
                //         //     verticalPosition: 'top',
                //         //     horizontalPosition: 'center'
                //         // });
                //     });
                // });

                const getLanguages = new Promise((resolve, reject) => {
                    this.confPost.getLanguages().subscribe(
                        items => {
                            this.languages = items;
                            resolve('success');
                        },
                        error => {
                            resolve('failure');
                            this.openSnackBar('Error while getting list of languages: ' + error.error.message, 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    );

                });
                const getCategoriesForPartnerAccount = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your data access service categories...';
                    if (this.partnerCategories === null || this.partnerCategories === undefined) {
                        this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                            this.partnerCategories = data;
                            this.progressMessage = 'Retrieving your data access service categories...Done';
                            this.progress = this.progress + this.incr;
                            resolve('success');
                        }, error => {
                            this.progress = this.progress + this.incr;
                            resolve('failure');
                            this.openSnackBar('Error while retrieving data access services group by categories for your account', 'Error', {
                                duration: 30000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                    }
                });
                const getDatabasesForPartnerAccount = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your configured databases...';
                    this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(async databases => {
                            this.databases = databases;
                            await this.updateIsNoSQLForMongo(this.databases);
                            this.progressMessage = 'Retrieving your configured databases...Done';
                            this.progress = this.progress + this.incr;
                            resolve('success');
                        },
                        error => {
                            this.progress = this.progress + this.incr;
                            resolve('failure');
                            this.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });
                const getDataTypesForPartnerAccount = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your configured datatypes...';
                    this.confPost.getDataTypes().subscribe(data => {
                            this.datatypes = data;
                            this.progressMessage = 'Retrieving your configured datatypes...Done';
                            this.progress = this.progress + this.incr;
                            resolve('success');
                        },
                        error => {
                            this.progress = this.progress + this.incr;
                            resolve('failure');
                            this.openSnackBar('Error while getting list of data types: ' + error.error.message, 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });
                const getAPIGateways = new Promise((resolve1, reject1) => {
                    this.progressMessage = 'Retrieving your configured API Gateways...';
                    this.confPost.getPartnerSettings(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey')).subscribe(data => {
                            let resp: any;
                            resp = data;
                            this.apiGateways = resp['apigateway'];
                            this.progressMessage = 'Retrieving your configured API Gateways...Done';
                            this.progress = this.progress + this.incr;
                            resolve1('success');
                        },
                        error => {
                            this.progress = this.progress + this.incr;
                            resolve1('failure');
                            this.openSnackBar('Error while getting list of API Gateways: ' + error.error.message, 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });
                const getEntityCountForPartner = new Promise((resolve, reject) => {
                    this.confPost.getEntityCountForPartner(localStorage.getItem('partner')).subscribe(data => {
                            this.countPartnerEntities = data;
                            this.progress = this.progress + this.incr;
                            resolve('success');
                        },
                        error => {
                            this.progress = this.progress + this.incr;
                            resolve('failure');
                            this.openSnackBar('Error while getting count of entities for partner: ' + error.error.message, 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });
                // const getEntityCountForPartnerAccount = new Promise((resolve, reject) => {
                //     this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                //             this.countPartnerAccountEntities = data;
                //             if (data) {
                //                 this.countOfDataAccessServices = data['noOfApis'];
                //             } else {
                //                 this.countOfDataAccessServices = 0;
                //             }
                //             this.progress = this.progress + this.incr;
                //             resolve('success');
                //         },
                //         error => {
                //             this.progress = this.progress + this.incr;
                //             resolve('failure');
                //             this.openSnackBar('Error while getting count of entities for partner account: ' + error.error.message, 'Error', {
                //                 duration: 5000,
                //                 verticalPosition: 'top',
                //                 horizontalPosition: 'center'
                //             });
                //         });
                // });
                const getCategoriesEntitiesForPartner = new Promise((resolve, reject) => {
                    this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                        this.categoriesEntitiesForPartner = data;
                        this.progress = this.progress + this.incr;
                        resolve('success');
                    }, error => {
                        this.progress = this.progress + this.incr;
                        resolve('failure');
                        this.openSnackBar('Error while getting entities grouped by category for partner account: ' + error.error.message, 'Error', {
                            duration: 30000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                });

                const getDatabaseObjectTypes = new Promise((resolve, reject) => {
                    this.confPost.getDatabaseObjectTypes().subscribe(data => {
                        this.databaseObjectTypes = data;
                        resolve('success');
                    }, error => {
                        resolve('failure');
                    });
                });

                // const getApiExecutorsByPartnerAccountType = new Promise((resolve, reject) => {
                //     this.progressMessage = 'Retrieving your Data Access APIs...';
                //     this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
                //         this.apiExecutors = data;
                //         if (this.apiExecutors) {
                //             this.countOfApiExecutors = this.apiExecutors.length;
                //         }
                //         // localStorage.setItem('dataAccessAPI', JSON.stringify(this.apiExecutors));
                //         this.progressMessage = 'Retrieving your Data Access APIs...Done';
                //         this.progress = this.progress + this.incr;
                //         resolve('success');
                //     });
                // });
                // const getBusinessLogicApiExecutorsByPartnerAccountType = new Promise((resolve, reject) => {
                //     this.progressMessage = 'Retrieving your Business Logic APIs...';
                //     this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'BUSINESSLOGIC').subscribe(data => {
                //         this.executors = data;
                //         if (this.executors) {
                //             this.countOfBusinessLogicApis = this.executors.length;
                //         }
                //         this.businessLogicExecutors = data;
                //         // localStorage.setItem('businessLogicAPI', JSON.stringify(this.executors));
                //         this.progressMessage = 'Retrieving your Business Logic APIs...Done';
                //         this.progress = this.progress + this.incr;
                //         resolve('success');
                //     });
                // });
                // const getThirdPartyApiExecutorsByPartnerAccountType = new Promise((resolve, reject) => {
                //     this.progressMessage = 'Retrieving your Third Party APIs...';
                //     this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'THIRDPARTY').subscribe(data => {
                //         this.thirdPartyApiExecutors = data;
                //         // localStorage.setItem('thirdPartyAPI', JSON.stringify(this.thirdPartyApiExecutors));
                //         if (this.thirdPartyApiExecutors) {
                //             this.countOfThirdPartyApis = this.thirdPartyApiExecutors.length;
                //         }
                //         this.progressMessage = 'Retrieving your Third Party APIs...Done';
                //         this.progress = this.progress + this.incr;
                //         resolve('success');
                //     });
                // });
                // const getSqlQueryApiExecutorsByPartnerAccountType = new Promise((resolve, reject) => {
                //     this.progressMessage = 'Retrieving your SQL Query APIs...';
                //     this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'SQLQUERY').subscribe(data => {
                //         this.sqlQueryExecutors = data;
                //         // localStorage.setItem('sqlQueryAPI', JSON.stringify(this.sqlQueryExecutors));
                //         if (this.sqlQueryExecutors) {
                //             this.countOfSqlQueryApis = this.sqlQueryExecutors.length;
                //         }
                //         this.progressMessage = 'Retrieving your SQL Query APIs...Done';
                //         this.progress = this.progress + this.incr;
                //         resolve('success');
                //     });
                // });
                // const getWorkFlowApiExecutorsByPartnerAccountType = new Promise((resolve, reject) => {
                //     this.progressMessage = 'Retrieving your Workflow APIs...';
                //     this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'WORKFLOW').subscribe(data => {
                //         this.workFlowExecutors = data;
                //         localStorage.setItem('workFlowAPI', JSON.stringify(this.workFlowExecutors));
                //         if (this.workFlowExecutors) {
                //             this.countOfWorkflowApis = this.workFlowExecutors.length;
                //         }
                //         this.progressMessage = 'Retrieving your Workflow APIs...Done';
                //         this.progress = this.progress + this.incr;
                //         resolve('success');
                //     });
                // });
                // const getDMNApiExecutorsByPartnerAccountType = new Promise((resolve, reject) => {
                //     this.progressMessage = 'Retrieving your DMN APIs...';
                //     this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'DECISION').subscribe(data => {
                //         this.dmnExecutors = data;
                //         localStorage.setItem('dmnAPI', JSON.stringify(this.dmnExecutors));
                //         if (this.dmnExecutors) {
                //             this.countOfDmnApis = this.dmnExecutors.length;
                //         }
                //         this.progressMessage = 'Retrieving your DMN APIs...Done';
                //         this.progress = this.progress + this.incr;
                //         resolve('success');
                //     });
                // });

                // const getb2bAPIs = new Promise((resolve, reject) => {
                //     this.confPost.getApiExecutorsForThirdPartnerAccount('b2b', 'b2b')
                //         .toPromise().then(data1 => {
                //         this.completeb2bExecutors = data1;
                //         for (let i = 0; i < this.completeb2bExecutors.length; i++) {
                //             for (let j = 0; j < this.completeb2bExecutors[i]['executors'].length; j++) {
                //                 this.b2bArrayValues.push('B2b_' + this.completeb2bExecutors[i]['executors'][j]['executor_category_group'] + '_' + this.completeb2bExecutors[i]['executors'][j]['executor_name'] + '_' + this.completeb2bExecutors[i]['executors'][j]['executor_version']);
                //             }
                //         }
                //         // localStorage.setItem('b2bAPI', JSON.stringify(this.b2bArrayValues));
                //         this.progress = this.progress + this.incr;
                //         resolve('success');
                //     });
                // });

                const b2bAPIs = new Promise((resolve, reject) => {
                    this.providerObjects = {};
                    this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(async response => {
                        if (response['body'] && response['body'][0]) {
                            const providers = response['body'][0]['subscriptions']['providers'];
                            const subscribedProviders = [];
                            const myServiceProviders = [];
                            providers.forEach(provider => {
                                if (provider.partner === localStorage.getItem('partner') &&
                                    provider.account === localStorage.getItem('account')) {
                                    myServiceProviders.push(provider['producer']);
                                } else {
                                    subscribedProviders.push(provider['producer']);
                                }
                                this.providerObjects[provider['producer']] = provider['title'];
                            });
                            myServiceProviders.push(localStorage.getItem('partner'));
                            let subscribedProvidersList = '';
                            for (let i = 0; i < subscribedProviders.length; i++) {
                                subscribedProvidersList += subscribedProviders[i];
                                if (i !== subscribedProviders.length - 1) {
                                    subscribedProvidersList += ',';
                                }
                            }
                            let myProvidersList = '';
                            for (let i = 0; i < myServiceProviders.length; i++) {
                                myProvidersList += myServiceProviders[i];
                                if (i !== myServiceProviders.length - 1) {
                                    myProvidersList += ',';
                                }
                            }
                            if (subscribedProvidersList !== '') {
                                await this.confPost.getSubscribedExecutors('b2b', 'b2b', subscribedProvidersList).subscribe(response1 => {
                                    this.b2bExecutors = response1;
                                    resolve('success');
                                }, error => {
                                    reject('failed');
                                });
                            } else {
                                resolve('success');
                            }

                            if (myProvidersList !== '') {
                                await this.confPost.getMyProviderExecutors(localStorage.getItem('partner'), localStorage.getItem('account'), myProvidersList).subscribe(response1 => {
                                    this.myProviderExecutors = response1;
                                    resolve('success');
                                }, error => {
                                    reject('failed');
                                });
                            } else {
                                resolve('success');
                            }
                        } else {
                            resolve('failure');
                        }
                    }, error => {
                        resolve('failure');
                    });
                });

                // const getCloudWatchNoOfHits = new Promise((resolve, reject) => {
                //     this.confPost.getCloudWatchMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                //             this.cloudWatchNoOfHits = data;
                //             this.progress = this.progress + this.incr;
                //             resolve('success');
                //         },
                //         error => {
                //             this.progress = this.progress + this.incr;
                //             resolve('failure');
                //             // this.openSnackBar('Error while getting noOfHits metrics from CloudWatch: ' + error.error.message, 'Error', {
                //             //     duration: 5000,
                //             //     verticalPosition: 'top',
                //             //     horizontalPosition: 'center'
                //             // });
                //         });
                // });
                // const cloudWatchLatency = new Promise((resolve, reject) => {
                //     this.confPost.getCloudWatchLatencyMetrics(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                //             this.cloudWatchLatency = data;
                //             this.progress = this.progress + this.incr;
                //             resolve('success');
                //         },
                //         error => {
                //             resolve('failure');
                //             // this.openSnackBar('Error while getting latency metrics from CloudWatch: ' + error.error.message, 'Error', {
                //             //     duration: 15000,
                //             //     verticalPosition: 'top',
                //             //     horizontalPosition: 'center'
                //             // });
                //         });
                // });
                const getMaxApiLimitForPartner = new Promise((resolve, reject) => {
                    this.confPost.getMaxAPILimit(localStorage.getItem('partner')).subscribe(count => {
                            this.maxCount = count;
                            this.progress = this.progress + this.incr;
                            resolve('success');
                        },
                        error => {
                            resolve('failure');
                            this.openSnackBar('Error while getting maximum API count for partner: ' + error.error.message, 'Error', {
                                duration: 15000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });
                // const entityCountForPartnerAccount = new Promise((resolve, reject) => {
                //     this.confPost.getEntityCountForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(entityCount => {
                //             if (entityCount) {
                //                 this.countOfDataAccessServices = entityCount['noOfApis'];
                //             } else {
                //                 this.countOfDataAccessServices = 0;
                //             }
                //             this.progress = this.progress + this.incr;
                //             resolve('success');
                //         },
                //         error => {
                //             this.progress = this.progress + this.incr;
                //             resolve('failure');
                //             this.openSnackBar('Error while getting data access services count for partner: ' + error.error.message, 'Error', {
                //                 duration: 15000,
                //                 verticalPosition: 'top',
                //                 horizontalPosition: 'center'
                //             });
                //         });
                // });
                // const entityNameAndVersionAsCustomType = new Promise((resolve, reject) => {
                //     this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
                //             if (response.status === 200) {
                //                 resolve('success');
                //                 this.entityAndVersion = response.body['entityNameAndVersion'];
                //             } else {
                //                 resolve('failed');
                //             }
                //         },
                //         error => {
                //             resolve('failure');
                //             // this.openSnackBar('Error while getting entity name and version for partner account' + (error.error !== undefined && error.error !== null) ? ': ' + error.error.message : '', 'Error', {
                //             //     duration: 15000,
                //             //     verticalPosition: 'top',
                //             //     horizontalPosition: 'center'
                //             // });
                //             this.openSnackBar('Error while getting entity name and version for partner account', 'Error', {
                //                 duration: 15000,
                //                 verticalPosition: 'top',
                //                 horizontalPosition: 'center'
                //             });
                //         });
                // });
                const authorizationTypes = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving Authorization types...';
                    this._service.getItems('v1', 'services', 'services', 'authorizationTypes', false).subscribe(authTypes => {
                            this.authorizationTypes = authTypes;
                            this.progressMessage = 'Retrieving Authorization types...Done';
                            resolve('success');
                        },
                        error => {
                            resolve('failure');
                            this.openSnackBar('Error while getting authorization types for partner account: ' + error.error.message, 'Error', {
                                duration: 15000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });

                const platformServiceProviders = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving Service Providers master...';
                    this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services' + '&account=services').subscribe(platformProviders => {
                            this.platformServiceProviders = platformProviders;
                            this.progressMessage = 'Retrieving Service Providers master...Done';
                            resolve('success');
                        },
                        error => {
                            resolve('failure');
                            this.openSnackBar('Error while getting list of service providers for platform: ' + error.error.message, 'Error', {
                                duration: 15000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });

                const partnerServiceProviders = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your subscribed service providers...';
                    this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account')).subscribe(partnerProviders => {
                            this.partnerServiceProviders = partnerProviders;
                            this.progressMessage = 'Retrieving your subscribed service providers...Done';
                            this.progress = this.progress + this.incr;
                            resolve('success');
                        },
                        error => {
                            this.progress = this.progress + this.incr;
                            resolve('failure');
                            this.openSnackBar('Error while getting list of service providers for partner: ' + error.error.message, 'Error', {
                                duration: 15000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });

                const settingsData = new Promise((resolve1, reject1) => {
                    this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(async settingsData => {
                            if (settingsData['body'] && settingsData['body'][0]) {
                                this.settingsData = settingsData;
                                this.partnerLogo = this.settingsData['body'][0]['logo'];
                                this.getDefaultGatewaySettings(this.settingsData);

                                for (const envs of this.settingsData['body'][0]['environments']) {
                                    if (envs && envs !== null && envs !== undefined) {
                                        if (envs['name'] === localStorage.getItem('partner')) {
                                            if (envs['services']) {
                                                const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                                                if (gatewayService && gatewayService.length > 0 && gatewayService[0]['configurations']) {
                                                    for (const gateway of gatewayService[0]['configurations']) {
                                                        if (gateway && gateway !== null && gateway !== undefined && gateway['is_default'] === true && gateway['gateway_configurations'] !== {}) {
                                                            this.defaultGatewaySettings = gateway['gateway_configurations'];
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                await this.patchDefaultGatewaySettingsAndInsert(settingsData['body'][0]['id'], settingsData['body'][0]['environments']);
                                resolve1('success');
                            } else {
                                resolve1('failure');
                                this.constructAndInsertSettingsPayload();
                            }
                        },
                        error => {
                            resolve1('failure');
                            this.openSnackBar('Error while getting list of settings data for partner: ' + error.error.message, 'Error', {
                                duration: 15000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });

                const settingsDataWithoutDBRef = new Promise((resolve, reject) => {
                    this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(settingsData => {
                            if (settingsData['body'] && settingsData['body'][0]) {
                                this.settingsDataWithoutDBRef = settingsData;
                                resolve('success');
                            } else {
                                resolve('failure');
                            }
                        },
                        error => {
                            resolve('failure');
                            this.openSnackBar('Error while getting list of settings data for partner: ' + error.error.message, 'Error', {
                                duration: 15000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });

                const registeredConnectors = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your configured API Connectors...';
                    this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + this.partner + '&account=' + this.account)
                        .toPromise().then(apiconnectors => {
                            this.registeredConnectors = apiconnectors;
                            this.progressMessage = 'Retrieving your configured API Connectors...Done';
                            this.progress = this.progress + this.incr;
                            resolve('success');
                        },
                        error => {
                            this.progress = this.progress + this.incr;
                            resolve('failure');
                            this.openSnackBar('Error while getting authorization types for partner account: ' + error.error.message, 'Error', {
                                duration: 15000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });
                const queryBuilderAttributes = new Promise((resolve, reject) => {
                    this.progressMessage = 'Retrieving your Query Builder Attributes...';
                    this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
                            this.queryBuilderAttributes = db;
                            this.progressMessage = 'Retrieving your Query Builder Attributes...Done';
                            resolve('success');
                        },
                        error => {
                            resolve('failure');
                            this.openSnackBar('Error while getting query builder attributes for partner account: ' + error.error.message, 'Error', {
                                duration: 15000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                });
                // const settingsPayload = new Promise((resolve, reject) => {
                //     this.progressMessage = 'Retrieving your settings configurations...';
                //     this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(data => {
                //         this.settingsData = data;
                //         this.progressMessage = 'Retrieving your settings configurations...Done';
                //         resolve('success');
                //     }, error => {
                //         resolve('failure');
                //         this.snackBar.open('Error while getting settings data for partner account: ' + error.error.message, 'Error', {
                //             duration: 15000,
                //             verticalPosition: 'top',
                //             horizontalPosition: 'center'
                //         });
                //     });
                // });

                Promise.all([getCategoriesEntitiesForPartner, getApplicationsForPartnerAccount,
                    getEntitiesPartnerAccount, getExecutorsForPartnerAccount, getDataTypesForPartnerAccount,
                    getEntityCountForPartner, getCategoriesForPartnerAccount,
                    authorizationTypes, settingsDataWithoutDBRef, getDatabaseObjectTypes,
                    registeredConnectors, queryBuilderAttributes, platformServiceProviders, partnerServiceProviders, settingsData, getAPIKey, b2bAPIs]).then(response => {
                    this.isDataInitialised.emit(true);
                    // if (this.loadingForTheFirstTime === true) {
                    //     this.loadingForTheFirstTime = false;
                    //     this.loadingForTheFirstTimeCompleted = true;
                    // }
                    this.progressMessage = 'Setting up your workspace...';
                    this.loadingForTheFirstTimeCompleted = true;
                    this.leftPanelLoading = false;
                    this.progressMessage = '';
                    this.progress = 100;
                    resolve('success');
                });
            } else {
                this.router.navigate(['/']);
            }
        });
    }

    encryptDatabaseAttributes(val) {
        return new Promise(async (resolve, reject) => {
            const iterationCount = 1000;
            let keySize = 128;
            keySize = keySize / 32;
            const passphrase = environment.cipheringPhrase;

            const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            val['shash'] = salt;
            val['ralam'] = iv;
            const attributes = Object.keys(val['database_attributes']);
            if (attributes && attributes.length > 0) {
                if (val['database_type'] === 'csv') {
                    if (val['database_attributes']['files'] && val['database_attributes']['files'].length) {
                        for (let i = 0; i < val['database_attributes']['files'].length; i++) {
                            const fileAttributes = Object.keys(val['database_attributes']['files'][i]);
                            for (let j = 0; j < fileAttributes.length; j++) {
                                await this.encryptAttribute(salt, iv, passphrase, val['database_attributes']['files'][i][fileAttributes[j]], keySize, iterationCount).then(response => {
                                    val['database_attributes']['files'][i][fileAttributes[j]] = response;
                                });
                            }
                        }
                    }
                    if (val['database_attributes']['connectionType']) {
                        await this.encryptAttribute(salt, iv, passphrase, val['database_attributes']['connectionType'], keySize, iterationCount).then(response => {
                            val['database_attributes']['connectionType'] = response;
                        });
                    }
                    if (val['database_attributes']['URL']) {
                        await this.encryptAttribute(salt, iv, passphrase, val['database_attributes']['URL'], keySize, iterationCount).then(response => {
                            val['database_attributes']['URL'] = response;
                        });
                    }
                    if (val['database_attributes']['connectTo']) {
                        await this.encryptAttribute(salt, iv, passphrase, val['database_attributes']['connectTo'], keySize, iterationCount).then(response => {
                            val['database_attributes']['connectTo'] = response;
                        });
                    }
                    if (val['database_attributes']['connector']) {
                        await this.encryptAttribute(salt, iv, passphrase, val['database_attributes']['connector'], keySize, iterationCount).then(response => {
                            val['database_attributes']['connector'] = response;
                        });
                    }
                    if (val['database_attributes']['file_selector']) {
                        await this.encryptAttribute(salt, iv, passphrase, val['database_attributes']['file_selector'], keySize, iterationCount).then(response => {
                            val['database_attributes']['file_selector'] = response;
                        });
                    }
                } else {
                    for (let i = 0; i < attributes.length; i++) {
                        await this.encryptAttribute(salt, iv, passphrase, val['database_attributes'][attributes[i]], keySize, iterationCount).then(response => {
                            val['database_attributes'][attributes[i]] = response;
                        });
                    }
                }

            }
            resolve({database: val});
        });
    }

    async passwordPolicyValidator(password) {
        return new Promise((resolve, reject) => {
            let i = 0;
            let character = '';
            let containsDigit = false;
            let containsLowerCase = false;
            let containsUpperCase = false;
            let containsSpecialCharacter = false;
            if (!password || password === '' || password.length < 8) {
                resolve(false);
            } else {
                while (i <= password.length) {
                    character = password.charAt(i);
                    if (character.charCodeAt(0) >= 48 && character.charCodeAt(0) <= 57) {
                        containsDigit = true;
                    }
                    if (character.charCodeAt(0) >= 65 && character.charCodeAt(0) <= 90) {
                        containsUpperCase = true;
                    }
                    if (character.charCodeAt(0) >= 97 && character.charCodeAt(0) <= 122) {
                        containsLowerCase = true;
                    }
                    if (character.charCodeAt(0) >= 32 && character.charCodeAt(0) <= 47 ||
                        character.charCodeAt(0) >= 58 && character.charCodeAt(0) <= 64 ||
                        character.charCodeAt(0) >= 91 && character.charCodeAt(0) <= 96 ||
                        character.charCodeAt(0) >= 123 && character.charCodeAt(0) <= 126) {
                        containsSpecialCharacter = true;
                    }
                    i++;
                    if (i === password.length) {
                        if (containsDigit && containsLowerCase && containsUpperCase && containsSpecialCharacter) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    }
                }
            }
        });
    }

    bulkUpdateDatabases(databases) {
        return new Promise((resolve, reject) => {
            this.confPost.bulkUpdateDatabases(localStorage.getItem('partner'), databases).subscribe(response => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    updateIsNoSQLForMongo(databasesParam) {
        return new Promise(async (resolve, reject) => {
            let databases: any;
            if (databasesParam.hasOwnProperty('databaseDetails')) {
                databases = databasesParam['databaseDetails'];
            } else {
                databases = databasesParam;
            }
            let isNoSQLFalseMatchFound = false;
            for (const database of databases) {
                if (database) {
                    if ((database['database_type'] === 'mongodb' || database['database_type'] === 'dynamodb') && database['is_nosql'] === false) {
                        isNoSQLFalseMatchFound = true;
                        database['is_nosql'] = true;
                    }
                }
            }
            // if (isNoSQLFalseMatchFound === true) {
            //     await this.bulkUpdateDatabases(databasesParam).then(resp => {
            //         this.databases = databasesParam;
            //         resolve('success');
            //     }, error => {
            //         this.databases = databasesParam;
            //         resolve('failed');
            //     });
            // } else {
            //     this.databases = databasesParam;
            //     resolve('success');
            // }
            this.databases = databases;
            resolve('success');
        });
    }

    getUpdatedDatabases(databasesParam) {
        let databases: any;
        if (databasesParam.hasOwnProperty('databaseDetails')) {
            databases = databasesParam['databaseDetails'];
        } else {
            databases = databasesParam;
        }
        let isNoSQLFalseMatchFound = false;
        for (const database of databases) {
            if (database) {
                if ((database['database_type'] === 'mongodb' || database['database_type'] === 'dynamodb') && database['is_nosql'] === false) {
                    isNoSQLFalseMatchFound = true;
                    database['is_nosql'] = true;
                }
            }
        }
        return databases;
    }

    patchEntityData(partner, account, version, entity, id, payload) {
        return new Promise((resolve, reject) => {
            this.confPost.patchEntityData(partner, account, version, entity, id, payload).subscribe(response1 => {
                resolve('success');
            }, error => {
                this.openSnackBar('Error while patching data for partner', 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                resolve('failed');
            });
        });
    }

    hasExecutorViewPermission(partner, item) {
        if (item['executor_type'] === 'API') {
            return this.hasAccountPermission('view:' + partner + '=>' + item.account_id + '=>' + item.executor_category + '=>' + item.executor_version);
        } else {
            return this.hasAccountPermission('view:' + partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version);
        }
    }

    patchDefaultGatewaySettingsAndInsert(id, environments) {
        return new Promise((resolve, reject) => {
            let withoutTypeFound = false;
            if (environments && environments !== null && environments !== undefined) {
                for (let i = 0; i < environments.length; i++) {
                    if (environments[i] && environments[i] !== null && environments[i] !== undefined) {
                        const gatewayService = environments[i]['services'].filter(element => element.type === 'apigateway');
                        for (let j = 0; j < gatewayService.length; j++) {
                            if (gatewayService[j] && gatewayService[j] !== null && gatewayService[j] !== undefined) {
                                const gatewayServiceConfig = gatewayService[j]['configurations'][0];
                                if (gatewayServiceConfig && !gatewayServiceConfig.hasOwnProperty('type')) {
                                    withoutTypeFound = true;
                                    gatewayServiceConfig['name'] = 'default';
                                    gatewayServiceConfig['type'] = 'kong';
                                    gatewayServiceConfig['gateway_configurations'] = [
                                        {
                                            'name': 'key-auth',
                                            'isConfigured': false,
                                            'img': '/assets/img/key-auth.png',
                                            'description': 'Configure KeyAuth service..',
                                            'enabled': true,
                                            'consumer': {},
                                            'tagline': 'Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests.',
                                            'config': [
                                                {
                                                    'displayName': 'Key Names',
                                                    'parameter': 'key_names',
                                                    'type': 'array_string',
                                                    'value': 'apikey',
                                                    'isRequired': true,
                                                    'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
                                                        'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
                                                },
                                                {
                                                    'displayName': 'Key In Body',
                                                    'parameter': 'key_in_body',
                                                    'type': 'boolean',
                                                    'value': false,
                                                    'isRequired': false,
                                                    'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
                                                },
                                                {
                                                    'displayName': 'Hide Credentials',
                                                    'parameter': 'hide_credentials',
                                                    'type': 'boolean',
                                                    'value': false,
                                                    'isRequired': false,
                                                    'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
                                                },
                                                {
                                                    'displayName': 'Run On Preflight',
                                                    'parameter': 'run_on_preflight',
                                                    'type': 'boolean',
                                                    'value': true,
                                                    'isRequired': false,
                                                    'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
                                                },
                                                // {
                                                //   'displayName': 'Anonymous',
                                                //   'parameter': 'anonymous',
                                                //   'type': 'string',
                                                //   'value': '',
                                                //     'isRequired': false,
                                                //     'description': 'An optional string (Consumer UUID) value to use as an anonymous Consumer if authentication fails. If empty (default), the request will fail with an authentication failure 4xx. Note that this value must refer to the Consumer id attribute that is internal to Kong, and not its custom_id'
                                                // },
                                                {
                                                    'displayName': 'Key In Header',
                                                    'parameter': 'key_in_header',
                                                    'type': 'boolean',
                                                    'value': true,
                                                    'isRequired': false,
                                                    'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
                                                },
                                                {
                                                    'displayName': 'Key In Query',
                                                    'parameter': 'key_in_query',
                                                    'type': 'boolean',
                                                    'value': true,
                                                    'isRequired': false,
                                                    'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
                                                },
                                            ],
                                            'id': 9,
                                            'itemName': 'key-auth'
                                        },
                                        {
                                            'name': 'cors',
                                            'isConfigured': false,
                                            'img': 'assets/img/cors.png',
                                            'description': 'Configure CORS service.',
                                            'tagline': 'Allow developers to make requests from the browser',
                                            'enabled': true,
                                            'consumer': {},
                                            'config': [
                                                // {
                                                //   'parameter': 'consumerID',
                                                //   'type': 'string',
                                                //   'value': '',
                                                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                                                // },
                                                {
                                                    'displayName': 'Origins',
                                                    'parameter': 'origins',
                                                    'type': 'array_string',
                                                    'value': '*',
                                                    'isRequired': false,
                                                    'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
                                                },
                                                {
                                                    'displayName': 'Headers',
                                                    'parameter': 'headers',
                                                    'type': 'array_string',
                                                    'value': null,
                                                    'isRequired': false,
                                                    'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
                                                },
                                                {
                                                    'displayName': 'Exposed Headers',
                                                    'parameter': 'exposed_headers',
                                                    'type': 'array_string',
                                                    'value': null,
                                                    'isRequired': false,
                                                    'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
                                                },
                                                {
                                                    'displayName': 'Methods',
                                                    'parameter': 'methods',
                                                    'type': 'array_string',
                                                    'value': null,
                                                    'isRequired': false,
                                                    'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
                                                },
                                                {
                                                    'displayName': 'Max Age',
                                                    'parameter': 'max_age',
                                                    'type': 'number',
                                                    'value': 300,
                                                    'isRequired': false,
                                                    'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
                                                },
                                                {
                                                    'displayName': 'Credentials',
                                                    'parameter': 'credentials',
                                                    'type': 'boolean',
                                                    'value': false,
                                                    'isRequired': true,
                                                    'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
                                                },
                                                {
                                                    'displayName': 'Preflight Continue',
                                                    'parameter': 'preflight_continue',
                                                    'type': 'boolean',
                                                    'value': false,
                                                    'isRequired': true,
                                                    'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
                                                }
                                            ],
                                            'id': 11,
                                            'itemName': 'cors'
                                        },
                                        {
                                            'name': 'ip-restriction',
                                            'isConfigured': false,
                                            'img': 'assets/img/ip-restriction.png',
                                            'description': 'Configure IP Restriction service.',
                                            'tagline': 'Whitelist or blacklist IPs that can make requests',
                                            'enabled': false,
                                            'consumer': {},
                                            'config': [
                                                // {
                                                //   'parameter': 'consumerID',
                                                //   'type': 'string',
                                                //   'value': '',
                                                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                                                // },
                                                {
                                                    'displayName': 'Allow',
                                                    'parameter': 'allow',
                                                    'type': 'array_string',
                                                    'value': '127.0.0.1',
                                                    'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
                                                },
                                                {
                                                    'displayName': 'Deny',
                                                    'parameter': 'deny',
                                                    'type': 'array_string',
                                                    'value': null,
                                                    'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
                                                }
                                            ],
                                            'id': 12,
                                            'itemName': 'ip-restriction'
                                        },
                                        {
                                            'name': 'rate-limiting',
                                            'isConfigured': false,
                                            'img': '/assets/img/rate-limiting.png',
                                            'description': 'Configure Rate limiting service.',
                                            'enabled': true,
                                            'consumer': {},
                                            'tagline': ' Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured.',
                                            'config': [
                                                {
                                                    'displayName': 'Second',
                                                    'parameter': 'second',
                                                    'type': 'number',
                                                    'value': null,
                                                    'isRequired': false,
                                                    'description': 'The number of HTTP requests that can be made per second'
                                                },
                                                {
                                                    'displayName': 'Minute',
                                                    'parameter': 'minute',
                                                    'type': 'number',
                                                    'value': 5,
                                                    'isRequired': false,
                                                    'description': 'The number of HTTP requests that can be made per minute'
                                                },
                                                {
                                                    'displayName': 'Hour',
                                                    'parameter': 'hour',
                                                    'type': 'number',
                                                    'value': null,
                                                    'isRequired': false,
                                                    'description': 'The number of HTTP requests that can be made per hour'
                                                },
                                                {
                                                    'displayName': 'Day',
                                                    'parameter': 'day',
                                                    'type': 'number',
                                                    'value': null,
                                                    'isRequired': false,
                                                    'description': 'The number of HTTP requests that can be made per day'
                                                },
                                                {
                                                    'displayName': 'Month',
                                                    'parameter': 'month',
                                                    'type': 'number',
                                                    'value': null,
                                                    'isRequired': false,
                                                    'description': 'The number of HTTP requests that can be made per month'
                                                },
                                                {
                                                    'displayName': 'Year',
                                                    'parameter': 'year',
                                                    'type': 'number',
                                                    'value': null,
                                                    'isRequired': false,
                                                    'description': 'The number of HTTP requests that can be made per year'
                                                },
                                                {
                                                    'displayName': 'Limit By',
                                                    'parameter': 'limit_by',
                                                    'type': 'string',
                                                    'value': 'consumer',
                                                    'isRequired': false,
                                                    'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
                                                },
                                                {
                                                    'displayName': 'Policy',
                                                    'parameter': 'policy',
                                                    'type': 'string',
                                                    'value': 'local',
                                                    'isRequired': false,
                                                    'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
                                                        '\n' +
                                                        'In Konnect Cloud, the default policy is redis'
                                                },
                                                {
                                                    'displayName': 'Fault Tolerant',
                                                    'parameter': 'fault_tolerant',
                                                    'type': 'boolean',
                                                    'value': true,
                                                    'isRequired': false,
                                                    'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
                                                },
                                                {
                                                    'displayName': 'Hide Client Headers',
                                                    'parameter': 'hide_client_headers',
                                                    'type': 'boolean',
                                                    'value': false,
                                                    'isRequired': false,
                                                    'description': 'Optionally hide informative response headers'
                                                },
                                                {
                                                    'displayName': 'Redis Host',
                                                    'parameter': 'redis_host',
                                                    'type': 'string',
                                                    'value': 'localhost',
                                                    'isRequired': false,
                                                    'description': 'When using the redis policy, this property specifies the address to the Redis server'
                                                },
                                                {
                                                    'displayName': 'Redis Password',
                                                    'parameter': 'redis_password',
                                                    'type': 'string',
                                                    'value': '',
                                                    'isRequired': false,
                                                    'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
                                                },
                                                {
                                                    'displayName': 'Redis Port',
                                                    'parameter': 'redis_port',
                                                    'type': 'number',
                                                    'value': 6379,
                                                    'isRequired': false,
                                                    'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
                                                },
                                                {
                                                    'displayName': 'Redis Timeout',
                                                    'parameter': 'redis_timeout',
                                                    'type': 'number',
                                                    'value': 2000,
                                                    'isRequired': false,
                                                    'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
                                                },
                                                {
                                                    'displayName': 'Redis Database',
                                                    'parameter': 'redis_database',
                                                    'type': 'number',
                                                    'value': 0,
                                                    'isRequired': false,
                                                    'description': 'When using the redis policy, this property specifies the Redis database to use'
                                                },
                                                // {
                                                //   'displayName': 'Header Name',
                                                //   'parameter': 'header_name',
                                                //   'type': 'string',
                                                //   'value': '',
                                                //     'isRequired': false,
                                                //     'description': 'Header name to be used if limit_by is set to header'
                                                // },
                                                // {
                                                //   'displayName': 'Path',
                                                //   'parameter': 'path',
                                                //   'type': 'string',
                                                //   'value': '',
                                                //   'isRequired': false,
                                                //   'description': 'Path to be used if limit_by is set to path'
                                                // },
                                            ],
                                            'id': 18,
                                            'itemName': 'rate-limiting'
                                        }
                                    ];
                                    const url = gatewayServiceConfig['url'];
                                    gatewayServiceConfig['url'] = [url];
                                    gatewayServiceConfig['config'] = {
                                        'protocol': 'https',
                                        'host': environment.adminGatewayHost,
                                        'port': environment.adminPort
                                    };
                                }
                            }
                        }
                    }
                }
                if (withoutTypeFound === true) {
                    const payload = {
                        environments: environments
                    };
                    this.patchEntityData('services', 'services', 'v2', 'settings', id, payload).then(response => {
                        resolve('success');
                    });
                } else {
                    resolve('success');

                }
            } else {
                resolve('failed');
            }
        });
    }

    checkForAdminInSettingsV1AndInsert(settingsPayload) {
        const environments = settingsPayload['environments'];
        const temp = this.partner.split('-');
        let partnerShortCode = '';
        if (temp.length > 1) {
            partnerShortCode = temp[temp.length - 1];
        } else {
            partnerShortCode = temp[0];
        }
        this.confPost.getSettingsV2CRUD('admin-' + partnerShortCode, 'admin-' + partnerShortCode, false).subscribe(response => {
            if (response['body'] && response['body'][0]) {
                response['body'][0]['environments'].push(environments[0]);
                this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).subscribe(response1 => {

                }, error => {
                    this.openSnackBar('Error while patching admin data for partner', 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
        }, error => {
            this.openSnackBar('Error while fetching admin data for partner', 'Error', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    constructAndInsertSettingsPayload() {
        this.settingsPayloadToInsert.partner = this.partner;
        this.settingsPayloadToInsert.account = this.account;
        this.settingsPayloadToInsert.email = localStorage.getItem('signInEmail');
        const env = this.partner.split('-');
        if (env.length > 1) {
            this.settingsPayloadToInsert.environments[0].type = env[0];
        } else {
            this.settingsPayloadToInsert.environments[0].type = 'prod';
        }
        this.settingsPayloadToInsert.environments[0].name = localStorage.getItem('partner');
        const platformServices = new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'platformServices', '').subscribe(response => {
                const iterator = response[Symbol.iterator]();
                while (true) {
                    const tempObject = iterator.next();
                    if (tempObject.done) {
                        break;
                    }
                    this.settingsPayloadToInsert.subscriptions.platform_services.push(tempObject.value.id);
                }
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });

        const platformServiceCategories = new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'platformServiceCategories', '').subscribe(response => {
                const iterator = response[Symbol.iterator]();
                while (true) {
                    const tempObject = iterator.next();
                    if (tempObject.done) {
                        break;
                    }
                    this.settingsPayloadToInsert.subscriptions.platform_service_categories.push(tempObject.value.id);
                }
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });

        Promise.all([platformServices, platformServiceCategories]).then(response4 => {
            this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
                this.settingsPayloadToInsert.phone_number = data['primary_phone'];
                if (data['logo'] === null) {
                    this.settingsPayloadToInsert.logo = '';
                } else {
                    this.settingsPayloadToInsert.logo = data['logo'];
                }
                if (data['brandImage'] === null) {
                    this.settingsPayloadToInsert.brand_image = '';
                } else {
                    this.settingsPayloadToInsert.brand_image = data['brandImage'];
                }
                const databaseConfigurations = [];
                data['databases'].forEach(database => {
                    const databaseService = database;
                    if (database['name'] === 'Default') {
                        databaseService['is_default'] = true;
                    } else {
                        databaseService['is_default'] = false;
                        database['shash'] = data['shash'];
                        database['ralam'] = data['ralam'];
                    }
                    databaseService['audit_logs'] = [];
                    const audit_log = {
                        action: 'CREATE',
                        by: localStorage.getItem('signInEmail'),
                        at: Date.now()
                    };
                    databaseService['audit_logs'].push(audit_log);
                    databaseConfigurations.push(databaseService);
                });
                for (let i = 0; i < this.settingsPayloadToInsert.environments[0].services.length; i++) {
                    if (this.settingsPayloadToInsert.environments[0].services[i].type === 'databases') {
                        this.settingsPayloadToInsert.environments[0].services[i].configurations = databaseConfigurations;
                    }
                }
                this._service.addItem(this.settingsPayloadToInsert, 'v2', 'services', 'services', 'settings').subscribe(response => {
                    if (this.settingsPayloadToInsert.environments[0].type !== 'admin') {
                        this.checkForAdminInSettingsV1AndInsert(this.settingsPayloadToInsert);
                    }
                    this.settingsPayloadToInsert['id'] = response['upsertedId'];
                    const tempSettings = {
                        body: []
                    };
                    tempSettings.body.push(this.settingsPayloadToInsert);
                    this.settingsData = tempSettings;
                }, error => {
                    const errorMessage = 'Welcome username, we recently upgraded our platform that needs your settings and preferences updated in our platform. It is an automated action and there is no action to be taken from your side. But the automated action has failed due to some reasons. Please report this to apiplatform administrator.';
                });
            }, error => {
                const databaseConfigurations = [];
                for (let i = 0; i < this.settingsPayloadToInsert.environments[0].services.length; i++) {
                    if (this.settingsPayloadToInsert.environments[0].services[i].type === 'databases') {
                        this.defaultDatabaseConfiguration.audit_logs[0].at = Date.now();
                        databaseConfigurations.push(this.defaultDatabaseConfiguration);
                        this.settingsPayloadToInsert.environments[0].services[i].configurations = databaseConfigurations;
                    }
                }
                this._service.addItem(this.settingsPayloadToInsert, 'v2', 'services', 'services', 'settings').subscribe(response => {
                    this.settingsPayloadToInsert['id'] = response['upsertedId'];
                    const tempSettings = {
                        body: []
                    };
                    tempSettings.body.push(this.settingsPayloadToInsert);
                    this.settingsData = tempSettings;
                }, error => {
                    const errorMessage = 'Welcome username, we recently upgraded our platform that needs your settings and preferences updated in our platform. It is an automated action and there is no action to be taken from your side. But the automated action has failed due to some reasons. Please report this to apiplatform administrator.';
                });
            });
        });
    }

    typeOf(val) {
        return typeof val;
    }

    resolved(captchaResponse: string) {
        this.captcha = captchaResponse;
    }

    configureGateway(partner, account, apiName, version, proto, host, path, port, methods, ipRestriction) {

        return new Promise(async (resolve, reject) => {
            if (!(methods.includes('OPTIONS'))) {
                methods.push('OPTIONS');
            }

            const temp = this.partner.split('-');
            const partnerShortCode = temp[temp.length - 1];

            if (!this.selection) {
                this.selection = [
                    {
                        'name': 'key-auth',
                        'isConfigured': false,
                        'img': '/assets/img/key-auth.png',
                        'description': 'Configure KeyAuth service..',
                        'enabled': true,
                        'consumer': {},
                        'tagline': 'Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests.',
                        'config': [
                            {
                                'displayName': 'Key Names',
                                'parameter': 'key_names',
                                'type': 'array_string',
                                'value': 'apikey',
                                'isRequired': true,
                                'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\nNote: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
                            },
                            {
                                'displayName': 'Key In Body',
                                'parameter': 'key_in_body',
                                'type': 'boolean',
                                'value': false,
                                'isRequired': false,
                                'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
                            },
                            {
                                'displayName': 'Hide Credentials',
                                'parameter': 'hide_credentials',
                                'type': 'boolean',
                                'value': false,
                                'isRequired': false,
                                'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
                            },
                            {
                                'displayName': 'Run On Preflight',
                                'parameter': 'run_on_preflight',
                                'type': 'boolean',
                                'value': true,
                                'isRequired': false,
                                'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
                            },
                            {
                                'displayName': 'Key In Header',
                                'parameter': 'key_in_header',
                                'type': 'boolean',
                                'value': true,
                                'isRequired': false,
                                'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
                            },
                            {
                                'displayName': 'Key In Query',
                                'parameter': 'key_in_query',
                                'type': 'boolean',
                                'value': true,
                                'isRequired': false,
                                'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
                            }
                        ]
                    },
                    {
                        'name': 'cors',
                        'isConfigured': false,
                        'img': 'assets/img/cors.png',
                        'enabled': true,
                        'consumer': {},
                        'description': 'Configure CORS service.',
                        'tagline': 'Allow developers to make requests from the browser. Easily add cross-origin resource sharing (CORS) to a Service and a Route by enabling this plugin',
                        'config': [
                            {
                                'displayName': 'Origins',
                                'parameter': 'origins',
                                'type': 'array_string',
                                'value': '*',
                                'isRequired': false,
                                'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
                            },
                            {
                                'displayName': 'Headers',
                                'parameter': 'headers',
                                'type': 'array_string',
                                'value': null,
                                'isRequired': false,
                                'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
                            },
                            {
                                'displayName': 'Exposed Headers',
                                'parameter': 'exposed_headers',
                                'type': 'array_string',
                                'value': null,
                                'isRequired': false,
                                'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
                            },
                            {
                                'displayName': 'Methods',
                                'parameter': 'methods',
                                'type': 'array_string',
                                'value': null,
                                'isRequired': false,
                                'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
                            },
                            {
                                'displayName': 'Max Age',
                                'parameter': 'max_age',
                                'type': 'number',
                                'value': 300,
                                'isRequired': false,
                                'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
                            },
                            {
                                'displayName': 'Credentials',
                                'parameter': 'credentials',
                                'type': 'boolean',
                                'value': false,
                                'isRequired': true,
                                'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
                            },
                            {
                                'displayName': 'Preflight Continue',
                                'parameter': 'preflight_continue',
                                'type': 'boolean',
                                'value': false,
                                'isRequired': true,
                                'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
                            }
                        ]
                    },
                    {
                        'name': 'ip-restriction',
                        'isConfigured': false,
                        'img': 'assets/img/ip-restriction.png',
                        'enabled': false,
                        'consumer': {},
                        'description': 'Configure IP Restriction service.',
                        'tagline': 'Restrict access to a Service or a Route by either allowing or denying IP addresses. Single IPs, multiple IPs or ranges in CIDR notation like 10.10.10.0/24 can be used. The plugin supports IPv4 and IPv6 addresses',
                        'config': [
                            {
                                'displayName': 'Allow',
                                'parameter': 'allow',
                                'type': 'array_string',
                                'value': '127.0.0.1',
                                'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
                            },
                            {
                                'displayName': 'Deny',
                                'parameter': 'deny',
                                'type': 'array_string',
                                'value': null,
                                'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
                            }
                        ]
                    },
                    {
                        'name': 'rate-limiting',
                        'isConfigured': false,
                        'img': '/assets/img/rate-limiting.png',
                        'description': 'Configure Rate limiting service.',
                        'enabled': true,
                        'consumer': {},
                        'tagline': 'Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured',
                        'config': [
                            {
                                'displayName': 'Second',
                                'parameter': 'second',
                                'type': 'number',
                                'value': null,
                                'isRequired': false,
                                'description': 'The number of HTTP requests that can be made per second'
                            },
                            {
                                'displayName': 'Minute',
                                'parameter': 'minute',
                                'type': 'number',
                                'value': 5,
                                'isRequired': false,
                                'description': 'The number of HTTP requests that can be made per minute'
                            },
                            {
                                'displayName': 'Hour',
                                'parameter': 'hour',
                                'type': 'number',
                                'value': null,
                                'isRequired': false,
                                'description': 'The number of HTTP requests that can be made per hour'
                            },
                            {
                                'displayName': 'Day',
                                'parameter': 'day',
                                'type': 'number',
                                'value': null,
                                'isRequired': false,
                                'description': 'The number of HTTP requests that can be made per day'
                            },
                            {
                                'displayName': 'Month',
                                'parameter': 'month',
                                'type': 'number',
                                'value': null,
                                'isRequired': false,
                                'description': 'The number of HTTP requests that can be made per month'
                            },
                            {
                                'displayName': 'Year',
                                'parameter': 'year',
                                'type': 'number',
                                'value': null,
                                'isRequired': false,
                                'description': 'The number of HTTP requests that can be made per year'
                            },
                            {
                                'displayName': 'Limit By',
                                'parameter': 'limit_by',
                                'type': 'string',
                                'value': 'consumer',
                                'isRequired': false,
                                'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
                            },
                            {
                                'displayName': 'Policy',
                                'parameter': 'policy',
                                'type': 'string',
                                'value': 'local',
                                'isRequired': false,
                                'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n\nIn Konnect Cloud, the default policy is redis'
                            },
                            {
                                'displayName': 'Fault Tolerant',
                                'parameter': 'fault_tolerant',
                                'type': 'boolean',
                                'value': true,
                                'isRequired': false,
                                'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
                            },
                            {
                                'displayName': 'Hide Client Headers',
                                'parameter': 'hide_client_headers',
                                'type': 'boolean',
                                'value': false,
                                'isRequired': false,
                                'description': 'Optionally hide informative response headers'
                            },
                            {
                                'displayName': 'Redis Host',
                                'parameter': 'redis_host',
                                'type': 'string',
                                'value': 'localhost',
                                'isRequired': false,
                                'description': 'When using the redis policy, this property specifies the address to the Redis server'
                            },
                            {
                                'displayName': 'Redis Password',
                                'parameter': 'redis_password',
                                'type': 'string',
                                'value': '',
                                'isRequired': false,
                                'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
                            },
                            {
                                'displayName': 'Redis Port',
                                'parameter': 'redis_port',
                                'type': 'number',
                                'value': 6379,
                                'isRequired': false,
                                'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
                            },
                            {
                                'displayName': 'Redis Timeout',
                                'parameter': 'redis_timeout',
                                'type': 'number',
                                'value': 2000,
                                'isRequired': false,
                                'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
                            },
                            {
                                'displayName': 'Redis Database',
                                'parameter': 'redis_database',
                                'type': 'number',
                                'value': 0,
                                'isRequired': false,
                                'description': 'When using the redis policy, this property specifies the Redis database to use'
                            }
                        ]
                    },
                    {
                        'name': 'acl',
                        'isConfigured': false,
                        'img': '/assets/img/acl.png',
                        'description': 'Configure ACL service.',
                        'tagline': 'Restrict access to a Service or a Route by adding Consumers to allowed or denied lists using arbitrary ACL group names. This plugin requires an authentication plugin (such as Basic Authentication, Key Authentication, OAuth 2.0, and OpenID Connect) to have been already enabled on the Service or Route',
                        'enabled': true,
                        'consumer': {},
                        'config': [
                            {
                                'displayName': 'Allow',
                                'parameter': 'allow',
                                'type': 'array_string',
                                'value': partnerShortCode,
                                'description': 'Tip: Comma separated list of arbitrary group names that are allowed to consume the API. At least one between whitelist or blacklist must be specified.'
                            },
                            {
                                'displayName': 'Deny',
                                'parameter': 'deny',
                                'type': 'array_string',
                                'value': null,
                                'description': 'Tip: Comma separated list of arbitrary group names that are not allowed to consume the API. At least one between whitelist or blacklist must be specified.'
                            },
                            {
                                'displayName': 'Hide Groups Header',
                                'parameter': 'hide_groups_header',
                                'type': 'boolean',
                                'value': false,
                                'isRequired': true,
                                'description': 'Flag that if enabled (true), prevents the X-Consumer-Groups header to be sent in the request to the Upstream service'
                            }
                        ]
                    },
                    {
                        'name': 'datadog',
                        'isConfigured': false,
                        'img': '/assets/img/datadog.png',
                        'description': 'Configure Datadog service.',
                        'tagline': 'Visualize API metrics on Datadog',
                        'enabled': true,
                        'consumer': {},
                        'config': [
                            {
                                'displayName': 'Host',
                                'parameter': 'host',
                                'type': 'string',
                                'value': '127.0.0.1',
                                'isRequired': true,
                                'description': 'The IP address or host name to send data to'
                            },
                            {
                                'displayName': 'Port',
                                'parameter': 'port',
                                'type': 'number',
                                'value': 8125,
                                'isRequired': true,
                                'description': 'The port to send data to on the upstream server'
                            },
                            {
                                'displayName': 'Prefix',
                                'parameter': 'prefix',
                                'type': 'string',
                                'value': 'apiplatform',
                                'isRequired': true,
                                'description': 'String to be attached as prefix to metric’s name'
                            }
                        ]
                    }
                ];
            }

            const index = this.selection.findIndex(function (item, i) {
                return item.name === 'ip-restriction';
            });

            if (index !== -1) {
                this.selection[index]['enabled'] = ipRestriction;
            }

            const servicedata = {
                'name': partner + '-' + account + '-' + apiName + '-' + version,
                'retries': 5,
                'protocol': proto,
                'host': host,
                'port': port,
                'path': path,
                'connect_timeout': 60000,
                'write_timeout': 60000,
                'read_timeout': 60000
            };

            const routeData = {
                data: []
            };

            for (const method of methods) {
                const routePayload = {
                    name: partner + '-' + account + '-' + apiName + '-' + version + '-' + method,
                    protocols: ['https', 'http'],
                    hosts: [await this.getDefaultGatewayURL()],
                    paths: ['/' + version + '/' + apiName],
                    methods: [method]
                };
                routeData.data.push(routePayload);
            }

            const entityDetails = {
                'entityName': apiName,
                'version': version,
                'action': 'deploy',
                'timeStamp': Date.now()
            };

            this.kong.configureAPIGatewayWithMethods(servicedata, routeData, this.constructKeyValueGatewayConfigurationsGeneric(this.selection), entityDetails).then(response => {
                // this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                //   info: 'Configuring Gateway Settings for the API',
                //   type: 'success',
                //   icon: 'fa fa-shield'
                // }, timeStamp, 'deploy');
                resolve('success');
            }, error1 => {
                reject(error1);
            });
        });
    }

    constructKeyValueGatewayConfigurationsGeneric(configuredGatewaySettings) {
        const gatewaySettings = [];
        for (const plugin of configuredGatewaySettings) {
            if (plugin) {
                const gatewaySetting = {
                    config: {}
                };
                if (plugin['name'] === 'rate-limiting') {
                    gatewaySetting['protocols'] = ['http', 'https'];
                }
                gatewaySetting['name'] = plugin['name'];
                gatewaySetting['enabled'] = plugin['enabled'];
                for (const config of plugin['config']) {
                    if (config) {
                        if (config['type'] === 'array_string') {
                            if (config['value'] && config['value'] !== null && config['value'] !== undefined) {
                                gatewaySetting.config[config['parameter']] = config['value'].split(',');
                            } else {
                                if (plugin['name'] === 'cors') {
                                    if (config['parameter'] === 'methods' && (config['value'] === undefined || config['value'] === [] || config['value'] === null)) {
                                        gatewaySetting.config[config['parameter']] = ['GET', 'PUT', 'POST', 'PATCH', 'DELETE', 'OPTIONS'];
                                    } else {
                                        gatewaySetting.config[config['parameter']] = config['value'];
                                    }
                                } else {
                                    gatewaySetting.config[config['parameter']] = config['value'];
                                }
                            }
                        } else {
                            gatewaySetting.config[config['parameter']] = config['value'];
                        }
                    }
                }
                gatewaySettings.push(gatewaySetting);
            }
        }
        return gatewaySettings;
    }

    constructKeyValueGatewayConfigurations(mode, partner, configuredGatewaySettings) {
        const temp = partner.split('-');
        let isPartnerAllowed = false;
        const gatewaySettings = [];
        for (const plugin of configuredGatewaySettings) {
            if (plugin) {
                const gatewaySetting = {
                    config: {}
                };
                if (plugin['name'] === 'rate-limiting') {
                    gatewaySetting['protocols'] = ['http', 'https'];
                } else if (plugin['name'] === 'acl') {
                    for (const allowableGroup of plugin['config']['allow']) {
                        if (allowableGroup === temp[temp.length - 1]) {
                            isPartnerAllowed = true;
                            break;
                        }
                    }
                    if (isPartnerAllowed === false) {
                        if (mode === 'copy') {
                            plugin['config']['allow'] = [temp[temp.length - 1]];
                        }
                    }
                }
                gatewaySetting['name'] = plugin['name'];
                gatewaySetting['enabled'] = plugin['enabled'];
                gatewaySetting['config'] = plugin['config'];
                if (plugin.hasOwnProperty('consumer')) {
                    gatewaySetting['consumer'] = plugin['consumer'];
                }
                gatewaySettings.push(gatewaySetting);
            }
        }
        return gatewaySettings;
    }

    getDefaultGatewaySettings(settingsData) {
        return new Promise((resolve, reject) => {
            for (const envs of settingsData['body'][0]['environments']) {
                if (envs && envs !== null && envs !== undefined) {
                    if (envs['name'] === localStorage.getItem('partner')) {
                        if (envs['services']) {
                            const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                            if (gatewayService && gatewayService.length > 0 && gatewayService[0]['configurations']) {
                                for (const gateway of gatewayService[0]['configurations']) {
                                    if (gateway && gateway !== null && gateway !== undefined && gateway['is_default'] === true && gateway['gateway_configurations'] !== {}) {
                                        this.defaultGatewaySettings = gateway['gateway_configurations'];
                                        this.selection = gateway['gateway_configurations'];
                                        this.selectedAPIGateway = gateway;
                                        this.selectedAPIGatewayName = gateway['name'];
                                        resolve('success');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    }

    async ngOnInit() {
        this.keySize = this.keySize / 32;
        this.appComponent.isSignUp = false;
        // if (this.captchaSiteKey === null || this.captchaSiteKey === undefined) {
        //     this.confPost.getCaptchaSiteKey().subscribe(response => {
        //         if (response && response[0]) {
        //             this.captchaSiteKey = response[0]['value'];
        //         }
        //     });
        // }

        this.confPost.getData('services', 'services', 'v1', 'databaseConfigurations', null).subscribe(response => {
            if (response && response[0]) {
                this.databasesMeta = response;
            } else {
                this.databasesMeta = this.databasesMetaDefault;
            }
        }, error => {
            this.databasesMeta = this.databasesMetaDefault;
        });

        $(document).ready(function () {
            $('#myInput').on('keyup', function () {
                const value = $(this).val().toString().toLowerCase();
                $('.connectorone').filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                    return true;
                });
            });
        });

        if (localStorage.getItem('partner') === 'linkzy') {
            let resumeParserPayload = {};
            let subCategory = [];
            for (const category of this.masterData) {
                if (category['category'] === 'tools') {
                    subCategory = category['subcategory'];
                    resumeParserPayload = {
                        categoryName: 'Parser',
                        route: '/parser',
                        icon: 'fa fa-angle-double-right'
                    };
                    subCategory.push(resumeParserPayload);
                    category['subcategory'] = subCategory;
                }
            }

        }
        // if (this.properties === null || this.properties === undefined) {
        //     await this.confPost.getDataFromServiceForPartnerAccount('properties', 'services', 'services').subscribe(props => {
        //         if (props && props !== null && props !== undefined) {
        //             this.properties = props[0]['properties'];
        //         }
        //     });
        // }


        setTimeout(() => {
            if (this.loadingForTheFirstTime === true && this.loadingForTheFirstTimeCompleted === false) {
                this.loadingForTheFirstTime = false;
                this.initialisePlatform();
            }
        }, 500);

        // if (this.partnerEntities === null || this.partnerEntities === undefined) {
        //     await this.getEntitiesAndExecutorsForThePartnerAccount();
        // }
        // if (this.partnerCategories === null || this.partnerCategories === undefined) {
        //     await this.getCategoriesForPartnerAccount();
        // }
        // if (this.languages === null || this.languages === undefined) {
        //     await this.getLanguages();
        //  }
        // if (this.databases === null || this.databases === undefined) {
        //     await this.getDatabasesForPartnerAccount();
        // }
        // if (this.datatypes === null || this.datatypes === undefined) {
        //     await this.getDataTypesForPartnerAccount();
        // }
        //
        // if (this.countPartnerEntities === null || this.countPartnerEntities === undefined) {
        //     await this.getEntityCountForPartner();
        // }
        // if (this.countPartnerAccountEntities === null || this.countPartnerAccountEntities === undefined) {
        //     await this.getEntityCountForPartnerAccount();
        // }
        // if (this.categoriesEntitiesForPartner === null || this.categoriesEntitiesForPartner === undefined) {
        //     await this.getCategoriesEntitiesForPartner();
        // }
        //
        // if (this.apiExecutors === null || this.apiExecutors === undefined) {
        //     await this.getApiExecutorsByPartnerAccountType();
        // }
        // if (this.businessLogicExecutors === null || this.businessLogicExecutors === undefined) {
        //     await this.getBusinessLogicApiExecutorsByPartnerAccountType();
        // }
        // if (this.workFlowExecutors === null || this.workFlowExecutors === undefined) {
        //     await this.getWorkFlowApiExecutorsByPartnerAccountType();
        // }
        // if (this.dmnExecutors === null || this.dmnExecutors === undefined) {
        //     await this.getDMNApiExecutorsByPartnerAccountType();
        // }
        // if (this.sqlQueryExecutors === null || this.sqlQueryExecutors === undefined) {
        //     await this.getSqlQueryApiExecutorsByPartnerAccountType();
        // }
        // if (this.thirdPartyApiExecutors === null || this.thirdPartyApiExecutors === undefined) {
        //     await this.getThirdPartyApiExecutorsByPartnerAccountType();
        // }
        // if (this.b2bExecutors === null || this.b2bExecutors === undefined) {
        //     await this.getb2bAPIs();
        // }


        this.appComponent.userName = (localStorage.getItem('partner') ? localStorage.getItem('partner') : 'Guest');
        this.userName = (localStorage.getItem('partner') ? localStorage.getItem('partner') : 'Guest');

        // this.router.events.filter(event => event instanceof NavigationEnd).subscribe(even => {
        //     this.getLearningVideoProperties(even.url.replaceAll('/',''));
        // });

        this.router.events.subscribe(event => {
            this.route = this.location.path();
            if (this.route.includes('/devex')) {
                this.SideMenuNavigationUrl = '/devex';
            } else {
                this.SideMenuNavigationUrl = '/api';
            }
        });
        if (this.location.path() !== '') {
            this.route = this.location.path();
            if (this.route.includes('/devex')) {
                this.SideMenuNavigationUrl = '/devex';
            } else {
                this.SideMenuNavigationUrl = '/api';
            }
        }

        this.basicPermission = true;
    }

    hasSubMenuFalse() {
        this.subMenu = false;
        this.appComponent.subMenuPanelExpanded = false;
    }

    async showDetails(category) {
        this.settingsflag = false;
        if (this.subMenu) {
            if (this.selectedMenu === category) {
                this.subMenu = false;
                this.appComponent.subMenuPanelExpanded = false;
                // this.appComponent.subMenuPanelExpanded = 'col-md-12 col-lg-12 sideBarCollapsed';
                this.appComponent.leftMenuPanelExpanded = 'col-md-1 col-lg-1 sideBarCollapsed';
            }
        } else {
            this.subMenu = true;
            this.appComponent.subMenuPanelExpanded = true;
            // this.appComponent.subMenuPanelExpanded = 'col-md-10 col-lg-10 sideBarExpanded';
            this.appComponent.leftMenuPanelExpanded = 'col-md-2 col-lg-2';
        }
        this.selectedMenu = category;

        this.JSONData = $(this.masterData).filter(function (i, n) {
            return n.category === category;
        });
        this.JSONData = this.JSONData['0'];
        if (category === 'Data Access API') {
            this.SideMenuNavigationUrl = '/api';
            const tempArrayOfJSON = [];
            for (let i = 0; i < this.categories.length; i++) {
                const tempJSON = {};
                const subCategoryArray = [];
                tempJSON['categoryName'] = this.categories[i].category;
                tempJSON['route'] = null;
                for (let j = 0; j < this.categories[i].entities.length; j++) {
                    const subCategory = {};
                    subCategory['categoryName'] = this.getEntity(this.categories[i].entities[j]);
                    subCategory['route'] = this.SideMenuNavigationUrl + '?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.getEntity(this.categories[i].entities[j]) + '&version=' + this.getVersion(this.categories[i].entities[j]);
                    subCategoryArray.push(subCategory);
                }
                tempJSON['subCategory'] = subCategoryArray;
                tempArrayOfJSON.push(tempJSON);
            }
            this.JSONData['subcategory'] = tempArrayOfJSON;
        } else if (category === 'Developer Experience') {
            this.SideMenuNavigationUrl = '/devex';
            const tempArrayOfJSON = [];
            for (let i = 0; i < this.categories.length; i++) {
                const tempJSON = {};
                const subCategoryArray = [];
                tempJSON['categoryName'] = this.categories[i].category;
                tempJSON['route'] = null;
                for (let j = 0; j < this.categories[i].entities.length; j++) {
                    const subCategory = {};
                    subCategory['categoryName'] = this.getEntity(this.categories[i].entities[j]);
                    subCategory['route'] = this.SideMenuNavigationUrl + '?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.getEntity(this.categories[i].entities[j]) + '&version=' + this.getVersion(this.categories[i].entities[j]);
                    subCategoryArray.push(subCategory);
                }
                tempJSON['subcategory'] = subCategoryArray;
                tempArrayOfJSON.push(tempJSON);

            }
            if (this.JSONData) {
                this.JSONData['subcategory'] = tempArrayOfJSON;
            }
        } else if (category === 'manage') {
            await this.getExecutorsForPartnerAccount();
            // this.JSONData['subcategory'] = this.leftpanelData;
            const log_payload = {
                logType: 'INFO',
                logLevel: 2,
                slugSearch: '',
                label: 'BUTTON_CLICK',
                featureArea: 'LEFT_PANEL',
                resource: 'MANAGE_MENU',
                action: 'CLICK',
                result: 'SUCCESS',
                payload: {},
                responseStatusCode: 200,
                response: {},
                errorMessage: '',
                logMessage: 'click success'
            };
            this.auditLog.log(log_payload);

            this.JSONData['subcategory'] = this.allExecutorsButDaaS;

        } else if (category === 'History') {
            this.JSONData['subcategory'] = this.apiHistory;
        } else if (category === 'creation') {
            this.JSONData = $(this.masterData).filter(function (i, n) {
                return n.category === category;
            });
            this.JSONData = this.JSONData['0'];
        } else if (category === 'Business Logic API') {
            this.SideMenuNavigationUrl = '/devex';
        } else if (category === 'Workflow API') {
            this.SideMenuNavigationUrl = '/devex';
        } else if (category === 'SQL Query API') {
            this.SideMenuNavigationUrl = '/devex';
        } else if (category === 'Third Party API') {
            this.SideMenuNavigationUrl = '/devex';
        }

        // const temp = localStorage.getItem('partner').split('-');
        // if (!(temp.length > 1 && temp[0] === 'admin')) {

        this.setPermissionsForSubcategories();
        // }
        this.appComponent.SidePanelCheck = true;
    }

    generateAuditForClick(resource) {
        Promise.resolve(this.appComponent.generatePayloadForAudit('INFO', '2', this.router.url, 'BUTTON_CLICK', 'LEFT_PANEL', (resource.toString().split(' ').join('_').replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').toUpperCase() + '_MENU'), 'CLICK', 'SUCCESS', '', 200, '', 'click success')).then(response => {
            this.leftpanelListner.leftpanelListener.emit({
                type: 'auditLog',
                category: this.auditLogPermissions.isAuditForLeftPanel,
                payload: response
            });
        });
    }

    setPermissionsForSubcategories() {
        if (this.JSONData && this.JSONData.hasOwnProperty('subcategory')) {
            for (const category of this.JSONData['subcategory']) {
                if (category && category.hasOwnProperty('categoryName')) {
                    switch (category['categoryName']) {
                        case 'Data as a Service':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_ACCESS_API');
                            break;
                        case 'Application Logic':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_BUSINESS_LOGIC_API');
                            break;
                        case 'SQL as a Service':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_QUERY_BUILDER_API');
                            break;
                        case 'API Joins':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_QUERY_BUILDER_API');
                            break;
                        case 'PLSQL as a Service':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_PLSQL_API');
                            break;
                        case 'Data as a Service (Advanced)':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_ACCESS_API_ADVANCED');
                            break;
                        case 'Workflows':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_WORKFLOW_API');
                            break;
                        case 'Decisions':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DMN_API');
                            break;
                        case 'Test Suite as a Service':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_TEST_SUITE_API');
                            break;
                        case 'API Tester':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_API_TESTER');
                            break;
                        case 'APIQL Engine':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_APIQL');
                            break;
                        case 'DATAQL Engine':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATAQL');
                            break;
                        case 'API Collection':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATAQL');
                            break;
                        case 'Test Suite Results':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_TEST_RESULTS');
                            break;
                        case 'API Providers':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_SERVICE_PROVIDERS');
                            break;
                        case 'API Provider Categories':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_SERVICE_PROVIDER_CATEGORIES');
                            break;
                        case 'Accelerators':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_ACCELERATORS');
                            break;
                        case 'API Tester/Registrar':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_API_TESTER');
                            break;
                        case 'API Register':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_API_REGISTER');
                            break;
                        case 'Postman Collection':
                            category['hasPermission'] = true;
                            break;
                        case 'Email Template Builder':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_EMAIL_TEMPLATE_BUILDER');
                            break;
                        case 'Scheduler':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_SCHEDULER');
                            break;
                        case 'Trigger':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_SCHEDULER');
                            break;
                        case 'Data Catalog':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_CATALOG');
                            break;
                        case 'File Manager':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_FILE_MANAGER');
                            break;
                        case 'Alerts':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_ALERTS');
                            break;
                        case 'Business Details':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_BUSINESS_DETAILS');
                            break;
                        case 'Database Connectors':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATABASES');
                            break;
                        case 'Business Locations':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_BUSINESS_LOCATIONS');
                            break;
                        case 'Branding':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_BRANDING');
                            break;
                        case 'API Management':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_API_MANAGEMENT');
                            break;
                        case 'Manage Email Configurations':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_EMAIL_CONFIGURATIONS');
                            break;
                        case 'Consumer Gateway Settings':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_CONSUMER_GATEWAY_SETTINGS');
                            break;
                        case 'Manage Users':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_MANAGE_USERS');
                            break;
                        case 'Manage User Groups':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_MANAGE_USER_GROUPS');
                            break;
                        case 'Idle Timeout Settings':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_IDLE_TIMEOUT_SETTINGS');
                            break;
                        case 'Design2API':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATABASES');
                            break;
                        case 'Data2API':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_CATALOG');
                            break;
                        case 'COBOL2API':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATABASES');
                            break;
                        case 'Data Transformation':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_TRANFORMATION_API');
                            break;
                        // case 'Data Transformation Advanced':
                        //     category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_TRANFORMATION_API_ADVANCED');
                        //     break;
                        case 'Cognitive Search':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_ACCESS_API');
                            break;
                        case 'Data Analytics':
                            category['hasPermission'] = this.hasPlatformPermission('MENU_DATA_ACCESS_API');
                            break;
                        default:

                            if (this.JSONData && this.JSONData.hasOwnProperty('category') && this.JSONData.category === 'environments') {
                                category['hasPermission'] = true;
                            } else {
                                category['hasPermission'] = false;
                            }
                            break;
                    }
                }
            }
        }
    }

    logout() {
        if (confirm('Are you sure you want to logout?')) {
            this.authService.logout();
        }
    }

    toggle(ev) {
        if (this.subMenu) {
            this.subMenu = false;
            this.appComponent.subMenuPanelExpanded = false;
            // this.appComponent.subMenuPanelExpanded = 'col-md-11 col-lg-11';
            // this.appComponent.leftMenuPanelExpanded = 'col-md-1 col-lg-1';
            // this.appComponent.subMenuPanelExpanded = 'col-md-12 col-lg-12 sideBarCollapsed';
            this.appComponent.leftMenuPanelExpanded = 'col-md-1 col-lg-1 sideBarCollapsed';
        } else {
            this.subMenu = true;
            this.appComponent.subMenuPanelExpanded = true;
            // this.appComponent.subMenuPanelExpanded = 'col-md-9 col-lg-9';
            // this.appComponent.leftMenuPanelExpanded = 'col-md-2 col-lg-2';
            // this.appComponent.subMenuPanelExpanded = 'col-md-10 col-lg-10 sideBarExpanded';
            this.appComponent.leftMenuPanelExpanded = 'col-md-2 col-lg-2';
        }
    }

    onActivate(e, outlet) {
        outlet.scrollTop = 0;
    }

    getMethodName(method, entityname) {
        return method.toLowerCase() + entityname;
    }

    getMenu(val) {
        if (val != null) {
            return val.replace(/ /g, '');
        } else {
            return 'Default';
        }

    }

    toUpper(val) {
        return val.toUpperCase();
        // return val;
    }

    getKey(val) {
        return Object.keys(val);
    }

    getValue(val) {
        if (val != null) {
            return Object.values(val);
        } else {
            return 'Default';
        }

    }

    getVersion(val) {
        /* var str = Object.values(val).toString();
         return str.substr(str.indexOf('.') + 1, str.length);*/
        const data = val.split('#');
        return data[1];
    }

    getEntity(val) {
        const data = val.split('#');
        /* var str = Object.values(val).toString();
         return str.substr(0, str.indexOf('.')).toString();*/
        return data[0];
    }

    $(category: string) {

    }

    promoteApi(migrateData, partner, account, entity, version) {

    }

    openGrantPermissionDialog(partner, account, executorName, executorVersion, executorType) {
        const dialogRef = this.dialog.open(GrantPermissionDialogComponent, {
            height: '75%',
            width: '60%',
            data: {
                partner: partner,
                account: account,
                executorName: executorName,
                executorVersion: executorVersion,
                executorType: executorType
            }
            /* disableClose: true,*/
        });
    }

    openApplicationDeletionConfirmationDialog(partner, account, title, version, id) {

        const deletedata = {};
        deletedata['title'] = title;
        deletedata['version'] = version;
        const dialogRef = this.dialog.open(ApplicationDeleteConfirmationComponent, {
            width: '60%',
            data: deletedata
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (id !== null && id !== undefined) {

                    this.confPost.deleteApplication(id).subscribe(resp1 => {
                        this.closePanel(this.menus[1]['stickyMenus'], 'envMenu');
                        this.leftPanelDataListener.changeInLeftPanelData.emit('application');
                        this.openSnackBar('Application deleted successfully.', 'Success', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }, error => {
                        this.openSnackBar('Error while deleting the Application.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                } else {
                    this.openSnackBar('Error while deleting the Application.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }
        });
    }

    openDeleteConfirmationDialog(partner, account, pkey, type, entity, version, entityOrExecutorType): void {
        this.partner = localStorage.getItem('partner');
        this.account = localStorage.getItem('account');
        const deletedata = {};
        deletedata['type'] = type;
        deletedata['entity'] = entity;
        deletedata['version'] = version;
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
            width: '60%',
            data: deletedata
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (type === 'entity') {
                    this.deleteApiWithDependencies(dialogRef.componentInstance.deleteData,
                        dialogRef.componentInstance.deleteExecutors,
                        dialogRef.componentInstance.deleteGatewayConfig,
                        partner, account, pkey, entity, version);
                } else {
                    this.deleteExecutorWithDependencies(dialogRef.componentInstance.deleteData,
                        dialogRef.componentInstance.deleteExecutors,
                        dialogRef.componentInstance.deleteGatewayConfig,
                        partner, account, pkey, entity, version, entityOrExecutorType);
                }
                this.closePanel(this.menus[1]['stickyMenus'], 'envMenu');
            }
        });
    }

    omit_special_char1(event) {
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        // if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57)) {
        //     this.item['partner'] = this.partner;
        // }
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57) || k === 32);
        // if (k !== 45) {
        //     this.item['partner'] = this.partner;
        // }
        // return (k !== 45);
    }

    specialCharAndPasteValidationForEntityNameAndVersion(entityName, entityVersion, timeStamp, action) {
        return new Promise(async (resolve, reject) => {
            this.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                info: 'Checking for special characters in Executor name',
                type: 'initial',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, action);
            await this.delay(1000);
            Promise.resolve(this.specialCharAndSpaceValidatorOnPaste(entityName, true)).then(async resp1 => {
                if (resp1 === true) {
                    this.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Checking for special characters in Executor name',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, action);
                    this.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Checking for special characters in Executor version',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, action);
                    await this.delay(1000);

                    Promise.resolve(this.specialCharAndSpaceValidatorOnPaste(entityVersion)).then(resp2 => {
                        this.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                            info: 'Checking for special characters in Executor version',
                            type: 'success',
                            icon: 'fa fa-newspaper-o'
                        }, timeStamp, action);
                        if (resp2 === true) {
                            resolve(true);
                        } else {
                            this.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                                info: 'Checking for special characters in Executor version',
                                type: 'fatal',
                                description: 'Executor version should not have any special characters or spaces in between',
                                icon: 'fa fa-newspaper-o'
                            }, timeStamp, action);

                            // this.openSnackBar('Executor version should not have any special characters or spaces in between', 'Error', {
                            //     duration: 10000,
                            //     verticalPosition: 'top',
                            //     horizontalPosition: 'center'
                            // });
                            resolve(false);
                        }

                    });
                } else {
                    this.publishEventMessage(entityName, entityVersion, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Checking for special characters in Executor name',
                        type: 'fatal',
                        description: 'Executor name should not have any special characters or spaces in between',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, action);
                    // this.openSnackBar('Executor name should not have any special characters or spaces in between', 'Error', {
                    //     duration: 10000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    resolve(false);
                }
            });
        });
    }

    specialCharAndSpaceValidatorOnPaste(name, allowHyphen = false) {
        return new Promise((resolve, reject) => {

            let format: any;
            if (allowHyphen) {
                format = /^[a-z0-9]+([a-z0-9-]+[a-z0-9])?$/i;
            } else {
                format = /^[a-zA-Z0-9]*$/;
            }
            resolve(format.test(name));

            // let i = 0;
            // let character = '';
            // let containsSpecialCharacter = false;
            // if (name && name !== '') {
            //     while (i <= name.length) {
            //         character = name.charAt(i);
            //         if (character.charCodeAt(0) >= 32 && character.charCodeAt(0) <= 47 ||
            //             character.charCodeAt(0) >= 58 && character.charCodeAt(0) <= 64 ||
            //             character.charCodeAt(0) >= 91 && character.charCodeAt(0) <= 96 ||
            //             character.charCodeAt(0) === 9 || character.charCodeAt(0) >= 123 && character.charCodeAt(0) <= 126) {
            //             containsSpecialCharacter = true;
            //         }
            //         i++;
            //     }
            //     if (containsSpecialCharacter === true) {
            //         resolve(false);
            //     } else {
            //         resolve(true);
            //     }
            // } else {
            //     resolve(false);
            // }
        });
    }

    table_omit_special_char(event) {
        let k;
        k = event.charCode;
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57) || k === 35 || k === 36 || k === 64 || k === 95);
    }

    omit_special_char_and_caps(event) {
        let k;
        k = event.charCode;
        if (event['key'].toUpperCase() !== event['key']) {
            return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57));
        } else {
            return ((k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57));
        }
    }

    omit_special_char(event, allowHyphen = false) {
        // this.partner = this.partner.toLowerCase();
        // let k;
        // k = event.keyCode;  //         k = event.keyCode;  (Both can be used)
        // if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57)) {
        //     this.item['partner'] = this.partner;
        // }
        // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57) || k === 189);
        // if (k !== 45) {
        //     this.item['partner'] = this.partner;
        // }
        // return (k !== 45);

        let regex: any;
        if (allowHyphen) {
            regex = new RegExp('^[a-zA-Z0-9-]+$');
        } else {
            regex = new RegExp('^[a-zA-Z0-9]+$');
        }

        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            return false;
        } else {
            return true;
        }
    }

    omit_space(event) {
        const regex = new RegExp('^[^\\s]+$');

        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            return false;
        } else {
            return true;
        }
    }

    getApiKeyForUser(signInEmail) {
        return new Promise((resolve, reject) => {
            this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(signInEmail).subscribe(keys => {
                this.apiKeyData = keys;
                if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
                    this.apiKeys = this.apiKeyData.data;
                    this.apiKey = this.apiKeys[0].key;
                    localStorage.setItem('apikey', this.apiKey);
                    resolve('success');
                } else {
                    resolve('success');
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    createDatabaseInApiplatform(partner, payload) {
        return new Promise((resolve, reject) => {
            this.confPost.addDatabase(partner, payload).subscribe(response => {
                resolve('success');
            }, error => {
                let errorMessage = '';
                if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                    errorMessage = error.error.message;
                } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                    errorMessage = error.error;
                } else {
                    errorMessage = 'Error occurred while creating the Database. Please try again after sometime.';
                }
                this.openSnackBar(errorMessage, 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                reject('failed');
            });
        });
    }

    validateDNS(url) {
        return new Promise((resolve, reject) => {
            this.confPost.dnsValidation({domainName: url}).subscribe(response => {
                if (response) {
                    const responseFromApi = response;
                    if (responseFromApi['body']['response'][0]['status']) {
                        resolve('verified');
                    } else {
                        resolve('not verified');
                    }
                }
            }, async error => {
                reject('failed');
            });
        });
    }

    encryptPasswordAndValidate(email, password, env) {
        return new Promise((resolve, reject) => {
            const iterationCount = 1000;
            let keySize = 128;
            keySize = keySize / 32;
            const passphrase = environment.cipheringPhrase;

            const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            const cipherText = this.encrypt(salt, iv, passphrase, password, keySize, iterationCount);
            const loginPayload = {
                emailId: email,
                environment: env,
                password: cipherText,
                shash: salt,
                ralam: iv
            };
            this.confPost.validateLogin(loginPayload).subscribe(resp => {
                if (resp.status === 200) {
                    if (resp.body != null) {
                        this.confPost.getUserDetailsOnSuccessfulLogin(loginPayload['environment'], loginPayload['environment']).subscribe(data => {
                            if (data.status === 200) {
                                if (data.body !== null) {
                                    this.auth.clearLocalStorage();
                                    Promise.resolve(this.getApiKeyForUser(email)).then(response => {
                                        Promise.resolve(this.validateDNS([data.body[0].partner + '.apiplatform.io'])).then(resp1 => {
                                            const dt = new Date();
                                            dt.setMinutes(dt.getMinutes() + 15);
                                            loginPayload['expiry'] = this.toTimestamp(dt) * 1000;
                                            if (resp1 === 'verified') {
                                                this.redirectToConsole(data, loginPayload, true);
                                            } else {
                                                this.redirectToConsole(data, loginPayload, false);
                                            }
                                        }, error => {
                                            this.redirectToConsole(data, loginPayload, false);
                                        });
                                    });
                                }
                            }
                        }, error => {
                            resolve('failed');
                            this.openSnackBar('Error while switching environments. Please try again later.', 'Error', {
                                duration: 3000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        });
                    } else {
                        resolve('failed');
                        this.openSnackBar('Incorrect Username or Password.', 'Error', {
                            duration: 3000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                } else {
                }
            }, error => {
                resolve('failed');
                this.openSnackBar('Incorrect Username or Password.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        });
    }

    redirectToConsole(data, loginPayload, isVerified) {
        if (data && data.hasOwnProperty('body') && data['body'][0] && data['body'][0]['partner'] && data['body'][0]['partnerKey'] &&
            data['body'][0].hasOwnProperty('accounts') && data.body[0].accounts[0] && data.body[0].accounts[0].hasOwnProperty('account_id')) {
            this.confPost.createJWTToken(data.body[0].partner, data.body[0].accounts[0].account_id !== undefined ? data.body[0].accounts[0].account_id : data.body[0].partner, data.body[0].partnerKey, {
                claims: loginPayload,
                consumedBy: 'apiplatform'
            }).subscribe(response2 => {
                if (response2 && response2['body']) {
                    let redirectURL = '';
                    const account = data.body[0].accounts[0].account_id !== undefined ? data.body[0].accounts[0].account_id : data.body[0].partner;
                    if (isVerified) {
                        if (environment.isOnPremise === false) {
                            redirectURL = 'https://' + data.body[0].partner + '.apiplatform.io/authenticator?token=' + response2['body'] + '&partner=' + data.body[0].partner + '&account=' + account + '&pk=' + data.body[0].partnerKey;
                        } else {
                            redirectURL = environment.platformRedirectURL + '/authenticator?token=' + response2['body'] + '&partner=' + data.body[0].partner + '&account=' + account + '&pk=' + data.body[0].partnerKey;
                        }
                    } else {
                        redirectURL = environment.platformRedirectURL + '/authenticator?token=' + response2['body'] + '&partner=' + data.body[0].partner + '&account=' + account + '&pk=' + data.body[0].partnerKey;
                    }
                    window.location.href = redirectURL;
                }
            }, error => {
                window.location.href = environment.platformRedirectURL + '/auth/login';
            });
        } else {
            this.openSnackBar('Error while switching environments. Please login again.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            window.location.href = environment.platformRedirectURL + '/auth/login';
        }
    }

    // setLocalStorage(data) {
    //     localStorage.setItem('Auth', 'true');
    //     localStorage.setItem('partnerId', data.body[0]._id);
    //     localStorage.setItem('partner', data.body[0].partner);
    //     localStorage.setItem('partnerKey', data.body[0].partnerKey);
    //     localStorage.setItem('currentPlan', data.body[0].currentPlan);
    //     localStorage.setItem('currentPlanDisplayName', data.body[0].currentPlanDisplayName);
    //     localStorage.setItem('account', data.body[0].accounts[0].account_id);
    // }


    postOverviewPageByDefaultIfNotExists(partner, account) {
        return new Promise(async (resolve, reject) => {
            const data = [
                {
                    'description': '<font face="Arial" size="4">Overview of APIs</font>',
                    'effective_date': '2021-09-29',
                    'sections': [
                        {
                            'title': '',
                            'description': '',
                            'sub_sections': []
                        }
                    ],
                    'title': 'Overview',
                    'account': partner,
                    'category_group': '',
                    'category_name': 'Getting Started',
                    'partner': account,
                    'is_active': true,
                    'isPublished': true,
                    'version': 'v1'
                },
                // {
                //     "description": "",
                //     "effective_date": "2021-09-29",
                //     "sections": [
                //         {
                //             "title": "",
                //             "description": "",
                //             "sub_sections": []
                //         }
                //     ],
                //     "title": "Authentication Basics",
                //     "account": partner,
                //     "category_group": "",
                //     "category_name": "Authentication",
                //     "partner": account,
                //     "is_active": true
                // }
                {
                    'description': '',
                    'effective_date': '2021-09-29',
                    'sections': [
                        {
                            'title': '',
                            'description': '',
                            'sub_sections': []
                        }
                    ],
                    'title': 'Credentials',
                    'account': partner,
                    'category_group': '',
                    'category_name': 'Authentication',
                    'partner': account,
                    'is_active': true,
                    'isPublished': true,
                    'version': 'v1'
                }
            ];

            for (let i = 0; i < data.length; i++) {
                await this.insertDefaultPages(data[i]);
                if (i === data.length - 1) {
                    resolve('success');
                }
            }
        });
    }

    insertDefaultPages(payload) {
        return new Promise((resolve, reject) => {
            this._service.addItem(payload, 'v1', 'services', 'services', 'documentor').subscribe(response => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    copyToPartner(name, version, type, metaSchema) {
        const dialogRef = this.dialog.open(CopyToPartnerComponent, {
            width: '60%',
            data: {
                name: name,
                version: version,
                type: type,
                metaSchema: metaSchema
            }
        });
    }

    deleteExecutorWithDependencies(deleteData, deleteExecutors, deleteGatewayConfig, partner, account, pkey, entity, version, entityOrExecutorType, showLoader = true) {
        return new Promise((resolve, reject) => {
            if (showLoader) {
                this.deleteDialog = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                });
            }
            if (deleteExecutors || deleteGatewayConfig) {
                if (deleteExecutors === true) {
                    deleteGatewayConfig = true;
                }
                let execResp: any;
                this.confPost.getAPIExecutorForPartnerAccount(partner, account, pkey, entity, version).subscribe(resp => {
                    if (resp) {
                        execResp = resp;
                        Promise.resolve(this.getGatewayItems(partner, account, entity, version)).then(response => {
                            this.deleteApiExecutorsForApi(partner, account, pkey, deleteExecutors, entity, version).then(response2 => {
                                if (execResp['executor_type'] && execResp['executor_type'].toUpperCase() === 'EXTERNALTESTSUITE') {
                                    this.confPost.deleteJenkinsJob(partner, pkey, entity, version).subscribe(deleteObj => {
                                    }, error => {
                                    });
                                }
                                this.deleteApiGatewayConfigForApi(partner, account, pkey, deleteGatewayConfig, entity, version).then(response3 => {
                                    if (deleteGatewayConfig && !deleteExecutors) {
                                        execResp['published'] = false;
                                        execResp['scopeOfAccess'] = 'private';
                                        this.confPost.updateApiExecutorForPartnerAccount(partner, account, execResp['id'], execResp).subscribe(updateResp => {
                                            this.refreshExecutors();
                                        }, updateError => {
                                        });
                                    }

                                    if (deleteExecutors && deleteGatewayConfig) {
                                        this.deleteApiExecutorForPartnerAccount(partner, account, pkey, entity, version).then(response4 => {
                                            this.deleteAPIAuditLog(partner, account, entity, version, entityOrExecutorType, execResp);
                                            this.confPost.deleteAPIPermissions(partner, account, entity, version).subscribe(response5 => {
                                            });
                                            if (partner === localStorage.getItem('partner')) {
                                                this.leftPanelDataListener.changeInLeftPanelDataV2.emit('deletionUpdationOfExecutor');
                                                // this.refreshExecutors();
                                                this.dataDeleted.emit({status: true, name: entity, version: version, type: 'executor'});
                                            }
                                            if (showLoader) {
                                                this.deleteDialog.close();
                                            }

                                            // window.location.reload();
                                            // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                        }, error => {

                                            if (showLoader) {
                                                this.deleteDialog.close();
                                            }
                                            this.handleErrorGracefully(error, 'Error while deleting API');
                                            reject(error);
                                        });
                                    } else {
                                        // this.leftPanelDataListener.changeInLeftPanelDataV2.emit('deletionUpdationOfExecutor');
                                        // this.dataDeleted.emit({status: true, name: entity, version: version, type: 'executor'});
                                        resolve('success');

                                        if (showLoader) {
                                            this.deleteDialog.close();
                                        }
                                        // window.location.reload();
                                    }
                                }, error => {

                                    if (showLoader) {
                                        this.deleteDialog.close();
                                    }
                                    this.handleErrorGracefully(error, 'Error while deleting the gateway configurations for the API');
                                    reject(error);
                                });
                            }, error => {

                                if (showLoader) {
                                    this.deleteDialog.close();
                                }
                                this.handleErrorGracefully(error, 'Error while deleting the API');
                                reject(error);
                            });
                        }, error => {
                            // this.handleErrorGracefully(error, 'Error while deleting API Executor');
                            if (deleteExecutors && deleteGatewayConfig) {
                                this.deleteApiExecutorsForApi(partner, account, pkey, deleteExecutors, entity, version).then(response2 => {

                                    this.deleteApiExecutorForPartnerAccount(partner, account, pkey, entity, version).then(response4 => {
                                        this.deleteAPIAuditLog(partner, account, entity, version, entityOrExecutorType, execResp);
                                        this.confPost.deleteAPIPermissions(partner, account, entity, version).subscribe(response5 => {
                                        });
                                        if (partner === localStorage.getItem('partner')) {
                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('deletionUpdationOfExecutor');
                                            // this.refreshExecutors();
                                            this.dataDeleted.emit({status: true, name: entity, version: version, type: 'executor'});
                                        }
                                        if (showLoader) {
                                            this.deleteDialog.close();
                                        }

                                        // window.location.reload();
                                        // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                    }, error1 => {
                                        if (showLoader) {
                                            this.deleteDialog.close();
                                        }

                                        this.handleErrorGracefully(error1, 'Error while deleting the API');
                                        reject(error1);
                                    });
                                }, error1 => {

                                    if (showLoader) {
                                        this.deleteDialog.close();
                                    }
                                    this.handleErrorGracefully(error, 'Error while deleting the API');
                                    reject(error);
                                });
                            }
                        });
                    }
                });
            }
        });
    }

    returnErrorMessage(error) {
        return this.appComponent.returnErrorMessage(error);
    }

    auditLogForDeletionOfEntityOrExecutors(isError, logEvent, logLevel, responseStatusCode, responseStatus, payload, response) {
        Promise.resolve(this.generateActionPayloadForAudit(isError, logEvent, logLevel, responseStatusCode, responseStatus, responseStatus, payload, response, this.router.url)).then(response1 => {
            const payloadToSend = {
                actions: response1
            };
            this.deletionListenerInstance.deletionListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
    }

    deleteApiWithDependencies(deleteData, deleteExecutors, deleteGatewayConfig, partner, account, pkey, entity, version, showLoader = true) {
        return new Promise((resolve, reject) => {
            if (showLoader) {
                this.deleteDialog = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                });
            }
            this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_delete_clicked', 'INFO', 200, 'OK', {
                partner: partner,
                account: account,
                name: entity,
                version: version
            }, '');
            if (deleteData || deleteExecutors || deleteGatewayConfig) {
                if (deleteExecutors === true) {
                    deleteGatewayConfig = true;
                }
                let entityResp: any;
                this.confPost.getEntityForPartner(partner, account, pkey, entity, version).subscribe(resp => {
                    if (resp) {
                        entityResp = resp;
                        Promise.resolve(this.getGatewayItems(partner, account, entity, version)).then(async response => {
                            this.deleteDataForApi(partner, account, pkey, deleteData, entity, version).then(response1 => {
                                // this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_data_delete_success', 'INFO', 200, 'OK', {
                                //     partner: partner,
                                //     account: account,
                                //     name: entity,
                                //     version: version
                                // }, '');
                                this.deleteApiExecutorsForApi(partner, account, pkey, deleteExecutors, entity, version).then(response2 => {
                                    // this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_apiexecutors_delete_success', 'INFO', 200, 'OK', {
                                    //     partner: partner,
                                    //     account: account,
                                    //     name: entity,
                                    //     version: version
                                    // }, '');
                                    this.deleteApiGatewayConfigForApi(partner, account, pkey, deleteGatewayConfig, entity, version).then(response3 => {
                                        if (deleteGatewayConfig && !deleteExecutors) {
                                            this.confPost.getEntityForPartner(partner, account, pkey, entity, version).subscribe(entityResp => {
                                                // this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_gatewayconfigurations_deletepublishgetentity_success', 'INFO', 200, 'OK', {partner: partner, account: account, name: entity, version: version}, '');
                                                if (entityResp) {
                                                    entityResp['published'] = false;
                                                    entityResp['scopeOfAccess'] = 'private';
                                                    const methods = [];
                                                    if (entityResp && entityResp['methods']) {
                                                        for (const method of entityResp['methods']) {
                                                            if (method !== 'OPTIONS') {
                                                                methods.push(method);
                                                            }
                                                        }
                                                        entityResp['methods'] = methods;
                                                    }
                                                    this.confPost.updateEntity(partner, account, entityResp).subscribe(updateResp => {
                                                        this.refreshEntities();
                                                        // this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_gatewayconfigurations_deletepublishupdateentity_success', 'INFO', 200, 'OK', {partner: partner, account: account, name: entity, version: version}, '');
                                                    }, updateError => {
                                                        // this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_gatewayconfigurations_deletepublishupdateentity_failed', 'ERROR', updateError.status, updateError.statusText, {partner: partner, account: account, name: entity, version: version}, this.returnErrorMessage(updateError));
                                                    });
                                                }
                                            }, getError => {
                                                // this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_gatewayconfigurations_deletepublishgetentity_failed', 'ERROR', getError.status, getError.statusText, {partner: partner, account: account, name: entity, version: version}, this.returnErrorMessage(getError));
                                            });
                                        }
                                        // this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_gatewayconfigurations_delete_success', 'INFO', 200, 'OK', {
                                        //     partner: partner,
                                        //     account: account,
                                        //     name: entity,
                                        //     version: version
                                        // }, '');
                                        if (deleteExecutors && deleteGatewayConfig) {
                                            this.deleteApiForPartnerAccount(partner, account, pkey, entity, version).then(response4 => {
                                                this.deleteAPIAuditLog(partner, account, entity, version, 'DAAS', entityResp);
                                                this.confPost.deleteAPIPermissions(partner, account, entity, version).subscribe(response5 => {
                                                });
                                                if (partner === localStorage.getItem('partner')) {
                                                    this.leftPanelDataListener.changeInLeftPanelDataV2.emit('deletionUpdationOfEntity');
                                                    this.leftPanelDataListener.changeInLeftPanelDataV2.emit('deletionUpdationOfExecutor');
                                                    this.dataDeleted.emit({status: true, name: entity, version: version, type: 'entity'});
                                                }
                                                if (showLoader) {
                                                    this.deleteDialog.close();
                                                }
                                                // this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_delete_success', 'INFO', 200, 'OK', {
                                                //     partner: partner,
                                                //     account: account,
                                                //     name: entity,
                                                //     version: version
                                                // }, '');
                                                resolve('success');
                                                // window.location.reload();
                                                // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                            }, error => {
                                                // this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_delete_failed', 'ERROR', error.status, error.statusText, {
                                                //     partner: partner,
                                                //     account: account,
                                                //     name: entity,
                                                //     version: version
                                                // }, this.returnErrorMessage(error));
                                                this.deleteDialog.close();
                                                this.handleErrorGracefully(error, 'Error while deleting API');
                                                reject(error);
                                            });
                                        } else {
                                            // this.leftPanelDataListener.changeInLeftPanelDataV2.emit('deletionUpdationOfEntity');
                                            // this.dataDeleted.emit({status: true, name: entity, version: version, type: 'entity'});
                                            // this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_delete_success', 'INFO', 200, 'OK', {
                                            //     partner: partner,
                                            //     account: account,
                                            //     name: entity,
                                            //     version: version
                                            // }, '');
                                            resolve('success');
                                            if (showLoader) {
                                                this.deleteDialog.close();
                                            }
                                            // window.location.reload();
                                        }
                                    }, error => {
                                        reject(error);
                                        this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_gatewayconfigurations_delete_failed', 'ERROR', error.status, error.statusText, {
                                            partner: partner,
                                            account: account,
                                            name: entity,
                                            version: version
                                        }, this.returnErrorMessage(error));
                                        this.deleteDialog.close();
                                        this.handleErrorGracefully(error, 'Error while deleting the gateway configurations for the API');
                                    });
                                }, error => {
                                    reject(error);
                                    this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_apiexecutors_delete_failed', 'ERROR', error.status, error.statusText, {
                                        partner: partner,
                                        account: account,
                                        name: entity,
                                        version: version
                                    }, this.returnErrorMessage(error));
                                    if (showLoader) {
                                        this.deleteDialog.close();
                                    }
                                    this.handleErrorGracefully(error, 'Error while deleting the API Executors for the API');
                                });
                            }, error => {
                                reject(error);
                                this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_data_delete_failed', 'ERROR', error.status, error.statusText, {
                                    partner: partner,
                                    account: account,
                                    name: entity,
                                    version: version
                                }, this.returnErrorMessage(error));
                                if (showLoader) {
                                    this.deleteDialog.close();
                                }
                                this.handleErrorGracefully(error, 'Error while deleting the API');
                            });
                        }, error => {
                            // this.confPost.getEntity(this.partner, this.account, entity, version).subscribe(response => {
                            if (deleteData && deleteExecutors && deleteGatewayConfig) {
                                if (entityResp && entityResp['entityname']) {
                                    this.deleteApiForPartnerAccount(partner, account, pkey, entity, version).then(response4 => {
                                        this.deleteAPIAuditLog(partner, account, entity, version, 'DAAS', entityResp);
                                        this.confPost.deleteAPIPermissions(partner, account, entity, version).subscribe(response5 => {
                                        });
                                        if (partner === localStorage.getItem('partner')) {
                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('deletionUpdationOfEntity');
                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('deletionUpdationOfExecutor');
                                            this.dataDeleted.emit({status: true, name: entity, version: version, type: 'entity'});
                                        }
                                        if (showLoader) {
                                            this.deleteDialog.close();
                                        }
                                        this.auditLogForDeletionOfEntityOrExecutors(false, 'dataaccessapi_delete_success', 'INFO', 200, 'OK', {
                                            partner: partner,
                                            account: account,
                                            name: entity,
                                            version: version
                                        }, '');
                                        resolve('success');
                                        // window.location.reload();
                                        // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                    }, error1 => {
                                        reject(error1);
                                        this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_delete_failed', 'ERROR', error.status, error.statusText, {
                                            partner: partner,
                                            account: account,
                                            name: entity,
                                            version: version
                                        }, this.returnErrorMessage(error1));
                                        if (showLoader) {
                                            this.deleteDialog.close();
                                        }
                                        this.handleErrorGracefully(error1, 'Error while deleting API');
                                    });
                                } else {
                                    if (showLoader) {
                                        this.deleteDialog.close();
                                    }
                                    this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_delete_failed', 'ERROR', error.status, error.statusText, {
                                        partner: partner,
                                        account: account,
                                        name: entity,
                                        version: version
                                    }, this.returnErrorMessage(error));
                                    this.handleErrorGracefully(error, 'Error while getting entity with name: ' + entity + ' and version: ' + version);
                                    reject('failed');
                                }
                            }
                            // }, error2 => {
                            //     this.auditLogForDeletionOfEntityOrExecutors(true, 'dataaccessapi_delete_failed', 'ERROR', error.status, error.statusText, {partner: partner, account: account, name: entity, version: version}, this.returnErrorMessage(error2));
                            //     this.deleteDialog.close();
                            //     this.handleErrorGracefully(error2, 'Error while getting entity');
                            //     reject('failed');
                            // });
                        });
                    }
                });
            } else {
                if (showLoader) {
                    this.deleteDialog.close();
                }
                resolve('success');
            }
        });
    }

    deleteApiForPartnerAccount(partner, account, pkey, entity, version) {
        /* Delete API from Partner collection */
        return new Promise((resolve, reject) => {
            this.confPost.deleteEntity(partner, account, pkey, entity, version).subscribe(data => {
                if (partner !== localStorage.getItem('partner')) {
                    resolve('success');
                } else {
                    this.openSnackBar('Deleted the API successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    const itemDuplicate = this.item;
                    const deleteditem = itemDuplicate.findIndex(p => p && this.getValue(p.APIs) === entity);
                    delete this.item[deleteditem];
                    /*
                    Update Dashboard collection with the status "deleted" for this API
                 */
                    this.confPost.updateApiStatusToPartnerAccountEntityInDashboard(partner, account, entity, version, 'deleted').subscribe(data => {
                        resolve('success');
                    }, error => {
                        resolve('success');
                        this.handleErrorGracefully(error, 'Error while updating API Status to Partner Account in dashboard');
                    });
                    this.router.navigate(['/controlplane']);
                }
            }, error => {
                reject(error);
            });
        });
    }

    deleteApiExecutorForPartnerAccount(partner, account, pkey, entity, version, skipIfNotFound = true) {
        /* Delete API from Partner collection */
        return new Promise((resolve, reject) => {
            this.confPost.deleteApiExecutorByPartnerAccountByNameAndVersion(partner, account, pkey, entity, version).subscribe(data => {
                if (partner === localStorage.getItem('partner')) {
                    this.openSnackBar('Deleted the API successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                resolve('success');
            }, error => {
                if (skipIfNotFound && error.status === 404) {
                    resolve('success');
                }
                reject(error);
            });
        });
    }

    removeCollectionFromSequences(partner, account, pkey, entity, version) {
        return new Promise((resolve, reject) => {
            this.confPost.removeCollectionFromSequences(partner, account, entity, version).subscribe(data => {
                resolve('success');
            }, error => {
                if (partner === localStorage.getItem('partner')) {
                    this.handleErrorGracefully(error, 'Error while removing collection from Sequence');
                }
                resolve('failure');
            });
        });
    }

    deleteCollectionByPartnerAccountEntityVersion(partner, account, pkey, entity, version) {
        // return new Promise((resolve, reject) => {
        //     this.confPost.deleteDataForAnEntity(partner, account, pkey, entity, version).subscribe(data => {
        //         resolve('success');
        //     }, error => {
        //         if (partner === localStorage.getItem('partner')) {
        //             this.handleErrorGracefully(error, 'Error while deleting collection for the data access service');
        //         }
        //         resolve('failure');
        //     });
        // });

        return new Promise((resolve, reject) => {
            this.confPost.deleteCollectionByPartnerAccountEntityVersion(partner, account, pkey, entity, version).subscribe(data => {
                resolve('success');
            }, error => {
                if (partner === localStorage.getItem('partner')) {
                    this.handleErrorGracefully(error, 'Error while deleting collection for the data access service');
                }
                resolve('failure');
            });
        });
    }


    deleteDataForApi(partner, account, pkey, deleteData, entity, version) {
        return new Promise((resolve, reject) => {
            if (deleteData) {
                this.removeCollectionFromSequences(partner, account, pkey, entity, version).then(data => {
                    this.deleteCollectionByPartnerAccountEntityVersion(partner, account, pkey, entity, version).then(data => {
                        resolve('success');
                    });
                });
            } else {
                resolve('success');
            }
        });
    }

    deleteApiExecutorsForApi(partner, account, pkey, deleteExecutors, entity, version) {
        return new Promise((resolve, reject) => {
            if (deleteExecutors) {
                this.confPost.deleteApiExecutorsByPartnerAccountEntityVersion(partner, account, pkey, entity, version).subscribe(data => {
                    resolve('success');
                }, error => {
                    this.handleErrorGracefully(error, 'Error while deleting API Executors for this API: ' + account + '_' + entity + '_' + version);
                    resolve('failure');
                });
            } else {
                resolve('success');
            }
        });
    }

    deletePluginsAndServiceFromApiGateway(partner, account, entity, version) {
        return new Promise((resolve, reject) => {
            let servicePluginsCount = 0;
            this.kong.getPluginsForServiceInApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(plugins => {
                this.gatewayPlugins = plugins;
                if (this.gatewayPlugins && this.gatewayPlugins !== undefined && this.gatewayPlugins !== null && this.gatewayPlugins['data'] && this.gatewayPlugins['data'].length > 0) {
                    this.gatewayPlugins.data.forEach(plugin => {
                        this.kong.deletePluginFromApiGateway(plugin['id']).subscribe(response1 => {
                            servicePluginsCount += 1;
                            if (servicePluginsCount === this.gatewayPlugins.data.length) {
                                this.kong.deleteServiceFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(res => {
                                    resolve('success');
                                }, error => {
                                    reject(error);
                                });
                            }
                        }, error => {
                            reject(error);
                        });
                    });
                } else {
                    this.kong.deleteServiceFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(res => {
                        resolve('success');
                    }, error => {
                        reject(error);
                    });
                }
            }, error => {
                reject(error);
            });
        });
    }

    deleteApiGatewayConfigForApi(partner, account, pkey, deleteGatewayConfig, entity, version) {
        return new Promise((resolve, reject) => {
            if (deleteGatewayConfig) {
                this.kong.getRoutesForAServiceFromApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(routes => {
                    this.gatewayRoutes = routes;
                    let routesCount = 0;
                    this.routes = this.gatewayRoutes.data;
                    if (this.routes && this.routes.length > 0) {
                        this.routes.forEach(route => {
                            Promise.resolve(this.removePluginsFromRoute(route)).then(response => {
                                this.kong.deleteRouteFromApiGatewayByNameOrId(route['id']).subscribe(resp => {
                                    routesCount += 1;
                                    if (routesCount === this.routes.length) {
                                        this.deletePluginsAndServiceFromApiGateway(partner, account, entity, version).then(response1 => {
                                            resolve('success');
                                        }, error => {
                                            reject(error);
                                        });
                                    }
                                }, error => {
                                    reject(error);
                                });
                            }, error => {
                                reject(error);
                            });
                        });
                    } else {
                        this.deletePluginsAndServiceFromApiGateway(partner, account, entity, version).then(response1 => {
                            resolve('success');
                        }, error => {
                            reject(error);
                        });
                    }
                }, error => {
                    reject(error);
                });
            } else {
                resolve('success');
            }
        });

        // this.kong.deletePluginFromApiGateway(this.rateLimitingId).subscribe(ratelimitingplugin => {
        //     this.kong.deletePluginFromApiGateway(this.keyAuthId).subscribe(keyauthplugin => {
        //         this.kong.deletePluginFromApiGateway(this.pathRouteRateLimitingPluginId).subscribe(rate1 => {
        //             // this.kong.deletePluginFromApiGateway(this.hostRouteRateLimitingPluginId).subscribe(r2 => {
        //             this.kong.deletePluginFromApiGateway(this.pathRouteKeyAuthPluginId).subscribe(ke1 => {
        //                 // this.kong.deletePluginFromApiGateway(this.hostRouteKeyAuthPluginId).subscribe(k2 => {
        //                 this.kong.deleteRouteFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + entity + +'-' + version + '-path').subscribe(route => {
        //                     // this.kong.deleteRouteFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + entity + '-host').subscribe(route1 => {
        //                     this.kong.deleteServiceFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + entity + '-' + version).subscribe(res => {
        //                     });
        //                 });
        //             });
        //             // });
        //             // });
        //             // });
        //         });
        //     });
        // });
    }

    getAdminSettingsData() {
        return new Promise((resolve, reject) => {
            if (this.adminSettingsData === null || this.adminSettingsData === undefined) {
                const temp = localStorage.getItem('partner').split('-');
                let partnerShortCode = '';
                let env = '';
                if (temp.length > 1) {
                    partnerShortCode = temp[temp.length - 1];
                    env = temp[0];
                } else {
                    partnerShortCode = temp[0];
                    env = 'prod';
                }
                this.confPost.getSettingsV2CRUD('admin-' + partnerShortCode, 'admin-' + partnerShortCode, false).subscribe(response => {
                    if (response['body'] && response['body'][0]) {
                        this.adminSettingsData = response;
                        resolve('success');
                    }
                }, error => {
                    this.handleErrorGracefully(error, 'Error while fetching admin data');
                    reject(error);
                });
            } else {
                resolve('success');
            }
        });
    }

    async patchAdminSettings(partnerShortcode, account, envPatchPayload, adminpatchPayload) {
        Promise.resolve(this.getAdminSettingsData()).then(resp => {
            if (this.adminSettingsData && this.adminSettingsData['environments']) {
                this.patchEntityData('services', 'services', 'v2', 'settings', this.adminSettingsData['body'][0]['id'], adminpatchPayload).then(response => {
                    if (response === 'success') {
                        const environments = this.adminSettingsData['body'][0]['environments'];
                        for (let i = 0; i < environments.length; i++) {
                            const env = environments[i];
                            if (env && env !== null && env !== undefined) {
                                this.confPost.getSettingsV2CRUD(env['name'], env['name'], false).subscribe(response1 => {
                                    if (response1 && response1['body']) {
                                        this.patchEntityData('services', 'services', 'v2', 'settings', response1['body'][0]['id'], envPatchPayload).then(response2 => {
                                        });
                                    }
                                });
                            }
                        }

                    }
                });
            }
        });
    }

    handleErrorGracefully(error, customMessage) {
        if (error) {
            if (error.error) {
                let errorMessage = '';
                if (error.error.error) {
                    errorMessage = error.error.error;
                } else if (error.error.message) {
                    errorMessage = error.error.message;
                } else if (error.error.body) {
                    errorMessage = error.error.body;
                } else {
                    errorMessage = error.error;
                }
                this.openSnackBar(errorMessage, 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (error.body) {
                this.openSnackBar(JSON.stringify(error.body), 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (error.message) {
                this.openSnackBar(JSON.stringify(error.message), 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                this.openSnackBar(customMessage, 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.openSnackBar(customMessage, 'Error', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    configureAPIGatewaySettingsWithMethods(service, routes, plugins, entity) {
        return new Promise((resolve, reject) => {
            this.kong.configureAPIGatewayWithMethods(service, routes, plugins, entity).then(response => {
                resolve('success');
            }, error => {
                reject(error);
            });
        });
    }

    insertExecutor(partner, account, pkey, metaSchema) {
        return new Promise((resolve, reject) => {
            this.confPost.insertApiExecutorForPartner(partner, account, pkey, metaSchema).subscribe(data => {
                resolve('success');
            }, error => {
                this.deleteExecutorWithDependencies(false, false, true, partner, account, pkey, metaSchema['executor_name'], metaSchema['executor_version'], metaSchema['executor_type']);
                this.handleErrorGracefully(error, 'We are working on the feature to deploy Business Logic APIs and Workflows onto Cloud... Meanwhile, please validate your designtime business use cases and let us know if you are interested in additional features.');
                reject('error');
            });
        });
    }

    insertEntity(partner, account, pkey, metaSchema) {
        return new Promise((resolve, reject) => {
            const that = this;
            this.confPost.insertEntityForPartner(partner, account, pkey, metaSchema).subscribe(data => {
                if (data && data['message'] === 'API already exists.') {
                    this.openSnackBar(data['message'], 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    reject('error');
                } else {
                    if (metaSchema['published']) {
                        this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                        this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
                            // localStorage.setItem('dataAccessAPI' , JSON.stringify(data));
                            this.apiExecutors = [];
                            let resp: any;
                            resp = data;
                            for (const item of resp) {
                                if (this.hasAccountPermission('view:' + this.partner + '=>' + item.account_id + '=>' + item.executor_category + '=>' + item.executor_version)) {
                                    this.apiExecutors.push(item);
                                }
                            }

                            // localStorage.setItem('isDataAccessAPISet', 'true');
                            this.isDataAccessAPISet = 'true';
                            // localStorage.setItem('updatedDataAccessAPI', JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']}));
                            this.updatedDataAccessAPI = JSON.stringify({
                                'entityName': metaSchema['entityname'],
                                'version': metaSchema['version']
                            });
                            resolve('success');
                        });
                    } else {
                        this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                        resolve('success');
                    }
                }
            }, error => {
                this.deleteApiWithDependencies(false, false, true, partner, account, pkey, metaSchema['entityname'], metaSchema['version']);
                this.handleErrorGracefully(error, 'Error while creating the API. Please try again sometime.');
                reject('error');
            });
        });
    }

    getGatewayItems(partner, account, entity, version) {
        return new Promise((resolve, reject) => {
            this.error = false;
            this.gatewayService = null;
            this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(service => {
                    this.gatewayService = service;
                    this.serviceId = this.gatewayService.id;
                    const routesPromise = new Promise((resolve, reject) => {
                        this.kong.getRoutesForAServiceFromApiGateway(this.serviceId).subscribe(routes => {
                            this.gatewayRoutes = routes;
                            this.routes = this.gatewayRoutes.data;
                            if (this.routes !== null && this.routes !== undefined && this.routes.length > 0) {
                                this.routes.forEach(route => {
                                    if (route.name === partner + '-' + account + '-' + entity + '-' + version + '-path') {
                                        this.pathRouteId = route.id;
                                    } else if (route.name === partner + '-' + account + '-' + entity + '-' + version + '-host') {
                                        this.hostRouteId = route.id;
                                    }
                                });
                            }

                            resolve('success');
                        }, error => {
                            reject(error);
                        });
                    });

                    const intermediatePromise = routesPromise.then(response => {
                        return new Promise((resolve, reject) => {
                            const pluginsPathPromise = new Promise((resolve, reject) => {
                                if (this.pathRouteId && this.pathRouteId !== null && this.pathRouteId !== undefined) {
                                    this.kong.getPluginsForRouteInApiGateway(this.pathRouteId).subscribe(pathRoutePluginRes => {
                                        this.pathRoutePlugins = pathRoutePluginRes;
                                        this.pathRoutePlugins.data.forEach(pathRoutePlugin => {
                                            if (pathRoutePlugin.name === 'rate-limiting') {
                                                this.pathRouteRateLimitingPluginId = pathRoutePlugin.id;
                                            } else if (pathRoutePlugin.name === 'key-auth') {
                                                this.pathRouteKeyAuthPluginId = pathRoutePlugin.id;
                                            }
                                        });
                                        resolve('success');
                                    });
                                }
                                resolve('success');
                            });

                            const pluginsHostPromise = new Promise((resolve, reject) => {
                                if (this.hostRouteId) {
                                    this.kong.getPluginsForRouteInApiGateway(this.hostRouteId).subscribe(hostPluginRes => {
                                        this.hostRoutePlugins = hostPluginRes;
                                        this.hostRoutePlugins.data.forEach(hostRoutePlugin => {
                                            if (hostRoutePlugin.name === 'rate-limiting') {
                                                this.hostRouteRateLimitingPluginId = hostRoutePlugin.id;
                                            } else if (hostRoutePlugin.name === 'key-auth') {
                                                this.hostRouteKeyAuthPluginId = hostRoutePlugin.id;
                                            }
                                        });
                                        resolve('success');
                                    });
                                } else {
                                    resolve('success');
                                }
                            });

                            Promise.all([pluginsPathPromise, pluginsHostPromise]).then(response1 => {
                                resolve('success');
                            });
                        });
                    });

                    const pluginsServicePromise = new Promise((resolve, reject) => {
                        this.kong.getPluginsForServiceInApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(plugins => {
                            this.gatewayPlugins = plugins;
                            this.gatewayPlugins.data.forEach(plugin => {
                                if (plugin.name === 'rate-limiting') {
                                    this.rateLimitingId = plugin.id;

                                } else if (plugin.name === 'key-auth') {
                                    this.keyAuthId = plugin.id;

                                } else if (plugin.name === 'request-size-limiting') {
                                    this.requestSizeLimitingId = plugin.id;

                                } else if (plugin.name === 'request-termination') {
                                    this.requestTerminationId = plugin.id;

                                } else if (plugin.name === 'cors') {
                                    this.corsId = plugin.id;

                                } else if (plugin.name === 'acl') {
                                    this.aclId = plugin.id;

                                } else if (plugin.name === 'bot-detection') {
                                    this.botDetectionId = plugin.id;

                                } else if (plugin.name === 'ip-restriction') {
                                    this.ipRestrictionId = plugin.id;
                                } else {
                                }
                            });
                            resolve('success');
                        });
                    });

                    Promise.all([pluginsServicePromise, routesPromise, intermediatePromise]).then(response => {
                        resolve('success');
                    });
                },
                error => {
                    // this.error = true;
                    // this.errorMessage = (error.error.message ? error.error.message : error.error);
                    reject(error);
                });
        });
    }

    getGatewayItemsForEntity(partner, account, entity, version) {
        return new Promise((resolve, reject) => {
            let gatewayService = null;
            let gatewayRoutes = null;
            let gatewayPlugins = null;
            this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(service => {
                gatewayService = service;
                const serviceId = gatewayService.id;
                const routesPromise = new Promise((resolve1, reject1) => {
                    this.kong.getRoutesForAServiceFromApiGateway(serviceId).subscribe(routes1 => {
                        gatewayRoutes = routes1;
                        const routes = gatewayRoutes.data;
                        if (routes !== null && routes !== undefined && routes.length > 0) {
                            routes.forEach(route => {
                                if (route.name === partner + '-' + account + '-' + entity + '-' + version + '-path') {
                                    this.pathRouteId = route.id;
                                } else if (route.name === partner + '-' + account + '-' + entity + '-' + version + '-host') {
                                    this.hostRouteId = route.id;
                                }
                            });
                        }

                        resolve1('success');
                    }, error => {
                        reject1(error);
                    });
                });

                const pluginsServicePromise = new Promise((resolve1, reject1) => {
                    this.kong.getPluginsForServiceInApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(plugins => {
                        gatewayPlugins = plugins;
                        // gatewayPlugins.data.forEach(plugin => {
                        //     if (plugin.name === 'rate-limiting') {
                        //         this.rateLimitingId = plugin.id;
                        //
                        //     } else if (plugin.name === 'key-auth') {
                        //         this.keyAuthId = plugin.id;
                        //
                        //     } else if (plugin.name === 'request-size-limiting') {
                        //         this.requestSizeLimitingId = plugin.id;
                        //
                        //     } else if (plugin.name === 'request-termination') {
                        //         this.requestTerminationId = plugin.id;
                        //
                        //     } else if (plugin.name === 'cors') {
                        //         this.corsId = plugin.id;
                        //
                        //     } else if (plugin.name === 'acl') {
                        //         this.aclId = plugin.id;
                        //
                        //     } else if (plugin.name === 'bot-detection') {
                        //         this.botDetectionId = plugin.id;
                        //
                        //     } else if (plugin.name === 'ip-restriction') {
                        //         this.ipRestrictionId = plugin.id;
                        //     } else {
                        //     }
                        // });
                        resolve1('success');
                    }, error => {
                        reject1(error);
                    });
                });

                Promise.all([pluginsServicePromise, routesPromise]).then(response => {
                    gatewayService = gatewayService ? gatewayService : {};
                    gatewayRoutes = gatewayRoutes ? gatewayRoutes : {data: []};
                    gatewayPlugins = gatewayPlugins ? gatewayPlugins : {data: []};
                    resolve([gatewayService, gatewayRoutes, gatewayPlugins]);
                });
            }, error => {
                reject(error);
            });
        });
    }

    removePluginsFromRoute(route) {
        return new Promise((resolve, reject) => {
            let status = '';
            let i = 0;
            this.kong.getPluginsForRouteInApiGateway(route['id']).subscribe(routePluginRes => {
                if (routePluginRes && routePluginRes !== null && routePluginRes !== undefined && routePluginRes['data'] && routePluginRes['data'].length > 0) {
                    routePluginRes['data'].forEach(routePlugin => {
                        this.kong.deletePluginFromApiGateway(routePlugin['id']).subscribe(response => {
                            i = i + 1;
                            if (i === routePluginRes['data'].length) {
                                status = 'success';
                                resolve('success');
                            }
                        }, error => {
                            reject(error);
                        });
                    });
                } else {
                    resolve('success');
                }
            }, error => {
                reject(error);
            });
        });
    }

}

@Pipe({name: 'filterByName', pure: false})
export class filterNames implements PipeTransform {
    transform(listOfNames: any[], nameToFilter: object): string[] {
        if (!listOfNames) {
            return null;
        }
        if (!nameToFilter) {
            return listOfNames;
        }
        return listOfNames.filter(listOfNames => listOfNames.executor_name.indexOf(nameToFilter['executor_name']) >= 0);
    }
}

@Pipe({name: 'filterByString', pure: false})
export class filterByName implements PipeTransform {
    transform(listOfNames: string[], nameToFilter: string): string[] {
        if (!listOfNames) {
            return null;
        }
        if (!nameToFilter) {
            return listOfNames;
        }
        return listOfNames.filter(n => n.indexOf(nameToFilter) >= 0);
    }
}

@Pipe({name: 'filterByName1', pure: false})
export class filterNames1 implements PipeTransform {
    transform(listOfNames: any[], nameToFilter: object): string[] {
        if (!listOfNames) {
            return null;
        }
        if (!nameToFilter) {
            return listOfNames;
        }
        return listOfNames.filter(listOfNames => listOfNames.categoryName.indexOf(nameToFilter['executor_name']) >= 0);
    }
}

@Component({
    selector: 'api-promotion-confirmation',
    templateUrl: 'api-promotion-confirmation.component.html',
    styleUrls: ['api-promotion-confirmation.component.css']
})
export class PromotionConfirmationComponent implements OnInit {
    migrateData = false;
    replaceApi = false;
    showStatusPanel = false;
    showResultsPage = false;
    deploymentResults: any;
    loading = false;
    target: string;
    entityPlans: any;
    entityTypes = [];
    entities: any;
    databases: any;
    selectedDatabase: string;
    selectedDatatypeFilter: any;
    dataTypeFilter: any;
    datatypes: any;

    partner: string;
    account: string;
    targetEnvironments: any;
    progress: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private confPost: ConfService, private platform: LeftpanelComponent) {
    }

    getDatabaseTypeForDatabaseName(val) {
        this.databases.filter(items => {
            if (items.database_name === val) {
                this.selectedDatatypeFilter = items.database_type;
            }
        });
    }

    getEntitiesForPartnerAccount(partner, account) {
        this.confPost.getEntitiesForPartnerAccount(partner, account).subscribe(data => {
            this.entities = data;
            this.entities.forEach(entity => {
                this.entityTypes.push(entity.entityname + '_' + entity.version);
            });
        });
    }

    ngOnInit() {

        this.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'));
        if (this.entityPlans) {
            this.entityPlans.forEach(entityPlan => {
                this.entityTypes.push(entityPlan.entity.entityname + '_' + entityPlan.entity.version);
            });
        }
        this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(async databases => {
            this.databases = databases;
            await this.platform.updateIsNoSQLForMongo(this.databases);
            this.getDatabaseTypeForDatabaseName(this.selectedDatabase !== null ? this.selectedDatabase : 'default');
            this.confPost.getDataTypes().subscribe(data => {
                this.datatypes = data;
                this.dataTypeFilter = [];
                this.datatypes.filter(items => {
                    if (items.database_type === this.selectedDatatypeFilter) {
                        this.dataTypeFilter.push(items);
                    }
                });
                if (this.selectedDatatypeFilter === 'mongodb') {
                    this.entityTypes.forEach(entityType => {
                        const newType = {
                            'database_type': 'mongodb',
                            'data_types': [
                                {
                                    'type': entityType,
                                    'default_length': '',
                                    'min_length': '',
                                    'max_length': ''
                                }]
                        };
                        this.dataTypeFilter.push(newType);
                    });
                }
            });
        });

    }

}

@Component({
    selector: 'api-delete-confirmation',
    templateUrl: 'api-delete-confirmation.component.html',
    styleUrls: ['api-delete-confirmation.component.css']
})
export class DeleteConfirmationComponent {
    deleteData = false;
    deleteGatewayConfig = true;
    deleteExecutors = true;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}

@Component({
    selector: 'application-delete-confirmation',
    templateUrl: 'application-delete-confirmation.component.html',
    styleUrls: ['application-delete-confirmation.component.css']
})
export class ApplicationDeleteConfirmationComponent {
    deleteData = true;
    deleteGatewayConfig = true;
    deleteExecutors = true;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}

@Component({
    selector: 'app-loader-with-progress',
    templateUrl: 'loader-with-progress.component.html',
    styleUrls: ['loader-with-progress.component.css']
})
export class LoaderWithProgressComponent implements OnInit {

    incr: any;
    progressMessage: any;
    progress = 0;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<LoaderWithProgressComponent>, public confPost: ConfService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {

    }

    refreshProgressStatus(incr, progressMessage) {
        this.progress = this.progress + incr;
        this.progressMessage = progressMessage;
    }

    close() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'add-gateway-resource',
    templateUrl: 'confirm-add-gateway-resource.component.html',
    styleUrls: ['confirm-add-gateway-resource.component.css']
})
export class AddGatewayResourceComponent implements OnInit {

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<AddGatewayResourceComponent>, public confPost: ConfService, public router: Router, public kongService: KongService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {

    }

    configureAPIGateway() {
        const logTimeStamp = Date.now();
        this.dialogRef.close();
        const deleteDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.kongService.configureApiGatewayWithIpRestrictionWithMethods(this.data.partner, this.data.account, this.data.entity, this.data.version, false, this.data.isExecutor, this.data.methods, logTimeStamp, '').then(response => {
            if (this.data.partner === localStorage.getItem('partner')) {
                if (this.data.isExecutor) {
                    this.confPost.getAPIExecutorForPartnerAccount(this.data.partner, this.data.account, localStorage.getItem('partnerKey'), this.data.entity, this.data.version).subscribe(resp => {
                        if (resp) {
                            resp['published'] = true;
                            this.confPost.updateApiExecutorForPartnerAccount(this.data.partner, this.data.account, resp['id'], resp).subscribe(updateResp => {
                                this.platform.refreshExecutors();
                                deleteDialog.close();
                                if (this.router.url.includes('apimanagement')) {
                                    location.reload();
                                }
                            }, error => {
                                deleteDialog.close();
                                if (this.router.url.includes('apimanagement')) {
                                    location.reload();
                                }
                            });
                        }
                    }, error => {
                        deleteDialog.close();
                        if (this.router.url.includes('apimanagement')) {
                            location.reload();
                        }
                    });
                } else {
                    this.confPost.getEntityForPartner(this.data.partner, this.data.account, localStorage.getItem('partnerKey'), this.data.entity, this.data.version).subscribe(resp => {
                        if (resp) {
                            const methods = [];
                            if (resp && resp['methods']) {
                                for (const method of resp['methods']) {
                                    if (method !== 'OPTIONS') {
                                        methods.push(method);
                                    }
                                }
                                resp['methods'] = methods;
                            }
                            resp['published'] = true;
                            this.confPost.updateEntity(this.data.partner, this.data.account, resp).subscribe(updateResp => {
                                this.platform.listOfDataAccessServices = null;
                                this.platform.refreshEntities();
                                deleteDialog.close();
                                if (this.router.url.includes('apimanagement')) {
                                    location.reload();
                                }
                            }, error => {
                                deleteDialog.close();
                                if (this.router.url.includes('apimanagement')) {
                                    location.reload();
                                }
                            });
                        }
                    }, error => {
                        deleteDialog.close();
                        if (this.router.url.includes('apimanagement')) {
                            location.reload();
                        }
                    });
                }
            } else {
                this.platform.openSnackBar('Default API Gateway configurations have been successfully configured.', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                deleteDialog.close();
                if (this.router.url.includes('apimanagement')) {
                    location.reload();
                }
            }
        });
    }

    close() {
        this.dialogRef.close();
        if (this.router.url.includes('apimanagement')) {
            this.router.navigateByUrl('/controlplane');
        }
    }
}

@Component({
    selector: 'copy-to-partner',
    templateUrl: 'copy-to-partner/copy-to-partner.component.html',
    styleUrls: ['copy-to-partner/copy-to-partner.component.css']
})
export class CopyToPartnerComponent implements OnInit {

    componentLoading = true;
    databases = [];
    targetDatabase: any;
    targetPartner: string;
    targetPkey: string;
    targetAccount: string;
    APIMetaData: any;
    APIName: string;
    APIVersion: string;
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    viewDependencies = false;
    settingsData: any;
    gatewayService: any;
    gatewayRoute = {
        data: []
    };
    pluginsConfiguredForRoute: any;
    checkAuthenticityAndGetDatabasesCompleted = false;
    isExecutor: boolean;
    targetPartnerEmail: any;
    @ViewChild('partnerEnv') partnerEnvironmentField: ElementRef;

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<CopyToPartnerComponent>, public confPost: ConfService, public router: Router, public kong: KongService) {
        dialogRef.disableClose = true;
    }

    async checkAuthenticityAndGetDatabasesOnFocusOut() {
        try {
            await this.checkAuthenticityAndGetDatabases();
        } catch (e) {

        }
    }

    getPartnerDatabases(loaderDialog: MatDialogRef<LoaderWithProgressComponent>) {
        return new Promise((resolve, reject) => {
            this.confPost.getDatabasesForPartner(this.targetPartner, this.targetPkey).subscribe(response1 => {
                if (response1 && response1 !== null && response1 !== undefined && response1.status && response1.status === 200) {
                    if (response1.body && response1.body !== null && response1.body !== undefined) {
                        if (response1.body && response1.body !== null && response1.body !== undefined) {
                            let databases: any;
                            databases = response1.body;
                            this.databases = [];
                            databases.forEach(db => {
                                if (db && db !== null && db !== undefined) {
                                    if (db['database_type'] === this.data.metaSchema['databaseType']) {
                                        this.databases.push(db);
                                    }
                                }
                            });
                            if (!this.databases.length) {
                                this.platform.openSnackBar('No matching database found for this API.', 'Error', {
                                    duration: 3000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                            loaderDialog.close();
                            resolve('success');
                        } else {
                            resolve('failed');
                        }
                    } else {
                        resolve('failed');
                    }
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
                loaderDialog.close();
                this.platform.handleErrorGracefully(error, 'Error while retrieving target partner\'s databases.');
            });
        });
    }

    checkAuthenticityAndGetDatabases() {
        return new Promise((resolve, reject) => {
            if (this.checkAuthenticityAndGetDatabasesCompleted === false) {
                if (this.targetPartner && this.targetPkey && this.targetAccount) {
                    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                        maxWidth: '95vw',
                        maxHeight: '60vh',
                    });
                    this.confPost.authorizePartner(this.targetPartner, this.targetPkey).subscribe(response => {
                        if (response.status === 200) {
                            Promise.resolve(this.platform.CheckForExistingEntityOrExecutorWithParams(this.targetPartner, this.targetAccount, this.targetPkey, this.APIName, this.APIVersion)).then(async resp => {
                                if (this.data.type !== 'BUSINESSLOGIC') {
                                    await this.getPartnerDatabases(loaderDialog);
                                    resolve('success');
                                    loaderDialog.close();
                                } else {
                                    loaderDialog.close();
                                    resolve('success');
                                }
                            }, error => {
                                if (error.status === 'already exists') {
                                    error['error'] = 'An API with the provided name and version already exists in the target partner';
                                    this.platform.openSnackBar('An API with the provided name and version already exists in the target partner', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    loaderDialog.close();
                                } else if (error.status === 'failed') {
                                    error['error'] = 'Error while checking API availability in target partner. Please try again after sometime';
                                    this.platform.openSnackBar('Error while checking API availability in target partner. Please try again after sometime', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    loaderDialog.close();
                                } else if (error.status === 500) {
                                    // this.platform.handleErrorGracefully(error, 'Invalid target partner. Please check the credentials.');
                                    this.platform.openSnackBar('Invalid credentials', 'Error', {
                                        duration: 30000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    reject(error);
                                    loaderDialog.close();
                                } else {
                                    reject(error);
                                    loaderDialog.close();
                                    this.close();
                                }

                            });
                        }
                    }, error => {
                        loaderDialog.close();
                        reject(error);
                        if (error.status === 401) {
                            error['error'] = 'Invalid target partner. Please check the credentials';
                            this.platform.handleErrorGracefully(error, 'Invalid target partner. Please check the credentials');
                            this.targetPartner = '';
                            this.targetPkey = '';
                            this.partnerEnvironmentField.nativeElement.focus();
                        } else {
                            error['error'] = 'Error while authenticating target partner. Please try again after sometime';
                            this.platform.handleErrorGracefully(error, 'Error while authenticating target partner. Please try again after sometime');
                            this.close();
                        }
                    });
                }
            }
        });
    }

    getTargetPartner() {
        return new Promise((resolve, reject) => {
            this.confPost.getPartnerWithPkey(this.targetPartner, this.targetAccount, this.targetPkey).subscribe(partnerResponse => {
                if (partnerResponse) {
                    this.targetPartnerEmail = partnerResponse['primary_email'];
                    resolve('success');
                } else {
                    this.platform.openSnackBar('Error while retrieving Target Partner. Please try again after sometime', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.dialogRef.close();
                    resolve('failed');
                }
            }, error => {
                this.platform.openSnackBar('Error while retrieving Target Partner. Please try again after sometime', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.dialogRef.close();
                resolve('failed');
            });
        });
    }

    async ngOnInit() {
        if (this.data) {
            if (this.data.type && this.data.name && this.data.version && this.data.metaSchema) {
                if (this.data.type === 'DAAS') {
                    this.APIName = this.data.metaSchema['entityname'];
                    this.APIVersion = this.data.metaSchema['version'];
                    this.isExecutor = false;
                } else {
                    this.APIName = this.data.metaSchema['executor_name'];
                    this.APIVersion = this.data.metaSchema['executor_version'];
                    this.isExecutor = true;
                }
                Promise.resolve(this.platform.getGatewayItems(this.partner, this.account, this.APIName, this.APIVersion)).then(resp => {

                }, error => {
                    if (error.status === 404) {
                        this.close();
                        const data = {
                            entity: this.APIName,
                            version: this.APIVersion,
                            partner: this.partner,
                            account: this.account,
                            methods: this.data.metaSchema['methods'],
                            isExecutor: this.isExecutor,
                            parentURL: this.router.url
                        };
                        const dialogRef = this.dialog.open(AddGatewayResourceComponent, {
                            width: 'auto',
                            height: 'auto',
                            data: {
                                entity: this.APIName,
                                version: this.APIVersion,
                                partner: this.partner,
                                account: this.account,
                                methods: this.data.metaSchema['methods'],
                                isExecutor: this.isExecutor,
                                parentURL: this.router.url
                            }
                        });
                    } else {
                        this.platform.handleErrorGracefully(error, 'Error while retrieving gateway resources. Please try again after sometime.');
                        this.close();
                    }
                });
            }
            if (this.platform.settingsData !== null && this.platform.settingsData !== undefined && this.platform.settingsData !== '') {
                this.settingsData = this.platform.settingsData;
                await this.platform.getDefaultGatewaySettings(this.settingsData);
            } else {
                this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(async settingsData => {
                    if (settingsData['body'] && settingsData['body'][0]) {
                        this.settingsData = settingsData;
                        await this.platform.getDefaultGatewaySettings(this.settingsData);
                    }
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while retrieving settings data. Please try again after sometime.');
                    this.close();
                });
            }
            this.componentLoading = false;
        }
    }


    checkForExistingTable() {
        return new Promise((resolve, reject) => {
            this.confPost.checkIfTableExistsForpartner(this.targetPartner, this.targetPkey, this.data.metaSchema['tableName'], this.data.metaSchema['database'], this.data.metaSchema['databaseType']).subscribe(response => {
                if (response && response !== undefined && response !== null) {
                    this.platform.openSnackBar('There is a table already present in the target partner.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.close();
                } else {
                    resolve('success');
                }
            }, error => {
                this.platform.openSnackBar('Error while checking the table existence in target partner. Please try again after sometime', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.close();
            });
        });
    }

    async createExecutor(loaderDialog: MatDialogRef<LoaderWithProgressComponent>) {
        const timeStamp = Date.now();
        this.data.metaSchema['partner'] = this.targetPartner;
        this.data.metaSchema['account_id'] = this.targetAccount;
        this.data.metaSchema['apiUrl'] = 'https://' + await this.platform.getDefaultGatewayURL() + '/' + this.APIVersion + '/' + this.APIName;
        Promise.resolve(this.platform.configureAPIGatewaySettingsWithMethods(this.platform.gatewayService, this.gatewayRoute, this.platform.constructKeyValueGatewayConfigurations('copy', this.targetPartner, this.platform.gatewayPlugins['data']), {})).then(async gatewayResponse => {
            this.platform.insertExecutor(this.targetPartner, this.targetAccount, this.targetPkey, this.data.metaSchema).then(async resp => {
                await this.platform.generateAccountRolePermissionGroupAndPermissions(this.targetPartner, this.targetAccount, this.targetPartnerEmail, this.APIName, this.APIVersion, this.data.type, true, timeStamp, '');
                this.platform.openSnackBar('API copied successfully', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.close();
                loaderDialog.close();
            }, error => {
                this.close();
                loaderDialog.close();
            });
        }, error => {
            this.close();
            loaderDialog.close();
            this.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
        });
    }

    async createDAAS(loaderDialog: MatDialogRef<LoaderWithProgressComponent>) {
        const timeStamp = Date.now();
        if (this.data.metaSchema['is_nosql'] === false) {
            await this.checkForExistingTable();
        }
        delete this.data.metaSchema['databaseType'];
        delete this.data.metaSchema['gateway'];
        delete this.data.metaSchema['is_nosql'];
        this.data.metaSchema['database'] = this.targetDatabase;
        this.data.metaSchema['tableCreation'] = true;
        if (this.data.metaSchema['published']) {
            Promise.resolve(this.platform.configureAPIGatewaySettingsWithMethods(this.platform.gatewayService, this.gatewayRoute, this.platform.constructKeyValueGatewayConfigurations('copy', this.targetPartner, this.platform.gatewayPlugins['data']), {})).then(async gatewayResponse => {
                this.platform.insertEntity(this.targetPartner, this.targetAccount, this.targetPkey, this.data.metaSchema).then(async resp => {
                    await this.platform.generateAccountRolePermissionGroupAndPermissions(this.targetPartner, this.targetAccount, this.targetPartnerEmail, this.APIName, this.APIVersion, 'DAAS', true, timeStamp, '');
                    this.platform.openSnackBar('API copied successfully', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.close();
                    loaderDialog.close();
                }, error => {
                    this.close();
                    loaderDialog.close();
                });
            }, error => {
                this.close();
                loaderDialog.close();
                this.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
            });
        } else {
            this.platform.insertEntity(this.targetPartner, this.targetAccount, this.targetPkey, this.data.metaSchema).then(resp => {
                this.platform.generateAccountRolePermissionGroupAndPermissions(this.targetPartner, this.targetAccount, this.targetPartnerEmail, this.APIName, this.APIVersion, 'DAAS', true, timeStamp, '');
                this.platform.openSnackBar('API copied successfully', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.close();
                loaderDialog.close();
            }, error => {
                this.close();
                loaderDialog.close();
            });
        }
    }

    getPluginsForRoute() {
        return new Promise((resolve, reject) => {
            this.kong.getPluginsForRouteInApiGateway(this.platform.gatewayRoutes['data'][0]['name']).subscribe(async plugins => {
                this.pluginsConfiguredForRoute = plugins['data'];
                resolve('success');
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching plugins for the route from API Gateway. Please try after sometime.');
                this.router.navigateByUrl('/controlplane');
            });
        });
    }

    async copy() {
        if (this.targetPartner && this.targetPartner !== ''
            && this.targetAccount && this.targetAccount !== ''
            && this.targetPkey && this.targetPkey !== '') {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.confPost.authorizePartner(this.targetPartner, this.targetPkey).subscribe(response => {
                if (response.status === 200) {
                    loaderDialog.close();
                    this.close();
                    const env = {
                        targetEnvironment: this.targetPartner,
                        targetAccount: this.targetAccount,
                        targetPkey: this.targetPkey
                    };
                    if (this.data.type === 'DAAS') {
                        this.router.navigateByUrl('/promotion?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.APIName + '&version=' + this.APIVersion + '&type=DATAACCESS' + '&env=' + JSON.stringify(env));
                    } else {
                        this.router.navigateByUrl('/promotion?partner=' + this.partner + '&account=' + this.account + '&entity=' + this.APIName + '&version=' + this.APIVersion + '&type=' + this.data.type + '&env=' + JSON.stringify(env));
                    }
                    this.close();
                }
            }, error => {
                loaderDialog.close();
                if (error.status === 401) {
                    error['error'] = 'Invalid target partner. Please check the credentials';
                    this.platform.handleErrorGracefully(error, 'Invalid target partner. Please check the credentials');
                    // this.targetPartner = '';
                    // this.targetPkey = '';
                    this.partnerEnvironmentField.nativeElement.focus();
                } else {
                    error['error'] = 'Error while authenticating target partner. Please try again after sometime';
                    this.platform.handleErrorGracefully(error, 'Error while authenticating target partner. Please try again after sometime');
                    this.close();
                }
            });
        } else {
            this.platform.openSnackBar('Please enter all the required values.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
        // if (this.targetPartner && this.targetPartner !== ''
        //     && this.targetAccount && this.targetAccount !== ''
        //     && this.targetPkey && this.targetPkey !== '') {
        //     await this.getTargetPartner();
        //     delete this.platform.gatewayService['id'];
        //     if (this.platform.gatewayRoutes.data) {
        //         let isRoutesOldDesign = false;
        //         for (const route of this.platform.gatewayRoutes.data) {
        //             if (route['methods'] === null || route['methods'] === undefined || (route['methods'] && (route['methods'].length === 0 || route['methods'].length > 1))) {
        //                 isRoutesOldDesign = true;
        //                 break;
        //             }
        //         }
        //
        //         if (isRoutesOldDesign === true) {
        //             const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        //                 maxWidth: '95vw',
        //                 maxHeight: '60vh',
        //             });
        //             await this.getPluginsForRoute();
        //             await this.kong.updateExistingRoutes(this.partner, this.account, this.APIName, this.APIVersion, this.platform.gatewayRoutes['data'], this.pluginsConfiguredForRoute, false);
        //             await this.platform.getGatewayItems(this.partner, this.account, this.APIName, this.APIVersion);
        //             delete this.platform.gatewayService['id'];
        //             loaderDialog.close();
        //         }
        //
        //         this.platform.gatewayRoutes.data.forEach(route => {
        //             if (route) {
        //                 const routeObject = {
        //                     name: this.targetPartner + '-' + this.targetAccount + '-' + this.APIName + '-' + this.APIVersion + '-' + route['methods'][0],
        //                     protocols: ['https', 'http'],
        //                     hosts: [this.platform.getDefaultGatewayURL()],
        //                     paths: route['paths'],
        //                     methods: [route['methods'][0]]
        //                 };
        //                 this.gatewayRoute.data.push(routeObject);
        //             }
        //         });
        //     }
        //     if (this.data.type === 'DAAS') {
        //         this.platform.gatewayService['name'] = this.targetPartner + '-' + this.targetAccount + '-' + this.APIName + '-' + this.APIVersion;
        //         this.platform.gatewayService['path'] = '/' + this.APIVersion + '/data/' + this.targetPartner + '/' + this.targetAccount + '/' + this.APIName;
        //         if (this.targetDatabase !== null && this.targetDatabase !== undefined && this.targetDatabase !== '') {
        //             const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        //                 maxWidth: '95vw',
        //                 maxHeight: '60vh',
        //             });
        //             // this.confPost.getDependenciesForEntities(this.partner, this.account, this.APIName, this.APIVersion).subscribe(response => {
        //             //     loaderDialog.close();
        //             // });
        //             this.viewDependencies = true;
        //             loaderDialog.close();
        //             //this.createDAAS(loaderDialog);
        //         } else {
        //             this.platform.openSnackBar('Please choose a target database.', 'Error', {
        //                 duration: 10000,
        //                 verticalPosition: 'top',
        //                 horizontalPosition: 'center'
        //             });
        //         }
        //     } else if (this.data.type === 'SQLQUERY') {
        //         this.platform.gatewayService['name'] = this.targetPartner + '-' + this.targetAccount + '-' + this.APIName + '-' + this.APIVersion;
        //         this.platform.gatewayService['path'] = '/' + this.targetPartner + '/' + this.targetAccount + '/' + this.APIVersion + '/' + this.APIName;
        //         if (this.targetDatabase !== null && this.targetDatabase !== undefined && this.targetDatabase !== '') {
        //             Promise.resolve(this.checkAuthenticityAndGetDatabases()).then(resp => {
        //                 const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        //                     maxWidth: '95vw',
        //                     maxHeight: '60vh',
        //                 });
        //                 delete this.data.metaSchema['databaseType'];
        //                 delete this.data.metaSchema['is_nosql'];
        //                 this.createExecutor(loaderDialog);
        //             }, error => {
        //                 this.platform.handleErrorGracefully(error, 'Error while checking authenticity of target partner. Please try again after sometime.');
        //             });
        //         } else {
        //             this.platform.openSnackBar('Please choose a target database.', 'Error', {
        //                 duration: 10000,
        //                 verticalPosition: 'top',
        //                 horizontalPosition: 'center'
        //             });
        //         }
        //     } else {
        //         this.platform.gatewayService['name'] = this.targetPartner + '-' + this.targetAccount + '-' + this.APIName + '-' + this.APIVersion;
        //         this.platform.gatewayService['path'] = '/' + this.targetPartner + '/' + this.targetAccount + '/' + this.APIVersion + '/' + this.APIName;
        //         delete this.data.metaSchema['id'];
        //         Promise.resolve(this.checkAuthenticityAndGetDatabases()).then(resp => {
        //             const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        //                 maxWidth: '95vw',
        //                 maxHeight: '60vh',
        //             });
        //             this.createExecutor(loaderDialog);
        //         }, error => {
        //             this.platform.handleErrorGracefully(error, 'Error while checking authenticity of target partner. Please try again after sometime.');
        //         });
        //     }
        // } else {
        //     this.platform.openSnackBar('Please enter all the required values.', 'Error', {
        //         duration: 10000,
        //         verticalPosition: 'top',
        //         horizontalPosition: 'center'
        //     });
        // }
    }

    getRegion(val) {
        return this.platform.getRegion(val);
    }

    close() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'schedule-job-dialog',
    templateUrl: 'schedule-job-dialog.component.html',
    styleUrls: ['schedule-job-dialog.component.css']
})
export class ScheduleJobDialogComponent implements OnInit {

    selectedTab = 0;

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ScheduleJobDialogComponent>, public confPost: ConfService, public router: Router, public kongService: KongService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
    }

    tabChanged(event) {
        this.selectedTab = event.index;
    }

    close() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'app-insufficient-permissions',
    templateUrl: 'insuffiecient-permissions.component.html',
    styleUrls: ['insuffiecient-permissions.component.css']
})
export class InsufficientPermissionsToAccessComponent implements OnInit {

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<InsufficientPermissionsToAccessComponent>, public confPost: ConfService, public router: Router, public kongService: KongService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
    }

    logout() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'app-grant-permissions-dialog',
    templateUrl: './grantpermission-dialog.html',
    styleUrls: ['./grantpermission-dialog.scss']
})
export class GrantPermissionDialogComponent implements OnInit {

    permissionGroups: any = {
        name: '',
        completed: false,
        object: {},
        color: 'primary',
        subtasks: []
    };
    userGroups: any = {
        name: '',
        completed: false,
        color: 'primary',
        subtasks: []
    };
    users: any = {
        name: '',
        completed: false,
        color: 'primary',
        subtasks: []
    };

    allPermissionGroupsComplete = false;
    allUserGroupComplete = false;
    allUsersComplete = false;
    permissionGroupss: any;
    displayName: any;
    userSearch: any;
    userGroupSearch: any;
    permissionGroupsSearch: any;
    permissionDataFound = false;
    userGroupDataFound = false;
    userDataFound = false;

    constructor(public dialogRef: MatDialogRef<GrantPermissionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, private confPost: ConfService, private _snackBar: MatSnackBar, public dialog: MatDialog, public _service: ConnecttocrudService) {
    }

    ngOnInit() {

        this.getPermissionGroups();
        this.getUserGroups();
        this.getUser();
    }


    updateAllComplete() {
        this.allPermissionGroupsComplete = this.permissionGroups.subtasks != null && this.permissionGroups.subtasks.every(t => t.completed);
    }

    someComplete(): boolean {
        if (this.permissionGroups.subtasks == null) {
            return false;
        }
        return this.permissionGroups.subtasks.filter(t => t.completed).length > 0 && !this.allPermissionGroupsComplete;
    }

    setAll(completed: boolean) {
        this.allPermissionGroupsComplete = completed;
        if (this.permissionGroups.subtasks == null) {
            return;
        }
        this.permissionGroups.subtasks.forEach(t => t.completed = completed);
    }

    update2AllComplete() {
        this.allUserGroupComplete = this.userGroups.subtasks != null && this.userGroups.subtasks.every(t => t.completed);
    }

    some2Complete(): boolean {
        if (this.userGroups.subtasks == null) {
            return false;
        }
        return this.userGroups.subtasks.filter(t => t.completed).length > 0 && !this.allUserGroupComplete;
    }

    set2All(completed: boolean) {
        this.allUserGroupComplete = completed;
        if (this.userGroups.subtasks == null) {
            return;
        }
        this.userGroups.subtasks.forEach(t => t.completed = completed);
    }

    update3AllComplete() {
        this.allUsersComplete = this.users.subtasks != null && this.users.subtasks.every(t => t.completed);
    }

    some3Complete(): boolean {
        if (this.users.subtasks == null) {
            return false;
        }
        return this.users.subtasks.filter(t => t.completed).length > 0 && !this.allUsersComplete;
    }

    set3All(completed: boolean) {
        this.allUsersComplete = completed;
        if (this.users.subtasks == null) {
            return;
        }
        this.users.subtasks.forEach(t => t.completed = completed);
    }

    getPermissionGroups() {
        // this.permissionGroupss = this.platform.generateAccountPermissions(this.data['partner'], this.data['account'], this.data['executorName'], this.data['executorVersion'], this.data['executorType']);
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'permissionGroup=' + this.data['partner'] + '=>' + this.data['account'] + '=>' + this.data['executorName'] + '=>' + this.data['executorVersion']).subscribe(data => {
            if (data) {
                this.permissionDataFound = true;
                this.permissionGroupss = data[0];
                this.displayName = this.permissionGroupss['display_name'];
                for (const pg of this.permissionGroupss['permissions']) {
                    const temp = pg['display_name'].split(':');
                    this.permissionGroups.subtasks.push(
                        {name: temp[0], completed: false, object: pg, color: 'primary'}
                    );
                }
                this.permissionGroups.object = this.permissionGroupss;

            }
        });
    }

    patchItemToApplicationRoles(id, item) {
        return new Promise((resolve, reject) => {
            this._service.patchItemUpdate(id, item, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(res => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }


    appendSelectedPermissions(e, query, type) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'role=' + query + '&dbref=false').subscribe(async data => {
                if (data) {
                    const tempRole = data[0];

                    if (this.allPermissionGroupsComplete) {

                        if ((tempRole['permission_groups'].filter(value => value === this.permissionGroups.object['id'])).length === 0) {
                            tempRole['permission_groups'].push(this.permissionGroups.object['id']);

                            await this.patchItemToApplicationRoles(tempRole['id'], {permission_groups: tempRole['permission_groups']});
                            resolve('success');
                        } else {
                            resolve('reject');
                        }

                    } else {
                        const tempRole = data[0];
                        const pGroup = [];
                        for (const pg of this.permissionGroups.subtasks) {
                            if (pg['completed'] && (tempRole['permissions'].filter(value => value['id'] === pg['object']['id'])).length === 0) {
                                pGroup.push(pg['object']['id']);
                            }
                        }
                        const permissions = tempRole['permissions'].concat(pGroup);
                        await this.patchItemToApplicationRoles(tempRole['id'], {permissions: permissions});
                        resolve('success');
                    }
                }
            });
        });

    }

    generateQuery(group, queryName, type) {
        return new Promise(async (resolve, reject) => {
            for (const e of group['object']['environments']) {
                if (e['name'] === localStorage.getItem('partner')) {
                    const query = e['name'] + '=>' + e['account'] + '=>' + group['object'][queryName];
                    await this.appendSelectedPermissions(e, query, type);
                }
            }
            // this._service.getItemswithParameter('v1','access','access','roles','role='+user['object']['partner']+'=>'+user['object']['account']+'=>'+user['object']['email'])
            resolve('Success');
        });
    }

    async submit() {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        const pGroup = this.permissionGroups.subtasks.filter(value => value['completed']);
        const uGroup = this.userGroups.subtasks.filter(value => value['completed']);
        const u = this.users.subtasks.filter(value => {
            if (value['completed']) {
                return value['object'];
            }
        });
        // await this.submitUsers(u);
        // const res=await this.submitUserGroup(uGroup);

        if (pGroup.length > 0) {
            if (uGroup.length > 0 || u.length > 0) {
                if (uGroup.length > 0) {
                    for (const group of uGroup) {
                        await this.generateQuery(group, 'name', 'userGroup');
                    }
                }

                if (u.length > 0) {
                    for (const user of u) {
                        await this.generateQuery(user, 'email', 'user');
                    }
                }
                this.platform.openSnackBar('Permissions Granted to the APIs', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                loaderDialog.close();
                this.dialogRef.close();
            } else {
                this.platform.openSnackBar('Permissions has to be assigned to atleast one user', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.platform.openSnackBar('Select atleast one permission to assign it to user(s)', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
        loaderDialog.close();


    }

    closeDialog() {
        this.dialogRef.close();
    }

    getUser() {
        const shortName = this.data['partner'].split('-');
        const temp = [];
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'partner.in=' + shortName[shortName.length - 1]).subscribe(data => {
            if (data) {
                this.userDataFound = true;
                let users: any;
                users = data;
                for (const user of users) {
                    const name = user['user'].split('-');
                    if (user['email'] !== localStorage.getItem('signInEmail') && user['status']) {
                        for (const e of user['environments']) {
                            if (e['name'] === this.data['partner']) {
                                this.users.subtasks.push(
                                    {name: user['user'], completed: false, object: user, color: 'primary'}
                                );
                            }
                        }
                    }

                }
            }
        });
    }


    getUserGroups() {
        const shortName = this.data['partner'].split('-');
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'usergroups', 'partner.in=' + shortName[shortName.length - 1]).subscribe(data => {
            if (data) {
                this.userGroupDataFound = true;
                let userGroup: any;
                userGroup = data;
                for (const group of userGroup) {
                    for (const e of group['environments']) {
                        if (e['name'] === this.data['partner']) {
                            this.userGroups.subtasks.push(
                                {name: group['name'], completed: false, object: group, color: 'primary'}
                            );
                        }
                    }

                }
            }
        });
    }

}

@Component({
    selector: 'app-api-policies',
    templateUrl: 'api-policies/api-policies.component.html',
    styleUrls: ['api-policies/api-policies.component.css']
})
export class APIPoliciesComponent implements OnInit {

    loading = true;

    pluginsConfigured: any;
    consumerId: string;
    OAuthClientApps: any;
    selectedPlugin: any;

    isOAuth2Configured = false;
    gatewayRoute: any;
    serviceName: string;

    isFatal = false;
    getAccessTokenInvoked = false;
    selectedAppName: any;
    selectedApp: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<APIPoliciesComponent>, public confPost: ConfService, private kong: KongService, private dialog: MatDialog) {
        dialogRef.disableClose = true;
    }

    getPluginsForService(service) {
        return new Promise((resolve, reject) => {
            this.kong.getPluginsForServiceInApiGateway(service).subscribe(response => {
                if (response && response['data']) {
                    this.pluginsConfigured = response['data'];
                    resolve('success');
                } else {
                    reject('failed');
                }
            }, error => {
                if (error.status === 404) {
                    resolve(this.configurePluginForServiceAndRoutes(service));
                } else {
                    reject('failed');
                }
            });
        });
    }

    configurePluginForServiceAndRoutes(service) {
        return new Promise((resolve, reject) => {
            const oauth2 = {
                enabled: false,
                name: 'oauth2',
                config: {
                    accept_http_if_already_terminated: true,
                    enable_client_credentials: true,
                    mandatory_scope: true,
                    provision_key: this.data.APIName + this.data.version,
                    scopes: ['read', 'write', 'update', 'delete']
                }
            };
            this.kong.createPluginForServiceInGateway({name: service}, oauth2, {}).then(async resp => {
                if (this.gatewayRoute['data'] && this.gatewayRoute['data'].length > 0) {
                    let i = 0;
                    for (const route of this.gatewayRoute['data']) {
                        i = i + 1;
                        if (route) {
                            await this.kong.createPluginForRouteInGateway(route, oauth2, {}).then(plugin => {
                                if (i === this.gatewayRoute['data'].length) {
                                    resolve('success');
                                }
                            }, error => {
                                if (i === this.gatewayRoute['data'].length) {
                                    resolve('failed');
                                }
                            });
                        } else {
                            if (i === this.gatewayRoute['data'].length) {
                                resolve('success');
                            }
                        }
                    }
                } else {
                    resolve('success');
                }
            }, error => {
                reject('failed');
            });
        });
    }

    async getInitialConfigs(service) {
        if (this.pluginsConfigured) {
            for (const plugin of this.pluginsConfigured) {
                if (plugin && plugin['name'] === 'oauth2') {
                    this.selectedPlugin = plugin;
                    this.isOAuth2Configured = true;
                    this.kong.getKongGatewayCredentialDetails('oauth2', this.consumerId).subscribe(response1 => {
                        if (response1 && response1['data']) {
                            this.OAuthClientApps = response1['data'];
                        }
                    });
                }
            }
            if (this.isOAuth2Configured === false) {
                await this.configurePluginForServiceAndRoutes(service).then(resp1 => {
                    this.getPluginsForService(service).then(resp => {
                        this.getInitialConfigs(service);
                    });
                }, error => {
                    this.isFatal = true;
                });
            } else {
                this.loading = false;
            }
        }
    }

    ngOnInit() {

        this.kong.getKongGatewayConsumerDetails(this.data.email).subscribe((data) => {
            const consumerResponse = data['data'][0];
            this.consumerId = consumerResponse['id'];
            this.kong.getServicesFromApiGatewayByNameOrId(this.data.partner + '-' + this.data.account + '-' + this.data.APIName + '-' + this.data.version).subscribe(service => {
                if (service) {
                    this.kong.getRoutesForAServiceFromApiGateway(service['name']).subscribe(routes => {
                        if (routes && routes['data']) {
                            this.gatewayRoute = routes;
                            this.serviceName = this.data.partner + '-' + this.data.account + '-' + this.data.APIName + '-' + this.data.version;
                            this.getPluginsForService(this.data.partner + '-' + this.data.account + '-' + this.data.APIName + '-' + this.data.version).then(resp => {
                                this.getInitialConfigs(this.data.partner + '-' + this.data.account + '-' + this.data.APIName + '-' + this.data.version);
                            });
                        }
                    });
                }
            }, error => {
                if (error.status === 404) {
                    this.kong.getServicesFromApiGatewayByNameOrId(this.data.partner + '-' + this.data.account + '-' + this.data.APIName).subscribe(service1 => {
                        if (service1) {
                            this.kong.getRoutesForAServiceFromApiGateway(service1['name']).subscribe(routes => {
                                if (routes && routes['data']) {
                                    this.gatewayRoute = routes;
                                    this.serviceName = this.data.partner + '-' + this.data.account + '-' + this.data.APIName;
                                    this.getPluginsForService(this.data.partner + '-' + this.data.account + '-' + this.data.APIName).then(resp => {
                                        this.getInitialConfigs(this.data.partner + '-' + this.data.account + '-' + this.data.APIName);
                                    });
                                }
                            });
                        }
                    });
                } else {
                    this.isFatal = true;
                }
            });
        });
    }

    patchPluginInGateway(plugin) {
        return new Promise((resolve, reject) => {
            this.kong.patchPluginInApiGateway(plugin['id'], plugin).subscribe(response1 => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    toggleOAuthEnabling(event) {
        const confirmPrompt = this.dialog.open(OAuth2ToggleConfirmationComponent, {
            width: '60%',
            disableClose: true,
            data: {
                APIName: this.data.APIName,
                version: this.data.version,
                plugin: this.selectedPlugin
            }
        });
        confirmPrompt.afterClosed().subscribe(response => {
            if (response) {
                if (response === 'disable') {
                    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                        width: 'auto',
                        height: 'auto',
                    });
                    this.selectedPlugin['enabled'] = false;
                    this.kong.patchPluginInApiGateway(this.selectedPlugin['id'], this.selectedPlugin).subscribe(response => {
                        if (this.gatewayRoute && this.gatewayRoute['data']) {
                            let i = 0;
                            for (const route of this.gatewayRoute['data']) {
                                i = i + 1;
                                if (route) {
                                    this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'oauth2').subscribe(async plugin => {
                                        if (plugin) {
                                            plugin['enabled'] = false;
                                            await this.patchPluginInGateway(plugin).then(response1 => {
                                                if (i === this.gatewayRoute['data'].length) {
                                                    loaderDialog.close();
                                                    this.platform.openSnackBar('Successfully disabled OAuth 2.0 setting', 'Success', {
                                                        duration: 3000,
                                                        verticalPosition: 'top',
                                                        horizontalPosition: 'center'
                                                    });
                                                }
                                            });
                                        } else {
                                            if (i === this.gatewayRoute['data'].length) {
                                                loaderDialog.close();
                                                this.platform.openSnackBar('Successfully disabled OAuth 2.0 setting', 'Success', {
                                                    duration: 3000,
                                                    verticalPosition: 'top',
                                                    horizontalPosition: 'center'
                                                });
                                            }
                                        }
                                    });
                                } else {
                                    if (i === this.gatewayRoute['data'].length) {
                                        loaderDialog.close();
                                        this.platform.openSnackBar('Successfully disabled OAuth 2.0 setting', 'Success', {
                                            duration: 3000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }
                                }
                            }
                        }
                    });
                } else if (response === 'enable') {
                    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                        width: 'auto',
                        height: 'auto',
                    });
                    this.selectedPlugin['enabled'] = true;
                    this.kong.patchPluginInApiGateway(this.selectedPlugin['id'], this.selectedPlugin).subscribe(response => {
                        if (this.gatewayRoute && this.gatewayRoute['data']) {
                            let i = 0;
                            for (const route of this.gatewayRoute['data']) {
                                i = i + 1;
                                if (route) {
                                    this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'oauth2').subscribe(async plugin => {
                                        if (plugin) {
                                            plugin['enabled'] = true;
                                            await this.patchPluginInGateway(plugin).then(response1 => {
                                                if (i === this.gatewayRoute['data'].length) {
                                                    loaderDialog.close();
                                                    this.platform.openSnackBar('Successfully enabled OAuth 2.0 setting', 'Success', {
                                                        duration: 3000,
                                                        verticalPosition: 'top',
                                                        horizontalPosition: 'center'
                                                    });
                                                }
                                            });

                                        } else {
                                            if (i === this.gatewayRoute['data'].length) {
                                                loaderDialog.close();
                                                this.platform.openSnackBar('Successfully enabled OAuth 2.0 setting', 'Success', {
                                                    duration: 3000,
                                                    verticalPosition: 'top',
                                                    horizontalPosition: 'center'
                                                });
                                            }
                                        }
                                    });
                                } else {
                                    if (i === this.gatewayRoute['data'].length) {
                                        loaderDialog.close();
                                        this.platform.openSnackBar('Successfully enabled OAuth 2.0 setting', 'Success', {
                                            duration: 3000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }
                                }
                            }
                        }
                    });
                } else {
                    event.source.checked = !event.source.checked;
                }
            } else {
                event.source.checked = !event.source.checked;
            }
        });
    }

    getJson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

    close() {
        this.dialogRef.close();
    }

    invokeGetAccessToken() {
        this.getAccessTokenInvoked = true;
    }

    setSelectedApp(app) {
        this.selectedApp = app;
    }

    async getOAuthToken(cred) {
        if (this.selectedPlugin) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                width: 'auto',
                height: 'auto',
            });
            const payload = {
                client_id: cred['client_id'],
                client_secret: cred['client_secret'],
                provision_key: this.selectedPlugin['config']['provision_key'],
                grant_type: 'client_credentials',
                authenticated_userid: this.data.email,
                scope: this.selectedPlugin['config']['scopes'][0]
            };

            const gatewayHost = await this.kong.getDefaultGatewayURL();

            this.kong.getOAuth2Token(this.data.partner, this.data.account, this.data.APIName, this.data.version, payload, localStorage.getItem('apikey'), gatewayHost).subscribe(response => {
                if (response && response.hasOwnProperty('access_token')) {
                    cred['access_token'] = response['access_token'];
                }
                loaderDialog.close();
                this.platform.openSnackBar('Access token has been generated successfully', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }, error => {
                loaderDialog.close();
                this.platform.handleErrorGracefully(error, 'Error while retrieving access token');
            });
        }
    }
}

@Component({
    selector: 'app-api-policies',
    templateUrl: 'api-policies/oauth2-toggle-confirmation.component.html',
    styleUrls: ['api-policies/oauth2-toggle-confirmation.component.css']
})
export class OAuth2ToggleConfirmationComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<APIPoliciesComponent>, public confPost: ConfService, private kong: KongService, private dialog: MatDialog) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
    }

    close() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'app-view-raw',
    templateUrl: 'view-raw/view-raw.component.html',
    styleUrls: ['view-raw/view-raw.component.css']
})
export class ViewRawComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ViewRawComponent>) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
    }

    close() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'app-datadog-metrics',
    templateUrl: 'datadog-metrics/datadog-metrics.component.html',
    styleUrls: ['datadog-metrics/datadog-metrics.component.css']
})
export class DatadogMetricsComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<DatadogMetricsComponent>, private kong: KongService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {

    }

    close() {
        this.dialogRef.close();
    }
}


@Component({
    selector: 'app-promote-to-environment',
    templateUrl: './promote-to-environment/promote-to-environment.component.html',
    styleUrls: ['./promote-to-environment/promote-to-environment.component.css']
})
export class PromoteToEnvironmentComponent implements OnInit {
    availableEnvironmentsForPromote = [];
    showNextPanel = false;
    showUserSelection = false;
    targetEnvironment: any;
    targetPkey: any;
    userSearch: any;
    users: any = {
        name: '',
        completed: false,
        color: 'primary',
        subtasks: []
    };
    usersSelected = true;
    allUsersSelected = false;
    userInfoRetrieving = true;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<PromoteToEnvironmentComponent>, public router: Router, public confPost: ConfService, public _service: ConnecttocrudService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
        if (this.platform.availableEnvironmentsToSwitch) {
            const envList = this.platform.availableEnvironmentsToSwitch;
            for (const env of envList) {
                if (env['envName'] !== 'admin') {
                    this.availableEnvironmentsForPromote.push(env);
                }
            }
        } else {
            this.getEnvironments();
        }
    }

    ngOnChanges(): void {
        if (!this.availableEnvironmentsForPromote) {
            this.availableEnvironmentsForPromote = this.platform.availableEnvironmentsToSwitch;
        }
    }

    getEnvironments() {
        this.availableEnvironmentsForPromote = [];
        const partnerTemp = localStorage.getItem('partner').split('-');
        const accountTemp = localStorage.getItem('account').split('-');
        let partnerShortCode: string;
        let partnerAccount: string;
        if (partnerTemp.length > 1) {
            partnerShortCode = partnerTemp[partnerTemp.length - 1];
        } else {
            partnerShortCode = partnerTemp[0];
        }
        if (accountTemp.length > 1) {
            partnerAccount = accountTemp[accountTemp.length - 1];
        } else {
            partnerAccount = accountTemp[0];
        }
        this.confPost.getSettingsV2CRUD('admin-' + partnerShortCode, 'admin-' + partnerAccount, false).subscribe(response => {
            if (response && response['body'] && response['body'][0]) {
                const environments = response['body'][0]['environments'];
                if (environments && environments.length > 1) {
                    environments.forEach(env => {
                        const subMenuPayload = {};
                        if (env && env !== undefined && env !== null) {
                            if (env['display_name'] && env['display_name'] !== null && env['display_name'] !== undefined && env['display_name'] !== '') {
                                subMenuPayload['categoryName'] = env['display_name'];
                            } else {
                                subMenuPayload['categoryName'] = env['type'];
                            }
                            switch (env['type']) {
                                case 'admin':
                                    subMenuPayload['icon'] = 'fa fa-cog';
                                    break;
                                case 'prod':
                                    subMenuPayload['icon'] = 'fa fa-users';
                                    break;
                                case 'dev':
                                    subMenuPayload['icon'] = 'fa fa-users';
                                    break;
                                case 'staging':
                                    subMenuPayload['icon'] = 'fa fa-users';
                                    break;
                                case 'qa':
                                    subMenuPayload['icon'] = 'fa fa-users';
                                    break;
                                default:
                                    subMenuPayload['icon'] = 'fa fa-users';
                                    break;
                            }
                            subMenuPayload['envName'] = env['type'];
                            subMenuPayload['environmentName'] = env['name'];
                            subMenuPayload['email'] = localStorage.getItem('signInEmail');
                            if (env['name'] !== localStorage.getItem('partner') && env['type'] !== 'admin') {
                                this.availableEnvironmentsForPromote.push(subMenuPayload);
                            }
                        }
                    });
                }
            }
        });
    }

    userSelection() {
        const tempUsersSelected = this.users.subtasks.filter(t => t.completed).length;
        this.allUsersSelected = this.users.subtasks != null && tempUsersSelected === this.users.subtasks.length;
        this.usersSelected = this.users.subtasks != null && tempUsersSelected > 0;
    }

    someComplete(): boolean {
        if (this.users.subtasks == null) {
            return false;
        }
        return this.users.subtasks.filter(t => t.completed).length > 0 && !this.allUsersSelected;
    }

    setAllUsers(completed: boolean) {
        this.allUsersSelected = completed;
        if (this.users.subtasks == null) {
            return;
        }
        this.users.subtasks.filter(function (e) {
            if (!e.preSelected) {
                e.completed = completed;
            }
        });
    }

    retrieveUserInfo() {
        this.userInfoRetrieving = true;
        this.users = {
            name: '',
            completed: false,
            color: 'primary',
            subtasks: []
        };
        const shortName = this.targetEnvironment.environmentName.split('-');
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'partner.in=' + shortName[shortName.length - 1]).subscribe(data => {
            if (data) {
                this.userInfoRetrieving = false;
                let users: any;
                users = data;
                for (const user of users) {
                    if (user['status']) {
                        for (const e of user['environments']) {
                            if (e['name'] === this.targetEnvironment.environmentName) {
                                this.users.subtasks.push(
                                    {name: user['user'], completed: false, object: user, color: 'primary'}
                                );
                                this.users.subtasks[this.users.subtasks.length - 1]['preSelected'] = user['email'] === localStorage.getItem('signInEmail') || user['user'] === 'admin-' + shortName[shortName.length - 1];
                                this.users.subtasks[this.users.subtasks.length - 1]['completed'] = this.users.subtasks[this.users.subtasks.length - 1]['preSelected'];
                            }
                        }
                    }

                }
            } else {
                this.dialogRef.close();
                this.platform.openSnackBar('No users associated to this partner Environment.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            this.dialogRef.close();
            this.platform.openSnackBar('Unknown error occurred while retrieving users on target environment. Please try again later.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    onSelectingEnvironment(environmentName) {
        this.targetEnvironment = environmentName;
        this.showNextPanel = true;
    }

    validatePkey() {
        if (this.targetPkey && this.targetPkey !== '' && this.targetPkey !== ' ') {
            this.confPost.authorizePartner(this.targetEnvironment.environmentName, this.targetPkey).subscribe(response => {
                if (response.status === 200) {
                    const env = {
                        targetEnvironment: this.targetEnvironment.environmentName,
                        targetPkey: this.targetPkey
                    };
                    this.showUserSelection = true;
                    this.showNextPanel = false;
                    this.retrieveUserInfo();
                    this.router.navigateByUrl('/promotion?partner=' + this.data.partner + '&account=' + this.data.account + '&entity=' + this.data.entity + '&version=' + this.data.version + '&type=' + this.data.type + '&env=' + JSON.stringify(env));
                    this.dialogRef.close();
                } else {
                    this.platform.openSnackBar('Invalid PKey', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }, error => {
                this.platform.openSnackBar('Invalid PKey', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }
    }

    close() {
        this.dialogRef.close();
    }
}


@Component({
    selector: 'billing-warning',
    templateUrl: 'billing-warning.html',
    styleUrls: ['billing-warning.css'],
})
export class BillingWarningDialog {

    constructor(public dialogRef: MatDialogRef<BillingWarningDialog>, @Inject(MAT_DIALOG_DATA) public data: any, public router: Router) {
        console.log(data);
        dialogRef.disableClose = true;
    }

    goToBilling() {
        if (this.data['admin-account'] && this.data['admin-account'] !== '') {
            window.open('https://' + this.data['admin-account'] + '.apiplatform.io/billing?month=' + this.data['month_num'] + '&year=' + this.data['year'], '_blank');
        }
        // this.dialogRef.close();

    }

    closeDialog() {
        this.dialogRef.close();
    }
}
